export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AWSDate: { input: string; output: string; }
  AWSDateTime: { input: string; output: string; }
  AWSEmail: { input: string; output: string; }
  AWSJSON: { input: string; output: string; }
  AWSPhone: { input: string; output: string; }
  AWSURL: { input: string; output: string; }
};

export type AddCVsToCandidateBatchInput = {
  candidateBatchId: Scalars['ID']['input'];
  cvS3Keys: Array<Scalars['String']['input']>;
};

export type AddCandidateProfilesToListInput = {
  candidateProfileIds: Array<Scalars['ID']['input']>;
  candidateProfileListId: Scalars['ID']['input'];
};

export type AddCandidateProfilesToListOutput = {
  message: Scalars['String']['output'];
};

export type AddDocumentTypeInput = {
  classificationRules?: InputMaybe<Array<ClassificationRuleInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  validation?: InputMaybe<Array<DocumentValidationCheck>>;
  validationSettings?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type AddNewCandidatesToCampaignInput = {
  campaignId: Scalars['ID']['input'];
  candidateBatchId: Scalars['ID']['input'];
  candidateIds: Array<Scalars['ID']['input']>;
};

export type AddNewCandidatesToCampaignOutput = {
  message: Scalars['String']['output'];
};

export type AddWorkflowContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowId: Scalars['ID']['input'];
};

export type Agent = {
  campaigns?: Maybe<ModelCampaignConnection>;
  conversations?: Maybe<ModelConversationConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  messages?: Maybe<ModelMessageConnection>;
  name: Scalars['String']['output'];
  organizationConfig?: Maybe<OrganizationConfig>;
  organizationConfigId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  personality?: Maybe<Scalars['String']['output']>;
  tone?: Maybe<Tone>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};


export type AgentCampaignsArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type AgentConversationsArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type AgentMessagesArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type AlreadyEnrolledContact = {
  candidateProfileId: Scalars['ID']['output'];
  contactIndex?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  existingRunId: Scalars['ID']['output'];
  existingRunStatus: WorkflowRunStatus;
  externalId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type AnalysedApplicationSnapshot = {
  analysisErrorCode?: Maybe<CandidateAnalysisErrorCode>;
  atsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  candidate?: Maybe<Candidate>;
  candidateBatchId: Scalars['ID']['output'];
  candidateId: Scalars['ID']['output'];
  candidateProfileId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  cvS3Key?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAllRequirementsMet?: Maybe<Scalars['Boolean']['output']>;
  komboApplicationId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  requirementOutcomes: Array<AnalysedApplicationSnapshotRequirementOutcome>;
  screeningAnswers?: Maybe<Array<AtsScreeningAnswer>>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  totalScoreScaled?: Maybe<Scalars['Float']['output']>;
  trigger: AnalysedApplicationSnapshotTrigger;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  workflowNodeId: Scalars['String']['output'];
  workflowNodeLabel?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
  workflowVersion?: Maybe<WorkflowVersion>;
  workflowVersionId: Scalars['ID']['output'];
  workflowVersionNumber: Scalars['Int']['output'];
};

export type AnalysedApplicationSnapshotRequirement = {
  analysisRequirementId: Scalars['ID']['output'];
  generatedRequirementText?: Maybe<Scalars['String']['output']>;
  isMandatory: Scalars['Boolean']['output'];
  originalRequirementText: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  weight: Scalars['Float']['output'];
};

export type AnalysedApplicationSnapshotRequirementInput = {
  analysisRequirementId: Scalars['ID']['input'];
  generatedRequirementText?: InputMaybe<Scalars['String']['input']>;
  isMandatory: Scalars['Boolean']['input'];
  originalRequirementText: Scalars['String']['input'];
  slug?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Float']['input'];
};

export type AnalysedApplicationSnapshotRequirementOutcome = {
  evidence: Scalars['String']['output'];
  isMet: Scalars['Boolean']['output'];
  requirement: AnalysedApplicationSnapshotRequirement;
  requirementOutcomeId?: Maybe<Scalars['ID']['output']>;
  scoredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  scoringConfigurationDigest?: Maybe<Scalars['String']['output']>;
};

export type AnalysedApplicationSnapshotRequirementOutcomeInput = {
  evidence: Scalars['String']['input'];
  isMet: Scalars['Boolean']['input'];
  requirement: AnalysedApplicationSnapshotRequirementInput;
  requirementOutcomeId?: InputMaybe<Scalars['ID']['input']>;
  scoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  scoringConfigurationDigest?: InputMaybe<Scalars['String']['input']>;
};

export enum AnalysedApplicationSnapshotTrigger {
  Rescored = 'RESCORED',
  RescoredAfterActedOn = 'RESCORED_AFTER_ACTED_ON',
  RescoreFailed = 'RESCORE_FAILED',
  Scored = 'SCORED'
}

export type AnalysisAutomationTaskUpdateInput = {
  action: AutomationActionInput;
  id: Scalars['ID']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  requirementConditions: Array<RequirementConditionInput>;
};

export type AnalysisNodeMoveOnBand = {
  branchId: Scalars['String']['output'];
  candidatesCount: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  maxScore: Scalars['Int']['output'];
  minScore: Scalars['Int']['output'];
};

export type AnalysisNodeMoveOnCount = {
  candidatesCount: Scalars['Int']['output'];
  scoreBands: Array<AnalysisNodeMoveOnBand>;
};

export type AnalysisNodeRequirementCount = {
  analysisRequirement: AnalysisRequirement;
  requirementMetCandidatesCount: Scalars['Int']['output'];
  requirementNotMetCandidatesCount: Scalars['Int']['output'];
};

export type AnalysisNodeScoreBand = {
  branchId: Scalars['String']['output'];
  candidatesCount: Scalars['Int']['output'];
  label?: Maybe<Scalars['String']['output']>;
  maxScore: Scalars['Int']['output'];
  maxTotalScoreScaled: Scalars['Float']['output'];
  minScore: Scalars['Int']['output'];
  minTotalScoreScaled: Scalars['Float']['output'];
};

export type AnalysisNodeSummary = {
  candidateBatch: CandidateBatch;
  candidatesAnalysisErrorCount: Scalars['Int']['output'];
  candidatesCount: Scalars['Int']['output'];
  candidatesRequirementsMetCount: Scalars['Int']['output'];
  candidatesRequirementsNotMetCount: Scalars['Int']['output'];
  isActive: Scalars['Boolean']['output'];
  requirements: Array<AnalysisNodeRequirementCount>;
  scoreBands: Array<AnalysisNodeScoreBand>;
  workflowNodeLabel?: Maybe<Scalars['String']['output']>;
};

export type AnalysisRequirement = {
  candidateBatchGroupId?: Maybe<Scalars['ID']['output']>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  generatedRequirementText?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMandatory: Scalars['Boolean']['output'];
  isParent?: Maybe<Scalars['Boolean']['output']>;
  isRecommendationDismissed?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  originalRequirementText: Scalars['String']['output'];
  parentAnalysisRequirementId?: Maybe<Scalars['ID']['output']>;
  recommendationCategory?: Maybe<RequirementRecommendationCategory>;
  recommendationText?: Maybe<Scalars['String']['output']>;
  requirementMetCandidatesCount?: Maybe<Scalars['Int']['output']>;
  requirementOutcomes?: Maybe<ModelRequirementOutcomeConnection>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  weight: Scalars['Float']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};


export type AnalysisRequirementRequirementOutcomesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum AnalysisRequirementCountField {
  RequirementMetCandidatesCount = 'requirementMetCandidatesCount'
}

export type AnalysisRequirementCountFieldInput = {
  field: AnalysisRequirementCountField;
  value: Scalars['Int']['input'];
};

export type AnalysisRequirementCountsOutput = {
  id: Scalars['ID']['output'];
  requirementMetCandidatesCount: Scalars['Int']['output'];
};

export type AnalysisRequirementCreateInput = {
  content: Scalars['String']['input'];
  isMandatory: Scalars['Boolean']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  recommendationCategory?: InputMaybe<RequirementRecommendationCategory>;
  recommendationText?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Float']['input'];
};

export type AnalysisRequirementUpdateInput = {
  id: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  recommendationCategory?: InputMaybe<RequirementRecommendationCategory>;
  recommendationText?: InputMaybe<Scalars['String']['input']>;
  updatedContent?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type AnalysisRequirementsUpdateOutput = {
  message: Scalars['String']['output'];
};

export type AnswerProgress = {
  details?: Maybe<Scalars['String']['output']>;
  documentName: Scalars['String']['output'];
  documentTypeId?: Maybe<Scalars['String']['output']>;
  status: DocumentAnswerStatus;
};

export type AnswerProgressInput = {
  details?: InputMaybe<Scalars['String']['input']>;
  documentName: Scalars['String']['input'];
  documentTypeId?: InputMaybe<Scalars['String']['input']>;
  status: DocumentAnswerStatus;
};

export enum AnswerState {
  DocumentNotUploaded = 'DOCUMENT_NOT_UPLOADED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  DoesNotInclude = 'DOES_NOT_INCLUDE',
  Includes = 'INCLUDES',
  IsAny = 'IS_ANY',
  IsNo = 'IS_NO',
  IsYes = 'IS_YES',
  NeedsClarification = 'NEEDS_CLARIFICATION'
}

export type ApplicationStageUpdate = {
  applicationStage: Scalars['String']['output'];
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  stageUpdatedAt: Scalars['AWSDateTime']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type ApplyCandidateBatchGroupInput = {
  candidateBatchGroupId: Scalars['ID']['input'];
  candidateBatchIds: Array<Scalars['ID']['input']>;
  launchDraft?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApplyCandidateBatchGroupOutput = {
  message: Scalars['String']['output'];
};

export type ArchiveWorkflowResult = {
  archivedAt: Scalars['AWSDateTime']['output'];
  status: WorkflowStatus;
  workflowId: Scalars['ID']['output'];
};

export type AtsApplication = {
  analyses?: Maybe<ModelCandidateConnection>;
  analysisCandidateId?: Maybe<Scalars['ID']['output']>;
  analysisRequirementsMet?: Maybe<Scalars['Boolean']['output']>;
  analysisScore?: Maybe<Scalars['Int']['output']>;
  analysisScoredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  analysisWorkflowNodeId?: Maybe<Scalars['ID']['output']>;
  appliedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsApplicationId?: Maybe<Scalars['ID']['output']>;
  atsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  atsCandidateId?: Maybe<Scalars['ID']['output']>;
  atsJobId: Scalars['ID']['output'];
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  currentStage?: Maybe<Scalars['String']['output']>;
  currentStageId?: Maybe<Scalars['ID']['output']>;
  cvFileName?: Maybe<Scalars['String']['output']>;
  cvS3Key?: Maybe<Scalars['String']['output']>;
  cvText?: Maybe<Scalars['String']['output']>;
  hiringOutcome?: Maybe<Scalars['String']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  komboApplicationId: Scalars['ID']['output'];
  organizationGroupId: Scalars['ID']['output'];
  /** @deprecated Use organizationGroupId (tenant key) and organizationIds (read ACL) instead. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationIds: Array<Scalars['ID']['output']>;
  rejectedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  remoteUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type AtsApplicationAnalysesArgs = {
  candidateBatchId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum AtsApplicationCreateOutcome {
  Added = 'ADDED',
  Failed = 'FAILED',
  Skipped = 'SKIPPED'
}

export type AtsApplicationScreeningAnswers = {
  answers: Array<AtsScreeningAnswer>;
  createdAt: Scalars['AWSDateTime']['output'];
  komboApplicationId: Scalars['ID']['output'];
  organizationGroupId: Scalars['ID']['output'];
  organizationIds: Array<Scalars['ID']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AtsBulkSync = {
  atsAccountId: Scalars['String']['output'];
  atsBulkSyncType: AtsBulkSyncType;
  createdAt: Scalars['AWSDateTime']['output'];
  errors?: Maybe<ModelAtsBulkSyncErrorConnection>;
  id: Scalars['ID']['output'];
  nextProcessingToken?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationGroup?: Maybe<OrganizationGroup>;
  organizationGroupId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  recordsAttempted?: Maybe<Scalars['Int']['output']>;
  recordsFailed?: Maybe<Scalars['Int']['output']>;
  recordsFound?: Maybe<Scalars['Int']['output']>;
  recordsSucceeded?: Maybe<Scalars['Int']['output']>;
  status: SyncStatus;
  syncCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  syncMetadata?: Maybe<Scalars['AWSJSON']['output']>;
  syncStartedAt: Scalars['AWSDateTime']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type AtsBulkSyncErrorsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncErrorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type AtsBulkSyncError = {
  atsBulkSync?: Maybe<AtsBulkSync>;
  atsBulkSyncId: Scalars['ID']['output'];
  atsRecordId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  errorDetails?: Maybe<Scalars['AWSJSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  retryCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum AtsBulkSyncType {
  Candidates = 'CANDIDATES',
  Jobs = 'JOBS'
}

export type AtsConfig = {
  applicationProxy?: Maybe<Scalars['AWSJSON']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobPostingProxy?: Maybe<Scalars['AWSJSON']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AtsJob = {
  analysis?: Maybe<ConnectedRecord>;
  atsJobId: Scalars['ID']['output'];
  atsJobReference?: Maybe<Scalars['String']['output']>;
  campaign?: Maybe<ConnectedRecord>;
  category?: Maybe<Scalars['String']['output']>;
  closedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  customFields?: Maybe<Scalars['AWSJSON']['output']>;
  department?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  experienceLevel?: Maybe<Scalars['String']['output']>;
  isConnected: Scalars['Boolean']['output'];
  komboJobId?: Maybe<Scalars['ID']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationCountry?: Maybe<Scalars['String']['output']>;
  locationState?: Maybe<Scalars['String']['output']>;
  openedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  postUrl?: Maybe<Scalars['String']['output']>;
  rawStatus?: Maybe<Scalars['String']['output']>;
  remoteUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  remoteUrl?: Maybe<Scalars['String']['output']>;
  remoteWorkStatus?: Maybe<AtsRemoteWorkStatus>;
  salaryAmount?: Maybe<Scalars['Float']['output']>;
  salaryAmountFrom?: Maybe<Scalars['Float']['output']>;
  salaryAmountTo?: Maybe<Scalars['Float']['output']>;
  salaryCurrency?: Maybe<Scalars['String']['output']>;
  salaryPeriod?: Maybe<Scalars['String']['output']>;
  screeningQuestions?: Maybe<Array<AtsScreeningQuestion>>;
  stages?: Maybe<Array<AtsStage>>;
  status?: Maybe<AtsJobStatus>;
  title?: Maybe<Scalars['String']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
  weeklyHours?: Maybe<Scalars['Float']['output']>;
  workflow?: Maybe<ConnectedRecord>;
};

export type AtsJobFilterInput = {
  atsJobIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  jobCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  nameContains?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<AtsJobStatus>;
  updatedAfter?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type AtsJobInput = {
  atsJobId: Scalars['ID']['input'];
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  atsQuestions?: InputMaybe<Array<AtsQuestionInput>>;
  jobDescription: Scalars['String']['input'];
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
};

export enum AtsJobStatus {
  Archived = 'ARCHIVED',
  Closed = 'CLOSED',
  Draft = 'DRAFT',
  Open = 'OPEN'
}

export type AtsQuestion = {
  atsJobId?: Maybe<Scalars['ID']['output']>;
  atsQuestionId: Scalars['String']['output'];
  atsQuestionOptions?: Maybe<Array<AtsQuestionOption>>;
  candidateBatchId: Scalars['ID']['output'];
  category?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  komboQuestionId?: Maybe<Scalars['ID']['output']>;
  multipleChoiceAnswers?: Maybe<Array<Scalars['String']['output']>>;
  organizationId: Scalars['ID']['output'];
  questionIndex?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type AtsQuestionInput = {
  content: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  multipleChoiceAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AtsQuestionOption = {
  atsOptionId?: Maybe<Scalars['ID']['output']>;
  komboOptionId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AtsQuestionOptionInput = {
  atsOptionId?: InputMaybe<Scalars['ID']['input']>;
  komboOptionId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type AtsQuestionnaireAnswer = {
  answer: Scalars['String']['output'];
  atsQuestionId?: Maybe<Scalars['ID']['output']>;
  multipleChoiceAnswers?: Maybe<Array<Scalars['String']['output']>>;
  question: Scalars['String']['output'];
};

export type AtsQuestionnaireAnswerInput = {
  answer: Scalars['String']['input'];
  atsQuestionId?: InputMaybe<Scalars['ID']['input']>;
  multipleChoiceAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  question: Scalars['String']['input'];
};

export type AtsRejectionReason = {
  atsReasonId?: Maybe<Scalars['ID']['output']>;
  komboReasonId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export enum AtsRemoteWorkStatus {
  Hybrid = 'HYBRID',
  OnSite = 'ON_SITE',
  Remote = 'REMOTE',
  Temporary = 'TEMPORARY'
}

export type AtsScreeningAnswer = {
  answerBoolean?: Maybe<Scalars['Boolean']['output']>;
  answerDate?: Maybe<Scalars['AWSDate']['output']>;
  answerNumber?: Maybe<Scalars['Float']['output']>;
  answerText?: Maybe<Scalars['String']['output']>;
  atsQuestionId?: Maybe<Scalars['ID']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  isAnswered: Scalars['Boolean']['output'];
  isRequired?: Maybe<Scalars['Boolean']['output']>;
  komboQuestionId?: Maybe<Scalars['ID']['output']>;
  questionContent?: Maybe<Scalars['String']['output']>;
  questionIndex?: Maybe<Scalars['Int']['output']>;
  selectedOptions?: Maybe<Array<AtsQuestionOption>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AtsScreeningAnswerInput = {
  answerBoolean?: InputMaybe<Scalars['Boolean']['input']>;
  answerDate?: InputMaybe<Scalars['AWSDate']['input']>;
  answerNumber?: InputMaybe<Scalars['Float']['input']>;
  answerText?: InputMaybe<Scalars['String']['input']>;
  atsQuestionId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  isAnswered: Scalars['Boolean']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  komboQuestionId?: InputMaybe<Scalars['ID']['input']>;
  questionContent?: InputMaybe<Scalars['String']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
  selectedOptions?: InputMaybe<Array<AtsQuestionOptionInput>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type AtsScreeningQuestion = {
  atsQuestionId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  komboQuestionId: Scalars['ID']['output'];
  options?: Maybe<Array<AtsScreeningQuestionOption>>;
  required?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AtsScreeningQuestionOption = {
  atsOptionId?: Maybe<Scalars['ID']['output']>;
  komboOptionId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AtsStage = {
  atsStageId?: Maybe<Scalars['ID']['output']>;
  index?: Maybe<Scalars['Int']['output']>;
  komboStageId: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type AttachOrganizationWebhookInput = {
  name: Scalars['String']['input'];
  subscribedEvents?: InputMaybe<Array<WebhookEventType>>;
  url: Scalars['AWSURL']['input'];
};

export type AttachOrganizationWebhookResult = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  signingSecret: Scalars['String']['output'];
  subscribedEvents?: Maybe<Array<WebhookEventType>>;
  url: Scalars['AWSURL']['output'];
};

export type Attachment = {
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  media: Media;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type AutomationAction = {
  atsInterviewStageId?: Maybe<Scalars['ID']['output']>;
  atsRejectedReasonId?: Maybe<Scalars['ID']['output']>;
  automationTaskEmailTemplateId?: Maybe<Scalars['ID']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidateStatus?: Maybe<Scalars['String']['output']>;
  includeJobBoardLink?: Maybe<Scalars['Boolean']['output']>;
  includePersonalisation?: Maybe<Scalars['Boolean']['output']>;
  jobBoardLink?: Maybe<Scalars['String']['output']>;
  komboRejectionReasonId?: Maybe<Scalars['ID']['output']>;
  komboStageId?: Maybe<Scalars['ID']['output']>;
  recipientEmailAddress?: Maybe<Scalars['String']['output']>;
  type: AutomationActionType;
};

export type AutomationActionInput = {
  atsInterviewStageId?: InputMaybe<Scalars['ID']['input']>;
  atsRejectedReasonId?: InputMaybe<Scalars['ID']['input']>;
  automationTaskEmailTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateStatus?: InputMaybe<Scalars['String']['input']>;
  includeJobBoardLink?: InputMaybe<Scalars['Boolean']['input']>;
  includePersonalisation?: InputMaybe<Scalars['Boolean']['input']>;
  jobBoardLink?: InputMaybe<Scalars['String']['input']>;
  komboRejectionReasonId?: InputMaybe<Scalars['ID']['input']>;
  komboStageId?: InputMaybe<Scalars['ID']['input']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']['input']>;
  type: AutomationActionType;
};

export enum AutomationActionType {
  CreateCandidateNoteFromConversation = 'CREATE_CANDIDATE_NOTE_FROM_CONVERSATION',
  SendCampaign = 'SEND_CAMPAIGN',
  SendDocumentViaEmail = 'SEND_DOCUMENT_VIA_EMAIL',
  SendEmail = 'SEND_EMAIL',
  SendJobRecommendationEmail = 'SEND_JOB_RECOMMENDATION_EMAIL',
  UpdateAts = 'UPDATE_ATS',
  UpdateCandidateStatus = 'UPDATE_CANDIDATE_STATUS'
}

export type AutomationTask = {
  action: AutomationAction;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidateBatchGroupId?: Maybe<Scalars['ID']['output']>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isParent?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  parentAutomationTaskId?: Maybe<Scalars['ID']['output']>;
  requirementConditions: Array<RequirementCondition>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type AutomationTaskEmailTemplate = {
  createdAt: Scalars['AWSDateTime']['output'];
  customEmailTemplate?: Maybe<Scalars['String']['output']>;
  defaultEmailTemplate: Scalars['String']['output'];
  emailTemplateWithJobBoardLink: Scalars['String']['output'];
  emailTemplateWithPersonalisation: Scalars['String']['output'];
  emailTemplateWithPersonalisationAndJobBoardLink: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  jobRecommendationsEmailTemplate?: Maybe<Scalars['String']['output']>;
  jobRecommendationsEmailTemplateWithJobBoardLink?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type AutomationTaskInput = {
  action: AutomationActionInput;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  requirementConditions: Array<RequirementConditionInput>;
};

export type AutomationTaskItem = {
  action: AutomationAction;
  requirementConditions: Array<RequirementCondition>;
};

export type AutomationTaskItemInput = {
  action: AutomationActionInput;
  requirementConditions: Array<RequirementConditionInput>;
};

export type AutomationTasksSavedInput = {
  candidateBatchId: Scalars['ID']['input'];
};

export type AutomationTasksSavedOutput = {
  message: Scalars['String']['output'];
};

export type AutomationTasksTemplate = {
  automationTasks: Array<AutomationTaskItem>;
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export enum AutomationType {
  Action = 'ACTION',
  Rule = 'RULE'
}

export enum AvailabilityMethod {
  Collective = 'COLLECTIVE',
  RoundRobinMaxAvailability = 'ROUND_ROBIN_MAX_AVAILABILITY'
}

export type AvailabilityOutreachSettings = {
  additionalRecipients?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  customTemplatedMessage?: Maybe<Scalars['String']['output']>;
  customTemplatedSubjectLine?: Maybe<Scalars['String']['output']>;
  nudgeSettings?: Maybe<Array<Maybe<NudgeSetting>>>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  requiredHours?: Maybe<Scalars['Int']['output']>;
};

export type AvailabilityOutreachSettingsInput = {
  additionalRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  customTemplatedMessage?: InputMaybe<Scalars['String']['input']>;
  customTemplatedSubjectLine?: InputMaybe<Scalars['String']['input']>;
  nudgeSettings?: InputMaybe<Array<InputMaybe<NudgeSettingInput>>>;
  periodDays?: InputMaybe<Scalars['Int']['input']>;
  requiredHours?: InputMaybe<Scalars['Int']['input']>;
};

export type AvailabilitySlot = {
  endTime: Scalars['AWSDateTime']['output'];
  startTime: Scalars['AWSDateTime']['output'];
};

export type BiasPrediction = {
  ageBias: Scalars['Boolean']['output'];
  criminalHistoryBias: Scalars['Boolean']['output'];
  disabilityBias: Scalars['Boolean']['output'];
  englishProficiencyBias?: Maybe<Scalars['Boolean']['output']>;
  genderIdentityBias: Scalars['Boolean']['output'];
  maritalStatusBias: Scalars['Boolean']['output'];
  medicalConditionsBias: Scalars['Boolean']['output'];
  nationalOriginBias: Scalars['Boolean']['output'];
  pregnancyStatusBias: Scalars['Boolean']['output'];
  raceEthnicityBias: Scalars['Boolean']['output'];
  religionBias: Scalars['Boolean']['output'];
  sexBias: Scalars['Boolean']['output'];
  sexualOrientationBias: Scalars['Boolean']['output'];
  veteranStatusBias: Scalars['Boolean']['output'];
};

export type BookingParticipant = {
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type BookingParticipantInput = {
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarBooking = {
  bookingParticipants?: Maybe<Array<BookingParticipant>>;
  calendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  calendarMeetingTemplateId: Scalars['ID']['output'];
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ID']['output'];
  candidateEmail: Scalars['String']['output'];
  candidateName: Scalars['String']['output'];
  candidateTimeZone?: Maybe<Scalars['String']['output']>;
  conferenceUrl?: Maybe<Scalars['String']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  endDateTime: Scalars['AWSDateTime']['output'];
  icalUid?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Scalars['String']['output']>;
  noteTakerId?: Maybe<Scalars['ID']['output']>;
  noteTakerMediaTranscriptS3Key?: Maybe<Scalars['String']['output']>;
  noteTakerStatus?: Maybe<NoteTakerStatus>;
  noteTakerTranscript?: Maybe<Array<NoteTakerTranscriptItem>>;
  noteTakerTranscriptSummary?: Maybe<Scalars['String']['output']>;
  notetakerMediaRecordingS3Key?: Maybe<Scalars['String']['output']>;
  nylasBookingId: Scalars['String']['output'];
  nylasBookingRef: Scalars['String']['output'];
  nylasEventId?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  organizerUserCalendar: UserCalendar;
  organizerUserCalendarId: Scalars['ID']['output'];
  startDateTime: Scalars['AWSDateTime']['output'];
  status: MeetingBookingStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type CalendarMeetingTemplate = {
  availabilityMethod?: Maybe<AvailabilityMethod>;
  availabilityOutreachSettings?: Maybe<AvailabilityOutreachSettings>;
  calendarBookings?: Maybe<ModelCalendarBookingConnection>;
  campaigns?: Maybe<ModelCampaignConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  durationMinutes: Scalars['Int']['output'];
  guestLabel?: Maybe<Scalars['String']['output']>;
  hideParticipantEmails?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isSingleUse?: Maybe<Scalars['Boolean']['output']>;
  isVideoConference?: Maybe<Scalars['Boolean']['output']>;
  isWorkflowManaged?: Maybe<Scalars['Boolean']['output']>;
  lastUsedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  nylasConfigurationId: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  organizerUserCalendar?: Maybe<UserCalendar>;
  organizerUserCalendarId?: Maybe<Scalars['ID']['output']>;
  participants?: Maybe<ModelUserCalendarMeetingTemplateConnection>;
  status: CalendarMeetingTemplateStatus;
  title: Scalars['String']['output'];
  totalBookingsCount?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  updatedByUserId: Scalars['ID']['output'];
  user?: Maybe<User>;
};


export type CalendarMeetingTemplateCalendarBookingsArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CalendarMeetingTemplateCampaignsArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CalendarMeetingTemplateParticipantsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CalendarMeetingTemplateStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type Campaign = {
  additionalContext?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['ID']['output']>;
  atsJobId?: Maybe<Scalars['ID']['output']>;
  atsJobPostingId?: Maybe<Scalars['ID']['output']>;
  atsListId?: Maybe<Scalars['ID']['output']>;
  averageTimeToComplete?: Maybe<Scalars['Float']['output']>;
  averageTimeToFirstResponse?: Maybe<Scalars['Float']['output']>;
  calendarBookings?: Maybe<ModelCalendarBookingConnection>;
  calendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  calendarMeetingTemplateId?: Maybe<Scalars['ID']['output']>;
  campaignGroupId?: Maybe<Scalars['ID']['output']>;
  campaignSubscriptions?: Maybe<ModelCampaignSubscriptionConnection>;
  cancellationMessage?: Maybe<Scalars['String']['output']>;
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  channel?: Maybe<Channels>;
  closingMessage?: Maybe<Scalars['String']['output']>;
  closingMethod?: Maybe<ClosingMethod>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  conversationCompletedMessage?: Maybe<Scalars['String']['output']>;
  conversations?: Maybe<ModelConversationConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  csvKeys?: Maybe<ModelCampaignCsvKeysConnection>;
  csvS3Key?: Maybe<Scalars['String']['output']>;
  customRequest?: Maybe<Scalars['String']['output']>;
  customTemplatedMessage?: Maybe<Scalars['String']['output']>;
  customTemplatedSubjectLine?: Maybe<Scalars['String']['output']>;
  disableNudging?: Maybe<Scalars['Boolean']['output']>;
  emailChannelFallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  followUpMessage?: Maybe<Scalars['String']['output']>;
  guestLabel?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  initialMessagesDeliveredCount?: Maybe<Scalars['Int']['output']>;
  initialMessagesReadCount?: Maybe<Scalars['Int']['output']>;
  initialMessagesSentCount?: Maybe<Scalars['Int']['output']>;
  initialMessagesUndeliveredCount?: Maybe<Scalars['Int']['output']>;
  isDuplicate?: Maybe<Scalars['Boolean']['output']>;
  isParent?: Maybe<Scalars['Boolean']['output']>;
  isWorkflowManaged?: Maybe<Scalars['Boolean']['output']>;
  jobDescription?: Maybe<Scalars['AWSJSON']['output']>;
  jobDescriptionParsed?: Maybe<JobDescriptionParsed>;
  jobDescriptionText?: Maybe<Scalars['String']['output']>;
  komboJobId?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  launchScheduleDateTime?: Maybe<Scalars['AWSDateTime']['output']>;
  launchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  meetingUrl?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<ModelMessageConnection>;
  messagesProcessedCount?: Maybe<Scalars['Int']['output']>;
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  nudgeSettings?: Maybe<Array<Maybe<NudgeSetting>>>;
  nudgesCount?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  outreachDescription?: Maybe<Scalars['String']['output']>;
  outreachQuestions?: Maybe<ModelOutreachQuestionConnection>;
  owner?: Maybe<Scalars['String']['output']>;
  periodDays?: Maybe<Scalars['Int']['output']>;
  questions?: Maybe<Array<Question>>;
  referenceId?: Maybe<Scalars['String']['output']>;
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  requiredHours?: Maybe<Scalars['Int']['output']>;
  selectedCandidateBatchStatuses?: Maybe<ModelSelectedCandidateBatchStatusesConnection>;
  sourcedCandidates?: Maybe<ModelSourcedCandidateConnection>;
  status: CampaignStatus;
  stoppedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  stoppedByUserId?: Maybe<Scalars['ID']['output']>;
  templateId?: Maybe<Scalars['ID']['output']>;
  timeToAutoCloseConversationsInHours?: Maybe<Scalars['Float']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalConversationsCount?: Maybe<Scalars['Int']['output']>;
  totalConversationsWithRepliesCount?: Maybe<Scalars['Int']['output']>;
  totalMessagesCount?: Maybe<Scalars['Int']['output']>;
  totalMessagesWithCallRequest?: Maybe<Scalars['Int']['output']>;
  totalMessagesWithCustomRequest?: Maybe<Scalars['Int']['output']>;
  totalMessagesWithMeetingUrlCount?: Maybe<Scalars['Int']['output']>;
  totalNotInterestedConversationCount?: Maybe<Scalars['Int']['output']>;
  totalOptedOutConversationCount?: Maybe<Scalars['Int']['output']>;
  totalProspectsCount?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<CampaignType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  webChatTemplateId?: Maybe<Scalars['ID']['output']>;
  workflow?: Maybe<Workflow>;
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowVersion?: Maybe<WorkflowVersion>;
  workflowVersionId?: Maybe<Scalars['ID']['output']>;
};


export type CampaignCalendarBookingsArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignCampaignSubscriptionsArgs = {
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type CampaignConversationsArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignCsvKeysArgs = {
  filter?: InputMaybe<ModelCampaignCsvKeysFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignMessagesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignOutreachQuestionsArgs = {
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignSelectedCandidateBatchStatusesArgs = {
  filter?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CampaignSourcedCandidatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type CampaignAutomationTasksSavedInput = {
  campaignId: Scalars['ID']['input'];
};

export type CampaignAutomationTasksSavedOutput = {
  message: Scalars['String']['output'];
};

export type CampaignCandidate = {
  campaignId: Scalars['ID']['output'];
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isProcessed?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum CampaignCountField {
  InitialMessagesDeliveredCount = 'initialMessagesDeliveredCount',
  InitialMessagesReadCount = 'initialMessagesReadCount',
  InitialMessagesSentCount = 'initialMessagesSentCount',
  InitialMessagesUndeliveredCount = 'initialMessagesUndeliveredCount',
  MessagesProcessedCount = 'messagesProcessedCount',
  TotalConversationsCount = 'totalConversationsCount',
  TotalConversationsWithRepliesCount = 'totalConversationsWithRepliesCount',
  TotalMessagesCount = 'totalMessagesCount',
  TotalMessagesWithCallRequest = 'totalMessagesWithCallRequest',
  TotalMessagesWithCustomRequest = 'totalMessagesWithCustomRequest',
  TotalMessagesWithMeetingUrlCount = 'totalMessagesWithMeetingUrlCount',
  TotalNotInterestedConversationCount = 'totalNotInterestedConversationCount',
  TotalOptedOutConversationCount = 'totalOptedOutConversationCount',
  TotalProspectsCount = 'totalProspectsCount'
}

export type CampaignCountFieldInput = {
  field: CampaignCountField;
  value: Scalars['Int']['input'];
};

export type CampaignCsvKeys = {
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  csvS3Key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isProcessed?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type CampaignQuestion = {
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  hubSpotProperty?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  order: Scalars['Int']['output'];
  supportingInformation?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type CampaignStatsInput = {
  field: Scalars['String']['input'];
  value: Scalars['Int']['input'];
};

export enum CampaignStatus {
  Archived = 'ARCHIVED',
  Disconnected = 'DISCONNECTED',
  Draft = 'DRAFT',
  FinishedGenerating = 'FINISHED_GENERATING',
  FinishedSending = 'FINISHED_SENDING',
  GeneratingMessages = 'GENERATING_MESSAGES',
  Live = 'LIVE',
  Paused = 'PAUSED',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED',
  SendingMessages = 'SENDING_MESSAGES'
}

export type CampaignSubscriber = {
  campaignId: Scalars['ID']['output'];
  campaignSubscriptionId: Scalars['ID']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
};

export type CampaignSubscription = {
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum CampaignType {
  ApplicantOutreach = 'APPLICANT_OUTREACH',
  AtsJobApplicationUrlOutreach = 'ATS_JOB_APPLICATION_URL_OUTREACH',
  AvailabilityOutreach = 'AVAILABILITY_OUTREACH',
  CustomJobApplicationUrlOutreach = 'CUSTOM_JOB_APPLICATION_URL_OUTREACH',
  EngagementOutreach = 'ENGAGEMENT_OUTREACH',
  HumanOutreach = 'HUMAN_OUTREACH',
  NewCandidateOutreach = 'NEW_CANDIDATE_OUTREACH',
  NotificationOutreach = 'NOTIFICATION_OUTREACH',
  RequestCvOutreach = 'REQUEST_CV_OUTREACH',
  Scheduling = 'SCHEDULING'
}

export type CancelSubscriptionOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type CancelWorkflowRunInput = {
  closeActiveConversations?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  workflowRunId: Scalars['ID']['input'];
};

export type CancelWorkflowRunResult = {
  cancelledAt: Scalars['AWSDateTime']['output'];
  status: WorkflowRunStatus;
  workflowRunId: Scalars['ID']['output'];
};

export type Candidate = {
  analysedApplicationSnapshots?: Maybe<ModelAnalysedApplicationSnapshotConnection>;
  analysisErrorCode?: Maybe<CandidateAnalysisErrorCode>;
  analysisOutcomeActedOnAt?: Maybe<Scalars['AWSDateTime']['output']>;
  applicationSource?: Maybe<Scalars['String']['output']>;
  atsApplication?: Maybe<AtsApplication>;
  atsApplicationId?: Maybe<Scalars['ID']['output']>;
  atsApplicationSource?: Maybe<Scalars['String']['output']>;
  atsCandidateId?: Maybe<Scalars['ID']['output']>;
  atsInterviewStageId?: Maybe<Scalars['ID']['output']>;
  atsJobId?: Maybe<Scalars['ID']['output']>;
  atsQuestionnaireAnswers?: Maybe<Array<AtsQuestionnaireAnswer>>;
  atsRejectedReasonId?: Maybe<Scalars['ID']['output']>;
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  candidateCvsParsing?: Maybe<CandidateCvsParsing>;
  candidateCvsParsingId?: Maybe<Scalars['ID']['output']>;
  candidateNotes?: Maybe<ModelCandidateNoteConnection>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  candidateStatusUpdates?: Maybe<ModelCandidateStatusUpdateConnection>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  conversationPreferredAnswersScore?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  cvParsedText?: Maybe<Scalars['String']['output']>;
  cvS3Key?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isAllRequirementsMet?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isLocked?: Maybe<Scalars['Boolean']['output']>;
  isMessagesGenerating?: Maybe<Scalars['Boolean']['output']>;
  jobPostingRecommendations?: Maybe<ModelJobPostingRecommendationConnection>;
  komboApplicationId?: Maybe<Scalars['ID']['output']>;
  komboCandidateId?: Maybe<Scalars['ID']['output']>;
  komboJobId?: Maybe<Scalars['ID']['output']>;
  komboRejectionReasonId?: Maybe<Scalars['ID']['output']>;
  komboStageId?: Maybe<Scalars['ID']['output']>;
  lastName: Scalars['String']['output'];
  linkedInProfileId?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<ModelCandidateMessageConnection>;
  metRequirementSlugs?: Maybe<Array<Scalars['String']['output']>>;
  organizationId: Scalars['ID']['output'];
  origin?: Maybe<CandidateOrigin>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  requirementOutcomes?: Maybe<ModelRequirementOutcomeConnection>;
  requirements?: Maybe<Array<CandidateRequirement>>;
  scoring?: Maybe<Array<CandidateScoring>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  sourcedCandidate?: Maybe<SourcedCandidate>;
  sourcedCandidateId?: Maybe<Scalars['ID']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalScore?: Maybe<Scalars['Float']['output']>;
  totalScoreScaled?: Maybe<Scalars['Float']['output']>;
  unmetRequirementSlugs?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};


export type CandidateAnalysedApplicationSnapshotsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateCandidateNotesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateCandidateStatusUpdatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateJobPostingRecommendationsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateMessagesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateRequirementOutcomesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CandidateAnalysisErrorCode {
  AnalysisFailed = 'ANALYSIS_FAILED',
  AnalysisInputUnavailable = 'ANALYSIS_INPUT_UNAVAILABLE',
  DocumentTooLarge = 'DOCUMENT_TOO_LARGE'
}

export type CandidateAvailabilitySuggestion = {
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  timeSlots: Array<CandidateSuggestedTimeSlot>;
  timezone?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CandidateBatch = {
  analysisRequirements?: Maybe<ModelAnalysisRequirementConnection>;
  atsJobId?: Maybe<Scalars['ID']['output']>;
  atsJobPostingId?: Maybe<Scalars['ID']['output']>;
  atsJobPostingUrl?: Maybe<Scalars['String']['output']>;
  atsJobReference?: Maybe<Scalars['String']['output']>;
  atsQuestions?: Maybe<ModelAtsQuestionConnection>;
  automationTasks?: Maybe<ModelAutomationTaskConnection>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  campaigns?: Maybe<ModelCampaignConnection>;
  candidateBatchGroup?: Maybe<CandidateBatchGroup>;
  candidateBatchGroupId?: Maybe<Scalars['ID']['output']>;
  candidateBatchReanalysisReferenceId?: Maybe<Scalars['ID']['output']>;
  candidates?: Maybe<ModelCandidateConnection>;
  candidatesCount?: Maybe<Scalars['Int']['output']>;
  candidatesRequirementsMetCount?: Maybe<Scalars['Int']['output']>;
  candidatesRequirementsNotMetCount?: Maybe<Scalars['Int']['output']>;
  candidatesToProcessCount?: Maybe<Scalars['Int']['output']>;
  categorizedRequirements?: Maybe<Array<CategorizedRequirements>>;
  createdAt: Scalars['AWSDateTime']['output'];
  csvS3Key?: Maybe<Scalars['String']['output']>;
  customJobPostingUrl?: Maybe<Scalars['String']['output']>;
  cvS3Keys?: Maybe<Array<Scalars['String']['output']>>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isInitial?: Maybe<Scalars['Boolean']['output']>;
  isRecalculatingScores?: Maybe<Scalars['Boolean']['output']>;
  isWorkflowManaged?: Maybe<Scalars['Boolean']['output']>;
  jobDescription: Scalars['String']['output'];
  jobDescriptionParsed?: Maybe<JobDescription>;
  komboJobId?: Maybe<Scalars['ID']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  remainingRescoredCandidatesCount?: Maybe<Scalars['Int']['output']>;
  requirements?: Maybe<Array<Requirement>>;
  rubric?: Maybe<Rubric>;
  screeningQuestions?: Maybe<Array<Question>>;
  searchPeopleQueryFields?: Maybe<SearchPeopleQueryFields>;
  selectedCandidateBatchStatuses?: Maybe<ModelSelectedCandidateBatchStatusesConnection>;
  sourcedCandidates?: Maybe<ModelSourcedCandidateConnection>;
  status: CandidateBatchStatus;
  title?: Maybe<Scalars['String']['output']>;
  typeformLinks?: Maybe<ModelTypeformLinkConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  weights?: Maybe<Weights>;
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowNodeSlug?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
  workflowVersionId?: Maybe<Scalars['ID']['output']>;
};


export type CandidateBatchAnalysisRequirementsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchAtsQuestionsArgs = {
  filter?: InputMaybe<ModelAtsQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchAutomationTasksArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchCampaignsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchCandidatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchSelectedCandidateBatchStatusesArgs = {
  filter?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchSourcedCandidatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchTypeformLinksArgs = {
  filter?: InputMaybe<ModelTypeformLinkFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CandidateBatchCountField {
  CandidatesCount = 'candidatesCount',
  RemainingRescoredCandidatesCount = 'remainingRescoredCandidatesCount'
}

export type CandidateBatchCountFieldInput = {
  field: CandidateBatchCountField;
  value: Scalars['Int']['input'];
};

export type CandidateBatchCountsOutput = {
  candidatesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  remainingRescoredCandidatesCount: Scalars['Int']['output'];
};

export type CandidateBatchGroup = {
  analysisRequirements?: Maybe<ModelAnalysisRequirementConnection>;
  automationTasks?: Maybe<ModelAutomationTaskConnection>;
  candidateBatches?: Maybe<ModelCandidateBatchConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};


export type CandidateBatchGroupAnalysisRequirementsArgs = {
  filter?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchGroupAutomationTasksArgs = {
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateBatchGroupCandidateBatchesArgs = {
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CandidateBatchStatus {
  Archived = 'ARCHIVED',
  Created = 'CREATED',
  Draft = 'DRAFT',
  FinishedRankingCandidates = 'FINISHED_RANKING_CANDIDATES',
  Live = 'LIVE',
  Paused = 'PAUSED',
  PreProcessing = 'PRE_PROCESSING',
  RankingCandidates = 'RANKING_CANDIDATES',
  ReadyToProcess = 'READY_TO_PROCESS'
}

export type CandidateBlockingDependencies = {
  blockingReason?: Maybe<CandidateBlockingReason>;
  conversationId: Scalars['ID']['output'];
  dependencies: Array<CandidateBlockingDependency>;
};

export type CandidateBlockingDependency = {
  candidateVccStage?: Maybe<Scalars['String']['output']>;
  conversationStatus?: Maybe<ConversationStatus>;
  dependencyCampaignId?: Maybe<Scalars['ID']['output']>;
  dependencyConversationId?: Maybe<Scalars['ID']['output']>;
  hiringManagerEmail: Scalars['String']['output'];
  hiringManagerName?: Maybe<Scalars['String']['output']>;
  lastMessageAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastNudgeAt?: Maybe<Scalars['AWSDateTime']['output']>;
  outreachRoundCount?: Maybe<Scalars['Int']['output']>;
  responseState: HiringManagerResponseState;
  sharedAvailability?: Maybe<Array<AvailabilitySlot>>;
  userCalendarId: Scalars['ID']['output'];
};

export enum CandidateBlockingReason {
  AllRespondedStillBlocked = 'ALL_RESPONDED_STILL_BLOCKED',
  AwaitingFirstReply = 'AWAITING_FIRST_REPLY',
  BlockedOptedOut = 'BLOCKED_OPTED_OUT',
  PartiallyResponded = 'PARTIALLY_RESPONDED'
}

export type CandidateCvsParsing = {
  candidates?: Maybe<ModelCandidateConnection>;
  candidatesCount?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  cvsZipS3Key: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  status?: Maybe<CandidateCvsParsingStatus>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};


export type CandidateCvsParsingCandidatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CandidateCvsParsingStatus {
  Failed = 'FAILED',
  Finished = 'FINISHED',
  Processing = 'PROCESSING',
  Starting = 'STARTING'
}

export type CandidateEmailCorrespondence = {
  atsCandidateId?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  komboCandidateId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  recipientEmailAddress: Scalars['String']['output'];
  scheduleDelayInHours?: Maybe<Scalars['String']['output']>;
  scheduleId?: Maybe<Scalars['ID']['output']>;
  scheduledAt?: Maybe<Scalars['AWSDateTime']['output']>;
  senderEmailAddress?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sesMessageId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<CorrespondenceStatus>;
  subject: Scalars['String']['output'];
  type?: Maybe<EmailCorrespondenceType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type CandidateMessage = {
  body: Scalars['String']['output'];
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  type: CandidateMessageType;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum CandidateMessageType {
  InterestedMessage = 'INTERESTED_MESSAGE',
  RejectionMessage = 'REJECTION_MESSAGE'
}

export type CandidateNote = {
  candidateId: Scalars['ID']['output'];
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum CandidateOrigin {
  ExternallySourcedViaContactOut = 'EXTERNALLY_SOURCED_VIA_CONTACT_OUT',
  InternallySourcedViaAts = 'INTERNALLY_SOURCED_VIA_ATS',
  NonAtsCvUpload = 'NON_ATS_CV_UPLOAD',
  NonAtsTypeform = 'NON_ATS_TYPEFORM'
}

export type CandidateProfile = {
  analysedApplicationNotes?: Maybe<ModelCandidateNoteConnection>;
  analysedApplications?: Maybe<ModelCandidateConnection>;
  atsApplicationIds?: Maybe<Array<Scalars['ID']['output']>>;
  atsApplications?: Maybe<ModelAtsApplicationConnection>;
  atsCandidateId?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<ModelAttachmentConnection>;
  awards?: Maybe<Array<Scalars['String']['output']>>;
  candidateProfileListMemberships?: Maybe<ModelCandidateProfileListMembershipConnection>;
  candidateProfileNotes?: Maybe<ModelCandidateProfileNoteConnection>;
  candidateProfileVectorId?: Maybe<Scalars['ID']['output']>;
  certifications?: Maybe<Array<Scalars['String']['output']>>;
  company?: Maybe<Scalars['String']['output']>;
  conversations?: Maybe<ModelConversationConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  customFields?: Maybe<Scalars['AWSJSON']['output']>;
  education?: Maybe<Array<Education>>;
  email?: Maybe<Scalars['String']['output']>;
  emailFromCv?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Scalars['String']['output']>>;
  expectedSalaryFromQuestionnaire?: Maybe<ExpectedSalary>;
  externalId?: Maybe<Scalars['String']['output']>;
  externalUrl?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  firstNameFromCv?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  jobs?: Maybe<Array<Job>>;
  komboApplicationIds?: Maybe<Array<Scalars['ID']['output']>>;
  komboCandidateId?: Maybe<Scalars['ID']['output']>;
  languages?: Maybe<Array<Scalars['String']['output']>>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastNameFromCv?: Maybe<Scalars['String']['output']>;
  latestAtsApplicationDate?: Maybe<Scalars['AWSDateTime']['output']>;
  latestAtsApplicationId?: Maybe<Scalars['ID']['output']>;
  latestCvS3Key?: Maybe<Scalars['String']['output']>;
  latestCvText?: Maybe<Scalars['String']['output']>;
  latestKomboApplicationId?: Maybe<Scalars['ID']['output']>;
  linkedInProfileUrl?: Maybe<Scalars['String']['output']>;
  linkedInProfileUrlFromCv?: Maybe<Scalars['String']['output']>;
  linksFromCv?: Maybe<Array<Scalars['String']['output']>>;
  location?: Maybe<Location>;
  locationFromCv?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationGroupId: Scalars['ID']['output'];
  organizationIds: Array<Scalars['ID']['output']>;
  originalSource?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberFromCv?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Scalars['String']['output']>>;
  professionalSummaryFromCv?: Maybe<Scalars['String']['output']>;
  publications?: Maybe<Array<Scalars['String']['output']>>;
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  qualificationsFromCv?: Maybe<Array<Scalars['String']['output']>>;
  questionOutcomes?: Maybe<ModelQuestionOutcomeConnection>;
  relevantExperienceFromQuestionnaire?: Maybe<RelevantExperience>;
  searchCandidateProfileSelectedItems?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  skillsFromCv?: Maybe<Array<Scalars['String']['output']>>;
  socialLinks?: Maybe<Array<Scalars['String']['output']>>;
  sourcedCandidates?: Maybe<ModelSourcedCandidateConnection>;
  status?: Maybe<CandidateProfileSyncStatus>;
  statusChangedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
  totalExperienceInYears?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  /** @deprecated Use WorkflowRun.candidateProfileName/FirstName/LastName with searchWorkflowRuns. This composite is retired once popp-web-v2 stops reading it (PAD-6083 phase 3). */
  workflowRunCandidateProfiles?: Maybe<ModelWorkflowRunCandidateProfileConnection>;
  workflowRuns?: Maybe<ModelWorkflowRunConnection>;
};


export type CandidateProfileAnalysedApplicationNotesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileAnalysedApplicationsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileAtsApplicationsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileAttachmentsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAttachmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileCandidateProfileListMembershipsArgs = {
  candidateProfileListId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileCandidateProfileNotesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileConversationsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileQuestionOutcomesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileSearchCandidateProfileSelectedItemsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileSourcedCandidatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileWorkflowRunCandidateProfilesArgs = {
  filter?: InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type CandidateProfileWorkflowRunsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type CandidateProfileList = {
  candidateProfileListMemberships?: Maybe<ModelCandidateProfileListMembershipConnection>;
  candidateProfilesCount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastApiWriteAt?: Maybe<Scalars['AWSDateTime']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  teamIds?: Maybe<Array<Scalars['ID']['output']>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};


export type CandidateProfileListCandidateProfileListMembershipsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum CandidateProfileListCountField {
  CandidateProfilesCount = 'candidateProfilesCount'
}

export type CandidateProfileListCountFieldInput = {
  field: CandidateProfileListCountField;
  value: Scalars['Int']['input'];
};

export type CandidateProfileListForUser = {
  candidateProfilesCount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  teams: Array<ListTeam>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type CandidateProfileListForUserConnection = {
  items: Array<CandidateProfileListForUser>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CandidateProfileListMembership = {
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId: Scalars['ID']['output'];
  candidateProfileList?: Maybe<CandidateProfileList>;
  candidateProfileListId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type CandidateProfileNote = {
  atsApplicationId?: Maybe<Scalars['String']['output']>;
  atsAuthorId?: Maybe<Scalars['String']['output']>;
  atsCandidateId?: Maybe<Scalars['String']['output']>;
  atsCandidateNoteId?: Maybe<Scalars['String']['output']>;
  atsNoteCreatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsNoteDeletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsNoteUpdatedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId: Scalars['ID']['output'];
  content?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  komboApplicationId?: Maybe<Scalars['String']['output']>;
  komboCandidateId?: Maybe<Scalars['String']['output']>;
  komboCandidateNoteId?: Maybe<Scalars['String']['output']>;
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  organizationGroupId: Scalars['ID']['output'];
  organizationIds: Array<Scalars['ID']['output']>;
  type: NoteType;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum CandidateProfileSyncStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS'
}

export type CandidateRequirement = {
  content: Scalars['String']['output'];
  isMet: Scalars['Boolean']['output'];
};

export type CandidateRequirementInput = {
  content: Scalars['String']['input'];
  isMet: Scalars['Boolean']['input'];
};

export type CandidateScoring = {
  category: ScoringCategory;
  description?: Maybe<Scalars['String']['output']>;
  score: Scalars['Int']['output'];
  scoreScaled: Scalars['Float']['output'];
  scoreWithWeight: Scalars['Float']['output'];
  weight: Scalars['Float']['output'];
};

export type CandidateScoringInput = {
  category: ScoringCategory;
  description?: InputMaybe<Scalars['String']['input']>;
  score: Scalars['Int']['input'];
  scoreScaled: Scalars['Float']['input'];
  scoreWithWeight: Scalars['Float']['input'];
  weight: Scalars['Float']['input'];
};

export enum CandidateSource {
  ExternallySourcedViaContactOut = 'EXTERNALLY_SOURCED_VIA_CONTACT_OUT',
  InternallySourcedViaAts = 'INTERNALLY_SOURCED_VIA_ATS'
}

export enum CandidateStatus {
  InterviewStage_1 = 'INTERVIEW_STAGE_1',
  InterviewStage_2 = 'INTERVIEW_STAGE_2',
  NotProgressing = 'NOT_PROGRESSING',
  Offer = 'OFFER',
  Progressing = 'PROGRESSING',
  Rejected = 'REJECTED',
  Review = 'REVIEW',
  ShortListed = 'SHORT_LISTED'
}

export type CandidateStatusUpdate = {
  candidate?: Maybe<Candidate>;
  candidateBatchId: Scalars['ID']['output'];
  candidateId: Scalars['ID']['output'];
  changeRecord: ChangeRecord;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type CandidateSuggestedTimeSlot = {
  end: Scalars['AWSDateTime']['output'];
  start: Scalars['AWSDateTime']['output'];
};

export type CandidateSuggestedTimeSlotInput = {
  end: Scalars['AWSDateTime']['input'];
  start: Scalars['AWSDateTime']['input'];
};

export type CandidateTag = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  value: Scalars['String']['output'];
  valueNormalized: Scalars['String']['output'];
};

export type CategorizedRequirements = {
  category: ScoringCategory;
  requirements: Array<Scalars['String']['output']>;
};

export type CategorizedRequirementsInput = {
  category: ScoringCategory;
  requirements: Array<Scalars['String']['input']>;
};

export type ChangeRecord = {
  from?: Maybe<Scalars['String']['output']>;
  to: Scalars['String']['output'];
};

export type ChangeRecordInput = {
  from?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export enum Channels {
  Email = 'EMAIL',
  Sms = 'SMS',
  WebChat = 'WEB_CHAT',
  WebChatViaEmail = 'WEB_CHAT_VIA_EMAIL',
  Whatsapp = 'WHATSAPP'
}

export type ClassificationRule = {
  type: ClassificationRuleType;
  value: Scalars['String']['output'];
};

export type ClassificationRuleInput = {
  type: ClassificationRuleType;
  value: Scalars['String']['input'];
};

export enum ClassificationRuleType {
  IncludesField = 'INCLUDES_FIELD'
}

export type ClientApiKey = {
  createdAt: Scalars['AWSDateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  hashedKey: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  partialKey: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
};

export type ClosedQuestion = {
  content: Scalars['String']['output'];
};

export enum ClosingMethod {
  CalendarMeetingIntegration = 'CALENDAR_MEETING_INTEGRATION',
  Custom = 'CUSTOM',
  MeetingUrl = 'MEETING_URL',
  PhoneNumber = 'PHONE_NUMBER'
}

export type ConnectedRecord = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type Conversation = {
  activeChannel?: Maybe<Channels>;
  additionalContext?: Maybe<Scalars['String']['output']>;
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['ID']['output']>;
  applicationSource?: Maybe<Scalars['String']['output']>;
  applicationStage?: Maybe<Scalars['String']['output']>;
  applicationStageUpdates?: Maybe<ModelApplicationStageUpdateConnection>;
  atsApplicationId?: Maybe<Scalars['ID']['output']>;
  atsCandidateId?: Maybe<Scalars['ID']['output']>;
  atsInterviewStageId?: Maybe<Scalars['ID']['output']>;
  atsRejectedReasonId?: Maybe<Scalars['ID']['output']>;
  attachments?: Maybe<ModelAttachmentConnection>;
  calendarBooking?: Maybe<CalendarBooking>;
  calendarBookingId?: Maybe<Scalars['ID']['output']>;
  calendarMeetingTemplateId?: Maybe<Scalars['ID']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidate?: Maybe<Candidate>;
  candidateAvailabilitySuggestions?: Maybe<ModelCandidateAvailabilitySuggestionConnection>;
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  closePreviousConversations?: Maybe<Scalars['Boolean']['output']>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  crmContactId?: Maybe<Scalars['ID']['output']>;
  currentQuestionId?: Maybe<Scalars['String']['output']>;
  disableNudging?: Maybe<Scalars['Boolean']['output']>;
  emailPrefix?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<ConversationErrorCode>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstQuestionHasBeenAsked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isHumanTakeover?: Maybe<Scalars['Boolean']['output']>;
  isInbound?: Maybe<Scalars['Boolean']['output']>;
  isInitialEmailMessageOpened?: Maybe<Scalars['Boolean']['output']>;
  isRead?: Maybe<Scalars['Boolean']['output']>;
  isWebChatJoined?: Maybe<Scalars['Boolean']['output']>;
  komboApplicationId?: Maybe<Scalars['ID']['output']>;
  komboCandidateId?: Maybe<Scalars['ID']['output']>;
  komboRejectionReasonId?: Maybe<Scalars['ID']['output']>;
  komboStageId?: Maybe<Scalars['ID']['output']>;
  meetingBookingStatus?: Maybe<MeetingBookingStatus>;
  messages?: Maybe<ModelMessageConnection>;
  messagesCount?: Maybe<Scalars['Int']['output']>;
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  needsReviewItems?: Maybe<ModelNeedsReviewItemConnection>;
  nudgesSentCount?: Maybe<Scalars['Int']['output']>;
  openQuestionOutcomes?: Maybe<Array<OpenQuestionOutcome>>;
  openingMessage?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  participantEmailAddress?: Maybe<Scalars['String']['output']>;
  participantFirstName?: Maybe<Scalars['String']['output']>;
  participantLastName?: Maybe<Scalars['String']['output']>;
  participantLinkedInProfile?: Maybe<Scalars['String']['output']>;
  participantPhoneNumber?: Maybe<Scalars['String']['output']>;
  pastOngoingConversation?: Maybe<Conversation>;
  pastOngoingConversationId?: Maybe<Scalars['ID']['output']>;
  preferredAnswersScore?: Maybe<Scalars['Float']['output']>;
  previousConversationOutcome?: Maybe<Array<PreviousQuestionAnswer>>;
  questionOutcomes?: Maybe<ModelQuestionOutcomeConnection>;
  repliesCount?: Maybe<Scalars['Int']['output']>;
  screeningQuestionsOutcome?: Maybe<Array<ScreeningQuestionOutcome>>;
  sentAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sourcedCandidate?: Maybe<SourcedCandidate>;
  sourcedCandidateId?: Maybe<Scalars['ID']['output']>;
  stage?: Maybe<ConversationStage>;
  status: ConversationStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tagsNormalized?: Maybe<Array<Scalars['String']['output']>>;
  timeToComplete?: Maybe<Scalars['Float']['output']>;
  timeToFirstResponse?: Maybe<Scalars['Float']['output']>;
  totalNudgesSentCount?: Maybe<Scalars['Int']['output']>;
  twilioConversationId?: Maybe<Scalars['String']['output']>;
  twilioParticipantId?: Maybe<Scalars['String']['output']>;
  twilioRedirectConversationId?: Maybe<Scalars['ID']['output']>;
  twilioRedirectParticipantId?: Maybe<Scalars['ID']['output']>;
  unresolvedNeedsReviewReasons?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  virtualCalendarConversations?: Maybe<ModelVirtualCalendarConversationConnection>;
  webChatUrlId?: Maybe<Scalars['String']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};


export type ConversationApplicationStageUpdatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelApplicationStageUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationAttachmentsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAttachmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationCandidateAvailabilitySuggestionsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationMessagesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationNeedsReviewItemsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelNeedsReviewItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationQuestionOutcomesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type ConversationVirtualCalendarConversationsArgs = {
  filter?: InputMaybe<ModelVirtualCalendarConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userCalendarId?: InputMaybe<ModelIdKeyConditionInput>;
};

export enum ConversationCountField {
  MessagesCount = 'messagesCount',
  NudgesSentCount = 'nudgesSentCount',
  RepliesCount = 'repliesCount',
  TotalNudgesSentCount = 'totalNudgesSentCount'
}

export type ConversationCountFieldInput = {
  field: ConversationCountField;
  value: Scalars['Int']['input'];
};

export enum ConversationErrorCode {
  EmailDeliveryFailed = 'EMAIL_DELIVERY_FAILED',
  InvalidEmailAddress = 'INVALID_EMAIL_ADDRESS',
  InvalidPhoneNumber = 'INVALID_PHONE_NUMBER',
  MissingEmailAddress = 'MISSING_EMAIL_ADDRESS',
  MissingPhoneNumber = 'MISSING_PHONE_NUMBER',
  PhoneDeliveryFailed = 'PHONE_DELIVERY_FAILED'
}

export enum ConversationStage {
  AwaitingBookingUrl = 'AWAITING_BOOKING_URL',
  BookingUrlSent = 'BOOKING_URL_SENT',
  Initial = 'INITIAL'
}

export enum ConversationStatus {
  Completed = 'COMPLETED',
  CompletedAwaitingCall = 'COMPLETED_AWAITING_CALL',
  CompletedCustomRequest = 'COMPLETED_CUSTOM_REQUEST',
  CompletedMeetingRequested = 'COMPLETED_MEETING_REQUESTED',
  CompletedNotInterested = 'COMPLETED_NOT_INTERESTED',
  CompletedRejected = 'COMPLETED_REJECTED',
  Created = 'CREATED',
  DeliveryFailed = 'DELIVERY_FAILED',
  NoReply = 'NO_REPLY',
  Ongoing = 'ONGOING',
  OptedOut = 'OPTED_OUT',
  Queued = 'QUEUED',
  Replied = 'REPLIED',
  ShouldBeSkipped = 'SHOULD_BE_SKIPPED',
  Skipped = 'SKIPPED'
}

export enum CorrespondenceStatus {
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Failed = 'FAILED',
  Paused = 'PAUSED',
  Scheduled = 'SCHEDULED',
  Sent = 'SENT'
}

export type CreateAgentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  personality?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Tone>;
  userId: Scalars['ID']['input'];
};

export type CreateAnalysedApplicationSnapshotInput = {
  analysisErrorCode?: InputMaybe<CandidateAnalysisErrorCode>;
  candidateBatchId: Scalars['ID']['input'];
  candidateId: Scalars['ID']['input'];
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isAllRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  requirementOutcomes: Array<AnalysedApplicationSnapshotRequirementOutcomeInput>;
  screeningAnswers?: InputMaybe<Array<AtsScreeningAnswerInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScoreScaled?: InputMaybe<Scalars['Float']['input']>;
  trigger: AnalysedApplicationSnapshotTrigger;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowNodeId: Scalars['String']['input'];
  workflowNodeLabel?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId: Scalars['ID']['input'];
  workflowVersionNumber: Scalars['Int']['input'];
};

export type CreateAnalysisRequirementInput = {
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  generatedRequirementText?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMandatory: Scalars['Boolean']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  originalRequirementText: Scalars['String']['input'];
  parentAnalysisRequirementId?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<RequirementRecommendationCategory>;
  recommendationText?: InputMaybe<Scalars['String']['input']>;
  requirementMetCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  weight: Scalars['Float']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateApplicationStageUpdateInput = {
  applicationStage: Scalars['String']['input'];
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  stageUpdatedAt: Scalars['AWSDateTime']['input'];
  userId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAtsApplicationForCandidateInput = {
  atsJobId: Scalars['ID']['input'];
  candidateProfileId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  stageId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAtsApplicationForCandidateResult = {
  komboApplicationId?: Maybe<Scalars['ID']['output']>;
  outcome: AtsApplicationCreateOutcome;
};

export type CreateAtsApplicationInput = {
  analysisCandidateId?: InputMaybe<Scalars['ID']['input']>;
  analysisRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  analysisScore?: InputMaybe<Scalars['Int']['input']>;
  analysisScoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  analysisWorkflowNodeId?: InputMaybe<Scalars['ID']['input']>;
  appliedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId: Scalars['ID']['input'];
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentStage?: InputMaybe<Scalars['String']['input']>;
  currentStageId?: InputMaybe<Scalars['ID']['input']>;
  cvFileName?: InputMaybe<Scalars['String']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  cvText?: InputMaybe<Scalars['String']['input']>;
  hiringOutcome?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId: Scalars['ID']['input'];
  organizationGroupId: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds: Array<Scalars['ID']['input']>;
  rejectedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  remoteUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateAtsApplicationScreeningAnswersInput = {
  answers: Array<AtsScreeningAnswerInput>;
  komboApplicationId: Scalars['ID']['input'];
  organizationGroupId: Scalars['ID']['input'];
  organizationIds: Array<Scalars['ID']['input']>;
};

export type CreateAtsBulkSyncErrorInput = {
  atsBulkSyncId: Scalars['ID']['input'];
  atsRecordId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  errorDetails?: InputMaybe<Scalars['AWSJSON']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateAtsBulkSyncInput = {
  atsAccountId: Scalars['String']['input'];
  atsBulkSyncType: AtsBulkSyncType;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nextProcessingToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  recordsAttempted?: InputMaybe<Scalars['Int']['input']>;
  recordsFailed?: InputMaybe<Scalars['Int']['input']>;
  recordsFound?: InputMaybe<Scalars['Int']['input']>;
  recordsSucceeded?: InputMaybe<Scalars['Int']['input']>;
  status: SyncStatus;
  syncCompletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  syncMetadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  syncStartedAt: Scalars['AWSDateTime']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateAtsConfigInput = {
  applicationProxy?: InputMaybe<Scalars['AWSJSON']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobPostingProxy?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateAtsQuestionInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsQuestionId: Scalars['String']['input'];
  atsQuestionOptions?: InputMaybe<Array<AtsQuestionOptionInput>>;
  candidateBatchId: Scalars['ID']['input'];
  category?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  komboQuestionId?: InputMaybe<Scalars['ID']['input']>;
  multipleChoiceAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAttachmentInput = {
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  media: MediaInput;
  organizationId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAutomationTaskEmailTemplateInput = {
  customEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  defaultEmailTemplate: Scalars['String']['input'];
  emailTemplateWithJobBoardLink: Scalars['String']['input'];
  emailTemplateWithPersonalisation: Scalars['String']['input'];
  emailTemplateWithPersonalisationAndJobBoardLink: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  jobRecommendationsEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  jobRecommendationsEmailTemplateWithJobBoardLink?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateAutomationTaskInput = {
  action: AutomationActionInput;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  parentAutomationTaskId?: InputMaybe<Scalars['ID']['input']>;
  requirementConditions: Array<RequirementConditionInput>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAutomationTaskTemplateFromCandidateBatchInput = {
  candidateBatchId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type CreateAutomationTaskTemplateFromCandidateBatchOutput = {
  automationTaskTemplateId: Scalars['ID']['output'];
};

export type CreateAutomationTasksTemplateInput = {
  automationTasks: Array<AutomationTaskItemInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateCalendarBookingInput = {
  bookingParticipants?: InputMaybe<Array<BookingParticipantInput>>;
  calendarMeetingTemplateId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  candidateEmail: Scalars['String']['input'];
  candidateName: Scalars['String']['input'];
  candidateTimeZone?: InputMaybe<Scalars['String']['input']>;
  conferenceUrl?: InputMaybe<Scalars['String']['input']>;
  conversationId: Scalars['ID']['input'];
  endDateTime: Scalars['AWSDateTime']['input'];
  icalUid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  noteTakerId?: InputMaybe<Scalars['ID']['input']>;
  noteTakerMediaTranscriptS3Key?: InputMaybe<Scalars['String']['input']>;
  noteTakerStatus?: InputMaybe<NoteTakerStatus>;
  noteTakerTranscript?: InputMaybe<Array<NoteTakerTranscriptItemInput>>;
  noteTakerTranscriptSummary?: InputMaybe<Scalars['String']['input']>;
  notetakerMediaRecordingS3Key?: InputMaybe<Scalars['String']['input']>;
  nylasBookingId: Scalars['String']['input'];
  nylasBookingRef: Scalars['String']['input'];
  nylasEventId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  organizerUserCalendarId: Scalars['ID']['input'];
  startDateTime: Scalars['AWSDateTime']['input'];
  status: MeetingBookingStatus;
  title?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCalendarMeetingTemplateInput = {
  availabilityMethod?: InputMaybe<AvailabilityMethod>;
  availabilityOutreachSettings?: InputMaybe<AvailabilityOutreachSettingsInput>;
  durationMinutes: Scalars['Int']['input'];
  guestLabel?: InputMaybe<Scalars['String']['input']>;
  hideParticipantEmails?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isSingleUse?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoConference?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  lastUsedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nylasConfigurationId: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  organizerUserCalendarId?: InputMaybe<Scalars['ID']['input']>;
  status: CalendarMeetingTemplateStatus;
  title: Scalars['String']['input'];
  totalBookingsCount?: InputMaybe<Scalars['Int']['input']>;
  updatedByUserId: Scalars['ID']['input'];
};

export type CreateCampaignCandidateInput = {
  campaignId: Scalars['ID']['input'];
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isProcessed?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCampaignCsvKeysInput = {
  campaignId: Scalars['ID']['input'];
  csvS3Key: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCampaignInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsListId?: InputMaybe<Scalars['ID']['input']>;
  averageTimeToComplete?: InputMaybe<Scalars['Float']['input']>;
  averageTimeToFirstResponse?: InputMaybe<Scalars['Float']['input']>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignGroupId?: InputMaybe<Scalars['ID']['input']>;
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Channels>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  closingMethod?: InputMaybe<ClosingMethod>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  conversationCompletedMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  customTemplatedMessage?: InputMaybe<Scalars['String']['input']>;
  customTemplatedSubjectLine?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  followUpMessage?: InputMaybe<Scalars['String']['input']>;
  guestLabel?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialMessagesDeliveredCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesReadCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesSentCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesUndeliveredCount?: InputMaybe<Scalars['Int']['input']>;
  isDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  launchScheduleDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  launchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  messagesProcessedCount?: InputMaybe<Scalars['Int']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nudgeSettings?: InputMaybe<Array<InputMaybe<NudgeSettingInput>>>;
  nudgesCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  periodDays?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Array<QuestionInput>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  requiredHours?: InputMaybe<Scalars['Int']['input']>;
  status: CampaignStatus;
  stoppedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  stoppedByUserId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  timeToAutoCloseConversationsInHours?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalConversationsCount?: InputMaybe<Scalars['Int']['input']>;
  totalConversationsWithRepliesCount?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithCallRequest?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithCustomRequest?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<Scalars['Int']['input']>;
  totalNotInterestedConversationCount?: InputMaybe<Scalars['Int']['input']>;
  totalOptedOutConversationCount?: InputMaybe<Scalars['Int']['input']>;
  totalProspectsCount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CampaignType>;
  userId: Scalars['ID']['input'];
  webChatTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCampaignQuestionInput = {
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hubSpotProperty?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  order: Scalars['Int']['input'];
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCampaignSubscriptionInput = {
  campaignId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateAvailabilitySuggestionInput = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  timeSlots: Array<CandidateSuggestedTimeSlotInput>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCandidateBatchGroupFromCandidateBatchInput = {
  candidateBatchId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CreateCandidateBatchGroupFromCandidateBatchOutput = {
  candidateBatchGroupId: Scalars['ID']['output'];
};

export type CreateCandidateBatchGroupInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobCode?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateBatchInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchReanalysisReferenceId?: InputMaybe<Scalars['ID']['input']>;
  candidatesCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesRequirementsMetCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesRequirementsNotMetCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesToProcessCount?: InputMaybe<Scalars['Int']['input']>;
  categorizedRequirements?: InputMaybe<Array<CategorizedRequirementsInput>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  customJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  cvS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isInitial?: InputMaybe<Scalars['Boolean']['input']>;
  isRecalculatingScores?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription: Scalars['String']['input'];
  jobDescriptionParsed?: InputMaybe<JobDescriptionInput>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  remainingRescoredCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Array<RequirementInput>>;
  rubric?: InputMaybe<RubricInput>;
  screeningQuestions?: InputMaybe<Array<QuestionInput>>;
  status: CandidateBatchStatus;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  weights?: InputMaybe<WeightsInput>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowNodeSlug?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateCvsParsingInput = {
  candidatesCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvsZipS3Key: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  status?: InputMaybe<CandidateCvsParsingStatus>;
  userId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateEmailCorrespondenceInput = {
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  recipientEmailAddress: Scalars['String']['input'];
  scheduleDelayInHours?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sesMessageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CorrespondenceStatus>;
  subject: Scalars['String']['input'];
  type?: InputMaybe<EmailCorrespondenceType>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateInput = {
  analysisErrorCode?: InputMaybe<CandidateAnalysisErrorCode>;
  analysisOutcomeActedOnAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  applicationSource?: InputMaybe<Scalars['String']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsApplicationSource?: InputMaybe<Scalars['String']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsInterviewStageId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsQuestionnaireAnswers?: InputMaybe<Array<AtsQuestionnaireAnswerInput>>;
  atsRejectedReasonId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateCvsParsingId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationPreferredAnswersScore?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvParsedText?: InputMaybe<Scalars['String']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isAllRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isMessagesGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  komboRejectionReasonId?: InputMaybe<Scalars['ID']['input']>;
  komboStageId?: InputMaybe<Scalars['ID']['input']>;
  lastName: Scalars['String']['input'];
  linkedInProfileId?: InputMaybe<Scalars['String']['input']>;
  metRequirementSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId: Scalars['ID']['input'];
  origin?: InputMaybe<CandidateOrigin>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<CandidateRequirementInput>>;
  scoring?: InputMaybe<Array<CandidateScoringInput>>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcedCandidateId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScoreScaled?: InputMaybe<Scalars['Float']['input']>;
  unmetRequirementSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateMessageInput = {
  body: Scalars['String']['input'];
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  type: CandidateMessageType;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateNoteInput = {
  candidateId: Scalars['ID']['input'];
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateProfileInput = {
  atsApplicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  awards?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateProfileVectorId?: InputMaybe<Scalars['ID']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customFields?: InputMaybe<Scalars['AWSJSON']['input']>;
  education?: InputMaybe<Array<EducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailFromCv?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedSalaryFromQuestionnaire?: InputMaybe<ExpectedSalaryInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameFromCv?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  jobs?: InputMaybe<Array<JobInput>>;
  komboApplicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameFromCv?: InputMaybe<Scalars['String']['input']>;
  latestAtsApplicationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  latestAtsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  latestCvS3Key?: InputMaybe<Scalars['String']['input']>;
  latestCvText?: InputMaybe<Scalars['String']['input']>;
  latestKomboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  linkedInProfileUrl?: InputMaybe<Scalars['String']['input']>;
  linkedInProfileUrlFromCv?: InputMaybe<Scalars['String']['input']>;
  linksFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<LocationInput>;
  locationFromCv?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationIds: Array<Scalars['ID']['input']>;
  originalSource?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberFromCv?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  professionalSummaryFromCv?: InputMaybe<Scalars['String']['input']>;
  publications?: InputMaybe<Array<Scalars['String']['input']>>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  qualificationsFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  relevantExperienceFromQuestionnaire?: InputMaybe<RelevantExperienceInput>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  skillsFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  socialLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CandidateProfileSyncStatus>;
  statusChangedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalExperienceInYears?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateCandidateProfileListForUserInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
};

export type CreateCandidateProfileListInput = {
  candidateProfilesCount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastApiWriteAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  organizationId: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateCandidateProfileListMembershipInput = {
  candidateProfileId: Scalars['ID']['input'];
  candidateProfileListId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateCandidateProfileNoteInput = {
  atsApplicationId?: InputMaybe<Scalars['String']['input']>;
  atsAuthorId?: InputMaybe<Scalars['String']['input']>;
  atsCandidateId?: InputMaybe<Scalars['String']['input']>;
  atsCandidateNoteId?: InputMaybe<Scalars['String']['input']>;
  atsNoteCreatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsNoteDeletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsNoteUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  candidateProfileId: Scalars['ID']['input'];
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['String']['input']>;
  komboCandidateId?: InputMaybe<Scalars['String']['input']>;
  komboCandidateNoteId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationIds: Array<Scalars['ID']['input']>;
  type: NoteType;
};

export type CreateCandidateStatusUpdateInput = {
  candidateBatchId: Scalars['ID']['input'];
  candidateId: Scalars['ID']['input'];
  changeRecord: ChangeRecordInput;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCandidateTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
  valueNormalized: Scalars['String']['input'];
};

export type CreateClientApiKeyInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  enabled: Scalars['Boolean']['input'];
  expiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hashedKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  partialKey: Scalars['String']['input'];
  userId: Scalars['ID']['input'];
};

export type CreateConversationInput = {
  activeChannel?: InputMaybe<Channels>;
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  applicationSource?: InputMaybe<Scalars['String']['input']>;
  applicationStage?: InputMaybe<Scalars['String']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsInterviewStageId?: InputMaybe<Scalars['ID']['input']>;
  atsRejectedReasonId?: InputMaybe<Scalars['ID']['input']>;
  calendarBookingId?: InputMaybe<Scalars['ID']['input']>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  closePreviousConversations?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  crmContactId?: InputMaybe<Scalars['ID']['input']>;
  currentQuestionId?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  emailPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<ConversationErrorCode>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstQuestionHasBeenAsked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isHumanTakeover?: InputMaybe<Scalars['Boolean']['input']>;
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  isInitialEmailMessageOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isWebChatJoined?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  komboRejectionReasonId?: InputMaybe<Scalars['ID']['input']>;
  komboStageId?: InputMaybe<Scalars['ID']['input']>;
  meetingBookingStatus?: InputMaybe<MeetingBookingStatus>;
  messagesCount?: InputMaybe<Scalars['Int']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nudgesSentCount?: InputMaybe<Scalars['Int']['input']>;
  openQuestionOutcomes?: InputMaybe<Array<OpenQuestionOutcomeInput>>;
  openingMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  participantEmailAddress?: InputMaybe<Scalars['String']['input']>;
  participantFirstName?: InputMaybe<Scalars['String']['input']>;
  participantLastName?: InputMaybe<Scalars['String']['input']>;
  participantLinkedInProfile?: InputMaybe<Scalars['String']['input']>;
  participantPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pastOngoingConversationId?: InputMaybe<Scalars['ID']['input']>;
  preferredAnswersScore?: InputMaybe<Scalars['Float']['input']>;
  previousConversationOutcome?: InputMaybe<Array<PreviousQuestionAnswerInput>>;
  repliesCount?: InputMaybe<Scalars['Int']['input']>;
  screeningQuestionsOutcome?: InputMaybe<Array<ScreeningQuestionOutcomeInput>>;
  sentAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sourcedCandidateId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<ConversationStage>;
  status: ConversationStatus;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsNormalized?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToComplete?: InputMaybe<Scalars['Float']['input']>;
  timeToFirstResponse?: InputMaybe<Scalars['Float']['input']>;
  totalNudgesSentCount?: InputMaybe<Scalars['Int']['input']>;
  twilioConversationId?: InputMaybe<Scalars['String']['input']>;
  twilioParticipantId?: InputMaybe<Scalars['String']['input']>;
  twilioRedirectConversationId?: InputMaybe<Scalars['ID']['input']>;
  twilioRedirectParticipantId?: InputMaybe<Scalars['ID']['input']>;
  unresolvedNeedsReviewReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId: Scalars['ID']['input'];
  webChatUrlId?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateDocumentCredentialInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  encryptedToken: Scalars['String']['input'];
  headerTokenKey: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationGroupId: Scalars['ID']['input'];
};

export type CreateDocumentTypeInput = {
  classificationRules?: InputMaybe<Array<ClassificationRuleInput>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedInCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  validation?: InputMaybe<Array<DocumentValidationCheck>>;
  validationSettings?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateDocumentTypeRelationshipsInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentTypeId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateIntegrationCredentialsInput = {
  appSubdomain?: InputMaybe<Scalars['String']['input']>;
  atsApplicationsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsCandidatesLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsInstanceId?: InputMaybe<Scalars['String']['input']>;
  atsJobsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsListsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hubSpotAccessToken?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  komboIntegrationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
  stackOneAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateJobPostingInput = {
  atsJobId: Scalars['ID']['input'];
  atsJobPostingId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobDescription: Scalars['String']['input'];
  jobPostingUrl: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  normalisedJobDescription?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  status: Scalars['String']['input'];
};

export type CreateJobPostingRecommendationInput = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  jobPostingId: Scalars['ID']['input'];
  jobRecommendationSummary: Scalars['String']['input'];
};

export type CreateMessageInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  body: Scalars['String']['input'];
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  deliveredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  emailDeliveryEvent?: InputMaybe<EmailDeliveryEvent>;
  emailSubjectLine?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isFallback?: InputMaybe<Scalars['Boolean']['input']>;
  isInitial?: InputMaybe<Scalars['Boolean']['input']>;
  isNegativeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  messageUnansweredQuestionId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  outreachQuestionId?: InputMaybe<Scalars['ID']['input']>;
  rawBody?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sender: Sender;
  sentimentName?: InputMaybe<SentimentName>;
  sesEmailId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageStatus>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateMessageValues?: InputMaybe<Array<TemplateMessageValueInput>>;
  twilioErrorCode?: InputMaybe<Scalars['String']['input']>;
  twilioMessageId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateNeedsReviewItemInput = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationId: Scalars['ID']['input'];
  reason: Scalars['String']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateOptOutEmailAddressInput = {
  emailAddress: Scalars['String']['input'];
  emailIdentity: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateOptOutPhoneNumberInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type CreateOrganizationConfigInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  allowWhatsAppForAtsListCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  availableLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  defaultAutomationTaskTemplateId?: InputMaybe<Scalars['ID']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFooterHtml?: InputMaybe<Scalars['String']['input']>;
  globalContext?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  internalSourcingAddToJobActionUrl?: InputMaybe<Scalars['String']['input']>;
  internalSourcingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  internalSourcingProtectedCharacteristics?: InputMaybe<Scalars['AWSJSON']['input']>;
  openingMessageMode?: InputMaybe<OpeningMessageMode>;
  organizationId: Scalars['ID']['input'];
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  sourcingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timeToAutoCloseConversationsInHours?: InputMaybe<Scalars['Int']['input']>;
  webhookJobSyncingFlowEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabelSettings?: InputMaybe<WhiteLabelSettingsInput>;
  whiteLabelingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CreateOrganizationCustomFieldConfigInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  displayAs?: InputMaybe<CustomFieldDisplay>;
  fieldKey: Scalars['String']['input'];
  hasFixedOptions: Scalars['Boolean']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label: Scalars['String']['input'];
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  retiredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type: CustomFieldType;
  vectorDbKey: Scalars['String']['input'];
};

export type CreateOrganizationCustomFieldInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  displayAs?: InputMaybe<CustomFieldDisplay>;
  fieldKey: Scalars['String']['input'];
  hasFixedOptions: Scalars['Boolean']['input'];
  label: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  type: CustomFieldType;
};

export type CreateOrganizationGroupInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOrganizationInput = {
  alphaSenderID?: InputMaybe<Scalars['String']['input']>;
  campaignEmailAddress?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  channelsEnabled?: InputMaybe<Array<Channels>>;
  emailIdentity?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasCalendarIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  initialWhatsAppTemplatesBatchStatus?: InputMaybe<InitialWhatsAppTemplatesBatchStatus>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSandbox?: InputMaybe<Scalars['Boolean']['input']>;
  jobRecommendationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationAtsConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationOrganizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationTwilioAccountCredentialsId?: InputMaybe<Scalars['ID']['input']>;
  sandboxExpiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sandboxStatus?: InputMaybe<SandboxStatus>;
  twilioInboundPhoneNumberAnswers?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioInboundPhoneNumberQuestions?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioPhoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioSenderStatus?: InputMaybe<TwilioSenderStatus>;
  usersCount?: InputMaybe<Scalars['Int']['input']>;
  vectorDbTenantName?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  whatsAppBusinessAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOrganizationWebhookInput = {
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  signingSecret: Scalars['String']['input'];
  subscribedEvents?: InputMaybe<Array<WebhookEventType>>;
  url: Scalars['AWSURL']['input'];
};

export type CreateOutreachQuestionInput = {
  answerRoutes?: InputMaybe<Scalars['AWSJSON']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  content: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentItems?: InputMaybe<Array<DocumentItemInput>>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedAnswer?: InputMaybe<QuestionExpectedAnswer>;
  hasPreferredAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  preferredAnswerRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredAnswerText?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<QuestionType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  strictness?: InputMaybe<QuestionStrictness>;
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreatePlanMembershipInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  messagesLimit?: InputMaybe<Scalars['Int']['input']>;
  messagesUsage?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  plan?: InputMaybe<Plan>;
  product?: InputMaybe<SubscriptionProduct>;
  scoringLimit?: InputMaybe<Scalars['Int']['input']>;
  scoringUsage?: InputMaybe<Scalars['Int']['input']>;
  sourcingUsage?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<PlanStatus>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeProductName?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  usersCountLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreatePreferencesInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<Role>;
  tone?: InputMaybe<Tone>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateProfileDataInput = {
  data: Scalars['AWSJSON']['input'];
  profileId: Scalars['String']['input'];
};

export type CreateQualificationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  qualification: Scalars['String']['input'];
  vectorDbTenantName: Scalars['String']['input'];
};

export type CreateQuestionOutcomeInput = {
  agentMessageId?: InputMaybe<Scalars['ID']['input']>;
  answerPolarity?: InputMaybe<Scalars['String']['input']>;
  answerProgress?: InputMaybe<Array<AnswerProgressInput>>;
  answerState: AnswerState;
  answerSummary?: InputMaybe<Scalars['String']['input']>;
  answerText?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId: Scalars['ID']['input'];
  classifiedDocumentString?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentType?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentTypeId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentFileName?: InputMaybe<Scalars['String']['input']>;
  documentS3Key?: InputMaybe<Scalars['String']['input']>;
  documentTwilioMediaSid?: InputMaybe<Scalars['String']['input']>;
  evaluationResult: QuestionEvaluationResult;
  evidence?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isMet?: InputMaybe<Scalars['Boolean']['input']>;
  neededReview?: InputMaybe<Scalars['Boolean']['input']>;
  neededReviewReason?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  outreachQuestionId: Scalars['ID']['input'];
  preferredAnswerEvaluations?: InputMaybe<Array<PreferredAnswerEvaluationInput>>;
  prospectMessageId?: InputMaybe<Scalars['ID']['input']>;
  questionContent?: InputMaybe<Scalars['String']['input']>;
  questionSlug?: InputMaybe<Scalars['String']['input']>;
  routeTaken?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  trafficLight?: InputMaybe<TrafficLight>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateRequirementOutcomeInput = {
  analysisRequirementId: Scalars['ID']['input'];
  candidateBatchId: Scalars['ID']['input'];
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  evidence: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isMet: Scalars['Boolean']['input'];
  organizationId: Scalars['ID']['input'];
  requirementSlug?: InputMaybe<Scalars['String']['input']>;
  scoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  scoringConfigurationDigest?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSandboxAccountInput = {
  email: Scalars['AWSEmail']['input'];
  name: Scalars['String']['input'];
  organizationName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type CreateSandboxAccountResult = {
  clientApiKey: GenerateClientApiKeyResult;
  organization: Organization;
  user: User;
};

export type CreateSearchCandidateProfileMessageInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  generatedSemanticSearchFilters?: InputMaybe<GeneratedSemanticSearchFiltersInput>;
  generatedSemanticSearchQuery?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isOverwritten?: InputMaybe<Scalars['Boolean']['input']>;
  normalisedQueryUserBody?: InputMaybe<Scalars['String']['input']>;
  optimisedSemanticMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  searchCandidateProfileQueryId: Scalars['ID']['input'];
  semanticQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  sender: SearchCandidateProfileMessageSender;
};

export type CreateSearchCandidateProfileQueryInput = {
  appliedFilter?: InputMaybe<Scalars['AWSJSON']['input']>;
  ats_candidate_id?: InputMaybe<Scalars['String']['input']>;
  candidate_profile_list_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  current_company?: InputMaybe<Scalars['String']['input']>;
  current_job_title?: InputMaybe<Scalars['String']['input']>;
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['AWSJSON']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  generatedFilter?: InputMaybe<Scalars['AWSJSON']['input']>;
  geo_coordinates?: InputMaybe<GeoCoordinatesInput>;
  geo_radius?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  original_source?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  returnedCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  time_in_role?: InputMaybe<Array<TimeComparison>>;
  total_years_of_experience?: InputMaybe<Scalars['Float']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateSearchCandidateProfileSelectedInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateSearchCandidateProfileSelectedItemInput = {
  candidateProfileId: Scalars['ID']['input'];
  candidateRelevance?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customInvitationMessage?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  searchCandidateProfileSelectedId: Scalars['ID']['input'];
};

export type CreateSearchPeopleQueryFieldsInput = {
  accumulated_results?: InputMaybe<Scalars['Int']['input']>;
  candidateBatchId: Scalars['ID']['input'];
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  company_filter?: InputMaybe<TimeFilterType>;
  company_size?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  current_company_only?: InputMaybe<Scalars['Boolean']['input']>;
  current_titles_only?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Array<Scalars['String']['input']>>;
  education?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_companies?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_job_titles?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  include_related_job_titles?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  job_title?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  match_experience?: InputMaybe<TimeFilterType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  total_results?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  years_in_current_role?: InputMaybe<Array<Scalars['String']['input']>>;
  years_of_experience?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSelectedCandidateBatchStatusesInput = {
  campaignId: Scalars['ID']['input'];
  candidateBatchId: Scalars['ID']['input'];
  candidateStatuses: Array<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSimulationConversationInput = {
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentQuestionId?: InputMaybe<Scalars['String']['input']>;
  firstQuestionHasBeenAsked?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<ConversationStage>;
  status: ConversationStatus;
};

export type CreateSimulationMessageInput = {
  body: Scalars['String']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  rawBody?: InputMaybe<Scalars['String']['input']>;
  sender: Sender;
  simulationId: Scalars['ID']['input'];
  userId: Scalars['String']['input'];
};

export type CreateSkillInput = {
  description: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  normalizedSkill?: InputMaybe<Scalars['String']['input']>;
  skill: Scalars['String']['input'];
  vectorDbTenantName: Scalars['String']['input'];
};

export type CreateSourcedCandidateInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId: Scalars['ID']['input'];
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateRelevance?: InputMaybe<Scalars['String']['input']>;
  contactOutRawData?: InputMaybe<Scalars['AWSJSON']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationNeedsReview?: InputMaybe<Scalars['Boolean']['input']>;
  conversationRepliesCount?: InputMaybe<Scalars['Int']['input']>;
  conversationStatus?: InputMaybe<ConversationStatus>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customInvitationMessage?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fetchPhoneNumberAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInProfileUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  personalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source: CandidateSource;
  status: SourcedCandidateStatus;
  title?: InputMaybe<Scalars['String']['input']>;
  workEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateStatusSetInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  statuses: Array<StatusInput>;
};

export type CreateTagInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  tag: Scalars['String']['input'];
  vectorDbTenantName: Scalars['String']['input'];
};

export type CreateTeamInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationGroupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateTeamMembershipInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  teamId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId: Scalars['ID']['input'];
};

export type CreateTwilioAccountCredentialsInput = {
  accountSid: Scalars['ID']['input'];
  alphaSenderMessagingServiceId?: InputMaybe<Scalars['ID']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  authToken: Scalars['String']['input'];
  chatServiceSid: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  inboundChatServiceId?: InputMaybe<Scalars['ID']['input']>;
  messagingServiceSid?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
};

export type CreateTypeformLinkInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  url: Scalars['String']['input'];
};

export type CreateTypeformRecordInput = {
  formId: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  type: TypeformRecordType;
};

export type CreateUnansweredQuestionInput = {
  associatedMessageId: Scalars['ID']['input'];
  campaignId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isAnswered?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  summary: Scalars['String']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserCalendarInput = {
  availabilityRedirectCalendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId: Scalars['ID']['input'];
  email: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  isSharedMailbox?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  nylasGrantId?: InputMaybe<Scalars['String']['input']>;
  nylasVirtualCalendarId?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  provider?: InputMaybe<UserCalendarProvider>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status: UserCalendarStatus;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateUserCalendarMeetingTemplateInput = {
  autoCollectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityOutreachSettings?: InputMaybe<AvailabilityOutreachSettingsInput>;
  calendarMeetingTemplateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userCalendarId: Scalars['ID']['input'];
};

export type CreateUserCalendarOrganizationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  userCalendarId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserInput = {
  correspondenceEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  email: Scalars['AWSEmail']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  invitedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboard?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastLoginAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingTourStatus?: InputMaybe<OnboardingTourStatus>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationGroupRole?: InputMaybe<OrganizationGroupRole>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role: UserRole;
  twilioPhoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  userPlanMembershipId?: InputMaybe<Scalars['ID']['input']>;
  userPreferencesId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateUserOrganizationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
  role: UserRole;
  userId: Scalars['ID']['input'];
};

export type CreateVirtualCalendarConversationInput = {
  calendarMeetingTemplateId: Scalars['ID']['input'];
  conversationId: Scalars['ID']['input'];
  conversationStage: ConversationStage;
  conversationStatus: ConversationStatus;
  id?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  userCalendarId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWhatsaapTemplateInput = {
  campaignType?: InputMaybe<CampaignType>;
  channel?: InputMaybe<Channels>;
  content: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  isLinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  mapping: Array<TemplateMappingInput>;
  organizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationConfigWhatsAppTemplatesId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  twilioContentTemplateId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TemplateType>;
  variablesCount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWorkflowAtsJobInput = {
  atsJobId: Scalars['ID']['input'];
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  atsJobTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvRequired?: InputMaybe<Scalars['Boolean']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  stageFilter?: InputMaybe<WorkflowAtsStageFilterInput>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type CreateWorkflowContactImportInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  emailColumn?: InputMaybe<Scalars['String']['input']>;
  externalIdColumn?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  firstFailedRowNumber?: InputMaybe<Scalars['Int']['input']>;
  firstNameColumn?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  importedByUserId?: InputMaybe<Scalars['ID']['input']>;
  lastNameColumn?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumberColumn?: InputMaybe<Scalars['String']['input']>;
  rowsImported?: InputMaybe<Scalars['Int']['input']>;
  rowsInFile?: InputMaybe<Scalars['Int']['input']>;
  s3ETag?: InputMaybe<Scalars['String']['input']>;
  s3Key: Scalars['String']['input'];
  status: WorkflowContactImportStatus;
  tagColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type CreateWorkflowContactInput = {
  alreadyEnrolledRunId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dedupKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolmentFailureReason?: InputMaybe<StartWorkflowRunRejectionReason>;
  entrySource?: InputMaybe<WorkflowTriggerSource>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceRow?: InputMaybe<Scalars['AWSJSON']['input']>;
  status: WorkflowContactStatus;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  validationErrors?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowContactImportId?: InputMaybe<Scalars['ID']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateWorkflowEventInput = {
  analysedApplicationId?: InputMaybe<Scalars['ID']['input']>;
  calendarBookingId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  causationId?: InputMaybe<Scalars['String']['input']>;
  contextSnapshot?: InputMaybe<Scalars['AWSJSON']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventData: Scalars['AWSJSON']['input'];
  eventSource: Scalars['String']['input'];
  eventType: Scalars['String']['input'];
  eventVersion: Scalars['String']['input'];
  failureReason?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  processedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  status: WorkflowEventStatus;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowExternalId?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId: Scalars['ID']['input'];
  workflowVersionId: Scalars['ID']['input'];
};

export type CreateWorkflowFromApiInput = {
  configuration: Scalars['AWSJSON']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  settings?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type CreateWorkflowInput = {
  apiModifiedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  canvasVisualConfiguration?: InputMaybe<Scalars['AWSJSON']['input']>;
  canvasVisualConfigurationModifiedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  configuration?: InputMaybe<Scalars['AWSJSON']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId: Scalars['ID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  embeddedAtsJobId?: InputMaybe<Scalars['String']['input']>;
  entrySources?: InputMaybe<Array<WorkflowTriggerSource>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  liveWorkflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  organizationId: Scalars['ID']['input'];
  settings?: InputMaybe<Scalars['AWSJSON']['input']>;
  status: WorkflowStatus;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type CreateWorkflowRunCandidateProfileInput = {
  candidateProfileFirstName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileId: Scalars['ID']['input'];
  candidateProfileLastName?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentNodeId?: InputMaybe<Scalars['String']['input']>;
  hasPartialFailures?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowRunId: Scalars['ID']['input'];
  workflowRunStatus: WorkflowRunStatus;
  workflowVersionId: Scalars['ID']['input'];
  workflowVersionNumber: Scalars['Int']['input'];
};

export type CreateWorkflowRunInput = {
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  cancellationCode?: InputMaybe<WorkflowRunCancellationCode>;
  candidateProfileFirstName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileId: Scalars['ID']['input'];
  candidateProfileLastName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileName?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  context: Scalars['AWSJSON']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentNodeId?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorReason?: InputMaybe<Scalars['String']['input']>;
  failedNodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasPartialFailures?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  inFlightNodeId?: InputMaybe<Scalars['String']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  lastFailedNodeId?: InputMaybe<Scalars['String']['input']>;
  latestAnalysisNodeSlug?: InputMaybe<Scalars['String']['input']>;
  latestAnalysisRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  latestAnalysisScore?: InputMaybe<Scalars['Int']['input']>;
  latestAnalysisScoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nodeExecutionState?: InputMaybe<NodeExecutionState>;
  organizationId: Scalars['ID']['input'];
  runVersion: Scalars['Int']['input'];
  status: WorkflowRunStatus;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsNormalized?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowVersionId: Scalars['ID']['input'];
  workflowVersionNumber: Scalars['Int']['input'];
};

export type CreateWorkflowStatsInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastFailureAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastRunCompletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastRunStartedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  liveWorkflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  liveWorkflowVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  totalActiveRunCount: Scalars['Int']['input'];
  totalCancelledCount: Scalars['Int']['input'];
  totalCompletedCount: Scalars['Int']['input'];
  totalFailedCount: Scalars['Int']['input'];
  totalNeedsReviewCount: Scalars['Int']['input'];
  totalRunCount: Scalars['Int']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type CreateWorkflowVersionInput = {
  activeRunCount: Scalars['Int']['input'];
  archivedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cancelledCount: Scalars['Int']['input'];
  canvasVisualConfiguration?: InputMaybe<Scalars['AWSJSON']['input']>;
  changeNotes?: InputMaybe<Scalars['String']['input']>;
  completedCount: Scalars['Int']['input'];
  configuration: Scalars['AWSJSON']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  entrySources?: InputMaybe<Array<WorkflowTriggerSource>>;
  failedCount: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  needsReviewCount: Scalars['Int']['input'];
  organizationId: Scalars['ID']['input'];
  publishedAt: Scalars['AWSDateTime']['input'];
  publishedByUserId: Scalars['ID']['input'];
  runCount: Scalars['Int']['input'];
  status: WorkflowVersionStatus;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  versionNumber: Scalars['Int']['input'];
  workflowId: Scalars['ID']['input'];
};

export type CreateWorkflowVersionNodeStatsInput = {
  activeCount: Scalars['Int']['input'];
  awaitingCount?: InputMaybe<Scalars['Int']['input']>;
  completedCount: Scalars['Int']['input'];
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  enteredCount: Scalars['Int']['input'];
  failedCount: Scalars['Int']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  lastActivityAt: Scalars['AWSDateTime']['input'];
  nodeId: Scalars['String']['input'];
  nodeType: WorkflowNodeType;
  organizationId: Scalars['ID']['input'];
  stats?: InputMaybe<Scalars['AWSJSON']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId: Scalars['ID']['input'];
  workflowVersionId: Scalars['ID']['input'];
};

export enum CustomFieldDisplay {
  Age = 'AGE',
  Date = 'DATE'
}

export enum CustomFieldType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Number = 'NUMBER',
  Text = 'TEXT',
  TextArray = 'TEXT_ARRAY'
}

export enum CustomTemplatedMessageVariables {
  AgentName = 'AGENT_NAME',
  CampaignOwnerName = 'CAMPAIGN_OWNER_NAME',
  CandidateFirstName = 'CANDIDATE_FIRST_NAME',
  CandidateLastName = 'CANDIDATE_LAST_NAME',
  CandidateRelevance = 'CANDIDATE_RELEVANCE',
  EmployerName = 'EMPLOYER_NAME',
  InterviewerName = 'INTERVIEWER_NAME',
  JobApplicationUrl = 'JOB_APPLICATION_URL',
  JobTitle = 'JOB_TITLE',
  Location = 'LOCATION',
  MeetingAvailabilityText = 'MEETING_AVAILABILITY_TEXT',
  MeetingTitle = 'MEETING_TITLE',
  MeetingUrl = 'MEETING_URL',
  OrganizationName = 'ORGANIZATION_NAME'
}

export type DeactivateUserInput = {
  userId: Scalars['ID']['input'];
};

export type DeactivateUserOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type DecrementCandidateProfileListCountInput = {
  candidateProfileId: Scalars['ID']['input'];
  decrements: Array<CandidateProfileListCountFieldInput>;
  id: Scalars['ID']['input'];
};

export type DecrementCandidateProfileListCountResult = {
  candidateProfilesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DeleteAgentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAnalysedApplicationSnapshotInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAnalysisRequirementInput = {
  id: Scalars['ID']['input'];
};

export type DeleteApplicationStageUpdateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAtsApplicationInput = {
  komboApplicationId: Scalars['ID']['input'];
};

export type DeleteAtsApplicationScreeningAnswersInput = {
  komboApplicationId: Scalars['ID']['input'];
};

export type DeleteAtsBulkSyncErrorInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAtsBulkSyncInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAtsConfigInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAtsQuestionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAttachmentInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAutomationTaskEmailTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAutomationTaskInput = {
  id: Scalars['ID']['input'];
};

export type DeleteAutomationTasksTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCalendarBookingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCalendarMeetingTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignCandidateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignCsvKeysInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignQuestionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCampaignSubscriptionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateAvailabilitySuggestionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateBatchGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateBatchInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateCvsParsingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateEmailCorrespondenceInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateMessageInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateNoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateProfileInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateProfileListInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateProfileListMembershipInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateProfileNoteInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateStatusUpdateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteCandidateTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteClientApiKeyInput = {
  hashedKey: Scalars['String']['input'];
};

export type DeleteConversationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentCredentialInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentTypeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteDocumentTypeRelationshipsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteIntegrationCredentialsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobPostingInput = {
  id: Scalars['ID']['input'];
};

export type DeleteJobPostingRecommendationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMessageInput = {
  id: Scalars['ID']['input'];
};

export type DeleteNeedsReviewItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOptOutEmailAddressInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOptOutPhoneNumberInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationConfigInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationCustomFieldConfigInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationGroupInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOrganizationWebhookInput = {
  id: Scalars['ID']['input'];
};

export type DeleteOutreachQuestionInput = {
  id: Scalars['ID']['input'];
};

export type DeletePlanMembershipInput = {
  id: Scalars['ID']['input'];
};

export type DeletePreferencesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteProfileDataInput = {
  profileId: Scalars['String']['input'];
};

export type DeleteQualificationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteQuestionOutcomeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRequirementOutcomeInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSearchCandidateProfileMessageInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSearchCandidateProfileQueryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSearchCandidateProfileSelectedInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSearchCandidateProfileSelectedItemInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSearchPeopleQueryFieldsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSelectedCandidateBatchStatusesInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSimulationConversationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSimulationMessageInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSkillInput = {
  id: Scalars['ID']['input'];
};

export type DeleteSourcedCandidateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteStatusSetInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTagInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTeamInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTeamMembershipInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTwilioAccountCredentialsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTypeformLinkInput = {
  id: Scalars['ID']['input'];
};

export type DeleteTypeformRecordInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUnansweredQuestionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserCalendarInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserCalendarMeetingTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserCalendarOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserInput = {
  id: Scalars['ID']['input'];
};

export type DeleteUserOrganizationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteVirtualCalendarConversationInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWhatsaapTemplateInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowAtsJobInput = {
  atsJobId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type DeleteWorkflowContactImportInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowContactInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowEventInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowRunCandidateProfileInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowRunInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowStatsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowVersionInput = {
  id: Scalars['ID']['input'];
};

export type DeleteWorkflowVersionNodeStatsInput = {
  id: Scalars['ID']['input'];
};

export type DetectBiasedSearchResult = {
  biasPrediction: BiasPrediction;
  intentPrediction?: Maybe<IntentPrediction>;
  message?: Maybe<Scalars['String']['output']>;
  queryIsBiased: Scalars['Boolean']['output'];
};

export enum DocumentAnswerStatus {
  FailedValidation = 'FAILED_VALIDATION',
  NoActivity = 'NO_ACTIVITY',
  RefusedUpload = 'REFUSED_UPLOAD',
  SuccessfullyUploaded = 'SUCCESSFULLY_UPLOADED'
}

export type DocumentCredential = {
  createdAt: Scalars['AWSDateTime']['output'];
  encryptedToken: Scalars['String']['output'];
  headerTokenKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationGroupId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type DocumentItem = {
  documentTypeId: Scalars['ID']['output'];
  documentTypeName?: Maybe<Scalars['String']['output']>;
};

export type DocumentItemInput = {
  documentTypeId: Scalars['ID']['input'];
  documentTypeName?: InputMaybe<Scalars['String']['input']>;
};

export type DocumentType = {
  classificationRules?: Maybe<Array<ClassificationRule>>;
  createdAt: Scalars['AWSDateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isUsedInCampaign?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  relationships?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
  validation?: Maybe<Array<DocumentValidationCheck>>;
  validationSettings?: Maybe<Scalars['AWSJSON']['output']>;
};


export type DocumentTypeRelationshipsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type DocumentTypeRelationships = {
  campaignId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  documentType?: Maybe<DocumentType>;
  documentTypeId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
};

export enum DocumentValidationCheck {
  CheckDateOfBirthInclusion = 'CHECK_DATE_OF_BIRTH_INCLUSION',
  CheckDocumentCornerInclusion = 'CHECK_DOCUMENT_CORNER_INCLUSION',
  CheckExpirationDate = 'CHECK_EXPIRATION_DATE',
  CheckHomeAddressInclusion = 'CHECK_HOME_ADDRESS_INCLUSION',
  CheckIssueDate = 'CHECK_ISSUE_DATE',
  CheckNameMatch = 'CHECK_NAME_MATCH'
}

export type DuplicateContactInRequest = {
  contactIndex: Scalars['Int']['output'];
  email?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstSeenAtIndex: Scalars['Int']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export type EditCampaignInfoInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  jobDescriptionParsed?: InputMaybe<EditJobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditCampaignInfoOutput = {
  message: Scalars['String']['output'];
};

export type EditDocumentTypeInput = {
  classificationRules?: InputMaybe<Array<ClassificationRuleInput>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  validation?: InputMaybe<Array<DocumentValidationCheck>>;
  validationSettings?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type EditJobDescriptionParsedInput = {
  contractType?: InputMaybe<Scalars['String']['input']>;
  employerName: Scalars['String']['input'];
  location: Scalars['String']['input'];
};

export type EditWorkflowContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowContactId: Scalars['ID']['input'];
};

export type Education = {
  completionDate?: Maybe<Scalars['AWSDateTime']['output']>;
  course: Scalars['String']['output'];
  grade?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<Scalars['String']['output']>;
};

export type EducationInput = {
  completionDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  course: Scalars['String']['input'];
  grade?: InputMaybe<Scalars['String']['input']>;
  institution?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailCorrespondenceType {
  CandidateRejectionEmail = 'CANDIDATE_REJECTION_EMAIL',
  JobRecommendationEmail = 'JOB_RECOMMENDATION_EMAIL'
}

export enum EmailDeliveryEvent {
  Complaint = 'COMPLAINT',
  Delivered = 'DELIVERED'
}

export type EnrolWorkflowContactsInput = {
  workflowId: Scalars['ID']['input'];
};

export type EnrolWorkflowContactsResult = {
  accepted: Scalars['Int']['output'];
  eligible: Scalars['Int']['output'];
  startedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
};

export type ExpectedSalary = {
  convertedExpectedSalaryAmount?: Maybe<ExpectedSalaryAmount>;
  convertedExpectedSalaryCurrency?: Maybe<Scalars['String']['output']>;
  expectedSalaryAmount?: Maybe<ExpectedSalaryAmount>;
  expectedSalaryCurrency?: Maybe<Scalars['String']['output']>;
};

export type ExpectedSalaryAmount = {
  maximum?: Maybe<Scalars['Float']['output']>;
  minimum?: Maybe<Scalars['Float']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
};

export type ExpectedSalaryAmountInput = {
  maximum?: InputMaybe<Scalars['Float']['input']>;
  minimum?: InputMaybe<Scalars['Float']['input']>;
  rawText?: InputMaybe<Scalars['String']['input']>;
};

export type ExpectedSalaryInput = {
  convertedExpectedSalaryAmount?: InputMaybe<ExpectedSalaryAmountInput>;
  convertedExpectedSalaryCurrency?: InputMaybe<Scalars['String']['input']>;
  expectedSalaryAmount?: InputMaybe<ExpectedSalaryAmountInput>;
  expectedSalaryCurrency?: InputMaybe<Scalars['String']['input']>;
};

export type ExportAllAnalysisDataOutput = {
  message: Scalars['String']['output'];
};

export type ExportAllCampaignsDataOutput = {
  url: Scalars['String']['output'];
};

export type ExportAllCampaignsDataV2Output = {
  message: Scalars['String']['output'];
};

export type ExportAnalysisDataOutput = {
  url: Scalars['String']['output'];
};

export type ExportCampaignDataOutput = {
  message?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use message field. Export is now async and delivers results via email. */
  url?: Maybe<Scalars['String']['output']>;
};

export type GenerateAdjustedAnalysisRequirementInput = {
  analysisRequirementText: Scalars['String']['input'];
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory: RequirementRecommendationCategory;
  recommendationText: Scalars['String']['input'];
};

export type GenerateAdjustedAnalysisRequirementOutput = {
  adjustedAnalysisRequirementText: Array<Scalars['String']['output']>;
  adjustmentExplanationText: Scalars['String']['output'];
};

export type GenerateAnalysisRequirementRecommendationInput = {
  analysisRequirementText: Scalars['String']['input'];
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
};

export type GenerateAnalysisRequirementRecommendationOutput = {
  isCompliant: Scalars['Boolean']['output'];
  recommendationCategory?: Maybe<RequirementRecommendationCategory>;
  recommendationText?: Maybe<Scalars['String']['output']>;
};

export type GenerateCandidateProfileRelevanceInput = {
  channel?: InputMaybe<Channels>;
  customTemplatedMessage: Scalars['String']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  jobDescriptionText: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  searchCandidateProfileSelectedItemId: Scalars['ID']['input'];
};

export type GenerateCandidateProfileRelevanceOutput = {
  candidateRelevance: Scalars['String']['output'];
};

export type GenerateCandidateRelevanceInput = {
  channel?: InputMaybe<Channels>;
  customTemplatedMessage: Scalars['String']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  jobDescriptionText: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  sourcedCandidateId: Scalars['ID']['input'];
};

export type GenerateCandidateRelevanceOutput = {
  candidateRelevance: Scalars['String']['output'];
};

export type GenerateClientApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateClientApiKeyResult = {
  clientApiKey: ClientApiKey;
  generatedClientApiKey: Scalars['String']['output'];
};

export type GenerateEmailOutput = {
  emailAddress?: Maybe<Scalars['AWSEmail']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  profileUrl: Scalars['AWSURL']['output'];
};

export type GenerateJobRequirementsResolverResponse = {
  requirements?: Maybe<Array<Requirement>>;
};

export type GeneratePreferredAnswerRequirementsResponse = {
  statements?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateQuestionsResponse = {
  closedQuestions: Array<ClosedQuestion>;
  openEndedQuestions: Array<OpenEndedQuestion>;
};

export type GenerateSearchPeopleQueryFieldsInput = {
  candidateBatchId: Scalars['ID']['input'];
  jobDescription: Scalars['String']['input'];
};

export type GenerateSearchPeopleQueryFieldsResponse = {
  company?: Maybe<Array<Scalars['String']['output']>>;
  company_filter?: Maybe<TimeFilterType>;
  company_size?: Maybe<Array<Scalars['String']['output']>>;
  current_titles_only?: Maybe<Scalars['Boolean']['output']>;
  education?: Maybe<Array<Scalars['String']['output']>>;
  exclude_companies?: Maybe<Array<Scalars['String']['output']>>;
  exclude_job_titles?: Maybe<Array<Scalars['String']['output']>>;
  id?: Maybe<Scalars['ID']['output']>;
  include_related_job_titles?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<Array<Scalars['String']['output']>>;
  job_title?: Maybe<Array<Scalars['String']['output']>>;
  keyword?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Scalars['String']['output']>>;
  name?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  years_in_current_role?: Maybe<Array<Scalars['String']['output']>>;
  years_of_experience?: Maybe<Array<Scalars['String']['output']>>;
};

export type GenerateSourcingTemplateInput = {
  channel: Channels;
  employerName: Scalars['String']['input'];
  jobDescription: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
};

export type GenerateSourcingTemplateOutput = {
  template: Scalars['String']['output'];
};

export type GenerateVectorSearchQuestionsInput = {
  body: Scalars['String']['input'];
};

export type GenerateVectorSearchQuestionsOutput = {
  content: Scalars['String']['output'];
};

export type GenerateVectorSearchReplyInput = {
  candidateProfileIds: Array<Scalars['ID']['input']>;
  searchCandidateProfileQueryId: Scalars['ID']['input'];
  totalCandidatesCount: Scalars['Int']['input'];
};

export type GenerateVectorSearchReplyOutput = {
  newAgentMessage: SearchCandidateProfileMessage;
};

export type GeneratedSemanticDateComparison = {
  endDate?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
};

export type GeneratedSemanticDateComparisonInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
};

export type GeneratedSemanticSearchFilters = {
  current_company?: Maybe<Array<Scalars['String']['output']>>;
  current_job_title?: Maybe<Scalars['String']['output']>;
  current_role_start_date?: Maybe<Array<GeneratedSemanticDateComparison>>;
  job_titles?: Maybe<Array<Scalars['String']['output']>>;
  location_name?: Maybe<Array<Scalars['String']['output']>>;
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
};

export type GeneratedSemanticSearchFiltersInput = {
  current_company?: InputMaybe<Array<Scalars['String']['input']>>;
  current_job_title?: InputMaybe<Scalars['String']['input']>;
  current_role_start_date?: InputMaybe<Array<GeneratedSemanticDateComparisonInput>>;
  job_titles?: InputMaybe<Array<Scalars['String']['input']>>;
  location_name?: InputMaybe<Array<Scalars['String']['input']>>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GeoCoordinates = {
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeoCoordinatesInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type GetAnalysisNodeMoveOnCountInput = {
  workflowId: Scalars['ID']['input'];
  workflowNodeSlug: Scalars['String']['input'];
};

export type GetAnalysisNodeSummaryInput = {
  workflowId: Scalars['ID']['input'];
  workflowNodeSlug: Scalars['String']['input'];
};

export type GetAutomationTasksByAutomationTypeOutput = {
  automationTasks: Array<AutomationTask>;
};

export type GetCampaignSubscribersOutput = {
  items: Array<CampaignSubscriber>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type GetFormattedPhoneNumberOutput = {
  countryCode?: Maybe<Scalars['String']['output']>;
  formattedPhoneNumber?: Maybe<Scalars['String']['output']>;
};

export type GetJobDescriptionOutput = {
  jobDescription?: Maybe<JobDescription>;
  questions?: Maybe<Array<Maybe<Question>>>;
};

export type GetMediaDownloadUrlOutput = {
  url: Scalars['String']['output'];
};

export type GetOutreachQuestionsResolverResponse = {
  outreachDescription: Scalars['String']['output'];
  outreachQuestions: Array<Question>;
};

export type GetStripeCustomerPortalOutput = {
  url?: Maybe<Scalars['String']['output']>;
};

export type GetUserRelationshipToOrganizationOutput = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationGroupId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  role: UserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type GetUsersForOrganizationOutput = {
  items: Array<OrganizationUserItem>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type GlobalSignOutInput = {
  userId: Scalars['ID']['input'];
};

export type GlobalSignOutOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type HideOrganizationInput = {
  organizationId: Scalars['ID']['input'];
};

export type HideOrganizationResult = {
  hiddenAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
};

export enum HiringManagerResponseState {
  AwaitingReply = 'AWAITING_REPLY',
  NotStarted = 'NOT_STARTED',
  OptedOut = 'OPTED_OUT',
  Responded = 'RESPONDED'
}

export type IncrementAnalysisRequirementCountsInput = {
  id: Scalars['ID']['input'];
  increments: Array<AnalysisRequirementCountFieldInput>;
};

export type IncrementCampaignCountsInput = {
  id: Scalars['ID']['input'];
  increments: Array<CampaignCountFieldInput>;
};

export type IncrementCampaignCountsResult = {
  id: Scalars['ID']['output'];
  initialMessagesDeliveredCount: Scalars['Int']['output'];
  initialMessagesReadCount: Scalars['Int']['output'];
  initialMessagesSentCount: Scalars['Int']['output'];
  initialMessagesUndeliveredCount: Scalars['Int']['output'];
  messagesProcessedCount: Scalars['Int']['output'];
  totalConversationsCount: Scalars['Int']['output'];
  totalConversationsWithRepliesCount: Scalars['Int']['output'];
  totalMessagesCount: Scalars['Int']['output'];
  totalMessagesWithCallRequest: Scalars['Int']['output'];
  totalMessagesWithCustomRequest: Scalars['Int']['output'];
  totalMessagesWithMeetingUrlCount: Scalars['Int']['output'];
  totalNotInterestedConversationCount: Scalars['Int']['output'];
  totalOptedOutConversationCount: Scalars['Int']['output'];
  totalProspectsCount: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type IncrementCandidateBatchCountsInput = {
  id: Scalars['ID']['input'];
  increments: Array<CandidateBatchCountFieldInput>;
};

export type IncrementCandidateProfileListCountInput = {
  candidateProfileId: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  increments: Array<CandidateProfileListCountFieldInput>;
};

export type IncrementCandidateProfileListCountResult = {
  candidateProfilesCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type IncrementConversationCountsInput = {
  id: Scalars['ID']['input'];
  increments: Array<ConversationCountFieldInput>;
};

export type IncrementConversationCountsResult = {
  messagesCount: Scalars['Int']['output'];
  nudgesSentCount: Scalars['Int']['output'];
  repliesCount: Scalars['Int']['output'];
  totalNudgesSentCount: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum InitialWhatsAppTemplatesBatchStatus {
  Approved = 'APPROVED',
  Pending = 'PENDING',
  Rejected = 'REJECTED'
}

export type InitializeCampaignInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentId: Scalars['ID']['input'];
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsListId?: InputMaybe<Scalars['ID']['input']>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidatesSelectedIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  channel?: InputMaybe<Channels>;
  closePreviousConversations?: InputMaybe<Scalars['Boolean']['input']>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  closingMethod: ClosingMethod;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  customTemplatedMessage?: InputMaybe<Scalars['String']['input']>;
  customTemplatedSubjectLine?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  followUpMessage?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  nudgesCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  questions?: InputMaybe<Array<InputMaybe<QuestionInput>>>;
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  timeToAutoCloseConversationsInHours?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type: CampaignType;
  userId: Scalars['ID']['input'];
  webChatTemplateId?: InputMaybe<Scalars['ID']['input']>;
};

export type InitializeCampaignWithParticipantsInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  campaignGroupId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Channels>;
  closeOngoingConversations?: InputMaybe<Scalars['Boolean']['input']>;
  customTemplatedMessage?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  existingCampaignId?: InputMaybe<Scalars['ID']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  parentCampaignId?: InputMaybe<Scalars['ID']['input']>;
  selectedParticipants: Array<SelectedParticipantInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<CampaignType>;
};

export type InitializeCandidateBatchGroupInput = {
  analysisRequirements: Array<AnalysisRequirementCreateInput>;
  automationTasks?: InputMaybe<Array<AutomationTaskInput>>;
  name: Scalars['String']['input'];
};

export type InitializeCandidateBatchInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  atsQuestions?: InputMaybe<Array<AtsQuestionInput>>;
  automationTasks?: InputMaybe<Array<AutomationTaskInput>>;
  candidateBatchId?: InputMaybe<Scalars['String']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  cvS3Keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  jobDescription: Scalars['String']['input'];
  requirements: Array<RequirementInput>;
  rubric?: InputMaybe<RubricInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  weights?: InputMaybe<WeightsInput>;
};

export type InitializeDraftCandidateBatchInput = {
  automationTasks?: InputMaybe<Array<AutomationTaskInput>>;
  candidateBatchId: Scalars['String']['input'];
  requirements: Array<RequirementInput>;
};

export type InitializeSourcedCandidatesCampaignInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentName: Scalars['String']['input'];
  agentTone: Tone;
  campaignType: CampaignType;
  candidateBatchId: Scalars['ID']['input'];
  channel?: InputMaybe<Channels>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  customTemplatedMessage: Scalars['String']['input'];
  customTemplatedSubjectLine: Scalars['String']['input'];
  employerName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  searchCandidateProfileSelectedId?: InputMaybe<Scalars['ID']['input']>;
  sourcedCandidatesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type InitializeVectorSearchSessionInput = {
  body: Scalars['String']['input'];
};

export type InitializeVectorSearchSessionOutput = {
  content: Scalars['String']['output'];
  searchCandidateProfileQueryId: Scalars['ID']['output'];
};

export type IntegrationCredentials = {
  appSubdomain?: Maybe<Scalars['String']['output']>;
  atsApplicationsLastFetchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsCandidatesLastFetchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsInstanceId?: Maybe<Scalars['String']['output']>;
  atsJobsLastFetchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  atsListsLastFetchedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  hubSpotAccessToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isActive?: Maybe<Scalars['Boolean']['output']>;
  komboIntegrationId?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  stackOneAccountId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type IntentPrediction = {
  isCandidateSearch: Scalars['Boolean']['output'];
  reply?: Maybe<Scalars['String']['output']>;
};

export type InviteUserToOrganizationInput = {
  email: Scalars['AWSEmail']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  organizationGroupRole?: InputMaybe<OrganizationGroupRole>;
  organizationId: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  userOrganizationRole: UserRole;
};

export type InviteUserToOrganizationOutput = {
  message?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type Job = {
  companyName?: Maybe<Scalars['String']['output']>;
  currentRole: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['AWSDateTime']['output']>;
  jobTitle: Scalars['String']['output'];
  startDate: Scalars['AWSDateTime']['output'];
};

export type JobDescription = {
  benefits?: Maybe<Scalars['String']['output']>;
  closingDate?: Maybe<Scalars['String']['output']>;
  contractType?: Maybe<Scalars['String']['output']>;
  diversityEqualityInclusion?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  hours?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Scalars['String']['output']>;
  responsibilities?: Maybe<Scalars['String']['output']>;
  salary?: Maybe<Scalars['String']['output']>;
  summaryOfRole?: Maybe<Scalars['String']['output']>;
};

export type JobDescriptionInput = {
  benefits?: InputMaybe<Scalars['String']['input']>;
  closingDate?: InputMaybe<Scalars['String']['input']>;
  contractType?: InputMaybe<Scalars['String']['input']>;
  diversityEqualityInclusion?: InputMaybe<Scalars['String']['input']>;
  employerName?: InputMaybe<Scalars['String']['input']>;
  hours?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Scalars['String']['input']>;
  responsibilities?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['String']['input']>;
  summaryOfRole?: InputMaybe<Scalars['String']['input']>;
};

export type JobDescriptionParsed = {
  contractType?: Maybe<Scalars['String']['output']>;
  employerName: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  location: Scalars['String']['output'];
  summaryOfRole?: Maybe<Scalars['String']['output']>;
};

export type JobDescriptionParsedInput = {
  contractType?: InputMaybe<Scalars['String']['input']>;
  employerName: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  location: Scalars['String']['input'];
  summaryOfRole?: InputMaybe<Scalars['String']['input']>;
};

export type JobInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  currentRole: Scalars['Boolean']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  jobTitle: Scalars['String']['input'];
  startDate: Scalars['AWSDateTime']['input'];
};

export type JobPosting = {
  JobPostingRecommendations?: Maybe<ModelJobPostingRecommendationConnection>;
  atsJobId: Scalars['ID']['output'];
  atsJobPostingId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobDescription: Scalars['String']['output'];
  jobPostingUrl: Scalars['String']['output'];
  jobTitle: Scalars['String']['output'];
  komboJobId?: Maybe<Scalars['ID']['output']>;
  normalisedJobDescription?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type JobPostingJobPostingRecommendationsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type JobPostingRecommendation = {
  candidate?: Maybe<Candidate>;
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  jobPosting?: Maybe<JobPosting>;
  jobPostingId: Scalars['ID']['output'];
  jobRecommendationSummary: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type ListAtsJobStagesInput = {
  atsJobId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};

export type ListAtsJobsInput = {
  filter?: InputMaybe<AtsJobFilterInput>;
  next?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  pageSize?: InputMaybe<Scalars['Int']['input']>;
};

export type ListAtsJobsResult = {
  jobs: Array<AtsJob>;
  next?: Maybe<Scalars['String']['output']>;
};

export type ListAtsRejectionReasonsInput = {
  organizationId: Scalars['ID']['input'];
};

export type ListTeam = {
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ListTeamConnection = {
  items: Array<ListTeam>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  geoCoordinates?: Maybe<GeoCoordinates>;
  name?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
};

export type LocationAutocompleteInput = {
  query: Scalars['String']['input'];
};

export type LocationAutocompleteOutput = {
  locations: Array<LocationAutocompleteResult>;
};

export type LocationAutocompleteResult = {
  coordinates: GeoCoordinates;
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  placeId: Scalars['String']['output'];
  searchRadiusMeters: Scalars['Float']['output'];
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  geoCoordinates?: InputMaybe<GeoCoordinatesInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
};

export type Media = {
  audioTranscription?: Maybe<Scalars['String']['output']>;
  classifiedDocumentString?: Maybe<Scalars['String']['output']>;
  classifiedDocumentType?: Maybe<Scalars['String']['output']>;
  classifiedDocumentTypes?: Maybe<Array<Scalars['String']['output']>>;
  contentType: Scalars['String']['output'];
  documentTypeId?: Maybe<Scalars['ID']['output']>;
  fileName: Scalars['String']['output'];
  s3Key?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['Int']['output']>;
  twilioMediaSid?: Maybe<Scalars['String']['output']>;
};

export type MediaInput = {
  audioTranscription?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentString?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentType?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  contentType: Scalars['String']['input'];
  documentTypeId?: InputMaybe<Scalars['ID']['input']>;
  fileName: Scalars['String']['input'];
  s3Key?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  twilioMediaSid?: InputMaybe<Scalars['String']['input']>;
};

export enum MeetingBookingStatus {
  Cancelled = 'CANCELLED',
  Rescheduled = 'RESCHEDULED',
  ReschedulingRequested = 'RESCHEDULING_REQUESTED',
  Scheduled = 'SCHEDULED'
}

export type Message = {
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['ID']['output']>;
  body: Scalars['String']['output'];
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  deliveredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  emailDeliveryEvent?: Maybe<EmailDeliveryEvent>;
  emailSubjectLine?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isEmailOpened?: Maybe<Scalars['Boolean']['output']>;
  isFallback?: Maybe<Scalars['Boolean']['output']>;
  isInitial?: Maybe<Scalars['Boolean']['output']>;
  isNegativeSentiment?: Maybe<Scalars['Boolean']['output']>;
  media?: Maybe<Media>;
  messageUnansweredQuestionId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  outreachQuestionId?: Maybe<Scalars['ID']['output']>;
  rawBody?: Maybe<Scalars['String']['output']>;
  readAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sender: Sender;
  sentimentName?: Maybe<SentimentName>;
  sesEmailId?: Maybe<Scalars['String']['output']>;
  status?: Maybe<MessageStatus>;
  template?: Maybe<WhatsaapTemplate>;
  templateId?: Maybe<Scalars['ID']['output']>;
  templateMessageValues?: Maybe<Array<TemplateMessageValue>>;
  twilioErrorCode?: Maybe<Scalars['String']['output']>;
  twilioMessageId?: Maybe<Scalars['String']['output']>;
  unansweredQuestion?: Maybe<UnansweredQuestion>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum MessageStatus {
  NotSent = 'NOT_SENT',
  Read = 'READ',
  ReceivedSuccess = 'RECEIVED_SUCCESS',
  Sent = 'SENT',
  SentFailed = 'SENT_FAILED',
  SentSkipped = 'SENT_SKIPPED',
  SentSuccess = 'SENT_SUCCESS'
}

export type ModelAgentConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAgentConditionInput>>>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAgentConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAgentConditionInput>>>;
  organizationConfigId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  personality?: InputMaybe<ModelStringInput>;
  tone?: InputMaybe<ModelToneInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelAgentConnection = {
  items: Array<Maybe<Agent>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAgentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAgentFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAgentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAgentFilterInput>>>;
  organizationConfigId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  personality?: InputMaybe<ModelStringInput>;
  tone?: InputMaybe<ModelToneInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelAnalysedApplicationSnapshotConditionInput = {
  analysisErrorCode?: InputMaybe<ModelCandidateAnalysisErrorCodeInput>;
  and?: InputMaybe<Array<InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  isAllRequirementsMet?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  totalScore?: InputMaybe<ModelFloatInput>;
  totalScoreScaled?: InputMaybe<ModelFloatInput>;
  trigger?: InputMaybe<ModelAnalysedApplicationSnapshotTriggerInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowNodeLabel?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelAnalysedApplicationSnapshotConnection = {
  items: Array<Maybe<AnalysedApplicationSnapshot>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAnalysedApplicationSnapshotFilterInput = {
  analysisErrorCode?: InputMaybe<ModelCandidateAnalysisErrorCodeInput>;
  and?: InputMaybe<Array<InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isAllRequirementsMet?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  totalScore?: InputMaybe<ModelFloatInput>;
  totalScoreScaled?: InputMaybe<ModelFloatInput>;
  trigger?: InputMaybe<ModelAnalysedApplicationSnapshotTriggerInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowNodeLabel?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelAnalysedApplicationSnapshotTriggerInput = {
  eq?: InputMaybe<AnalysedApplicationSnapshotTrigger>;
  ne?: InputMaybe<AnalysedApplicationSnapshotTrigger>;
};

export type ModelAnalysisRequirementConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAnalysisRequirementConditionInput>>>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  generatedRequirementText?: InputMaybe<ModelStringInput>;
  isMandatory?: InputMaybe<ModelBooleanInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  isRecommendationDismissed?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAnalysisRequirementConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAnalysisRequirementConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  originalRequirementText?: InputMaybe<ModelStringInput>;
  parentAnalysisRequirementId?: InputMaybe<ModelIdInput>;
  recommendationCategory?: InputMaybe<ModelRequirementRecommendationCategoryInput>;
  recommendationText?: InputMaybe<ModelStringInput>;
  requirementMetCandidatesCount?: InputMaybe<ModelIntInput>;
  slug?: InputMaybe<ModelStringInput>;
  weight?: InputMaybe<ModelFloatInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAnalysisRequirementConnection = {
  items: Array<Maybe<AnalysisRequirement>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAnalysisRequirementFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAnalysisRequirementFilterInput>>>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  generatedRequirementText?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isMandatory?: InputMaybe<ModelBooleanInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  isRecommendationDismissed?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAnalysisRequirementFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  originalRequirementText?: InputMaybe<ModelStringInput>;
  parentAnalysisRequirementId?: InputMaybe<ModelIdInput>;
  recommendationCategory?: InputMaybe<ModelRequirementRecommendationCategoryInput>;
  recommendationText?: InputMaybe<ModelStringInput>;
  requirementMetCandidatesCount?: InputMaybe<ModelIntInput>;
  slug?: InputMaybe<ModelStringInput>;
  weight?: InputMaybe<ModelFloatInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAnswerStateInput = {
  eq?: InputMaybe<AnswerState>;
  ne?: InputMaybe<AnswerState>;
};

export type ModelApplicationStageUpdateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelApplicationStageUpdateConditionInput>>>;
  applicationStage?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelApplicationStageUpdateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelApplicationStageUpdateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  stageUpdatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelApplicationStageUpdateConnection = {
  items: Array<Maybe<ApplicationStageUpdate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelApplicationStageUpdateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelApplicationStageUpdateFilterInput>>>;
  applicationStage?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelApplicationStageUpdateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelApplicationStageUpdateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  stageUpdatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAtsApplicationConditionInput = {
  analysisCandidateId?: InputMaybe<ModelIdInput>;
  analysisRequirementsMet?: InputMaybe<ModelBooleanInput>;
  analysisScore?: InputMaybe<ModelIntInput>;
  analysisScoredAt?: InputMaybe<ModelStringInput>;
  analysisWorkflowNodeId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelAtsApplicationConditionInput>>>;
  appliedAt?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentStage?: InputMaybe<ModelStringInput>;
  currentStageId?: InputMaybe<ModelIdInput>;
  cvFileName?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  cvText?: InputMaybe<ModelStringInput>;
  hiringOutcome?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAtsApplicationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsApplicationConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  rejectedAt?: InputMaybe<ModelStringInput>;
  rejectionReason?: InputMaybe<ModelStringInput>;
  remoteUrl?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelAtsApplicationConnection = {
  items: Array<Maybe<AtsApplication>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsApplicationFilterInput = {
  analysisCandidateId?: InputMaybe<ModelIdInput>;
  analysisRequirementsMet?: InputMaybe<ModelBooleanInput>;
  analysisScore?: InputMaybe<ModelIntInput>;
  analysisScoredAt?: InputMaybe<ModelStringInput>;
  analysisWorkflowNodeId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelAtsApplicationFilterInput>>>;
  appliedAt?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentStage?: InputMaybe<ModelStringInput>;
  currentStageId?: InputMaybe<ModelIdInput>;
  cvFileName?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  cvText?: InputMaybe<ModelStringInput>;
  hiringOutcome?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAtsApplicationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsApplicationFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  rejectedAt?: InputMaybe<ModelStringInput>;
  rejectionReason?: InputMaybe<ModelStringInput>;
  remoteUrl?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelAtsApplicationScreeningAnswersConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>>>;
  not?: InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
};

export type ModelAtsApplicationScreeningAnswersConnection = {
  items: Array<Maybe<AtsApplicationScreeningAnswers>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsApplicationScreeningAnswersFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsApplicationScreeningAnswersFilterInput>>>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAtsApplicationScreeningAnswersFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsApplicationScreeningAnswersFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
};

export type ModelAtsBulkSyncConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncConditionInput>>>;
  atsAccountId?: InputMaybe<ModelStringInput>;
  atsBulkSyncType?: InputMaybe<ModelAtsBulkSyncTypeInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  nextProcessingToken?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsBulkSyncConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  recordsAttempted?: InputMaybe<ModelIntInput>;
  recordsFailed?: InputMaybe<ModelIntInput>;
  recordsFound?: InputMaybe<ModelIntInput>;
  recordsSucceeded?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelSyncStatusInput>;
  syncCompletedAt?: InputMaybe<ModelStringInput>;
  syncMetadata?: InputMaybe<ModelStringInput>;
  syncStartedAt?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelAtsBulkSyncConnection = {
  items: Array<Maybe<AtsBulkSync>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsBulkSyncErrorConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncErrorConditionInput>>>;
  atsBulkSyncId?: InputMaybe<ModelIdInput>;
  atsRecordId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  errorDetails?: InputMaybe<ModelStringInput>;
  errorMessage?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsBulkSyncErrorConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncErrorConditionInput>>>;
  retryCount?: InputMaybe<ModelIntInput>;
};

export type ModelAtsBulkSyncErrorConnection = {
  items: Array<Maybe<AtsBulkSyncError>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsBulkSyncErrorFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncErrorFilterInput>>>;
  atsBulkSyncId?: InputMaybe<ModelIdInput>;
  atsRecordId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  errorDetails?: InputMaybe<ModelStringInput>;
  errorMessage?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAtsBulkSyncErrorFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncErrorFilterInput>>>;
  retryCount?: InputMaybe<ModelIntInput>;
};

export type ModelAtsBulkSyncFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncFilterInput>>>;
  atsAccountId?: InputMaybe<ModelStringInput>;
  atsBulkSyncType?: InputMaybe<ModelAtsBulkSyncTypeInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  nextProcessingToken?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsBulkSyncFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  recordsAttempted?: InputMaybe<ModelIntInput>;
  recordsFailed?: InputMaybe<ModelIntInput>;
  recordsFound?: InputMaybe<ModelIntInput>;
  recordsSucceeded?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelSyncStatusInput>;
  syncCompletedAt?: InputMaybe<ModelStringInput>;
  syncMetadata?: InputMaybe<ModelStringInput>;
  syncStartedAt?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelAtsBulkSyncTypeInput = {
  eq?: InputMaybe<AtsBulkSyncType>;
  ne?: InputMaybe<AtsBulkSyncType>;
};

export type ModelAtsConfigConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsConfigConditionInput>>>;
  applicationProxy?: InputMaybe<ModelStringInput>;
  jobPostingProxy?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsConfigConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsConfigConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelAtsConfigConnection = {
  items: Array<Maybe<AtsConfig>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsConfigFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsConfigFilterInput>>>;
  applicationProxy?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  jobPostingProxy?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsConfigFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsConfigFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelAtsQuestionByOrganizationAtsJobCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>>>;
  eq?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
  ge?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
  gt?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
  le?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
  lt?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput>;
};

export type ModelAtsQuestionByOrganizationAtsJobCompositeKeyInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsQuestionId?: InputMaybe<Scalars['String']['input']>;
};

export type ModelAtsQuestionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsQuestionConditionInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsQuestionId?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  category?: InputMaybe<ModelStringInput>;
  content?: InputMaybe<ModelStringInput>;
  description?: InputMaybe<ModelStringInput>;
  isRequired?: InputMaybe<ModelBooleanInput>;
  komboQuestionId?: InputMaybe<ModelIdInput>;
  multipleChoiceAnswers?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsQuestionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsQuestionConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  questionIndex?: InputMaybe<ModelIntInput>;
  type?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAtsQuestionConnection = {
  items: Array<Maybe<AtsQuestion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAtsQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAtsQuestionFilterInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsQuestionId?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  category?: InputMaybe<ModelStringInput>;
  content?: InputMaybe<ModelStringInput>;
  description?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isRequired?: InputMaybe<ModelBooleanInput>;
  komboQuestionId?: InputMaybe<ModelIdInput>;
  multipleChoiceAnswers?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAtsQuestionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAtsQuestionFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  questionIndex?: InputMaybe<ModelIntInput>;
  type?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAttachmentConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAttachmentConditionInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAttachmentConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAttachmentConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAttachmentConnection = {
  items: Array<Maybe<Attachment>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAttachmentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAttachmentFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAttachmentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAttachmentFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export enum ModelAttributeTypes {
  Null = '_null',
  Binary = 'binary',
  BinarySet = 'binarySet',
  Bool = 'bool',
  List = 'list',
  Map = 'map',
  Number = 'number',
  NumberSet = 'numberSet',
  String = 'string',
  StringSet = 'stringSet'
}

export type ModelAutomationTaskConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTaskConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAutomationTaskConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTaskConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  parentAutomationTaskId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAutomationTaskConnection = {
  items: Array<Maybe<AutomationTask>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAutomationTaskEmailTemplateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>>>;
  customEmailTemplate?: InputMaybe<ModelStringInput>;
  defaultEmailTemplate?: InputMaybe<ModelStringInput>;
  emailTemplateWithJobBoardLink?: InputMaybe<ModelStringInput>;
  emailTemplateWithPersonalisation?: InputMaybe<ModelStringInput>;
  emailTemplateWithPersonalisationAndJobBoardLink?: InputMaybe<ModelStringInput>;
  jobRecommendationsEmailTemplate?: InputMaybe<ModelStringInput>;
  jobRecommendationsEmailTemplateWithJobBoardLink?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelAutomationTaskEmailTemplateConnection = {
  items: Array<Maybe<AutomationTaskEmailTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAutomationTaskEmailTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTaskEmailTemplateFilterInput>>>;
  customEmailTemplate?: InputMaybe<ModelStringInput>;
  defaultEmailTemplate?: InputMaybe<ModelStringInput>;
  emailTemplateWithJobBoardLink?: InputMaybe<ModelStringInput>;
  emailTemplateWithPersonalisation?: InputMaybe<ModelStringInput>;
  emailTemplateWithPersonalisationAndJobBoardLink?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  jobRecommendationsEmailTemplate?: InputMaybe<ModelStringInput>;
  jobRecommendationsEmailTemplateWithJobBoardLink?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAutomationTaskEmailTemplateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTaskEmailTemplateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelAutomationTaskFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTaskFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelAutomationTaskFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTaskFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  parentAutomationTaskId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelAutomationTasksTemplateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTasksTemplateConditionInput>>>;
  description?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelAutomationTasksTemplateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTasksTemplateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  title?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelAutomationTasksTemplateConnection = {
  items: Array<Maybe<AutomationTasksTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelAutomationTasksTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelAutomationTasksTemplateFilterInput>>>;
  description?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelAutomationTasksTemplateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelAutomationTasksTemplateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  title?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelAvailabilityMethodInput = {
  eq?: InputMaybe<AvailabilityMethod>;
  ne?: InputMaybe<AvailabilityMethod>;
};

export type ModelBooleanInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelCalendarBookingConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarBookingConditionInput>>>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateEmail?: InputMaybe<ModelStringInput>;
  candidateName?: InputMaybe<ModelStringInput>;
  candidateTimeZone?: InputMaybe<ModelStringInput>;
  conferenceUrl?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  endDateTime?: InputMaybe<ModelStringInput>;
  icalUid?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCalendarBookingConditionInput>;
  noteTakerId?: InputMaybe<ModelIdInput>;
  noteTakerMediaTranscriptS3Key?: InputMaybe<ModelStringInput>;
  noteTakerStatus?: InputMaybe<ModelNoteTakerStatusInput>;
  noteTakerTranscriptSummary?: InputMaybe<ModelStringInput>;
  notetakerMediaRecordingS3Key?: InputMaybe<ModelStringInput>;
  nylasBookingId?: InputMaybe<ModelStringInput>;
  nylasBookingRef?: InputMaybe<ModelStringInput>;
  nylasEventId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarBookingConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizerUserCalendarId?: InputMaybe<ModelIdInput>;
  startDateTime?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelMeetingBookingStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCalendarBookingConnection = {
  items: Array<Maybe<CalendarBooking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCalendarBookingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarBookingFilterInput>>>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateEmail?: InputMaybe<ModelStringInput>;
  candidateName?: InputMaybe<ModelStringInput>;
  candidateTimeZone?: InputMaybe<ModelStringInput>;
  conferenceUrl?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  endDateTime?: InputMaybe<ModelStringInput>;
  icalUid?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCalendarBookingFilterInput>;
  noteTakerId?: InputMaybe<ModelIdInput>;
  noteTakerMediaTranscriptS3Key?: InputMaybe<ModelStringInput>;
  noteTakerStatus?: InputMaybe<ModelNoteTakerStatusInput>;
  noteTakerTranscriptSummary?: InputMaybe<ModelStringInput>;
  notetakerMediaRecordingS3Key?: InputMaybe<ModelStringInput>;
  nylasBookingId?: InputMaybe<ModelStringInput>;
  nylasBookingRef?: InputMaybe<ModelStringInput>;
  nylasEventId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarBookingFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizerUserCalendarId?: InputMaybe<ModelIdInput>;
  startDateTime?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelMeetingBookingStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCalendarMeetingTemplateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarMeetingTemplateConditionInput>>>;
  availabilityMethod?: InputMaybe<ModelAvailabilityMethodInput>;
  durationMinutes?: InputMaybe<ModelIntInput>;
  guestLabel?: InputMaybe<ModelStringInput>;
  hideParticipantEmails?: InputMaybe<ModelBooleanInput>;
  isSingleUse?: InputMaybe<ModelBooleanInput>;
  isVideoConference?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  lastUsedAt?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCalendarMeetingTemplateConditionInput>;
  nylasConfigurationId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarMeetingTemplateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizerUserCalendarId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelCalendarMeetingTemplateStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  totalBookingsCount?: InputMaybe<ModelIntInput>;
  updatedByUserId?: InputMaybe<ModelIdInput>;
};

export type ModelCalendarMeetingTemplateConnection = {
  items: Array<Maybe<CalendarMeetingTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCalendarMeetingTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCalendarMeetingTemplateFilterInput>>>;
  availabilityMethod?: InputMaybe<ModelAvailabilityMethodInput>;
  durationMinutes?: InputMaybe<ModelIntInput>;
  guestLabel?: InputMaybe<ModelStringInput>;
  hideParticipantEmails?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  isSingleUse?: InputMaybe<ModelBooleanInput>;
  isVideoConference?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  lastUsedAt?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  nylasConfigurationId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCalendarMeetingTemplateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  organizerUserCalendarId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelCalendarMeetingTemplateStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  totalBookingsCount?: InputMaybe<ModelIntInput>;
  updatedByUserId?: InputMaybe<ModelIdInput>;
};

export type ModelCalendarMeetingTemplateStatusInput = {
  eq?: InputMaybe<CalendarMeetingTemplateStatus>;
  ne?: InputMaybe<CalendarMeetingTemplateStatus>;
};

export type ModelCampaignCandidateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignCandidateConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  isProcessed?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCampaignCandidateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignCandidateConditionInput>>>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignCandidateConnection = {
  items: Array<Maybe<CampaignCandidate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCampaignCandidateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignCandidateFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  isProcessed?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCampaignCandidateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignCandidateFilterInput>>>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignConditionInput = {
  additionalContext?: InputMaybe<ModelStringInput>;
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelCampaignConditionInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  atsListId?: InputMaybe<ModelIdInput>;
  averageTimeToComplete?: InputMaybe<ModelFloatInput>;
  averageTimeToFirstResponse?: InputMaybe<ModelFloatInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignGroupId?: InputMaybe<ModelIdInput>;
  cancellationMessage?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  channel?: InputMaybe<ModelChannelsInput>;
  closingMessage?: InputMaybe<ModelStringInput>;
  closingMethod?: InputMaybe<ModelClosingMethodInput>;
  contactNumber?: InputMaybe<ModelStringInput>;
  conversationCompletedMessage?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  customRequest?: InputMaybe<ModelStringInput>;
  customTemplatedMessage?: InputMaybe<ModelStringInput>;
  customTemplatedSubjectLine?: InputMaybe<ModelStringInput>;
  disableNudging?: InputMaybe<ModelBooleanInput>;
  emailChannelFallbackEnabled?: InputMaybe<ModelBooleanInput>;
  externalId?: InputMaybe<ModelStringInput>;
  followUpMessage?: InputMaybe<ModelStringInput>;
  guestLabel?: InputMaybe<ModelStringInput>;
  initialMessagesDeliveredCount?: InputMaybe<ModelIntInput>;
  initialMessagesReadCount?: InputMaybe<ModelIntInput>;
  initialMessagesSentCount?: InputMaybe<ModelIntInput>;
  initialMessagesUndeliveredCount?: InputMaybe<ModelIntInput>;
  isDuplicate?: InputMaybe<ModelBooleanInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  jobDescriptionText?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  language?: InputMaybe<ModelStringInput>;
  launchScheduleDateTime?: InputMaybe<ModelStringInput>;
  launchedAt?: InputMaybe<ModelStringInput>;
  meetingUrl?: InputMaybe<ModelStringInput>;
  messagesProcessedCount?: InputMaybe<ModelIntInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCampaignConditionInput>;
  nudgesCount?: InputMaybe<ModelIntInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachDescription?: InputMaybe<ModelStringInput>;
  owner?: InputMaybe<ModelStringInput>;
  periodDays?: InputMaybe<ModelIntInput>;
  referenceId?: InputMaybe<ModelStringInput>;
  rejectionMessage?: InputMaybe<ModelStringInput>;
  requiredHours?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelCampaignStatusInput>;
  stoppedAt?: InputMaybe<ModelStringInput>;
  stoppedByUserId?: InputMaybe<ModelIdInput>;
  templateId?: InputMaybe<ModelIdInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<ModelFloatInput>;
  title?: InputMaybe<ModelStringInput>;
  totalConversationsCount?: InputMaybe<ModelIntInput>;
  totalConversationsWithRepliesCount?: InputMaybe<ModelIntInput>;
  totalMessagesCount?: InputMaybe<ModelIntInput>;
  totalMessagesWithCallRequest?: InputMaybe<ModelIntInput>;
  totalMessagesWithCustomRequest?: InputMaybe<ModelIntInput>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<ModelIntInput>;
  totalNotInterestedConversationCount?: InputMaybe<ModelIntInput>;
  totalOptedOutConversationCount?: InputMaybe<ModelIntInput>;
  totalProspectsCount?: InputMaybe<ModelIntInput>;
  type?: InputMaybe<ModelCampaignTypeInput>;
  userId?: InputMaybe<ModelIdInput>;
  webChatTemplateId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignConnection = {
  items: Array<Maybe<Campaign>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCampaignCsvKeysConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignCsvKeysConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  isProcessed?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCampaignCsvKeysConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignCsvKeysConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignCsvKeysConnection = {
  items: Array<Maybe<CampaignCsvKeys>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCampaignCsvKeysFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignCsvKeysFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isProcessed?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCampaignCsvKeysFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignCsvKeysFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignFilterInput = {
  additionalContext?: InputMaybe<ModelStringInput>;
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelCampaignFilterInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  atsListId?: InputMaybe<ModelIdInput>;
  averageTimeToComplete?: InputMaybe<ModelFloatInput>;
  averageTimeToFirstResponse?: InputMaybe<ModelFloatInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignGroupId?: InputMaybe<ModelIdInput>;
  cancellationMessage?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  channel?: InputMaybe<ModelChannelsInput>;
  closingMessage?: InputMaybe<ModelStringInput>;
  closingMethod?: InputMaybe<ModelClosingMethodInput>;
  contactNumber?: InputMaybe<ModelStringInput>;
  conversationCompletedMessage?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  customRequest?: InputMaybe<ModelStringInput>;
  customTemplatedMessage?: InputMaybe<ModelStringInput>;
  customTemplatedSubjectLine?: InputMaybe<ModelStringInput>;
  disableNudging?: InputMaybe<ModelBooleanInput>;
  emailChannelFallbackEnabled?: InputMaybe<ModelBooleanInput>;
  externalId?: InputMaybe<ModelStringInput>;
  followUpMessage?: InputMaybe<ModelStringInput>;
  guestLabel?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  initialMessagesDeliveredCount?: InputMaybe<ModelIntInput>;
  initialMessagesReadCount?: InputMaybe<ModelIntInput>;
  initialMessagesSentCount?: InputMaybe<ModelIntInput>;
  initialMessagesUndeliveredCount?: InputMaybe<ModelIntInput>;
  isDuplicate?: InputMaybe<ModelBooleanInput>;
  isParent?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  jobDescriptionText?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  language?: InputMaybe<ModelStringInput>;
  launchScheduleDateTime?: InputMaybe<ModelStringInput>;
  launchedAt?: InputMaybe<ModelStringInput>;
  meetingUrl?: InputMaybe<ModelStringInput>;
  messagesProcessedCount?: InputMaybe<ModelIntInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCampaignFilterInput>;
  nudgesCount?: InputMaybe<ModelIntInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachDescription?: InputMaybe<ModelStringInput>;
  owner?: InputMaybe<ModelStringInput>;
  periodDays?: InputMaybe<ModelIntInput>;
  referenceId?: InputMaybe<ModelStringInput>;
  rejectionMessage?: InputMaybe<ModelStringInput>;
  requiredHours?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelCampaignStatusInput>;
  stoppedAt?: InputMaybe<ModelStringInput>;
  stoppedByUserId?: InputMaybe<ModelIdInput>;
  templateId?: InputMaybe<ModelIdInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<ModelFloatInput>;
  title?: InputMaybe<ModelStringInput>;
  totalConversationsCount?: InputMaybe<ModelIntInput>;
  totalConversationsWithRepliesCount?: InputMaybe<ModelIntInput>;
  totalMessagesCount?: InputMaybe<ModelIntInput>;
  totalMessagesWithCallRequest?: InputMaybe<ModelIntInput>;
  totalMessagesWithCustomRequest?: InputMaybe<ModelIntInput>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<ModelIntInput>;
  totalNotInterestedConversationCount?: InputMaybe<ModelIntInput>;
  totalOptedOutConversationCount?: InputMaybe<ModelIntInput>;
  totalProspectsCount?: InputMaybe<ModelIntInput>;
  type?: InputMaybe<ModelCampaignTypeInput>;
  userId?: InputMaybe<ModelIdInput>;
  webChatTemplateId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignQuestionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignQuestionConditionInput>>>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  hubSpotProperty?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCampaignQuestionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignQuestionConditionInput>>>;
  order?: InputMaybe<ModelIntInput>;
  supportingInformation?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignQuestionConnection = {
  items: Array<Maybe<CampaignQuestion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCampaignQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignQuestionFilterInput>>>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  hubSpotProperty?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCampaignQuestionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignQuestionFilterInput>>>;
  order?: InputMaybe<ModelIntInput>;
  supportingInformation?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignStatusInput = {
  eq?: InputMaybe<CampaignStatus>;
  ne?: InputMaybe<CampaignStatus>;
};

export type ModelCampaignSubscriptionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignSubscriptionConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCampaignSubscriptionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignSubscriptionConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignSubscriptionConnection = {
  items: Array<Maybe<CampaignSubscription>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCampaignSubscriptionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCampaignSubscriptionFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCampaignSubscriptionFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCampaignTypeInput = {
  eq?: InputMaybe<CampaignType>;
  ne?: InputMaybe<CampaignType>;
};

export type ModelCandidateAnalysisErrorCodeInput = {
  eq?: InputMaybe<CandidateAnalysisErrorCode>;
  ne?: InputMaybe<CandidateAnalysisErrorCode>;
};

export type ModelCandidateAvailabilitySuggestionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>>>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>;
  notes?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  timezone?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateAvailabilitySuggestionConnection = {
  items: Array<Maybe<CandidateAvailabilitySuggestion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateAvailabilitySuggestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>>>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>;
  notes?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  timezone?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateBatchConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateBatchConditionInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  atsJobPostingUrl?: InputMaybe<ModelStringInput>;
  atsJobReference?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchReanalysisReferenceId?: InputMaybe<ModelIdInput>;
  candidatesCount?: InputMaybe<ModelIntInput>;
  candidatesRequirementsMetCount?: InputMaybe<ModelIntInput>;
  candidatesRequirementsNotMetCount?: InputMaybe<ModelIntInput>;
  candidatesToProcessCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  customJobPostingUrl?: InputMaybe<ModelStringInput>;
  cvS3Keys?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  isInitial?: InputMaybe<ModelBooleanInput>;
  isRecalculatingScores?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateBatchConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateBatchConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  remainingRescoredCandidatesCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelCandidateBatchStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowNodeSlug?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateBatchConnection = {
  items: Array<Maybe<CandidateBatch>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateBatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateBatchFilterInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  atsJobPostingUrl?: InputMaybe<ModelStringInput>;
  atsJobReference?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchGroupId?: InputMaybe<ModelIdInput>;
  candidateBatchReanalysisReferenceId?: InputMaybe<ModelIdInput>;
  candidatesCount?: InputMaybe<ModelIntInput>;
  candidatesRequirementsMetCount?: InputMaybe<ModelIntInput>;
  candidatesRequirementsNotMetCount?: InputMaybe<ModelIntInput>;
  candidatesToProcessCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  csvS3Key?: InputMaybe<ModelStringInput>;
  customJobPostingUrl?: InputMaybe<ModelStringInput>;
  cvS3Keys?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isInitial?: InputMaybe<ModelBooleanInput>;
  isRecalculatingScores?: InputMaybe<ModelBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelBooleanInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateBatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateBatchFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  remainingRescoredCandidatesCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelCandidateBatchStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowNodeSlug?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateBatchGroupConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateBatchGroupConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  jobCode?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateBatchGroupConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateBatchGroupConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateBatchGroupConnection = {
  items: Array<Maybe<CandidateBatchGroup>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateBatchGroupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateBatchGroupFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  jobCode?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateBatchGroupFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateBatchStatusInput = {
  eq?: InputMaybe<CandidateBatchStatus>;
  ne?: InputMaybe<CandidateBatchStatus>;
};

export type ModelCandidateConditionInput = {
  analysisErrorCode?: InputMaybe<ModelCandidateAnalysisErrorCodeInput>;
  analysisOutcomeActedOnAt?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelCandidateConditionInput>>>;
  applicationSource?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsApplicationSource?: InputMaybe<ModelStringInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsInterviewStageId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateCvsParsingId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationPreferredAnswersScore?: InputMaybe<ModelFloatInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvParsedText?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  isAllRequirementsMet?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isLocked?: InputMaybe<ModelBooleanInput>;
  isMessagesGenerating?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelIdInput>;
  komboStageId?: InputMaybe<ModelIdInput>;
  lastName?: InputMaybe<ModelStringInput>;
  linkedInProfileId?: InputMaybe<ModelStringInput>;
  metRequirementSlugs?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  origin?: InputMaybe<ModelCandidateOriginInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  sourcedCandidateId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelStringInput>;
  totalScore?: InputMaybe<ModelFloatInput>;
  totalScoreScaled?: InputMaybe<ModelFloatInput>;
  unmetRequirementSlugs?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateConnection = {
  items: Array<Maybe<Candidate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateCvsParsingConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateCvsParsingConditionInput>>>;
  candidatesCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvsZipS3Key?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateCvsParsingConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateCvsParsingConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelCandidateCvsParsingStatusInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateCvsParsingConnection = {
  items: Array<Maybe<CandidateCvsParsing>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateCvsParsingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateCvsParsingFilterInput>>>;
  candidatesCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvsZipS3Key?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateCvsParsingFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelCandidateCvsParsingStatusInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateCvsParsingStatusInput = {
  eq?: InputMaybe<CandidateCvsParsingStatus>;
  ne?: InputMaybe<CandidateCvsParsingStatus>;
};

export type ModelCandidateEmailCorrespondenceConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>>>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  body?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  recipientEmailAddress?: InputMaybe<ModelStringInput>;
  scheduleDelayInHours?: InputMaybe<ModelStringInput>;
  scheduleId?: InputMaybe<ModelIdInput>;
  scheduledAt?: InputMaybe<ModelStringInput>;
  senderEmailAddress?: InputMaybe<ModelStringInput>;
  sentAt?: InputMaybe<ModelStringInput>;
  sesMessageId?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelCorrespondenceStatusInput>;
  subject?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelEmailCorrespondenceTypeInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateEmailCorrespondenceConnection = {
  items: Array<Maybe<CandidateEmailCorrespondence>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateEmailCorrespondenceFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>>>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  body?: InputMaybe<ModelStringInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  recipientEmailAddress?: InputMaybe<ModelStringInput>;
  scheduleDelayInHours?: InputMaybe<ModelStringInput>;
  scheduleId?: InputMaybe<ModelIdInput>;
  scheduledAt?: InputMaybe<ModelStringInput>;
  senderEmailAddress?: InputMaybe<ModelStringInput>;
  sentAt?: InputMaybe<ModelStringInput>;
  sesMessageId?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelCorrespondenceStatusInput>;
  subject?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelEmailCorrespondenceTypeInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateFilterInput = {
  analysisErrorCode?: InputMaybe<ModelCandidateAnalysisErrorCodeInput>;
  analysisOutcomeActedOnAt?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelCandidateFilterInput>>>;
  applicationSource?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsApplicationSource?: InputMaybe<ModelStringInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsInterviewStageId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateCvsParsingId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationPreferredAnswersScore?: InputMaybe<ModelFloatInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvParsedText?: InputMaybe<ModelStringInput>;
  cvS3Key?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isAllRequirementsMet?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isLocked?: InputMaybe<ModelBooleanInput>;
  isMessagesGenerating?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelIdInput>;
  komboStageId?: InputMaybe<ModelIdInput>;
  lastName?: InputMaybe<ModelStringInput>;
  linkedInProfileId?: InputMaybe<ModelStringInput>;
  metRequirementSlugs?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  origin?: InputMaybe<ModelCandidateOriginInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  sourcedCandidateId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelStringInput>;
  totalScore?: InputMaybe<ModelFloatInput>;
  totalScoreScaled?: InputMaybe<ModelFloatInput>;
  unmetRequirementSlugs?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateMessageConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateMessageConditionInput>>>;
  body?: InputMaybe<ModelStringInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateMessageConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateMessageConditionInput>>>;
  type?: InputMaybe<ModelCandidateMessageTypeInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateMessageConnection = {
  items: Array<Maybe<CandidateMessage>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateMessageFilterInput>>>;
  body?: InputMaybe<ModelStringInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateMessageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateMessageFilterInput>>>;
  type?: InputMaybe<ModelCandidateMessageTypeInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateMessageTypeInput = {
  eq?: InputMaybe<CandidateMessageType>;
  ne?: InputMaybe<CandidateMessageType>;
};

export type ModelCandidateNoteConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateNoteConditionInput>>>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateNoteConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateNoteConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateNoteConnection = {
  items: Array<Maybe<CandidateNote>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateNoteFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateNoteFilterInput>>>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelCandidateNoteFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateNoteFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateOriginInput = {
  eq?: InputMaybe<CandidateOrigin>;
  ne?: InputMaybe<CandidateOrigin>;
};

export type ModelCandidateProfileConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileConditionInput>>>;
  atsApplicationIds?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  awards?: InputMaybe<ModelStringInput>;
  candidateProfileVectorId?: InputMaybe<ModelIdInput>;
  certifications?: InputMaybe<ModelStringInput>;
  company?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customFields?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  emailFromCv?: InputMaybe<ModelStringInput>;
  emails?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  externalUrl?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  firstNameFromCv?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboApplicationIds?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  languages?: InputMaybe<ModelStringInput>;
  lastName?: InputMaybe<ModelStringInput>;
  lastNameFromCv?: InputMaybe<ModelStringInput>;
  latestAtsApplicationDate?: InputMaybe<ModelStringInput>;
  latestAtsApplicationId?: InputMaybe<ModelIdInput>;
  latestCvS3Key?: InputMaybe<ModelStringInput>;
  latestCvText?: InputMaybe<ModelStringInput>;
  latestKomboApplicationId?: InputMaybe<ModelIdInput>;
  linkedInProfileUrl?: InputMaybe<ModelStringInput>;
  linkedInProfileUrlFromCv?: InputMaybe<ModelStringInput>;
  linksFromCv?: InputMaybe<ModelStringInput>;
  locationFromCv?: InputMaybe<ModelStringInput>;
  metadata?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  originalSource?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  phoneNumberFromCv?: InputMaybe<ModelStringInput>;
  phoneNumbers?: InputMaybe<ModelStringInput>;
  professionalSummaryFromCv?: InputMaybe<ModelStringInput>;
  publications?: InputMaybe<ModelStringInput>;
  qualifications?: InputMaybe<ModelStringInput>;
  qualificationsFromCv?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  skillsFromCv?: InputMaybe<ModelStringInput>;
  socialLinks?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelCandidateProfileSyncStatusInput>;
  statusChangedAt?: InputMaybe<ModelStringInput>;
  tags?: InputMaybe<ModelStringInput>;
  title?: InputMaybe<ModelStringInput>;
  totalExperienceInYears?: InputMaybe<ModelFloatInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateProfileConnection = {
  items: Array<Maybe<CandidateProfile>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateProfileFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileFilterInput>>>;
  atsApplicationIds?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  awards?: InputMaybe<ModelStringInput>;
  candidateProfileVectorId?: InputMaybe<ModelIdInput>;
  certifications?: InputMaybe<ModelStringInput>;
  company?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customFields?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  emailFromCv?: InputMaybe<ModelStringInput>;
  emails?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  externalUrl?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  firstNameFromCv?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboApplicationIds?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  languages?: InputMaybe<ModelStringInput>;
  lastName?: InputMaybe<ModelStringInput>;
  lastNameFromCv?: InputMaybe<ModelStringInput>;
  latestAtsApplicationDate?: InputMaybe<ModelStringInput>;
  latestAtsApplicationId?: InputMaybe<ModelIdInput>;
  latestCvS3Key?: InputMaybe<ModelStringInput>;
  latestCvText?: InputMaybe<ModelStringInput>;
  latestKomboApplicationId?: InputMaybe<ModelIdInput>;
  linkedInProfileUrl?: InputMaybe<ModelStringInput>;
  linkedInProfileUrlFromCv?: InputMaybe<ModelStringInput>;
  linksFromCv?: InputMaybe<ModelStringInput>;
  locationFromCv?: InputMaybe<ModelStringInput>;
  metadata?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  originalSource?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  phoneNumberFromCv?: InputMaybe<ModelStringInput>;
  phoneNumbers?: InputMaybe<ModelStringInput>;
  professionalSummaryFromCv?: InputMaybe<ModelStringInput>;
  publications?: InputMaybe<ModelStringInput>;
  qualifications?: InputMaybe<ModelStringInput>;
  qualificationsFromCv?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  skillsFromCv?: InputMaybe<ModelStringInput>;
  socialLinks?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelCandidateProfileSyncStatusInput>;
  statusChangedAt?: InputMaybe<ModelStringInput>;
  tags?: InputMaybe<ModelStringInput>;
  title?: InputMaybe<ModelStringInput>;
  totalExperienceInYears?: InputMaybe<ModelFloatInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateProfileListConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListConditionInput>>>;
  candidateProfilesCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  description?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  lastApiWriteAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileListConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  teamIds?: InputMaybe<ModelIdInput>;
  title?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateProfileListConnection = {
  items: Array<Maybe<CandidateProfileList>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateProfileListFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListFilterInput>>>;
  candidateProfilesCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  description?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  lastApiWriteAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileListFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  teamIds?: InputMaybe<ModelIdInput>;
  title?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateProfileListMembershipConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListMembershipConditionInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileListId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileListMembershipConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListMembershipConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateProfileListMembershipConnection = {
  items: Array<Maybe<CandidateProfileListMembership>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateProfileListMembershipFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListMembershipFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileListId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileListMembershipFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateProfileNoteConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileNoteConditionInput>>>;
  atsApplicationId?: InputMaybe<ModelStringInput>;
  atsAuthorId?: InputMaybe<ModelStringInput>;
  atsCandidateId?: InputMaybe<ModelStringInput>;
  atsCandidateNoteId?: InputMaybe<ModelStringInput>;
  atsNoteCreatedAt?: InputMaybe<ModelStringInput>;
  atsNoteDeletedAt?: InputMaybe<ModelStringInput>;
  atsNoteUpdatedAt?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelStringInput>;
  komboCandidateId?: InputMaybe<ModelStringInput>;
  komboCandidateNoteId?: InputMaybe<ModelStringInput>;
  metadata?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileNoteConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileNoteConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  type?: InputMaybe<ModelNoteTypeInput>;
};

export type ModelCandidateProfileNoteConnection = {
  items: Array<Maybe<CandidateProfileNote>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateProfileNoteFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateProfileNoteFilterInput>>>;
  atsApplicationId?: InputMaybe<ModelStringInput>;
  atsAuthorId?: InputMaybe<ModelStringInput>;
  atsCandidateId?: InputMaybe<ModelStringInput>;
  atsCandidateNoteId?: InputMaybe<ModelStringInput>;
  atsNoteCreatedAt?: InputMaybe<ModelStringInput>;
  atsNoteDeletedAt?: InputMaybe<ModelStringInput>;
  atsNoteUpdatedAt?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelStringInput>;
  komboCandidateId?: InputMaybe<ModelStringInput>;
  komboCandidateNoteId?: InputMaybe<ModelStringInput>;
  metadata?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateProfileNoteFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  type?: InputMaybe<ModelNoteTypeInput>;
};

export type ModelCandidateProfileSyncStatusInput = {
  eq?: InputMaybe<CandidateProfileSyncStatus>;
  ne?: InputMaybe<CandidateProfileSyncStatus>;
};

export type ModelCandidateSourceInput = {
  eq?: InputMaybe<CandidateSource>;
  ne?: InputMaybe<CandidateSource>;
};

export type ModelCandidateStatusUpdateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateStatusUpdateConditionInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelCandidateStatusUpdateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateStatusUpdateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateStatusUpdateConnection = {
  items: Array<Maybe<CandidateStatusUpdate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateStatusUpdateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateStatusUpdateFilterInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateStatusUpdateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelCandidateTagConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateTagConditionInput>>>;
  not?: InputMaybe<ModelCandidateTagConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateTagConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  value?: InputMaybe<ModelStringInput>;
  valueNormalized?: InputMaybe<ModelStringInput>;
};

export type ModelCandidateTagConnection = {
  items: Array<Maybe<CandidateTag>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelCandidateTagFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelCandidateTagFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelCandidateTagFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelCandidateTagFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  value?: InputMaybe<ModelStringInput>;
  valueNormalized?: InputMaybe<ModelStringInput>;
};

export type ModelChannelsInput = {
  eq?: InputMaybe<Channels>;
  ne?: InputMaybe<Channels>;
};

export type ModelChannelsListInput = {
  contains?: InputMaybe<Channels>;
  eq?: InputMaybe<Array<InputMaybe<Channels>>>;
  ne?: InputMaybe<Array<InputMaybe<Channels>>>;
  notContains?: InputMaybe<Channels>;
};

export type ModelClientApiKeyConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelClientApiKeyConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  enabled?: InputMaybe<ModelBooleanInput>;
  expiresAt?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelClientApiKeyConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelClientApiKeyConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  partialKey?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelClientApiKeyConnection = {
  items: Array<Maybe<ClientApiKey>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelClientApiKeyFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelClientApiKeyFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  enabled?: InputMaybe<ModelBooleanInput>;
  expiresAt?: InputMaybe<ModelStringInput>;
  hashedKey?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelClientApiKeyFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelClientApiKeyFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  partialKey?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelClosingMethodInput = {
  eq?: InputMaybe<ClosingMethod>;
  ne?: InputMaybe<ClosingMethod>;
};

export type ModelConversationConditionInput = {
  activeChannel?: InputMaybe<ModelChannelsInput>;
  additionalContext?: InputMaybe<ModelStringInput>;
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelConversationConditionInput>>>;
  applicationSource?: InputMaybe<ModelStringInput>;
  applicationStage?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsInterviewStageId?: InputMaybe<ModelIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelIdInput>;
  calendarBookingId?: InputMaybe<ModelIdInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  closePreviousConversations?: InputMaybe<ModelBooleanInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  crmContactId?: InputMaybe<ModelIdInput>;
  currentQuestionId?: InputMaybe<ModelStringInput>;
  disableNudging?: InputMaybe<ModelBooleanInput>;
  emailPrefix?: InputMaybe<ModelStringInput>;
  errorCode?: InputMaybe<ModelConversationErrorCodeInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isHumanTakeover?: InputMaybe<ModelBooleanInput>;
  isInbound?: InputMaybe<ModelBooleanInput>;
  isInitialEmailMessageOpened?: InputMaybe<ModelBooleanInput>;
  isRead?: InputMaybe<ModelBooleanInput>;
  isWebChatJoined?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelIdInput>;
  komboStageId?: InputMaybe<ModelIdInput>;
  meetingBookingStatus?: InputMaybe<ModelMeetingBookingStatusInput>;
  messagesCount?: InputMaybe<ModelIntInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelConversationConditionInput>;
  nudgesSentCount?: InputMaybe<ModelIntInput>;
  openingMessage?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelConversationConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  participantEmailAddress?: InputMaybe<ModelStringInput>;
  participantFirstName?: InputMaybe<ModelStringInput>;
  participantLastName?: InputMaybe<ModelStringInput>;
  participantLinkedInProfile?: InputMaybe<ModelStringInput>;
  participantPhoneNumber?: InputMaybe<ModelStringInput>;
  pastOngoingConversationId?: InputMaybe<ModelIdInput>;
  preferredAnswersScore?: InputMaybe<ModelFloatInput>;
  repliesCount?: InputMaybe<ModelIntInput>;
  sentAt?: InputMaybe<ModelStringInput>;
  sourcedCandidateId?: InputMaybe<ModelIdInput>;
  stage?: InputMaybe<ModelConversationStageInput>;
  status?: InputMaybe<ModelConversationStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  tagsNormalized?: InputMaybe<ModelStringInput>;
  timeToComplete?: InputMaybe<ModelFloatInput>;
  timeToFirstResponse?: InputMaybe<ModelFloatInput>;
  totalNudgesSentCount?: InputMaybe<ModelIntInput>;
  twilioConversationId?: InputMaybe<ModelStringInput>;
  twilioParticipantId?: InputMaybe<ModelStringInput>;
  twilioRedirectConversationId?: InputMaybe<ModelIdInput>;
  twilioRedirectParticipantId?: InputMaybe<ModelIdInput>;
  unresolvedNeedsReviewReasons?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  webChatUrlId?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelConversationConnection = {
  items: Array<Maybe<Conversation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelConversationErrorCodeInput = {
  eq?: InputMaybe<ConversationErrorCode>;
  ne?: InputMaybe<ConversationErrorCode>;
};

export type ModelConversationFilterInput = {
  activeChannel?: InputMaybe<ModelChannelsInput>;
  additionalContext?: InputMaybe<ModelStringInput>;
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelConversationFilterInput>>>;
  applicationSource?: InputMaybe<ModelStringInput>;
  applicationStage?: InputMaybe<ModelStringInput>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsCandidateId?: InputMaybe<ModelIdInput>;
  atsInterviewStageId?: InputMaybe<ModelIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelIdInput>;
  calendarBookingId?: InputMaybe<ModelIdInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  closePreviousConversations?: InputMaybe<ModelBooleanInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  crmContactId?: InputMaybe<ModelIdInput>;
  currentQuestionId?: InputMaybe<ModelStringInput>;
  disableNudging?: InputMaybe<ModelBooleanInput>;
  emailPrefix?: InputMaybe<ModelStringInput>;
  errorCode?: InputMaybe<ModelConversationErrorCodeInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isHumanTakeover?: InputMaybe<ModelBooleanInput>;
  isInbound?: InputMaybe<ModelBooleanInput>;
  isInitialEmailMessageOpened?: InputMaybe<ModelBooleanInput>;
  isRead?: InputMaybe<ModelBooleanInput>;
  isWebChatJoined?: InputMaybe<ModelBooleanInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboCandidateId?: InputMaybe<ModelIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelIdInput>;
  komboStageId?: InputMaybe<ModelIdInput>;
  meetingBookingStatus?: InputMaybe<ModelMeetingBookingStatusInput>;
  messagesCount?: InputMaybe<ModelIntInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelConversationFilterInput>;
  nudgesSentCount?: InputMaybe<ModelIntInput>;
  openingMessage?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelConversationFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  participantEmailAddress?: InputMaybe<ModelStringInput>;
  participantFirstName?: InputMaybe<ModelStringInput>;
  participantLastName?: InputMaybe<ModelStringInput>;
  participantLinkedInProfile?: InputMaybe<ModelStringInput>;
  participantPhoneNumber?: InputMaybe<ModelStringInput>;
  pastOngoingConversationId?: InputMaybe<ModelIdInput>;
  preferredAnswersScore?: InputMaybe<ModelFloatInput>;
  repliesCount?: InputMaybe<ModelIntInput>;
  sentAt?: InputMaybe<ModelStringInput>;
  sourcedCandidateId?: InputMaybe<ModelIdInput>;
  stage?: InputMaybe<ModelConversationStageInput>;
  status?: InputMaybe<ModelConversationStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  tagsNormalized?: InputMaybe<ModelStringInput>;
  timeToComplete?: InputMaybe<ModelFloatInput>;
  timeToFirstResponse?: InputMaybe<ModelFloatInput>;
  totalNudgesSentCount?: InputMaybe<ModelIntInput>;
  twilioConversationId?: InputMaybe<ModelStringInput>;
  twilioParticipantId?: InputMaybe<ModelStringInput>;
  twilioRedirectConversationId?: InputMaybe<ModelIdInput>;
  twilioRedirectParticipantId?: InputMaybe<ModelIdInput>;
  unresolvedNeedsReviewReasons?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  webChatUrlId?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelConversationStageInput = {
  eq?: InputMaybe<ConversationStage>;
  ne?: InputMaybe<ConversationStage>;
};

export type ModelConversationStatusInput = {
  eq?: InputMaybe<ConversationStatus>;
  ne?: InputMaybe<ConversationStatus>;
};

export type ModelCorrespondenceStatusInput = {
  eq?: InputMaybe<CorrespondenceStatus>;
  ne?: InputMaybe<CorrespondenceStatus>;
};

export type ModelCustomFieldDisplayInput = {
  eq?: InputMaybe<CustomFieldDisplay>;
  ne?: InputMaybe<CustomFieldDisplay>;
};

export type ModelCustomFieldTypeInput = {
  eq?: InputMaybe<CustomFieldType>;
  ne?: InputMaybe<CustomFieldType>;
};

export type ModelDocumentCredentialConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentCredentialConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  encryptedToken?: InputMaybe<ModelStringInput>;
  headerTokenKey?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelDocumentCredentialConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentCredentialConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
};

export type ModelDocumentCredentialConnection = {
  items: Array<Maybe<DocumentCredential>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDocumentCredentialFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentCredentialFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  encryptedToken?: InputMaybe<ModelStringInput>;
  headerTokenKey?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelDocumentCredentialFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentCredentialFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
};

export type ModelDocumentTypeConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentTypeConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  isArchived?: InputMaybe<ModelBooleanInput>;
  isUsedInCampaign?: InputMaybe<ModelBooleanInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelDocumentTypeConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentTypeConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  validation?: InputMaybe<ModelDocumentValidationCheckListInput>;
  validationSettings?: InputMaybe<ModelStringInput>;
};

export type ModelDocumentTypeConnection = {
  items: Array<Maybe<DocumentType>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDocumentTypeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentTypeFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isArchived?: InputMaybe<ModelBooleanInput>;
  isUsedInCampaign?: InputMaybe<ModelBooleanInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelDocumentTypeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentTypeFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  validation?: InputMaybe<ModelDocumentValidationCheckListInput>;
  validationSettings?: InputMaybe<ModelStringInput>;
};

export type ModelDocumentTypeRelationshipsConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentTypeRelationshipsConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentTypeId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelDocumentTypeRelationshipsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentTypeRelationshipsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelDocumentTypeRelationshipsConnection = {
  items: Array<Maybe<DocumentTypeRelationships>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelDocumentTypeRelationshipsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelDocumentTypeRelationshipsFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentTypeId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelDocumentTypeRelationshipsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelDocumentValidationCheckListInput = {
  contains?: InputMaybe<DocumentValidationCheck>;
  eq?: InputMaybe<Array<InputMaybe<DocumentValidationCheck>>>;
  ne?: InputMaybe<Array<InputMaybe<DocumentValidationCheck>>>;
  notContains?: InputMaybe<DocumentValidationCheck>;
};

export type ModelEmailCorrespondenceTypeInput = {
  eq?: InputMaybe<EmailCorrespondenceType>;
  ne?: InputMaybe<EmailCorrespondenceType>;
};

export type ModelEmailDeliveryEventInput = {
  eq?: InputMaybe<EmailDeliveryEvent>;
  ne?: InputMaybe<EmailDeliveryEvent>;
};

export type ModelFloatInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelFloatKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
};

export type ModelIdInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelIdKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
};

export type ModelInitialWhatsAppTemplatesBatchStatusInput = {
  eq?: InputMaybe<InitialWhatsAppTemplatesBatchStatus>;
  ne?: InputMaybe<InitialWhatsAppTemplatesBatchStatus>;
};

export type ModelIntInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntKeyConditionInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelIntegrationCredentialsConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelIntegrationCredentialsConditionInput>>>;
  appSubdomain?: InputMaybe<ModelStringInput>;
  atsApplicationsLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsCandidatesLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsInstanceId?: InputMaybe<ModelStringInput>;
  atsJobsLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsListsLastFetchedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  hubSpotAccessToken?: InputMaybe<ModelStringInput>;
  isActive?: InputMaybe<ModelBooleanInput>;
  komboIntegrationId?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelIntegrationCredentialsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelIntegrationCredentialsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  provider?: InputMaybe<ModelStringInput>;
  stackOneAccountId?: InputMaybe<ModelStringInput>;
};

export type ModelIntegrationCredentialsConnection = {
  items: Array<Maybe<IntegrationCredentials>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelIntegrationCredentialsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelIntegrationCredentialsFilterInput>>>;
  appSubdomain?: InputMaybe<ModelStringInput>;
  atsApplicationsLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsCandidatesLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsInstanceId?: InputMaybe<ModelStringInput>;
  atsJobsLastFetchedAt?: InputMaybe<ModelStringInput>;
  atsListsLastFetchedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  hubSpotAccessToken?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isActive?: InputMaybe<ModelBooleanInput>;
  komboIntegrationId?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelIntegrationCredentialsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  provider?: InputMaybe<ModelStringInput>;
  stackOneAccountId?: InputMaybe<ModelStringInput>;
};

export type ModelJobPostingConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelJobPostingConditionInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  jobPostingUrl?: InputMaybe<ModelStringInput>;
  jobTitle?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  normalisedJobDescription?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelJobPostingConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelJobPostingConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelStringInput>;
};

export type ModelJobPostingConnection = {
  items: Array<Maybe<JobPosting>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelJobPostingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelJobPostingFilterInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobPostingId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  jobDescription?: InputMaybe<ModelStringInput>;
  jobPostingUrl?: InputMaybe<ModelStringInput>;
  jobTitle?: InputMaybe<ModelStringInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  normalisedJobDescription?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelJobPostingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelJobPostingFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  status?: InputMaybe<ModelStringInput>;
};

export type ModelJobPostingRecommendationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelJobPostingRecommendationConditionInput>>>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  jobPostingId?: InputMaybe<ModelIdInput>;
  jobRecommendationSummary?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelJobPostingRecommendationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelJobPostingRecommendationConditionInput>>>;
};

export type ModelJobPostingRecommendationConnection = {
  items: Array<Maybe<JobPostingRecommendation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelJobPostingRecommendationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelJobPostingRecommendationFilterInput>>>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  jobPostingId?: InputMaybe<ModelIdInput>;
  jobRecommendationSummary?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelJobPostingRecommendationFilterInput>>>;
};

export type ModelMeetingBookingStatusInput = {
  eq?: InputMaybe<MeetingBookingStatus>;
  ne?: InputMaybe<MeetingBookingStatus>;
};

export type ModelMessageConditionInput = {
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelMessageConditionInput>>>;
  body?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  deliveredAt?: InputMaybe<ModelStringInput>;
  emailDeliveryEvent?: InputMaybe<ModelEmailDeliveryEventInput>;
  emailSubjectLine?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isEmailOpened?: InputMaybe<ModelBooleanInput>;
  isFallback?: InputMaybe<ModelBooleanInput>;
  isInitial?: InputMaybe<ModelBooleanInput>;
  isNegativeSentiment?: InputMaybe<ModelBooleanInput>;
  messageUnansweredQuestionId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelMessageConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMessageConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachQuestionId?: InputMaybe<ModelIdInput>;
  rawBody?: InputMaybe<ModelStringInput>;
  readAt?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSenderInput>;
  sentimentName?: InputMaybe<ModelSentimentNameInput>;
  sesEmailId?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelMessageStatusInput>;
  templateId?: InputMaybe<ModelIdInput>;
  twilioErrorCode?: InputMaybe<ModelStringInput>;
  twilioMessageId?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelMessageConnection = {
  items: Array<Maybe<Message>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelMessageFilterInput = {
  agentId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelMessageFilterInput>>>;
  body?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  deliveredAt?: InputMaybe<ModelStringInput>;
  emailDeliveryEvent?: InputMaybe<ModelEmailDeliveryEventInput>;
  emailSubjectLine?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isEmailOpened?: InputMaybe<ModelBooleanInput>;
  isFallback?: InputMaybe<ModelBooleanInput>;
  isInitial?: InputMaybe<ModelBooleanInput>;
  isNegativeSentiment?: InputMaybe<ModelBooleanInput>;
  messageUnansweredQuestionId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelMessageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelMessageFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachQuestionId?: InputMaybe<ModelIdInput>;
  rawBody?: InputMaybe<ModelStringInput>;
  readAt?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSenderInput>;
  sentimentName?: InputMaybe<ModelSentimentNameInput>;
  sesEmailId?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelMessageStatusInput>;
  templateId?: InputMaybe<ModelIdInput>;
  twilioErrorCode?: InputMaybe<ModelStringInput>;
  twilioMessageId?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelMessageStatusInput = {
  eq?: InputMaybe<MessageStatus>;
  ne?: InputMaybe<MessageStatus>;
};

export type ModelNeedsReviewItemConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelNeedsReviewItemConditionInput>>>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  metadata?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelNeedsReviewItemConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelNeedsReviewItemConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  reason?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelNeedsReviewItemConnection = {
  items: Array<Maybe<NeedsReviewItem>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelNeedsReviewItemFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelNeedsReviewItemFilterInput>>>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  metadata?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelNeedsReviewItemFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelNeedsReviewItemFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  reason?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelNodeExecutionStateInput = {
  eq?: InputMaybe<NodeExecutionState>;
  ne?: InputMaybe<NodeExecutionState>;
};

export type ModelNoteTakerStatusInput = {
  eq?: InputMaybe<NoteTakerStatus>;
  ne?: InputMaybe<NoteTakerStatus>;
};

export type ModelNoteTypeInput = {
  eq?: InputMaybe<NoteType>;
  ne?: InputMaybe<NoteType>;
};

export type ModelOnboardingTourStatusInput = {
  eq?: InputMaybe<OnboardingTourStatus>;
  ne?: InputMaybe<OnboardingTourStatus>;
};

export type ModelOpeningMessageModeInput = {
  eq?: InputMaybe<OpeningMessageMode>;
  ne?: InputMaybe<OpeningMessageMode>;
};

export type ModelOptOutEmailAddressConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOptOutEmailAddressConditionInput>>>;
  emailAddress?: InputMaybe<ModelStringInput>;
  emailIdentity?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOptOutEmailAddressConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOptOutEmailAddressConditionInput>>>;
};

export type ModelOptOutEmailAddressConnection = {
  items: Array<Maybe<OptOutEmailAddress>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOptOutEmailAddressFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOptOutEmailAddressFilterInput>>>;
  emailAddress?: InputMaybe<ModelStringInput>;
  emailIdentity?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelOptOutEmailAddressFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOptOutEmailAddressFilterInput>>>;
};

export type ModelOptOutPhoneNumberConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOptOutPhoneNumberConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOptOutPhoneNumberConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOptOutPhoneNumberConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
};

export type ModelOptOutPhoneNumberConnection = {
  items: Array<Maybe<OptOutPhoneNumber>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOptOutPhoneNumberFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOptOutPhoneNumberFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelOptOutPhoneNumberFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOptOutPhoneNumberFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationConditionInput = {
  alphaSenderID?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationConditionInput>>>;
  campaignEmailAddress?: InputMaybe<ModelStringInput>;
  candidateDisplayName?: InputMaybe<ModelStringInput>;
  channelsEnabled?: InputMaybe<ModelChannelsListInput>;
  emailIdentity?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  hasCalendarIntegration?: InputMaybe<ModelBooleanInput>;
  hiddenAt?: InputMaybe<ModelStringInput>;
  initialWhatsAppTemplatesBatchStatus?: InputMaybe<ModelInitialWhatsAppTemplatesBatchStatusInput>;
  isHidden?: InputMaybe<ModelBooleanInput>;
  isSandbox?: InputMaybe<ModelBooleanInput>;
  jobRecommendationsEnabled?: InputMaybe<ModelBooleanInput>;
  logoS3Key?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationConditionInput>>>;
  organizationAtsConfigId?: InputMaybe<ModelIdInput>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationOrganizationConfigId?: InputMaybe<ModelIdInput>;
  organizationTwilioAccountCredentialsId?: InputMaybe<ModelIdInput>;
  sandboxExpiresAt?: InputMaybe<ModelStringInput>;
  sandboxStatus?: InputMaybe<ModelSandboxStatusInput>;
  twilioInboundPhoneNumberAnswers?: InputMaybe<ModelStringInput>;
  twilioInboundPhoneNumberQuestions?: InputMaybe<ModelStringInput>;
  twilioPhoneNumber?: InputMaybe<ModelStringInput>;
  twilioSenderStatus?: InputMaybe<ModelTwilioSenderStatusInput>;
  usersCount?: InputMaybe<ModelIntInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
  websiteUrl?: InputMaybe<ModelStringInput>;
  whatsAppBusinessAccountId?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationConfigConditionInput = {
  agentId?: InputMaybe<ModelIdInput>;
  allowWhatsAppForAtsListCampaigns?: InputMaybe<ModelBooleanInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationConfigConditionInput>>>;
  availableLanguages?: InputMaybe<ModelStringInput>;
  closingMessage?: InputMaybe<ModelStringInput>;
  customRequest?: InputMaybe<ModelStringInput>;
  defaultAutomationTaskTemplateId?: InputMaybe<ModelIdInput>;
  emailChannelFallbackEnabled?: InputMaybe<ModelBooleanInput>;
  emailFooterHtml?: InputMaybe<ModelStringInput>;
  globalContext?: InputMaybe<ModelStringInput>;
  internalSourcingAddToJobActionUrl?: InputMaybe<ModelStringInput>;
  internalSourcingEnabled?: InputMaybe<ModelBooleanInput>;
  internalSourcingProtectedCharacteristics?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationConfigConditionInput>;
  openingMessageMode?: InputMaybe<ModelOpeningMessageModeInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationConfigConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  rejectionMessage?: InputMaybe<ModelStringInput>;
  sourcingEnabled?: InputMaybe<ModelBooleanInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<ModelIntInput>;
  webhookJobSyncingFlowEnabled?: InputMaybe<ModelBooleanInput>;
  whiteLabelingEnabled?: InputMaybe<ModelBooleanInput>;
};

export type ModelOrganizationConfigConnection = {
  items: Array<Maybe<OrganizationConfig>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOrganizationConfigFilterInput = {
  agentId?: InputMaybe<ModelIdInput>;
  allowWhatsAppForAtsListCampaigns?: InputMaybe<ModelBooleanInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationConfigFilterInput>>>;
  availableLanguages?: InputMaybe<ModelStringInput>;
  closingMessage?: InputMaybe<ModelStringInput>;
  customRequest?: InputMaybe<ModelStringInput>;
  defaultAutomationTaskTemplateId?: InputMaybe<ModelIdInput>;
  emailChannelFallbackEnabled?: InputMaybe<ModelBooleanInput>;
  emailFooterHtml?: InputMaybe<ModelStringInput>;
  globalContext?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  internalSourcingAddToJobActionUrl?: InputMaybe<ModelStringInput>;
  internalSourcingEnabled?: InputMaybe<ModelBooleanInput>;
  internalSourcingProtectedCharacteristics?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationConfigFilterInput>;
  openingMessageMode?: InputMaybe<ModelOpeningMessageModeInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationConfigFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  rejectionMessage?: InputMaybe<ModelStringInput>;
  sourcingEnabled?: InputMaybe<ModelBooleanInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<ModelIntInput>;
  webhookJobSyncingFlowEnabled?: InputMaybe<ModelBooleanInput>;
  whiteLabelingEnabled?: InputMaybe<ModelBooleanInput>;
};

export type ModelOrganizationConnection = {
  items: Array<Maybe<Organization>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOrganizationCustomFieldConfigConditionInput = {
  allowedValues?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>>>;
  displayAs?: InputMaybe<ModelCustomFieldDisplayInput>;
  fieldKey?: InputMaybe<ModelStringInput>;
  hasFixedOptions?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  label?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  retiredAt?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelCustomFieldTypeInput>;
  vectorDbKey?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationCustomFieldConfigConnection = {
  items: Array<Maybe<OrganizationCustomFieldConfig>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOrganizationCustomFieldConfigFilterInput = {
  allowedValues?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationCustomFieldConfigFilterInput>>>;
  displayAs?: InputMaybe<ModelCustomFieldDisplayInput>;
  fieldKey?: InputMaybe<ModelStringInput>;
  hasFixedOptions?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  label?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationCustomFieldConfigFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationCustomFieldConfigFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  retiredAt?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelCustomFieldTypeInput>;
  vectorDbKey?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationFilterInput = {
  alphaSenderID?: InputMaybe<ModelStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationFilterInput>>>;
  campaignEmailAddress?: InputMaybe<ModelStringInput>;
  candidateDisplayName?: InputMaybe<ModelStringInput>;
  channelsEnabled?: InputMaybe<ModelChannelsListInput>;
  emailIdentity?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  hasCalendarIntegration?: InputMaybe<ModelBooleanInput>;
  hiddenAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  initialWhatsAppTemplatesBatchStatus?: InputMaybe<ModelInitialWhatsAppTemplatesBatchStatusInput>;
  isHidden?: InputMaybe<ModelBooleanInput>;
  isSandbox?: InputMaybe<ModelBooleanInput>;
  jobRecommendationsEnabled?: InputMaybe<ModelBooleanInput>;
  logoS3Key?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationFilterInput>>>;
  organizationAtsConfigId?: InputMaybe<ModelIdInput>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationOrganizationConfigId?: InputMaybe<ModelIdInput>;
  organizationTwilioAccountCredentialsId?: InputMaybe<ModelIdInput>;
  sandboxExpiresAt?: InputMaybe<ModelStringInput>;
  sandboxStatus?: InputMaybe<ModelSandboxStatusInput>;
  twilioInboundPhoneNumberAnswers?: InputMaybe<ModelStringInput>;
  twilioInboundPhoneNumberQuestions?: InputMaybe<ModelStringInput>;
  twilioPhoneNumber?: InputMaybe<ModelStringInput>;
  twilioSenderStatus?: InputMaybe<ModelTwilioSenderStatusInput>;
  usersCount?: InputMaybe<ModelIntInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
  websiteUrl?: InputMaybe<ModelStringInput>;
  whatsAppBusinessAccountId?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationGroupConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationGroupConditionInput>>>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationGroupConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationGroupConditionInput>>>;
};

export type ModelOrganizationGroupConnection = {
  items: Array<Maybe<OrganizationGroup>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOrganizationGroupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationGroupFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationGroupFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationGroupFilterInput>>>;
};

export type ModelOrganizationGroupRoleInput = {
  eq?: InputMaybe<OrganizationGroupRole>;
  ne?: InputMaybe<OrganizationGroupRole>;
};

export type ModelOrganizationWebhookConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationWebhookConditionInput>>>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationWebhookConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationWebhookConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  signingSecret?: InputMaybe<ModelStringInput>;
  subscribedEvents?: InputMaybe<ModelWebhookEventTypeListInput>;
  url?: InputMaybe<ModelStringInput>;
};

export type ModelOrganizationWebhookConnection = {
  items: Array<Maybe<OrganizationWebhook>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOrganizationWebhookFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOrganizationWebhookFilterInput>>>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOrganizationWebhookFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  signingSecret?: InputMaybe<ModelStringInput>;
  subscribedEvents?: InputMaybe<ModelWebhookEventTypeListInput>;
  url?: InputMaybe<ModelStringInput>;
};

export type ModelOutreachQuestionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOutreachQuestionConditionInput>>>;
  answerRoutes?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentTypes?: InputMaybe<ModelStringInput>;
  expectedAnswer?: InputMaybe<ModelQuestionExpectedAnswerInput>;
  hasPreferredAnswer?: InputMaybe<ModelBooleanInput>;
  isMandatory?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelOutreachQuestionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOutreachQuestionConditionInput>>>;
  order?: InputMaybe<ModelIntInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  preferredAnswerRequirements?: InputMaybe<ModelStringInput>;
  preferredAnswerText?: InputMaybe<ModelStringInput>;
  questionType?: InputMaybe<ModelQuestionTypeInput>;
  slug?: InputMaybe<ModelStringInput>;
  strictness?: InputMaybe<ModelQuestionStrictnessInput>;
  supportingInformation?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelOutreachQuestionConnection = {
  items: Array<Maybe<OutreachQuestion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelOutreachQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelOutreachQuestionFilterInput>>>;
  answerRoutes?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  content?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentTypes?: InputMaybe<ModelStringInput>;
  expectedAnswer?: InputMaybe<ModelQuestionExpectedAnswerInput>;
  hasPreferredAnswer?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  isMandatory?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelOutreachQuestionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelOutreachQuestionFilterInput>>>;
  order?: InputMaybe<ModelIntInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  preferredAnswerRequirements?: InputMaybe<ModelStringInput>;
  preferredAnswerText?: InputMaybe<ModelStringInput>;
  questionType?: InputMaybe<ModelQuestionTypeInput>;
  slug?: InputMaybe<ModelStringInput>;
  strictness?: InputMaybe<ModelQuestionStrictnessInput>;
  supportingInformation?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelPlanInput = {
  eq?: InputMaybe<Plan>;
  ne?: InputMaybe<Plan>;
};

export type ModelPlanMembershipConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlanMembershipConditionInput>>>;
  messagesLimit?: InputMaybe<ModelIntInput>;
  messagesUsage?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelPlanMembershipConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlanMembershipConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  plan?: InputMaybe<ModelPlanInput>;
  product?: InputMaybe<ModelSubscriptionProductInput>;
  scoringLimit?: InputMaybe<ModelIntInput>;
  scoringUsage?: InputMaybe<ModelIntInput>;
  sourcingUsage?: InputMaybe<ModelIntInput>;
  startDate?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelPlanStatusInput>;
  stripeCustomerId?: InputMaybe<ModelStringInput>;
  stripePriceId?: InputMaybe<ModelStringInput>;
  stripeProductId?: InputMaybe<ModelStringInput>;
  stripeProductName?: InputMaybe<ModelStringInput>;
  stripeSubscriptionId?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  usersCountLimit?: InputMaybe<ModelIntInput>;
};

export type ModelPlanMembershipConnection = {
  items: Array<Maybe<PlanMembership>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPlanMembershipFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPlanMembershipFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  messagesLimit?: InputMaybe<ModelIntInput>;
  messagesUsage?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelPlanMembershipFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPlanMembershipFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  plan?: InputMaybe<ModelPlanInput>;
  product?: InputMaybe<ModelSubscriptionProductInput>;
  scoringLimit?: InputMaybe<ModelIntInput>;
  scoringUsage?: InputMaybe<ModelIntInput>;
  sourcingUsage?: InputMaybe<ModelIntInput>;
  startDate?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelPlanStatusInput>;
  stripeCustomerId?: InputMaybe<ModelStringInput>;
  stripePriceId?: InputMaybe<ModelStringInput>;
  stripeProductId?: InputMaybe<ModelStringInput>;
  stripeProductName?: InputMaybe<ModelStringInput>;
  stripeSubscriptionId?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
  usersCountLimit?: InputMaybe<ModelIntInput>;
};

export type ModelPlanStatusInput = {
  eq?: InputMaybe<PlanStatus>;
  ne?: InputMaybe<PlanStatus>;
};

export type ModelPreferencesConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPreferencesConditionInput>>>;
  companyName?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelPreferencesConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPreferencesConditionInput>>>;
  role?: InputMaybe<ModelRoleInput>;
  tone?: InputMaybe<ModelToneInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelPreferencesConnection = {
  items: Array<Maybe<Preferences>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelPreferencesFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelPreferencesFilterInput>>>;
  companyName?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelPreferencesFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelPreferencesFilterInput>>>;
  role?: InputMaybe<ModelRoleInput>;
  tone?: InputMaybe<ModelToneInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelProfileDataConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelProfileDataConditionInput>>>;
  data?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelProfileDataConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelProfileDataConditionInput>>>;
  profileId?: InputMaybe<ModelStringInput>;
};

export type ModelProfileDataConnection = {
  items: Array<Maybe<ProfileData>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelProfileDataFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelProfileDataFilterInput>>>;
  data?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelProfileDataFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelProfileDataFilterInput>>>;
  profileId?: InputMaybe<ModelStringInput>;
};

export type ModelQualificationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelQualificationConditionInput>>>;
  not?: InputMaybe<ModelQualificationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelQualificationConditionInput>>>;
  qualification?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export type ModelQualificationConnection = {
  items: Array<Maybe<Qualification>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQualificationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelQualificationFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelQualificationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelQualificationFilterInput>>>;
  qualification?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export type ModelQuestionEvaluationResultInput = {
  eq?: InputMaybe<QuestionEvaluationResult>;
  ne?: InputMaybe<QuestionEvaluationResult>;
};

export type ModelQuestionExpectedAnswerInput = {
  eq?: InputMaybe<QuestionExpectedAnswer>;
  ne?: InputMaybe<QuestionExpectedAnswer>;
};

export type ModelQuestionOutcomeConditionInput = {
  agentMessageId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelQuestionOutcomeConditionInput>>>;
  answerPolarity?: InputMaybe<ModelStringInput>;
  answerState?: InputMaybe<ModelAnswerStateInput>;
  answerSummary?: InputMaybe<ModelStringInput>;
  answerText?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  classifiedDocumentString?: InputMaybe<ModelStringInput>;
  classifiedDocumentType?: InputMaybe<ModelStringInput>;
  classifiedDocumentTypeId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentFileName?: InputMaybe<ModelStringInput>;
  documentS3Key?: InputMaybe<ModelStringInput>;
  documentTwilioMediaSid?: InputMaybe<ModelStringInput>;
  evaluationResult?: InputMaybe<ModelQuestionEvaluationResultInput>;
  evidence?: InputMaybe<ModelStringInput>;
  isMet?: InputMaybe<ModelBooleanInput>;
  neededReview?: InputMaybe<ModelBooleanInput>;
  neededReviewReason?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelQuestionOutcomeConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelQuestionOutcomeConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachQuestionId?: InputMaybe<ModelIdInput>;
  prospectMessageId?: InputMaybe<ModelIdInput>;
  questionContent?: InputMaybe<ModelStringInput>;
  questionSlug?: InputMaybe<ModelStringInput>;
  routeTaken?: InputMaybe<ModelStringInput>;
  score?: InputMaybe<ModelFloatInput>;
  trafficLight?: InputMaybe<ModelTrafficLightInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelQuestionOutcomeConnection = {
  items: Array<Maybe<QuestionOutcome>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelQuestionOutcomeFilterInput = {
  agentMessageId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelQuestionOutcomeFilterInput>>>;
  answerPolarity?: InputMaybe<ModelStringInput>;
  answerState?: InputMaybe<ModelAnswerStateInput>;
  answerSummary?: InputMaybe<ModelStringInput>;
  answerText?: InputMaybe<ModelStringInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  classifiedDocumentString?: InputMaybe<ModelStringInput>;
  classifiedDocumentType?: InputMaybe<ModelStringInput>;
  classifiedDocumentTypeId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  documentFileName?: InputMaybe<ModelStringInput>;
  documentS3Key?: InputMaybe<ModelStringInput>;
  documentTwilioMediaSid?: InputMaybe<ModelStringInput>;
  evaluationResult?: InputMaybe<ModelQuestionEvaluationResultInput>;
  evidence?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isMet?: InputMaybe<ModelBooleanInput>;
  neededReview?: InputMaybe<ModelBooleanInput>;
  neededReviewReason?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelQuestionOutcomeFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  outreachQuestionId?: InputMaybe<ModelIdInput>;
  prospectMessageId?: InputMaybe<ModelIdInput>;
  questionContent?: InputMaybe<ModelStringInput>;
  questionSlug?: InputMaybe<ModelStringInput>;
  routeTaken?: InputMaybe<ModelStringInput>;
  score?: InputMaybe<ModelFloatInput>;
  trafficLight?: InputMaybe<ModelTrafficLightInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelQuestionStrictnessInput = {
  eq?: InputMaybe<QuestionStrictness>;
  ne?: InputMaybe<QuestionStrictness>;
};

export type ModelQuestionTypeInput = {
  eq?: InputMaybe<QuestionType>;
  ne?: InputMaybe<QuestionType>;
};

export type ModelRequirementOutcomeConditionInput = {
  analysisRequirementId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelRequirementOutcomeConditionInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  evidence?: InputMaybe<ModelStringInput>;
  isMet?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelRequirementOutcomeConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRequirementOutcomeConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  requirementSlug?: InputMaybe<ModelStringInput>;
  scoredAt?: InputMaybe<ModelStringInput>;
  scoringConfigurationDigest?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelRequirementOutcomeConnection = {
  items: Array<Maybe<RequirementOutcome>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelRequirementOutcomeFilterInput = {
  analysisRequirementId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelRequirementOutcomeFilterInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  evidence?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isMet?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelRequirementOutcomeFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  requirementSlug?: InputMaybe<ModelStringInput>;
  scoredAt?: InputMaybe<ModelStringInput>;
  scoringConfigurationDigest?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelRequirementRecommendationCategoryInput = {
  eq?: InputMaybe<RequirementRecommendationCategory>;
  ne?: InputMaybe<RequirementRecommendationCategory>;
};

export type ModelRoleInput = {
  eq?: InputMaybe<Role>;
  ne?: InputMaybe<Role>;
};

export type ModelSandboxStatusInput = {
  eq?: InputMaybe<SandboxStatus>;
  ne?: InputMaybe<SandboxStatus>;
};

export type ModelSearchCandidateProfileMessageConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileMessageConditionInput>>>;
  body?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  generatedSemanticSearchQuery?: InputMaybe<ModelStringInput>;
  isOverwritten?: InputMaybe<ModelBooleanInput>;
  normalisedQueryUserBody?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchCandidateProfileMessageConditionInput>;
  optimisedSemanticMessage?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileMessageConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  searchCandidateProfileQueryId?: InputMaybe<ModelIdInput>;
  semanticQueries?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSearchCandidateProfileMessageSenderInput>;
};

export type ModelSearchCandidateProfileMessageConnection = {
  items: Array<Maybe<SearchCandidateProfileMessage>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSearchCandidateProfileMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileMessageFilterInput>>>;
  body?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  generatedSemanticSearchQuery?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isOverwritten?: InputMaybe<ModelBooleanInput>;
  normalisedQueryUserBody?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  optimisedSemanticMessage?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileMessageFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  searchCandidateProfileQueryId?: InputMaybe<ModelIdInput>;
  semanticQueries?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSearchCandidateProfileMessageSenderInput>;
};

export type ModelSearchCandidateProfileMessageSenderInput = {
  eq?: InputMaybe<SearchCandidateProfileMessageSender>;
  ne?: InputMaybe<SearchCandidateProfileMessageSender>;
};

export type ModelSearchCandidateProfileQueryConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileQueryConditionInput>>>;
  appliedFilter?: InputMaybe<ModelStringInput>;
  ats_candidate_id?: InputMaybe<ModelStringInput>;
  candidate_profile_list_ids?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  current_company?: InputMaybe<ModelStringInput>;
  current_job_title?: InputMaybe<ModelStringInput>;
  displayTitle?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  filter?: InputMaybe<ModelStringInput>;
  full_name?: InputMaybe<ModelStringInput>;
  generatedFilter?: InputMaybe<ModelStringInput>;
  geo_radius?: InputMaybe<ModelFloatInput>;
  isArchived?: InputMaybe<ModelBooleanInput>;
  isPinned?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelSearchCandidateProfileQueryConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileQueryConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  original_source?: InputMaybe<ModelStringInput>;
  phone?: InputMaybe<ModelStringInput>;
  qualifications?: InputMaybe<ModelStringInput>;
  returnedCandidatesCount?: InputMaybe<ModelIntInput>;
  skills?: InputMaybe<ModelStringInput>;
  tags?: InputMaybe<ModelStringInput>;
  time_in_role?: InputMaybe<ModelTimeComparisonListInput>;
  total_years_of_experience?: InputMaybe<ModelFloatInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchCandidateProfileQueryConnection = {
  items: Array<Maybe<SearchCandidateProfileQuery>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSearchCandidateProfileQueryFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileQueryFilterInput>>>;
  appliedFilter?: InputMaybe<ModelStringInput>;
  ats_candidate_id?: InputMaybe<ModelStringInput>;
  candidate_profile_list_ids?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  current_company?: InputMaybe<ModelStringInput>;
  current_job_title?: InputMaybe<ModelStringInput>;
  displayTitle?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  filter?: InputMaybe<ModelStringInput>;
  full_name?: InputMaybe<ModelStringInput>;
  generatedFilter?: InputMaybe<ModelStringInput>;
  geo_radius?: InputMaybe<ModelFloatInput>;
  id?: InputMaybe<ModelIdInput>;
  isArchived?: InputMaybe<ModelBooleanInput>;
  isPinned?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelSearchCandidateProfileQueryFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileQueryFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  original_source?: InputMaybe<ModelStringInput>;
  phone?: InputMaybe<ModelStringInput>;
  qualifications?: InputMaybe<ModelStringInput>;
  returnedCandidatesCount?: InputMaybe<ModelIntInput>;
  skills?: InputMaybe<ModelStringInput>;
  tags?: InputMaybe<ModelStringInput>;
  time_in_role?: InputMaybe<ModelTimeComparisonListInput>;
  total_years_of_experience?: InputMaybe<ModelFloatInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchCandidateProfileSelectedConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchCandidateProfileSelectedConnection = {
  items: Array<Maybe<SearchCandidateProfileSelected>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSearchCandidateProfileSelectedFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchCandidateProfileSelectedItemConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateRelevance?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customInvitationMessage?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  searchCandidateProfileSelectedId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchCandidateProfileSelectedItemConnection = {
  items: Array<Maybe<SearchCandidateProfileSelectedItem>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSearchCandidateProfileSelectedItemFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateRelevance?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customInvitationMessage?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  searchCandidateProfileSelectedId?: InputMaybe<ModelIdInput>;
};

export type ModelSearchPeopleQueryFieldsConditionInput = {
  accumulated_results?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  company?: InputMaybe<ModelStringInput>;
  company_filter?: InputMaybe<ModelTimeFilterTypeInput>;
  company_size?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  current_company_only?: InputMaybe<ModelBooleanInput>;
  current_titles_only?: InputMaybe<ModelBooleanInput>;
  domain?: InputMaybe<ModelStringInput>;
  education?: InputMaybe<ModelStringInput>;
  exclude_companies?: InputMaybe<ModelStringInput>;
  exclude_job_titles?: InputMaybe<ModelStringInput>;
  include_related_job_titles?: InputMaybe<ModelBooleanInput>;
  industry?: InputMaybe<ModelStringInput>;
  job_title?: InputMaybe<ModelStringInput>;
  keyword?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  match_experience?: InputMaybe<ModelTimeFilterTypeInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  page?: InputMaybe<ModelIntInput>;
  page_size?: InputMaybe<ModelIntInput>;
  skills?: InputMaybe<ModelStringInput>;
  total_results?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  years_in_current_role?: InputMaybe<ModelStringInput>;
  years_of_experience?: InputMaybe<ModelStringInput>;
};

export type ModelSearchPeopleQueryFieldsConnection = {
  items: Array<Maybe<SearchPeopleQueryFields>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSearchPeopleQueryFieldsFilterInput = {
  accumulated_results?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSearchPeopleQueryFieldsFilterInput>>>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  company?: InputMaybe<ModelStringInput>;
  company_filter?: InputMaybe<ModelTimeFilterTypeInput>;
  company_size?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  current_company_only?: InputMaybe<ModelBooleanInput>;
  current_titles_only?: InputMaybe<ModelBooleanInput>;
  domain?: InputMaybe<ModelStringInput>;
  education?: InputMaybe<ModelStringInput>;
  exclude_companies?: InputMaybe<ModelStringInput>;
  exclude_job_titles?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  include_related_job_titles?: InputMaybe<ModelBooleanInput>;
  industry?: InputMaybe<ModelStringInput>;
  job_title?: InputMaybe<ModelStringInput>;
  keyword?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  match_experience?: InputMaybe<ModelTimeFilterTypeInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSearchPeopleQueryFieldsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSearchPeopleQueryFieldsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  page?: InputMaybe<ModelIntInput>;
  page_size?: InputMaybe<ModelIntInput>;
  skills?: InputMaybe<ModelStringInput>;
  total_results?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  years_in_current_role?: InputMaybe<ModelStringInput>;
  years_of_experience?: InputMaybe<ModelStringInput>;
};

export type ModelSelectedCandidateBatchStatusesConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateStatuses?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelSelectedCandidateBatchStatusesConnection = {
  items: Array<Maybe<SelectedCandidateBatchStatuses>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSelectedCandidateBatchStatusesFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateStatuses?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelSenderInput = {
  eq?: InputMaybe<Sender>;
  ne?: InputMaybe<Sender>;
};

export type ModelSentimentNameInput = {
  eq?: InputMaybe<SentimentName>;
  ne?: InputMaybe<SentimentName>;
};

export type ModelSimulationConversationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSimulationConversationConditionInput>>>;
  completedAt?: InputMaybe<ModelStringInput>;
  currentQuestionId?: InputMaybe<ModelStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelSimulationConversationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSimulationConversationConditionInput>>>;
  stage?: InputMaybe<ModelConversationStageInput>;
  status?: InputMaybe<ModelConversationStatusInput>;
};

export type ModelSimulationConversationConnection = {
  items: Array<Maybe<SimulationConversation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSimulationConversationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSimulationConversationFilterInput>>>;
  completedAt?: InputMaybe<ModelStringInput>;
  currentQuestionId?: InputMaybe<ModelStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelSimulationConversationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSimulationConversationFilterInput>>>;
  stage?: InputMaybe<ModelConversationStageInput>;
  status?: InputMaybe<ModelConversationStatusInput>;
};

export type ModelSimulationMessageConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSimulationMessageConditionInput>>>;
  body?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSimulationMessageConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSimulationMessageConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  rawBody?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSenderInput>;
  simulationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelSimulationMessageConnection = {
  items: Array<Maybe<SimulationMessage>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSimulationMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSimulationMessageFilterInput>>>;
  body?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelSimulationMessageFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSimulationMessageFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  rawBody?: InputMaybe<ModelStringInput>;
  sender?: InputMaybe<ModelSenderInput>;
  simulationId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelStringInput>;
};

export type ModelSizeInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
};

export type ModelSkillConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSkillConditionInput>>>;
  description?: InputMaybe<ModelStringInput>;
  normalizedSkill?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSkillConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSkillConditionInput>>>;
  skill?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export type ModelSkillConnection = {
  items: Array<Maybe<Skill>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSkillFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSkillFilterInput>>>;
  description?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  normalizedSkill?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSkillFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSkillFilterInput>>>;
  skill?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export enum ModelSortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type ModelSourcedCandidateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSourcedCandidateConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateRelevance?: InputMaybe<ModelStringInput>;
  contactOutRawData?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationNeedsReview?: InputMaybe<ModelBooleanInput>;
  conversationRepliesCount?: InputMaybe<ModelIntInput>;
  conversationStatus?: InputMaybe<ModelConversationStatusInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customInvitationMessage?: InputMaybe<ModelStringInput>;
  education?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  experience?: InputMaybe<ModelStringInput>;
  fetchPhoneNumberAttempted?: InputMaybe<ModelBooleanInput>;
  firstName?: InputMaybe<ModelStringInput>;
  fullName?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  lastName?: InputMaybe<ModelStringInput>;
  linkedInProfileUrl?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSourcedCandidateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSourcedCandidateConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  personalEmails?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  source?: InputMaybe<ModelCandidateSourceInput>;
  status?: InputMaybe<ModelSourcedCandidateStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  workEmails?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelSourcedCandidateConnection = {
  items: Array<Maybe<SourcedCandidate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelSourcedCandidateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSourcedCandidateFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateRelevance?: InputMaybe<ModelStringInput>;
  contactOutRawData?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationNeedsReview?: InputMaybe<ModelBooleanInput>;
  conversationRepliesCount?: InputMaybe<ModelIntInput>;
  conversationStatus?: InputMaybe<ModelConversationStatusInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  customInvitationMessage?: InputMaybe<ModelStringInput>;
  education?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  experience?: InputMaybe<ModelStringInput>;
  fetchPhoneNumberAttempted?: InputMaybe<ModelBooleanInput>;
  firstName?: InputMaybe<ModelStringInput>;
  fullName?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  lastName?: InputMaybe<ModelStringInput>;
  linkedInProfileUrl?: InputMaybe<ModelStringInput>;
  location?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelSourcedCandidateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSourcedCandidateFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  personalEmails?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  skills?: InputMaybe<ModelStringInput>;
  source?: InputMaybe<ModelCandidateSourceInput>;
  status?: InputMaybe<ModelSourcedCandidateStatusInput>;
  title?: InputMaybe<ModelStringInput>;
  workEmails?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelSourcedCandidateStatusInput = {
  eq?: InputMaybe<SourcedCandidateStatus>;
  ne?: InputMaybe<SourcedCandidateStatus>;
};

export type ModelStartWorkflowRunRejectionReasonInput = {
  eq?: InputMaybe<StartWorkflowRunRejectionReason>;
  ne?: InputMaybe<StartWorkflowRunRejectionReason>;
};

export type ModelStatusSetConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelStatusSetConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelStatusSetConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelStatusSetConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelStatusSetConnection = {
  items: Array<Maybe<StatusSet>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelStatusSetFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelStatusSetFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelStatusSetFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelStatusSetFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelStringInput = {
  attributeExists?: InputMaybe<Scalars['Boolean']['input']>;
  attributeType?: InputMaybe<ModelAttributeTypes>;
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<ModelSizeInput>;
};

export type ModelStringKeyConditionInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
};

export type ModelSubscriptionAtsQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionAtsQuestionFilterInput>>>;
  atsJobId?: InputMaybe<ModelSubscriptionIdInput>;
  atsQuestionId?: InputMaybe<ModelSubscriptionStringInput>;
  candidateBatchId?: InputMaybe<ModelSubscriptionIdInput>;
  category?: InputMaybe<ModelSubscriptionStringInput>;
  content?: InputMaybe<ModelSubscriptionStringInput>;
  description?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isRequired?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboQuestionId?: InputMaybe<ModelSubscriptionIdInput>;
  multipleChoiceAnswers?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionAtsQuestionFilterInput>>>;
  questionIndex?: InputMaybe<ModelSubscriptionIntInput>;
  type?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionBooleanInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ModelSubscriptionCampaignFilterInput = {
  additionalContext?: InputMaybe<ModelSubscriptionStringInput>;
  agentId?: InputMaybe<ModelSubscriptionIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCampaignFilterInput>>>;
  atsJobId?: InputMaybe<ModelSubscriptionIdInput>;
  atsJobPostingId?: InputMaybe<ModelSubscriptionIdInput>;
  atsListId?: InputMaybe<ModelSubscriptionIdInput>;
  averageTimeToComplete?: InputMaybe<ModelSubscriptionFloatInput>;
  averageTimeToFirstResponse?: InputMaybe<ModelSubscriptionFloatInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelSubscriptionIdInput>;
  campaignGroupId?: InputMaybe<ModelSubscriptionIdInput>;
  cancellationMessage?: InputMaybe<ModelSubscriptionStringInput>;
  candidateBatchId?: InputMaybe<ModelSubscriptionIdInput>;
  channel?: InputMaybe<ModelSubscriptionStringInput>;
  closingMessage?: InputMaybe<ModelSubscriptionStringInput>;
  closingMethod?: InputMaybe<ModelSubscriptionStringInput>;
  contactNumber?: InputMaybe<ModelSubscriptionStringInput>;
  conversationCompletedMessage?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  csvS3Key?: InputMaybe<ModelSubscriptionStringInput>;
  customRequest?: InputMaybe<ModelSubscriptionStringInput>;
  customTemplatedMessage?: InputMaybe<ModelSubscriptionStringInput>;
  customTemplatedSubjectLine?: InputMaybe<ModelSubscriptionStringInput>;
  disableNudging?: InputMaybe<ModelSubscriptionBooleanInput>;
  emailChannelFallbackEnabled?: InputMaybe<ModelSubscriptionBooleanInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  followUpMessage?: InputMaybe<ModelSubscriptionStringInput>;
  guestLabel?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  initialMessagesDeliveredCount?: InputMaybe<ModelSubscriptionIntInput>;
  initialMessagesReadCount?: InputMaybe<ModelSubscriptionIntInput>;
  initialMessagesSentCount?: InputMaybe<ModelSubscriptionIntInput>;
  initialMessagesUndeliveredCount?: InputMaybe<ModelSubscriptionIntInput>;
  isDuplicate?: InputMaybe<ModelSubscriptionBooleanInput>;
  isParent?: InputMaybe<ModelSubscriptionBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelSubscriptionBooleanInput>;
  jobDescription?: InputMaybe<ModelSubscriptionStringInput>;
  jobDescriptionText?: InputMaybe<ModelSubscriptionStringInput>;
  komboJobId?: InputMaybe<ModelSubscriptionIdInput>;
  language?: InputMaybe<ModelSubscriptionStringInput>;
  launchScheduleDateTime?: InputMaybe<ModelSubscriptionStringInput>;
  launchedAt?: InputMaybe<ModelSubscriptionStringInput>;
  meetingUrl?: InputMaybe<ModelSubscriptionStringInput>;
  messagesProcessedCount?: InputMaybe<ModelSubscriptionIntInput>;
  needsReview?: InputMaybe<ModelSubscriptionBooleanInput>;
  nudgesCount?: InputMaybe<ModelSubscriptionIntInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCampaignFilterInput>>>;
  outreachDescription?: InputMaybe<ModelSubscriptionStringInput>;
  periodDays?: InputMaybe<ModelSubscriptionIntInput>;
  referenceId?: InputMaybe<ModelSubscriptionStringInput>;
  rejectionMessage?: InputMaybe<ModelSubscriptionStringInput>;
  requiredHours?: InputMaybe<ModelSubscriptionIntInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  stoppedAt?: InputMaybe<ModelSubscriptionStringInput>;
  stoppedByUserId?: InputMaybe<ModelSubscriptionIdInput>;
  templateId?: InputMaybe<ModelSubscriptionIdInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<ModelSubscriptionFloatInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  totalConversationsCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalConversationsWithRepliesCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalMessagesCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalMessagesWithCallRequest?: InputMaybe<ModelSubscriptionIntInput>;
  totalMessagesWithCustomRequest?: InputMaybe<ModelSubscriptionIntInput>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalNotInterestedConversationCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalOptedOutConversationCount?: InputMaybe<ModelSubscriptionIntInput>;
  totalProspectsCount?: InputMaybe<ModelSubscriptionIntInput>;
  type?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
  webChatTemplateId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowVersionId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionCandidateBatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateBatchFilterInput>>>;
  atsJobId?: InputMaybe<ModelSubscriptionIdInput>;
  atsJobPostingId?: InputMaybe<ModelSubscriptionIdInput>;
  atsJobPostingUrl?: InputMaybe<ModelSubscriptionStringInput>;
  atsJobReference?: InputMaybe<ModelSubscriptionStringInput>;
  campaignId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateBatchGroupId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateBatchReanalysisReferenceId?: InputMaybe<ModelSubscriptionIdInput>;
  candidatesCount?: InputMaybe<ModelSubscriptionIntInput>;
  candidatesRequirementsMetCount?: InputMaybe<ModelSubscriptionIntInput>;
  candidatesRequirementsNotMetCount?: InputMaybe<ModelSubscriptionIntInput>;
  candidatesToProcessCount?: InputMaybe<ModelSubscriptionIntInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  csvS3Key?: InputMaybe<ModelSubscriptionStringInput>;
  customJobPostingUrl?: InputMaybe<ModelSubscriptionStringInput>;
  cvS3Keys?: InputMaybe<ModelSubscriptionStringInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isInitial?: InputMaybe<ModelSubscriptionBooleanInput>;
  isRecalculatingScores?: InputMaybe<ModelSubscriptionBooleanInput>;
  isWorkflowManaged?: InputMaybe<ModelSubscriptionBooleanInput>;
  jobDescription?: InputMaybe<ModelSubscriptionStringInput>;
  komboJobId?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateBatchFilterInput>>>;
  remainingRescoredCandidatesCount?: InputMaybe<ModelSubscriptionIntInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeSlug?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowVersionId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionCandidateBatchGroupFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateBatchGroupFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  jobCode?: InputMaybe<ModelSubscriptionStringInput>;
  name?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateBatchGroupFilterInput>>>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionCandidateFilterInput = {
  analysisErrorCode?: InputMaybe<ModelSubscriptionStringInput>;
  analysisOutcomeActedOnAt?: InputMaybe<ModelSubscriptionStringInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateFilterInput>>>;
  applicationSource?: InputMaybe<ModelSubscriptionStringInput>;
  atsApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  atsApplicationSource?: InputMaybe<ModelSubscriptionStringInput>;
  atsCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  atsInterviewStageId?: InputMaybe<ModelSubscriptionIdInput>;
  atsJobId?: InputMaybe<ModelSubscriptionIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateBatchId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateCvsParsingId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  conversationId?: InputMaybe<ModelSubscriptionIdInput>;
  conversationPreferredAnswersScore?: InputMaybe<ModelSubscriptionFloatInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  cvParsedText?: InputMaybe<ModelSubscriptionStringInput>;
  cvS3Key?: InputMaybe<ModelSubscriptionStringInput>;
  email?: InputMaybe<ModelSubscriptionStringInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  firstName?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isAllRequirementsMet?: InputMaybe<ModelSubscriptionBooleanInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  isLocked?: InputMaybe<ModelSubscriptionBooleanInput>;
  isMessagesGenerating?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  komboCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  komboJobId?: InputMaybe<ModelSubscriptionIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelSubscriptionIdInput>;
  komboStageId?: InputMaybe<ModelSubscriptionIdInput>;
  lastName?: InputMaybe<ModelSubscriptionStringInput>;
  linkedInProfileId?: InputMaybe<ModelSubscriptionStringInput>;
  metRequirementSlugs?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateFilterInput>>>;
  origin?: InputMaybe<ModelSubscriptionStringInput>;
  phoneNumber?: InputMaybe<ModelSubscriptionStringInput>;
  skills?: InputMaybe<ModelSubscriptionStringInput>;
  sourcedCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  totalScore?: InputMaybe<ModelSubscriptionFloatInput>;
  totalScoreScaled?: InputMaybe<ModelSubscriptionFloatInput>;
  unmetRequirementSlugs?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionCandidateProfileFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileFilterInput>>>;
  atsApplicationIds?: InputMaybe<ModelSubscriptionIdInput>;
  atsCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  awards?: InputMaybe<ModelSubscriptionStringInput>;
  candidateProfileVectorId?: InputMaybe<ModelSubscriptionIdInput>;
  certifications?: InputMaybe<ModelSubscriptionStringInput>;
  company?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  customFields?: InputMaybe<ModelSubscriptionStringInput>;
  email?: InputMaybe<ModelSubscriptionStringInput>;
  emailFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  emails?: InputMaybe<ModelSubscriptionStringInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  externalUrl?: InputMaybe<ModelSubscriptionStringInput>;
  firstName?: InputMaybe<ModelSubscriptionStringInput>;
  firstNameFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboApplicationIds?: InputMaybe<ModelSubscriptionIdInput>;
  komboCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  languages?: InputMaybe<ModelSubscriptionStringInput>;
  lastName?: InputMaybe<ModelSubscriptionStringInput>;
  lastNameFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  latestAtsApplicationDate?: InputMaybe<ModelSubscriptionStringInput>;
  latestAtsApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  latestCvS3Key?: InputMaybe<ModelSubscriptionStringInput>;
  latestCvText?: InputMaybe<ModelSubscriptionStringInput>;
  latestKomboApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  linkedInProfileUrl?: InputMaybe<ModelSubscriptionStringInput>;
  linkedInProfileUrlFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  linksFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  locationFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  metadata?: InputMaybe<ModelSubscriptionStringInput>;
  name?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelSubscriptionIdInput>;
  originalSource?: InputMaybe<ModelSubscriptionStringInput>;
  phoneNumber?: InputMaybe<ModelSubscriptionStringInput>;
  phoneNumberFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  phoneNumbers?: InputMaybe<ModelSubscriptionStringInput>;
  professionalSummaryFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  publications?: InputMaybe<ModelSubscriptionStringInput>;
  qualifications?: InputMaybe<ModelSubscriptionStringInput>;
  qualificationsFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  skills?: InputMaybe<ModelSubscriptionStringInput>;
  skillsFromCv?: InputMaybe<ModelSubscriptionStringInput>;
  socialLinks?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  statusChangedAt?: InputMaybe<ModelSubscriptionStringInput>;
  tags?: InputMaybe<ModelSubscriptionStringInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  totalExperienceInYears?: InputMaybe<ModelSubscriptionFloatInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionCandidateProfileListFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileListFilterInput>>>;
  candidateProfilesCount?: InputMaybe<ModelSubscriptionIntInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  description?: InputMaybe<ModelSubscriptionStringInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  lastApiWriteAt?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileListFilterInput>>>;
  teamIds?: InputMaybe<ModelSubscriptionIdInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionCandidateProfileListMembershipFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileListMembershipFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateProfileListId?: InputMaybe<ModelSubscriptionIdInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileListMembershipFilterInput>>>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionCandidateProfileNoteFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileNoteFilterInput>>>;
  atsApplicationId?: InputMaybe<ModelSubscriptionStringInput>;
  atsAuthorId?: InputMaybe<ModelSubscriptionStringInput>;
  atsCandidateId?: InputMaybe<ModelSubscriptionStringInput>;
  atsCandidateNoteId?: InputMaybe<ModelSubscriptionStringInput>;
  atsNoteCreatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  atsNoteDeletedAt?: InputMaybe<ModelSubscriptionStringInput>;
  atsNoteUpdatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  content?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboApplicationId?: InputMaybe<ModelSubscriptionStringInput>;
  komboCandidateId?: InputMaybe<ModelSubscriptionStringInput>;
  komboCandidateNoteId?: InputMaybe<ModelSubscriptionStringInput>;
  metadata?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionCandidateProfileNoteFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelSubscriptionIdInput>;
  type?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionConversationFilterInput = {
  activeChannel?: InputMaybe<ModelSubscriptionStringInput>;
  additionalContext?: InputMaybe<ModelSubscriptionStringInput>;
  agentId?: InputMaybe<ModelSubscriptionIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionConversationFilterInput>>>;
  applicationSource?: InputMaybe<ModelSubscriptionStringInput>;
  applicationStage?: InputMaybe<ModelSubscriptionStringInput>;
  atsApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  atsCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  atsInterviewStageId?: InputMaybe<ModelSubscriptionIdInput>;
  atsRejectedReasonId?: InputMaybe<ModelSubscriptionIdInput>;
  calendarBookingId?: InputMaybe<ModelSubscriptionIdInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelSubscriptionIdInput>;
  campaignId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  closePreviousConversations?: InputMaybe<ModelSubscriptionBooleanInput>;
  completedAt?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  crmContactId?: InputMaybe<ModelSubscriptionIdInput>;
  currentQuestionId?: InputMaybe<ModelSubscriptionStringInput>;
  disableNudging?: InputMaybe<ModelSubscriptionBooleanInput>;
  emailPrefix?: InputMaybe<ModelSubscriptionStringInput>;
  errorCode?: InputMaybe<ModelSubscriptionStringInput>;
  externalId?: InputMaybe<ModelSubscriptionStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelSubscriptionBooleanInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  isHumanTakeover?: InputMaybe<ModelSubscriptionBooleanInput>;
  isInbound?: InputMaybe<ModelSubscriptionBooleanInput>;
  isInitialEmailMessageOpened?: InputMaybe<ModelSubscriptionBooleanInput>;
  isRead?: InputMaybe<ModelSubscriptionBooleanInput>;
  isWebChatJoined?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboApplicationId?: InputMaybe<ModelSubscriptionIdInput>;
  komboCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  komboRejectionReasonId?: InputMaybe<ModelSubscriptionIdInput>;
  komboStageId?: InputMaybe<ModelSubscriptionIdInput>;
  meetingBookingStatus?: InputMaybe<ModelSubscriptionStringInput>;
  messagesCount?: InputMaybe<ModelSubscriptionIntInput>;
  needsReview?: InputMaybe<ModelSubscriptionBooleanInput>;
  nudgesSentCount?: InputMaybe<ModelSubscriptionIntInput>;
  openingMessage?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionConversationFilterInput>>>;
  participantEmailAddress?: InputMaybe<ModelSubscriptionStringInput>;
  participantFirstName?: InputMaybe<ModelSubscriptionStringInput>;
  participantLastName?: InputMaybe<ModelSubscriptionStringInput>;
  participantLinkedInProfile?: InputMaybe<ModelSubscriptionStringInput>;
  participantPhoneNumber?: InputMaybe<ModelSubscriptionStringInput>;
  pastOngoingConversationId?: InputMaybe<ModelSubscriptionIdInput>;
  preferredAnswersScore?: InputMaybe<ModelSubscriptionFloatInput>;
  repliesCount?: InputMaybe<ModelSubscriptionIntInput>;
  sentAt?: InputMaybe<ModelSubscriptionStringInput>;
  sourcedCandidateId?: InputMaybe<ModelSubscriptionIdInput>;
  stage?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  tags?: InputMaybe<ModelSubscriptionStringInput>;
  tagsNormalized?: InputMaybe<ModelSubscriptionStringInput>;
  timeToComplete?: InputMaybe<ModelSubscriptionFloatInput>;
  timeToFirstResponse?: InputMaybe<ModelSubscriptionFloatInput>;
  totalNudgesSentCount?: InputMaybe<ModelSubscriptionIntInput>;
  twilioConversationId?: InputMaybe<ModelSubscriptionStringInput>;
  twilioParticipantId?: InputMaybe<ModelSubscriptionStringInput>;
  twilioRedirectConversationId?: InputMaybe<ModelSubscriptionIdInput>;
  twilioRedirectParticipantId?: InputMaybe<ModelSubscriptionIdInput>;
  unresolvedNeedsReviewReasons?: InputMaybe<ModelSubscriptionStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
  webChatUrlId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionFloatInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  ge?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  le?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type ModelSubscriptionIdInput = {
  beginsWith?: InputMaybe<Scalars['ID']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  ge?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  le?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ModelSubscriptionIntInput = {
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  ge?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  le?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type ModelSubscriptionIntegrationCredentialsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionIntegrationCredentialsFilterInput>>>;
  appSubdomain?: InputMaybe<ModelSubscriptionStringInput>;
  atsApplicationsLastFetchedAt?: InputMaybe<ModelSubscriptionStringInput>;
  atsCandidatesLastFetchedAt?: InputMaybe<ModelSubscriptionStringInput>;
  atsInstanceId?: InputMaybe<ModelSubscriptionStringInput>;
  atsJobsLastFetchedAt?: InputMaybe<ModelSubscriptionStringInput>;
  atsListsLastFetchedAt?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  hubSpotAccessToken?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isActive?: InputMaybe<ModelSubscriptionBooleanInput>;
  komboIntegrationId?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionIntegrationCredentialsFilterInput>>>;
  provider?: InputMaybe<ModelSubscriptionStringInput>;
  stackOneAccountId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionMessageFilterInput = {
  agentId?: InputMaybe<ModelSubscriptionIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionMessageFilterInput>>>;
  body?: InputMaybe<ModelSubscriptionStringInput>;
  campaignId?: InputMaybe<ModelSubscriptionIdInput>;
  conversationId?: InputMaybe<ModelSubscriptionIdInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  deliveredAt?: InputMaybe<ModelSubscriptionStringInput>;
  emailDeliveryEvent?: InputMaybe<ModelSubscriptionStringInput>;
  emailSubjectLine?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  isEmailOpened?: InputMaybe<ModelSubscriptionBooleanInput>;
  isFallback?: InputMaybe<ModelSubscriptionBooleanInput>;
  isInitial?: InputMaybe<ModelSubscriptionBooleanInput>;
  isNegativeSentiment?: InputMaybe<ModelSubscriptionBooleanInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionMessageFilterInput>>>;
  outreachQuestionId?: InputMaybe<ModelSubscriptionIdInput>;
  rawBody?: InputMaybe<ModelSubscriptionStringInput>;
  readAt?: InputMaybe<ModelSubscriptionStringInput>;
  sender?: InputMaybe<ModelSubscriptionStringInput>;
  sentimentName?: InputMaybe<ModelSubscriptionStringInput>;
  sesEmailId?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  templateId?: InputMaybe<ModelSubscriptionIdInput>;
  twilioErrorCode?: InputMaybe<ModelSubscriptionStringInput>;
  twilioMessageId?: InputMaybe<ModelSubscriptionStringInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionProductInput = {
  eq?: InputMaybe<SubscriptionProduct>;
  ne?: InputMaybe<SubscriptionProduct>;
};

export type ModelSubscriptionSearchCandidateProfileMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileMessageFilterInput>>>;
  body?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  generatedSemanticSearchQuery?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isOverwritten?: InputMaybe<ModelSubscriptionBooleanInput>;
  normalisedQueryUserBody?: InputMaybe<ModelSubscriptionStringInput>;
  optimisedSemanticMessage?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileMessageFilterInput>>>;
  searchCandidateProfileQueryId?: InputMaybe<ModelSubscriptionIdInput>;
  semanticQueries?: InputMaybe<ModelSubscriptionStringInput>;
  sender?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionSearchCandidateProfileQueryFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileQueryFilterInput>>>;
  appliedFilter?: InputMaybe<ModelSubscriptionStringInput>;
  ats_candidate_id?: InputMaybe<ModelSubscriptionStringInput>;
  candidate_profile_list_ids?: InputMaybe<ModelSubscriptionIdInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  current_company?: InputMaybe<ModelSubscriptionStringInput>;
  current_job_title?: InputMaybe<ModelSubscriptionStringInput>;
  displayTitle?: InputMaybe<ModelSubscriptionStringInput>;
  email?: InputMaybe<ModelSubscriptionStringInput>;
  filter?: InputMaybe<ModelSubscriptionStringInput>;
  full_name?: InputMaybe<ModelSubscriptionStringInput>;
  generatedFilter?: InputMaybe<ModelSubscriptionStringInput>;
  geo_radius?: InputMaybe<ModelSubscriptionFloatInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isArchived?: InputMaybe<ModelSubscriptionBooleanInput>;
  isPinned?: InputMaybe<ModelSubscriptionBooleanInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileQueryFilterInput>>>;
  original_source?: InputMaybe<ModelSubscriptionStringInput>;
  phone?: InputMaybe<ModelSubscriptionStringInput>;
  qualifications?: InputMaybe<ModelSubscriptionStringInput>;
  returnedCandidatesCount?: InputMaybe<ModelSubscriptionIntInput>;
  skills?: InputMaybe<ModelSubscriptionStringInput>;
  tags?: InputMaybe<ModelSubscriptionStringInput>;
  time_in_role?: InputMaybe<ModelSubscriptionStringInput>;
  total_years_of_experience?: InputMaybe<ModelSubscriptionFloatInput>;
  userId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionSearchCandidateProfileSelectedFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedFilterInput>>>;
};

export type ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateRelevance?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  customInvitationMessage?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput>>>;
  searchCandidateProfileSelectedId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionSimulationConversationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSimulationConversationFilterInput>>>;
  completedAt?: InputMaybe<ModelSubscriptionStringInput>;
  currentQuestionId?: InputMaybe<ModelSubscriptionStringInput>;
  firstQuestionHasBeenAsked?: InputMaybe<ModelSubscriptionBooleanInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSimulationConversationFilterInput>>>;
  stage?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionSimulationMessageFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSimulationMessageFilterInput>>>;
  body?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSimulationMessageFilterInput>>>;
  rawBody?: InputMaybe<ModelSubscriptionStringInput>;
  sender?: InputMaybe<ModelSubscriptionStringInput>;
  simulationId?: InputMaybe<ModelSubscriptionIdInput>;
  userId?: InputMaybe<ModelSubscriptionStringInput>;
};

export type ModelSubscriptionSourcedCandidateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionSourcedCandidateFilterInput>>>;
  campaignId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateBatchId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateProfileId?: InputMaybe<ModelSubscriptionIdInput>;
  candidateRelevance?: InputMaybe<ModelSubscriptionStringInput>;
  contactOutRawData?: InputMaybe<ModelSubscriptionStringInput>;
  conversationId?: InputMaybe<ModelSubscriptionIdInput>;
  conversationNeedsReview?: InputMaybe<ModelSubscriptionBooleanInput>;
  conversationRepliesCount?: InputMaybe<ModelSubscriptionIntInput>;
  conversationStatus?: InputMaybe<ModelSubscriptionStringInput>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  customInvitationMessage?: InputMaybe<ModelSubscriptionStringInput>;
  education?: InputMaybe<ModelSubscriptionStringInput>;
  email?: InputMaybe<ModelSubscriptionStringInput>;
  experience?: InputMaybe<ModelSubscriptionStringInput>;
  fetchPhoneNumberAttempted?: InputMaybe<ModelSubscriptionBooleanInput>;
  firstName?: InputMaybe<ModelSubscriptionStringInput>;
  fullName?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isDeleted?: InputMaybe<ModelSubscriptionBooleanInput>;
  lastName?: InputMaybe<ModelSubscriptionStringInput>;
  linkedInProfileUrl?: InputMaybe<ModelSubscriptionStringInput>;
  location?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionSourcedCandidateFilterInput>>>;
  personalEmails?: InputMaybe<ModelSubscriptionStringInput>;
  phoneNumber?: InputMaybe<ModelSubscriptionStringInput>;
  skills?: InputMaybe<ModelSubscriptionStringInput>;
  source?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  title?: InputMaybe<ModelSubscriptionStringInput>;
  workEmails?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionStringInput = {
  beginsWith?: InputMaybe<Scalars['String']['input']>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  ge?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  le?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ModelSubscriptionUnansweredQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionUnansweredQuestionFilterInput>>>;
  associatedMessageId?: InputMaybe<ModelSubscriptionIdInput>;
  campaignId?: InputMaybe<ModelSubscriptionIdInput>;
  conversationId?: InputMaybe<ModelSubscriptionIdInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isAnswered?: InputMaybe<ModelSubscriptionBooleanInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionUnansweredQuestionFilterInput>>>;
  summary?: InputMaybe<ModelSubscriptionStringInput>;
  workflowNodeId?: InputMaybe<ModelSubscriptionStringInput>;
  workflowRunId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSubscriptionWhatsaapTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionWhatsaapTemplateFilterInput>>>;
  campaignType?: InputMaybe<ModelSubscriptionStringInput>;
  channel?: InputMaybe<ModelSubscriptionStringInput>;
  content?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  isLinkedIn?: InputMaybe<ModelSubscriptionBooleanInput>;
  language?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionWhatsaapTemplateFilterInput>>>;
  organizationConfigId?: InputMaybe<ModelSubscriptionIdInput>;
  organizationId?: InputMaybe<ModelSubscriptionIdInput>;
  twilioContentTemplateId?: InputMaybe<ModelSubscriptionStringInput>;
  type?: InputMaybe<ModelSubscriptionStringInput>;
  variablesCount?: InputMaybe<ModelSubscriptionIntInput>;
};

export type ModelSubscriptionWorkflowContactImportFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkflowContactImportFilterInput>>>;
  createdAt?: InputMaybe<ModelSubscriptionStringInput>;
  emailColumn?: InputMaybe<ModelSubscriptionStringInput>;
  externalIdColumn?: InputMaybe<ModelSubscriptionStringInput>;
  failureReason?: InputMaybe<ModelSubscriptionStringInput>;
  fileName?: InputMaybe<ModelSubscriptionStringInput>;
  firstFailedRowNumber?: InputMaybe<ModelSubscriptionIntInput>;
  firstNameColumn?: InputMaybe<ModelSubscriptionStringInput>;
  id?: InputMaybe<ModelSubscriptionIdInput>;
  importedByUserId?: InputMaybe<ModelSubscriptionIdInput>;
  lastNameColumn?: InputMaybe<ModelSubscriptionStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelSubscriptionWorkflowContactImportFilterInput>>>;
  phoneNumberColumn?: InputMaybe<ModelSubscriptionStringInput>;
  rowsImported?: InputMaybe<ModelSubscriptionIntInput>;
  rowsInFile?: InputMaybe<ModelSubscriptionIntInput>;
  s3ETag?: InputMaybe<ModelSubscriptionStringInput>;
  s3Key?: InputMaybe<ModelSubscriptionStringInput>;
  status?: InputMaybe<ModelSubscriptionStringInput>;
  tagColumns?: InputMaybe<ModelSubscriptionStringInput>;
  updatedAt?: InputMaybe<ModelSubscriptionStringInput>;
  workflowId?: InputMaybe<ModelSubscriptionIdInput>;
};

export type ModelSyncStatusInput = {
  eq?: InputMaybe<SyncStatus>;
  ne?: InputMaybe<SyncStatus>;
};

export type ModelTagConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTagConditionInput>>>;
  not?: InputMaybe<ModelTagConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTagConditionInput>>>;
  tag?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export type ModelTagConnection = {
  items: Array<Maybe<Tag>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTagFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTagFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTagFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTagFilterInput>>>;
  tag?: InputMaybe<ModelStringInput>;
  vectorDbTenantName?: InputMaybe<ModelStringInput>;
};

export type ModelTeamConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelTeamConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelTeamConnection = {
  items: Array<Maybe<Team>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  externalId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelTeamFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelTeamMembershipConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamMembershipConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelTeamMembershipConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamMembershipConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  teamId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelTeamMembershipConnection = {
  items: Array<Maybe<TeamMembership>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTeamMembershipFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTeamMembershipFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTeamMembershipFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTeamMembershipFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  teamId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelTemplateTypeInput = {
  eq?: InputMaybe<TemplateType>;
  ne?: InputMaybe<TemplateType>;
};

export type ModelTimeComparisonListInput = {
  contains?: InputMaybe<TimeComparison>;
  eq?: InputMaybe<Array<InputMaybe<TimeComparison>>>;
  ne?: InputMaybe<Array<InputMaybe<TimeComparison>>>;
  notContains?: InputMaybe<TimeComparison>;
};

export type ModelTimeFilterTypeInput = {
  eq?: InputMaybe<TimeFilterType>;
  ne?: InputMaybe<TimeFilterType>;
};

export type ModelToneInput = {
  eq?: InputMaybe<Tone>;
  ne?: InputMaybe<Tone>;
};

export type ModelTrafficLightInput = {
  eq?: InputMaybe<TrafficLight>;
  ne?: InputMaybe<TrafficLight>;
};

export type ModelTwilioAccountCredentialsConditionInput = {
  accountSid?: InputMaybe<ModelIdInput>;
  alphaSenderMessagingServiceId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelTwilioAccountCredentialsConditionInput>>>;
  apiKey?: InputMaybe<ModelStringInput>;
  apiSecret?: InputMaybe<ModelStringInput>;
  authToken?: InputMaybe<ModelStringInput>;
  chatServiceSid?: InputMaybe<ModelIdInput>;
  inboundChatServiceId?: InputMaybe<ModelIdInput>;
  messagingServiceSid?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTwilioAccountCredentialsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTwilioAccountCredentialsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelTwilioAccountCredentialsConnection = {
  items: Array<Maybe<TwilioAccountCredentials>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTwilioAccountCredentialsFilterInput = {
  accountSid?: InputMaybe<ModelIdInput>;
  alphaSenderMessagingServiceId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelTwilioAccountCredentialsFilterInput>>>;
  apiKey?: InputMaybe<ModelStringInput>;
  apiSecret?: InputMaybe<ModelStringInput>;
  authToken?: InputMaybe<ModelStringInput>;
  chatServiceSid?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  inboundChatServiceId?: InputMaybe<ModelIdInput>;
  messagingServiceSid?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTwilioAccountCredentialsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTwilioAccountCredentialsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
};

export type ModelTwilioSenderStatusInput = {
  eq?: InputMaybe<TwilioSenderStatus>;
  ne?: InputMaybe<TwilioSenderStatus>;
};

export type ModelTypeformLinkConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTypeformLinkConditionInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTypeformLinkConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTypeformLinkConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  url?: InputMaybe<ModelStringInput>;
};

export type ModelTypeformLinkConnection = {
  items: Array<Maybe<TypeformLink>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTypeformLinkFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTypeformLinkFilterInput>>>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTypeformLinkFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTypeformLinkFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  url?: InputMaybe<ModelStringInput>;
};

export type ModelTypeformRecordConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTypeformRecordConditionInput>>>;
  formId?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelTypeformRecordConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTypeformRecordConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  type?: InputMaybe<ModelTypeformRecordTypeInput>;
};

export type ModelTypeformRecordConnection = {
  items: Array<Maybe<TypeformRecord>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelTypeformRecordFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelTypeformRecordFilterInput>>>;
  formId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelTypeformRecordFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelTypeformRecordFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  type?: InputMaybe<ModelTypeformRecordTypeInput>;
};

export type ModelTypeformRecordTypeInput = {
  eq?: InputMaybe<TypeformRecordType>;
  ne?: InputMaybe<TypeformRecordType>;
};

export type ModelUnansweredQuestionConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUnansweredQuestionConditionInput>>>;
  associatedMessageId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  isAnswered?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelUnansweredQuestionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUnansweredQuestionConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  summary?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelUnansweredQuestionConnection = {
  items: Array<Maybe<UnansweredQuestion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUnansweredQuestionFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUnansweredQuestionFilterInput>>>;
  associatedMessageId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  id?: InputMaybe<ModelIdInput>;
  isAnswered?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelUnansweredQuestionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUnansweredQuestionFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  summary?: InputMaybe<ModelStringInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelUserCalendarConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarConditionInput>>>;
  availabilityRedirectCalendarId?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  email?: InputMaybe<ModelStringInput>;
  invitedEmail?: InputMaybe<ModelStringInput>;
  isSharedMailbox?: InputMaybe<ModelBooleanInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelUserCalendarConditionInput>;
  nylasGrantId?: InputMaybe<ModelStringInput>;
  nylasVirtualCalendarId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  provider?: InputMaybe<ModelUserCalendarProviderInput>;
  reference?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelUserCalendarStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelUserCalendarConnection = {
  items: Array<Maybe<UserCalendar>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserCalendarFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarFilterInput>>>;
  availabilityRedirectCalendarId?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  email?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  invitedEmail?: InputMaybe<ModelStringInput>;
  isSharedMailbox?: InputMaybe<ModelBooleanInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelUserCalendarFilterInput>;
  nylasGrantId?: InputMaybe<ModelStringInput>;
  nylasVirtualCalendarId?: InputMaybe<ModelStringInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationIds?: InputMaybe<ModelIdInput>;
  provider?: InputMaybe<ModelUserCalendarProviderInput>;
  reference?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelUserCalendarStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelUserCalendarMeetingTemplateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>>>;
  autoCollectAvailability?: InputMaybe<ModelBooleanInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>>>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
};

export type ModelUserCalendarMeetingTemplateConnection = {
  items: Array<Maybe<UserCalendarMeetingTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserCalendarMeetingTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>>>;
  autoCollectAvailability?: InputMaybe<ModelBooleanInput>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>>>;
  updatedAt?: InputMaybe<ModelStringInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
};

export type ModelUserCalendarOrganizationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarOrganizationConditionInput>>>;
  not?: InputMaybe<ModelUserCalendarOrganizationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarOrganizationConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelUserCalendarOrganizationConnection = {
  items: Array<Maybe<UserCalendarOrganization>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserCalendarOrganizationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserCalendarOrganizationFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserCalendarOrganizationFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelUserCalendarProviderInput = {
  eq?: InputMaybe<UserCalendarProvider>;
  ne?: InputMaybe<UserCalendarProvider>;
};

export type ModelUserCalendarStatusInput = {
  eq?: InputMaybe<UserCalendarStatus>;
  ne?: InputMaybe<UserCalendarStatus>;
};

export type ModelUserConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserConditionInput>>>;
  correspondenceEmail?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  invitedDate?: InputMaybe<ModelStringInput>;
  isDeactivated?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isOnboard?: InputMaybe<ModelBooleanInput>;
  jobTitle?: InputMaybe<ModelStringInput>;
  lastLoginAt?: InputMaybe<ModelStringInput>;
  lastName?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelUserConditionInput>;
  onboardingTourStatus?: InputMaybe<ModelOnboardingTourStatusInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationGroupRole?: InputMaybe<ModelOrganizationGroupRoleInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  owner?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  role?: InputMaybe<ModelUserRoleInput>;
  twilioPhoneNumber?: InputMaybe<ModelStringInput>;
  userPlanMembershipId?: InputMaybe<ModelIdInput>;
  userPreferencesId?: InputMaybe<ModelIdInput>;
};

export type ModelUserConnection = {
  items: Array<Maybe<User>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
  correspondenceEmail?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  invitedDate?: InputMaybe<ModelStringInput>;
  isDeactivated?: InputMaybe<ModelBooleanInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  isOnboard?: InputMaybe<ModelBooleanInput>;
  jobTitle?: InputMaybe<ModelStringInput>;
  lastLoginAt?: InputMaybe<ModelStringInput>;
  lastName?: InputMaybe<ModelStringInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelUserFilterInput>;
  onboardingTourStatus?: InputMaybe<ModelOnboardingTourStatusInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationGroupRole?: InputMaybe<ModelOrganizationGroupRoleInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  owner?: InputMaybe<ModelStringInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  role?: InputMaybe<ModelUserRoleInput>;
  twilioPhoneNumber?: InputMaybe<ModelStringInput>;
  userPlanMembershipId?: InputMaybe<ModelIdInput>;
  userPreferencesId?: InputMaybe<ModelIdInput>;
};

export type ModelUserOrganizationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserOrganizationConditionInput>>>;
  not?: InputMaybe<ModelUserOrganizationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserOrganizationConditionInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  role?: InputMaybe<ModelUserRoleInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelUserOrganizationConnection = {
  items: Array<Maybe<UserOrganization>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelUserOrganizationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelUserOrganizationFilterInput>>>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelUserOrganizationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelUserOrganizationFilterInput>>>;
  organizationGroupId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  role?: InputMaybe<ModelUserRoleInput>;
  userId?: InputMaybe<ModelIdInput>;
};

export type ModelUserRoleInput = {
  eq?: InputMaybe<UserRole>;
  ne?: InputMaybe<UserRole>;
};

export type ModelVirtualCalendarConversationConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelVirtualCalendarConversationConditionInput>>>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationStage?: InputMaybe<ModelConversationStageInput>;
  conversationStatus?: InputMaybe<ModelConversationStatusInput>;
  not?: InputMaybe<ModelVirtualCalendarConversationConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelVirtualCalendarConversationConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelVirtualCalendarConversationConnection = {
  items: Array<Maybe<VirtualCalendarConversation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelVirtualCalendarConversationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelVirtualCalendarConversationFilterInput>>>;
  calendarMeetingTemplateId?: InputMaybe<ModelIdInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  conversationStage?: InputMaybe<ModelConversationStageInput>;
  conversationStatus?: InputMaybe<ModelConversationStatusInput>;
  id?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelVirtualCalendarConversationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelVirtualCalendarConversationFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  userCalendarId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelWebhookEventTypeListInput = {
  contains?: InputMaybe<WebhookEventType>;
  eq?: InputMaybe<Array<InputMaybe<WebhookEventType>>>;
  ne?: InputMaybe<Array<InputMaybe<WebhookEventType>>>;
  notContains?: InputMaybe<WebhookEventType>;
};

export type ModelWhatsaapTemplateConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWhatsaapTemplateConditionInput>>>;
  campaignType?: InputMaybe<ModelCampaignTypeInput>;
  channel?: InputMaybe<ModelChannelsInput>;
  content?: InputMaybe<ModelStringInput>;
  isLinkedIn?: InputMaybe<ModelBooleanInput>;
  language?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWhatsaapTemplateConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWhatsaapTemplateConditionInput>>>;
  organizationConfigId?: InputMaybe<ModelIdInput>;
  organizationConfigWhatsAppTemplatesId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  twilioContentTemplateId?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelTemplateTypeInput>;
  variablesCount?: InputMaybe<ModelIntInput>;
};

export type ModelWhatsaapTemplateConnection = {
  items: Array<Maybe<WhatsaapTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWhatsaapTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWhatsaapTemplateFilterInput>>>;
  campaignType?: InputMaybe<ModelCampaignTypeInput>;
  channel?: InputMaybe<ModelChannelsInput>;
  content?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isLinkedIn?: InputMaybe<ModelBooleanInput>;
  language?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWhatsaapTemplateFilterInput>>>;
  organizationConfigId?: InputMaybe<ModelIdInput>;
  organizationConfigWhatsAppTemplatesId?: InputMaybe<ModelIdInput>;
  organizationId?: InputMaybe<ModelIdInput>;
  twilioContentTemplateId?: InputMaybe<ModelStringInput>;
  type?: InputMaybe<ModelTemplateTypeInput>;
  variablesCount?: InputMaybe<ModelIntInput>;
};

export type ModelWorkflowAtsJobConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowAtsJobConditionInput>>>;
  atsJobReference?: InputMaybe<ModelStringInput>;
  atsJobTitle?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvRequired?: InputMaybe<ModelBooleanInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelWorkflowAtsJobConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowAtsJobConditionInput>>>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowAtsJobConnection = {
  items: Array<Maybe<WorkflowAtsJob>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowAtsJobFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowAtsJobFilterInput>>>;
  atsJobId?: InputMaybe<ModelIdInput>;
  atsJobReference?: InputMaybe<ModelStringInput>;
  atsJobTitle?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  cvRequired?: InputMaybe<ModelBooleanInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelWorkflowAtsJobFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowAtsJobFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowConditionInput>>>;
  apiModifiedDate?: InputMaybe<ModelStringInput>;
  canvasVisualConfiguration?: InputMaybe<ModelStringInput>;
  canvasVisualConfigurationModifiedDate?: InputMaybe<ModelStringInput>;
  configuration?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  description?: InputMaybe<ModelStringInput>;
  embeddedAtsJobId?: InputMaybe<ModelStringInput>;
  entrySources?: InputMaybe<ModelWorkflowTriggerSourceListInput>;
  externalId?: InputMaybe<ModelStringInput>;
  liveWorkflowVersionId?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  settings?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelWorkflowConnection = {
  items: Array<Maybe<Workflow>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowContactByWorkflowAndStatusCompositeKeyConditionInput = {
  beginsWith?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
  between?: InputMaybe<Array<InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>>>;
  eq?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
  ge?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
  gt?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
  le?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
  lt?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput>;
};

export type ModelWorkflowContactByWorkflowAndStatusCompositeKeyInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<WorkflowContactStatus>;
};

export type ModelWorkflowContactConditionInput = {
  alreadyEnrolledRunId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowContactConditionInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  dedupKey?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  enrolmentFailureReason?: InputMaybe<ModelStartWorkflowRunRejectionReasonInput>;
  entrySource?: InputMaybe<ModelWorkflowTriggerSourceInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  lastName?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowContactConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowContactConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  rowNumber?: InputMaybe<ModelIntInput>;
  sourceRow?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowContactStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  validationErrors?: InputMaybe<ModelStringInput>;
  workflowContactImportId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowContactConnection = {
  items: Array<Maybe<WorkflowContact>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowContactFilterInput = {
  alreadyEnrolledRunId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowContactFilterInput>>>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  dedupKey?: InputMaybe<ModelStringInput>;
  email?: InputMaybe<ModelStringInput>;
  enrolmentFailureReason?: InputMaybe<ModelStartWorkflowRunRejectionReasonInput>;
  entrySource?: InputMaybe<ModelWorkflowTriggerSourceInput>;
  externalId?: InputMaybe<ModelStringInput>;
  firstName?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  isDeleted?: InputMaybe<ModelBooleanInput>;
  lastName?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowContactFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowContactFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumber?: InputMaybe<ModelStringInput>;
  rowNumber?: InputMaybe<ModelIntInput>;
  sourceRow?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowContactStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  validationErrors?: InputMaybe<ModelStringInput>;
  workflowContactImportId?: InputMaybe<ModelIdInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowContactImportConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowContactImportConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  emailColumn?: InputMaybe<ModelStringInput>;
  externalIdColumn?: InputMaybe<ModelStringInput>;
  failureReason?: InputMaybe<ModelStringInput>;
  fileName?: InputMaybe<ModelStringInput>;
  firstFailedRowNumber?: InputMaybe<ModelIntInput>;
  firstNameColumn?: InputMaybe<ModelStringInput>;
  importedByUserId?: InputMaybe<ModelIdInput>;
  lastNameColumn?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowContactImportConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowContactImportConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumberColumn?: InputMaybe<ModelStringInput>;
  rowsImported?: InputMaybe<ModelIntInput>;
  rowsInFile?: InputMaybe<ModelIntInput>;
  s3ETag?: InputMaybe<ModelStringInput>;
  s3Key?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowContactImportStatusInput>;
  tagColumns?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowContactImportConnection = {
  items: Array<Maybe<WorkflowContactImport>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowContactImportFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowContactImportFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  emailColumn?: InputMaybe<ModelStringInput>;
  externalIdColumn?: InputMaybe<ModelStringInput>;
  failureReason?: InputMaybe<ModelStringInput>;
  fileName?: InputMaybe<ModelStringInput>;
  firstFailedRowNumber?: InputMaybe<ModelIntInput>;
  firstNameColumn?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  importedByUserId?: InputMaybe<ModelIdInput>;
  lastNameColumn?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowContactImportFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowContactImportFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  phoneNumberColumn?: InputMaybe<ModelStringInput>;
  rowsImported?: InputMaybe<ModelIntInput>;
  rowsInFile?: InputMaybe<ModelIntInput>;
  s3ETag?: InputMaybe<ModelStringInput>;
  s3Key?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowContactImportStatusInput>;
  tagColumns?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowContactImportStatusInput = {
  eq?: InputMaybe<WorkflowContactImportStatus>;
  ne?: InputMaybe<WorkflowContactImportStatus>;
};

export type ModelWorkflowContactStatusInput = {
  eq?: InputMaybe<WorkflowContactStatus>;
  ne?: InputMaybe<WorkflowContactStatus>;
};

export type ModelWorkflowEventConditionInput = {
  analysedApplicationId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowEventConditionInput>>>;
  calendarBookingId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  causationId?: InputMaybe<ModelStringInput>;
  contextSnapshot?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  correlationId?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  eventData?: InputMaybe<ModelStringInput>;
  eventSource?: InputMaybe<ModelStringInput>;
  eventType?: InputMaybe<ModelStringInput>;
  eventVersion?: InputMaybe<ModelStringInput>;
  failureReason?: InputMaybe<ModelStringInput>;
  messageId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelWorkflowEventConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowEventConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  processedAt?: InputMaybe<ModelStringInput>;
  publishedAt?: InputMaybe<ModelStringInput>;
  retryCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowEventStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowExternalId?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowEventConnection = {
  items: Array<Maybe<WorkflowEvent>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowEventFilterInput = {
  analysedApplicationId?: InputMaybe<ModelIdInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowEventFilterInput>>>;
  calendarBookingId?: InputMaybe<ModelIdInput>;
  campaignId?: InputMaybe<ModelIdInput>;
  candidateBatchId?: InputMaybe<ModelIdInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  causationId?: InputMaybe<ModelStringInput>;
  contextSnapshot?: InputMaybe<ModelStringInput>;
  conversationId?: InputMaybe<ModelIdInput>;
  correlationId?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  eventData?: InputMaybe<ModelStringInput>;
  eventSource?: InputMaybe<ModelStringInput>;
  eventType?: InputMaybe<ModelStringInput>;
  eventVersion?: InputMaybe<ModelStringInput>;
  failureReason?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  messageId?: InputMaybe<ModelIdInput>;
  not?: InputMaybe<ModelWorkflowEventFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowEventFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  processedAt?: InputMaybe<ModelStringInput>;
  publishedAt?: InputMaybe<ModelStringInput>;
  retryCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowEventStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowExternalId?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowNodeId?: InputMaybe<ModelStringInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowEventStatusInput = {
  eq?: InputMaybe<WorkflowEventStatus>;
  ne?: InputMaybe<WorkflowEventStatus>;
};

export type ModelWorkflowFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowFilterInput>>>;
  apiModifiedDate?: InputMaybe<ModelStringInput>;
  canvasVisualConfiguration?: InputMaybe<ModelStringInput>;
  canvasVisualConfigurationModifiedDate?: InputMaybe<ModelStringInput>;
  configuration?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  createdByUserId?: InputMaybe<ModelIdInput>;
  description?: InputMaybe<ModelStringInput>;
  embeddedAtsJobId?: InputMaybe<ModelStringInput>;
  entrySources?: InputMaybe<ModelWorkflowTriggerSourceListInput>;
  externalId?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  liveWorkflowVersionId?: InputMaybe<ModelIdInput>;
  name?: InputMaybe<ModelStringInput>;
  not?: InputMaybe<ModelWorkflowFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  settings?: InputMaybe<ModelStringInput>;
  status?: InputMaybe<ModelWorkflowStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
};

export type ModelWorkflowNodeTypeInput = {
  eq?: InputMaybe<WorkflowNodeType>;
  ne?: InputMaybe<WorkflowNodeType>;
};

export type ModelWorkflowRunCancellationCodeInput = {
  eq?: InputMaybe<WorkflowRunCancellationCode>;
  ne?: InputMaybe<WorkflowRunCancellationCode>;
};

export type ModelWorkflowRunCandidateProfileConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>>>;
  candidateProfileFirstName?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileLastName?: InputMaybe<ModelStringInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentNodeId?: InputMaybe<ModelStringInput>;
  hasPartialFailures?: InputMaybe<ModelBooleanInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowRunStatus?: InputMaybe<ModelWorkflowRunStatusInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelWorkflowRunCandidateProfileConnection = {
  items: Array<Maybe<WorkflowRunCandidateProfile>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowRunCandidateProfileFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>>>;
  candidateProfileFirstName?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileLastName?: InputMaybe<ModelStringInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentNodeId?: InputMaybe<ModelStringInput>;
  hasPartialFailures?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  not?: InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowRunId?: InputMaybe<ModelIdInput>;
  workflowRunStatus?: InputMaybe<ModelWorkflowRunStatusInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelWorkflowRunConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowRunConditionInput>>>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  cancellationCode?: InputMaybe<ModelWorkflowRunCancellationCodeInput>;
  candidateProfileFirstName?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileLastName?: InputMaybe<ModelStringInput>;
  candidateProfileName?: InputMaybe<ModelStringInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  context?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentNodeId?: InputMaybe<ModelStringInput>;
  errorCode?: InputMaybe<ModelStringInput>;
  errorMessage?: InputMaybe<ModelStringInput>;
  errorReason?: InputMaybe<ModelStringInput>;
  failedNodeIds?: InputMaybe<ModelStringInput>;
  hasPartialFailures?: InputMaybe<ModelBooleanInput>;
  inFlightNodeId?: InputMaybe<ModelStringInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  lastFailedNodeId?: InputMaybe<ModelStringInput>;
  latestAnalysisNodeSlug?: InputMaybe<ModelStringInput>;
  latestAnalysisRequirementsMet?: InputMaybe<ModelBooleanInput>;
  latestAnalysisScore?: InputMaybe<ModelIntInput>;
  latestAnalysisScoredAt?: InputMaybe<ModelStringInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  nodeExecutionState?: InputMaybe<ModelNodeExecutionStateInput>;
  not?: InputMaybe<ModelWorkflowRunConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowRunConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  runVersion?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowRunStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  tagsNormalized?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelWorkflowRunConnection = {
  items: Array<Maybe<WorkflowRun>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowRunFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowRunFilterInput>>>;
  atsApplicationId?: InputMaybe<ModelIdInput>;
  atsJobId?: InputMaybe<ModelIdInput>;
  cancellationCode?: InputMaybe<ModelWorkflowRunCancellationCodeInput>;
  candidateProfileFirstName?: InputMaybe<ModelStringInput>;
  candidateProfileId?: InputMaybe<ModelIdInput>;
  candidateProfileLastName?: InputMaybe<ModelStringInput>;
  candidateProfileName?: InputMaybe<ModelStringInput>;
  completedAt?: InputMaybe<ModelStringInput>;
  context?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  currentNodeId?: InputMaybe<ModelStringInput>;
  errorCode?: InputMaybe<ModelStringInput>;
  errorMessage?: InputMaybe<ModelStringInput>;
  errorReason?: InputMaybe<ModelStringInput>;
  failedNodeIds?: InputMaybe<ModelStringInput>;
  hasPartialFailures?: InputMaybe<ModelBooleanInput>;
  id?: InputMaybe<ModelIdInput>;
  inFlightNodeId?: InputMaybe<ModelStringInput>;
  komboApplicationId?: InputMaybe<ModelIdInput>;
  komboJobId?: InputMaybe<ModelIdInput>;
  lastFailedNodeId?: InputMaybe<ModelStringInput>;
  latestAnalysisNodeSlug?: InputMaybe<ModelStringInput>;
  latestAnalysisRequirementsMet?: InputMaybe<ModelBooleanInput>;
  latestAnalysisScore?: InputMaybe<ModelIntInput>;
  latestAnalysisScoredAt?: InputMaybe<ModelStringInput>;
  needsReview?: InputMaybe<ModelBooleanInput>;
  nodeExecutionState?: InputMaybe<ModelNodeExecutionStateInput>;
  not?: InputMaybe<ModelWorkflowRunFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowRunFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  runVersion?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowRunStatusInput>;
  tags?: InputMaybe<ModelStringInput>;
  tagsNormalized?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
  workflowVersionNumber?: InputMaybe<ModelIntInput>;
};

export type ModelWorkflowRunStatusInput = {
  eq?: InputMaybe<WorkflowRunStatus>;
  ne?: InputMaybe<WorkflowRunStatus>;
};

export type ModelWorkflowStatsConditionInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowStatsConditionInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  lastFailureAt?: InputMaybe<ModelStringInput>;
  lastRunCompletedAt?: InputMaybe<ModelStringInput>;
  lastRunStartedAt?: InputMaybe<ModelStringInput>;
  liveWorkflowVersionId?: InputMaybe<ModelIdInput>;
  liveWorkflowVersionNumber?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelWorkflowStatsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowStatsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  totalActiveRunCount?: InputMaybe<ModelIntInput>;
  totalCancelledCount?: InputMaybe<ModelIntInput>;
  totalCompletedCount?: InputMaybe<ModelIntInput>;
  totalFailedCount?: InputMaybe<ModelIntInput>;
  totalNeedsReviewCount?: InputMaybe<ModelIntInput>;
  totalRunCount?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowStatsConnection = {
  items: Array<Maybe<WorkflowStats>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowStatsFilterInput = {
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowStatsFilterInput>>>;
  createdAt?: InputMaybe<ModelStringInput>;
  id?: InputMaybe<ModelIdInput>;
  lastFailureAt?: InputMaybe<ModelStringInput>;
  lastRunCompletedAt?: InputMaybe<ModelStringInput>;
  lastRunStartedAt?: InputMaybe<ModelStringInput>;
  liveWorkflowVersionId?: InputMaybe<ModelIdInput>;
  liveWorkflowVersionNumber?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelWorkflowStatsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowStatsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  totalActiveRunCount?: InputMaybe<ModelIntInput>;
  totalCancelledCount?: InputMaybe<ModelIntInput>;
  totalCompletedCount?: InputMaybe<ModelIntInput>;
  totalFailedCount?: InputMaybe<ModelIntInput>;
  totalNeedsReviewCount?: InputMaybe<ModelIntInput>;
  totalRunCount?: InputMaybe<ModelIntInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowStatusInput = {
  eq?: InputMaybe<WorkflowStatus>;
  ne?: InputMaybe<WorkflowStatus>;
};

export type ModelWorkflowTriggerSourceInput = {
  eq?: InputMaybe<WorkflowTriggerSource>;
  ne?: InputMaybe<WorkflowTriggerSource>;
};

export type ModelWorkflowTriggerSourceListInput = {
  contains?: InputMaybe<WorkflowTriggerSource>;
  eq?: InputMaybe<Array<InputMaybe<WorkflowTriggerSource>>>;
  ne?: InputMaybe<Array<InputMaybe<WorkflowTriggerSource>>>;
  notContains?: InputMaybe<WorkflowTriggerSource>;
};

export type ModelWorkflowVersionConditionInput = {
  activeRunCount?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionConditionInput>>>;
  archivedAt?: InputMaybe<ModelStringInput>;
  cancelledCount?: InputMaybe<ModelIntInput>;
  canvasVisualConfiguration?: InputMaybe<ModelStringInput>;
  changeNotes?: InputMaybe<ModelStringInput>;
  completedCount?: InputMaybe<ModelIntInput>;
  configuration?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  entrySources?: InputMaybe<ModelWorkflowTriggerSourceListInput>;
  failedCount?: InputMaybe<ModelIntInput>;
  needsReviewCount?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelWorkflowVersionConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  publishedAt?: InputMaybe<ModelStringInput>;
  publishedByUserId?: InputMaybe<ModelIdInput>;
  runCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowVersionStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  versionNumber?: InputMaybe<ModelIntInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowVersionConnection = {
  items: Array<Maybe<WorkflowVersion>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowVersionFilterInput = {
  activeRunCount?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionFilterInput>>>;
  archivedAt?: InputMaybe<ModelStringInput>;
  cancelledCount?: InputMaybe<ModelIntInput>;
  canvasVisualConfiguration?: InputMaybe<ModelStringInput>;
  changeNotes?: InputMaybe<ModelStringInput>;
  completedCount?: InputMaybe<ModelIntInput>;
  configuration?: InputMaybe<ModelStringInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  entrySources?: InputMaybe<ModelWorkflowTriggerSourceListInput>;
  failedCount?: InputMaybe<ModelIntInput>;
  id?: InputMaybe<ModelIdInput>;
  needsReviewCount?: InputMaybe<ModelIntInput>;
  not?: InputMaybe<ModelWorkflowVersionFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  publishedAt?: InputMaybe<ModelStringInput>;
  publishedByUserId?: InputMaybe<ModelIdInput>;
  runCount?: InputMaybe<ModelIntInput>;
  status?: InputMaybe<ModelWorkflowVersionStatusInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  versionNumber?: InputMaybe<ModelIntInput>;
  workflowId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowVersionNodeStatsConditionInput = {
  activeCount?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>>>;
  awaitingCount?: InputMaybe<ModelIntInput>;
  completedCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  enteredCount?: InputMaybe<ModelIntInput>;
  failedCount?: InputMaybe<ModelIntInput>;
  lastActivityAt?: InputMaybe<ModelStringInput>;
  nodeId?: InputMaybe<ModelStringInput>;
  nodeType?: InputMaybe<ModelWorkflowNodeTypeInput>;
  not?: InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  stats?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowVersionNodeStatsConnection = {
  items: Array<Maybe<WorkflowVersionNodeStats>>;
  nextToken?: Maybe<Scalars['String']['output']>;
};

export type ModelWorkflowVersionNodeStatsFilterInput = {
  activeCount?: InputMaybe<ModelIntInput>;
  and?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>>>;
  awaitingCount?: InputMaybe<ModelIntInput>;
  completedCount?: InputMaybe<ModelIntInput>;
  createdAt?: InputMaybe<ModelStringInput>;
  enteredCount?: InputMaybe<ModelIntInput>;
  failedCount?: InputMaybe<ModelIntInput>;
  id?: InputMaybe<ModelIdInput>;
  lastActivityAt?: InputMaybe<ModelStringInput>;
  nodeId?: InputMaybe<ModelStringInput>;
  nodeType?: InputMaybe<ModelWorkflowNodeTypeInput>;
  not?: InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>;
  or?: InputMaybe<Array<InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>>>;
  organizationId?: InputMaybe<ModelIdInput>;
  stats?: InputMaybe<ModelStringInput>;
  updatedAt?: InputMaybe<ModelStringInput>;
  workflowId?: InputMaybe<ModelIdInput>;
  workflowVersionId?: InputMaybe<ModelIdInput>;
};

export type ModelWorkflowVersionStatusInput = {
  eq?: InputMaybe<WorkflowVersionStatus>;
  ne?: InputMaybe<WorkflowVersionStatus>;
};

export type Mutation = {
  addCVsToCandidateBatch?: Maybe<CandidateBatch>;
  addCandidateProfilesToList: AddCandidateProfilesToListOutput;
  addDocumentType: DocumentType;
  addWorkflowContact?: Maybe<WorkflowContact>;
  applyCandidateBatchGroup: ApplyCandidateBatchGroupOutput;
  archiveDocumentType: DocumentType;
  archiveWorkflow?: Maybe<ArchiveWorkflowResult>;
  attachOrganizationWebhook?: Maybe<AttachOrganizationWebhookResult>;
  automationTasksSaved?: Maybe<AutomationTasksSavedOutput>;
  campaignAutomationTasksSaved?: Maybe<CampaignAutomationTasksSavedOutput>;
  cancelSubscription?: Maybe<CancelSubscriptionOutput>;
  cancelWorkflowRun?: Maybe<CancelWorkflowRunResult>;
  createAgent?: Maybe<Agent>;
  createAnalysedApplicationSnapshot?: Maybe<AnalysedApplicationSnapshot>;
  createAnalysisRequirement?: Maybe<AnalysisRequirement>;
  createApplicationStageUpdate?: Maybe<ApplicationStageUpdate>;
  createAtsApplication?: Maybe<AtsApplication>;
  createAtsApplicationForCandidate: CreateAtsApplicationForCandidateResult;
  createAtsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  createAtsBulkSync?: Maybe<AtsBulkSync>;
  createAtsBulkSyncError?: Maybe<AtsBulkSyncError>;
  createAtsConfig?: Maybe<AtsConfig>;
  createAtsQuestion?: Maybe<AtsQuestion>;
  createAttachment?: Maybe<Attachment>;
  createAutomationTask?: Maybe<AutomationTask>;
  createAutomationTaskEmailTemplate?: Maybe<AutomationTaskEmailTemplate>;
  createAutomationTaskTemplateFromCandidateBatch?: Maybe<CreateAutomationTaskTemplateFromCandidateBatchOutput>;
  createAutomationTasksTemplate?: Maybe<AutomationTasksTemplate>;
  createCalendarBooking?: Maybe<CalendarBooking>;
  createCalendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  createCampaign?: Maybe<Campaign>;
  createCampaignCandidate?: Maybe<CampaignCandidate>;
  createCampaignCsvKeys?: Maybe<CampaignCsvKeys>;
  createCampaignQuestion?: Maybe<CampaignQuestion>;
  createCampaignSubscription?: Maybe<CampaignSubscription>;
  createCandidate?: Maybe<Candidate>;
  createCandidateAvailabilitySuggestion?: Maybe<CandidateAvailabilitySuggestion>;
  createCandidateBatch?: Maybe<CandidateBatch>;
  createCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  createCandidateBatchGroupFromCandidateBatch?: Maybe<CreateCandidateBatchGroupFromCandidateBatchOutput>;
  createCandidateCvsParsing?: Maybe<CandidateCvsParsing>;
  createCandidateEmailCorrespondence?: Maybe<CandidateEmailCorrespondence>;
  createCandidateMessage?: Maybe<CandidateMessage>;
  createCandidateNote?: Maybe<CandidateNote>;
  createCandidateProfile?: Maybe<CandidateProfile>;
  createCandidateProfileList?: Maybe<CandidateProfileList>;
  createCandidateProfileListForUser: CandidateProfileListForUser;
  createCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  createCandidateProfileNote?: Maybe<CandidateProfileNote>;
  createCandidateStatusUpdate?: Maybe<CandidateStatusUpdate>;
  createCandidateTag?: Maybe<CandidateTag>;
  createClientApiKey?: Maybe<ClientApiKey>;
  createConversation?: Maybe<Conversation>;
  createDocumentCredential?: Maybe<DocumentCredential>;
  createDocumentType?: Maybe<DocumentType>;
  createDocumentTypeRelationships?: Maybe<DocumentTypeRelationships>;
  createIntegrationCredentials?: Maybe<IntegrationCredentials>;
  createJobPosting?: Maybe<JobPosting>;
  createJobPostingRecommendation?: Maybe<JobPostingRecommendation>;
  createMessage?: Maybe<Message>;
  createNeedsReviewItem?: Maybe<NeedsReviewItem>;
  createOptOutEmailAddress?: Maybe<OptOutEmailAddress>;
  createOptOutPhoneNumber?: Maybe<OptOutPhoneNumber>;
  createOrganization?: Maybe<Organization>;
  createOrganizationConfig?: Maybe<OrganizationConfig>;
  createOrganizationCustomField?: Maybe<OrganizationCustomFieldConfig>;
  createOrganizationCustomFieldConfig?: Maybe<OrganizationCustomFieldConfig>;
  createOrganizationGroup?: Maybe<OrganizationGroup>;
  createOrganizationWebhook?: Maybe<OrganizationWebhook>;
  createOutreachQuestion?: Maybe<OutreachQuestion>;
  createPlanMembership?: Maybe<PlanMembership>;
  createPreferences?: Maybe<Preferences>;
  createProfileData?: Maybe<ProfileData>;
  createQualification?: Maybe<Qualification>;
  createQuestionOutcome?: Maybe<QuestionOutcome>;
  createRequirementOutcome?: Maybe<RequirementOutcome>;
  createSandboxAccount?: Maybe<CreateSandboxAccountResult>;
  createSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  createSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  createSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  createSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  createSearchPeopleQueryFields?: Maybe<SearchPeopleQueryFields>;
  createSelectedCandidateBatchStatuses?: Maybe<SelectedCandidateBatchStatuses>;
  createSimulationConversation?: Maybe<SimulationConversation>;
  createSimulationMessage?: Maybe<SimulationMessage>;
  createSkill?: Maybe<Skill>;
  createSourcedCandidate?: Maybe<SourcedCandidate>;
  createStatusSet?: Maybe<StatusSet>;
  createTag?: Maybe<Tag>;
  createTeam?: Maybe<Team>;
  createTeamMembership?: Maybe<TeamMembership>;
  createTwilioAccountCredentials?: Maybe<TwilioAccountCredentials>;
  createTypeformLink?: Maybe<TypeformLink>;
  createTypeformRecord?: Maybe<TypeformRecord>;
  createUnansweredQuestion?: Maybe<UnansweredQuestion>;
  createUser?: Maybe<User>;
  createUserCalendar?: Maybe<UserCalendar>;
  createUserCalendarMeetingTemplate?: Maybe<UserCalendarMeetingTemplate>;
  createUserCalendarOrganization?: Maybe<UserCalendarOrganization>;
  createUserOrganization?: Maybe<UserOrganization>;
  createVirtualCalendarConversation?: Maybe<VirtualCalendarConversation>;
  createWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  createWorkflow?: Maybe<Workflow>;
  createWorkflowAtsJob?: Maybe<WorkflowAtsJob>;
  createWorkflowContact?: Maybe<WorkflowContact>;
  createWorkflowContactImport?: Maybe<WorkflowContactImport>;
  createWorkflowEvent?: Maybe<WorkflowEvent>;
  createWorkflowFromApi?: Maybe<Workflow>;
  createWorkflowRun?: Maybe<WorkflowRun>;
  createWorkflowRunCandidateProfile?: Maybe<WorkflowRunCandidateProfile>;
  createWorkflowStats?: Maybe<WorkflowStats>;
  createWorkflowVersion?: Maybe<WorkflowVersion>;
  createWorkflowVersionNodeStats?: Maybe<WorkflowVersionNodeStats>;
  deactivateUser?: Maybe<DeactivateUserOutput>;
  decrementCandidateProfileListCount?: Maybe<DecrementCandidateProfileListCountResult>;
  deleteAgent?: Maybe<Agent>;
  deleteAnalysedApplicationSnapshot?: Maybe<AnalysedApplicationSnapshot>;
  deleteAnalysisRequirement?: Maybe<AnalysisRequirement>;
  deleteApplicationStageUpdate?: Maybe<ApplicationStageUpdate>;
  deleteAtsApplication?: Maybe<AtsApplication>;
  deleteAtsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  deleteAtsBulkSync?: Maybe<AtsBulkSync>;
  deleteAtsBulkSyncError?: Maybe<AtsBulkSyncError>;
  deleteAtsConfig?: Maybe<AtsConfig>;
  deleteAtsQuestion?: Maybe<AtsQuestion>;
  deleteAttachment?: Maybe<Attachment>;
  deleteAutomationTask?: Maybe<AutomationTask>;
  deleteAutomationTaskEmailTemplate?: Maybe<AutomationTaskEmailTemplate>;
  deleteAutomationTasksTemplate?: Maybe<AutomationTasksTemplate>;
  deleteCalendarBooking?: Maybe<CalendarBooking>;
  deleteCalendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  deleteCampaign?: Maybe<Campaign>;
  deleteCampaignCandidate?: Maybe<CampaignCandidate>;
  deleteCampaignCsvKeys?: Maybe<CampaignCsvKeys>;
  deleteCampaignQuestion?: Maybe<CampaignQuestion>;
  deleteCampaignSubscription?: Maybe<CampaignSubscription>;
  deleteCandidate?: Maybe<Candidate>;
  deleteCandidateAvailabilitySuggestion?: Maybe<CandidateAvailabilitySuggestion>;
  deleteCandidateBatch?: Maybe<CandidateBatch>;
  deleteCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  deleteCandidateCvsParsing?: Maybe<CandidateCvsParsing>;
  deleteCandidateEmailCorrespondence?: Maybe<CandidateEmailCorrespondence>;
  deleteCandidateMessage?: Maybe<CandidateMessage>;
  deleteCandidateNote?: Maybe<CandidateNote>;
  deleteCandidateProfile?: Maybe<CandidateProfile>;
  deleteCandidateProfileList?: Maybe<CandidateProfileList>;
  deleteCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  deleteCandidateProfileNote?: Maybe<CandidateProfileNote>;
  deleteCandidateStatusUpdate?: Maybe<CandidateStatusUpdate>;
  deleteCandidateTag?: Maybe<CandidateTag>;
  deleteClientApiKey?: Maybe<ClientApiKey>;
  deleteConversation?: Maybe<Conversation>;
  deleteDocumentCredential?: Maybe<DocumentCredential>;
  deleteDocumentType?: Maybe<DocumentType>;
  deleteDocumentTypeRelationships?: Maybe<DocumentTypeRelationships>;
  deleteIntegrationCredentials?: Maybe<IntegrationCredentials>;
  deleteJobPosting?: Maybe<JobPosting>;
  deleteJobPostingRecommendation?: Maybe<JobPostingRecommendation>;
  deleteMessage?: Maybe<Message>;
  deleteNeedsReviewItem?: Maybe<NeedsReviewItem>;
  deleteOptOutEmailAddress?: Maybe<OptOutEmailAddress>;
  deleteOptOutPhoneNumber?: Maybe<OptOutPhoneNumber>;
  deleteOrganization?: Maybe<Organization>;
  deleteOrganizationConfig?: Maybe<OrganizationConfig>;
  deleteOrganizationCustomField?: Maybe<OrganizationCustomFieldConfig>;
  deleteOrganizationCustomFieldConfig?: Maybe<OrganizationCustomFieldConfig>;
  deleteOrganizationGroup?: Maybe<OrganizationGroup>;
  deleteOrganizationWebhook?: Maybe<OrganizationWebhook>;
  deleteOutreachQuestion?: Maybe<OutreachQuestion>;
  deletePlanMembership?: Maybe<PlanMembership>;
  deletePreferences?: Maybe<Preferences>;
  deleteProfileData?: Maybe<ProfileData>;
  deleteQualification?: Maybe<Qualification>;
  deleteQuestionOutcome?: Maybe<QuestionOutcome>;
  deleteRequirementOutcome?: Maybe<RequirementOutcome>;
  deleteSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  deleteSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  deleteSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  deleteSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  deleteSearchPeopleQueryFields?: Maybe<SearchPeopleQueryFields>;
  deleteSelectedCandidateBatchStatuses?: Maybe<SelectedCandidateBatchStatuses>;
  deleteSimulationConversation?: Maybe<SimulationConversation>;
  deleteSimulationMessage?: Maybe<SimulationMessage>;
  deleteSkill?: Maybe<Skill>;
  deleteSourcedCandidate?: Maybe<SourcedCandidate>;
  deleteStatusSet?: Maybe<StatusSet>;
  deleteTag?: Maybe<Tag>;
  deleteTeam?: Maybe<Team>;
  deleteTeamMembership?: Maybe<TeamMembership>;
  deleteTwilioAccountCredentials?: Maybe<TwilioAccountCredentials>;
  deleteTypeformLink?: Maybe<TypeformLink>;
  deleteTypeformRecord?: Maybe<TypeformRecord>;
  deleteUnansweredQuestion?: Maybe<UnansweredQuestion>;
  deleteUser?: Maybe<User>;
  deleteUserCalendar?: Maybe<UserCalendar>;
  deleteUserCalendarMeetingTemplate?: Maybe<UserCalendarMeetingTemplate>;
  deleteUserCalendarOrganization?: Maybe<UserCalendarOrganization>;
  deleteUserOrganization?: Maybe<UserOrganization>;
  deleteVirtualCalendarConversation?: Maybe<VirtualCalendarConversation>;
  deleteWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  deleteWorkflow?: Maybe<Workflow>;
  deleteWorkflowAtsJob?: Maybe<WorkflowAtsJob>;
  deleteWorkflowContact?: Maybe<WorkflowContact>;
  deleteWorkflowContactImport?: Maybe<WorkflowContactImport>;
  deleteWorkflowEvent?: Maybe<WorkflowEvent>;
  deleteWorkflowRun?: Maybe<WorkflowRun>;
  deleteWorkflowRunCandidateProfile?: Maybe<WorkflowRunCandidateProfile>;
  deleteWorkflowStats?: Maybe<WorkflowStats>;
  deleteWorkflowVersion?: Maybe<WorkflowVersion>;
  deleteWorkflowVersionNodeStats?: Maybe<WorkflowVersionNodeStats>;
  editCampaignInfo?: Maybe<EditCampaignInfoOutput>;
  editDocumentType: DocumentType;
  editWorkflowContact?: Maybe<WorkflowContact>;
  enrolWorkflowContacts?: Maybe<EnrolWorkflowContactsResult>;
  generateAdjustedAnalysisRequirement?: Maybe<GenerateAdjustedAnalysisRequirementOutput>;
  generateAnalysisRequirementRecommendation?: Maybe<GenerateAnalysisRequirementRecommendationOutput>;
  generateCandidateProfileRelevance?: Maybe<GenerateCandidateProfileRelevanceOutput>;
  generateCandidateRelevance?: Maybe<GenerateCandidateRelevanceOutput>;
  generateSearchPeopleQueryFields: GenerateSearchPeopleQueryFieldsResponse;
  generateSourcingTemplate?: Maybe<GenerateSourcingTemplateOutput>;
  generateVectorSearchQuestions?: Maybe<GenerateVectorSearchQuestionsOutput>;
  generateVectorSearchReply?: Maybe<GenerateVectorSearchReplyOutput>;
  globalSignOut?: Maybe<GlobalSignOutOutput>;
  hideOrganization?: Maybe<HideOrganizationResult>;
  incrementAnalysisRequirementCounts?: Maybe<AnalysisRequirementCountsOutput>;
  incrementCampaignCounts?: Maybe<IncrementCampaignCountsResult>;
  incrementCandidateBatchCounts?: Maybe<CandidateBatchCountsOutput>;
  incrementCandidateProfileListCount?: Maybe<IncrementCandidateProfileListCountResult>;
  incrementConversationCounts?: Maybe<IncrementConversationCountsResult>;
  initializeCampaign: Campaign;
  initializeCampaignWithParticipants?: Maybe<InitializeCampaignWithParticipantsResult>;
  initializeCandidateBatch: CandidateBatch;
  initializeCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  initializeDraftCandidateBatch: CandidateBatch;
  initializeSourcedCandidatesCampaign: Campaign;
  initializeVectorSearchSession?: Maybe<InitializeVectorSearchSessionOutput>;
  inviteUserToOrganization?: Maybe<InviteUserToOrganizationOutput>;
  openOrCreateWorkflowForAtsJob: OpenOrCreateWorkflowForAtsJobResult;
  optimiseJobDescriptionForDEI?: Maybe<OptimiseJobDescriptionOutput>;
  pauseWorkflow?: Maybe<Workflow>;
  processCandidateBatches?: Maybe<CandidateBatchGroup>;
  publishWorkflow?: Maybe<PublishWorkflowResult>;
  regenerateWebhookSigningSecret?: Maybe<RegenerateWebhookSigningSecretResult>;
  registerCandidateTags?: Maybe<RegisterCandidateTagsResult>;
  removeCandidateProfileList: RemoveCandidateProfileListOutput;
  removeCandidateProfilesFromList: RemoveCandidateProfilesFromListOutput;
  removeDocumentType: DocumentType;
  removeUserFromOrganization?: Maybe<RemoveUserFromOrganizationOutput>;
  removeWorkflowContact?: Maybe<Scalars['ID']['output']>;
  resendUserInvite?: Maybe<ResendUserInviteOutput>;
  restartConversation?: Maybe<Conversation>;
  resumeWorkflow?: Maybe<Workflow>;
  revealSourcedCandidatePhoneNumber: RevealSourcedCandidatePhoneNumberOutput;
  sendMessageByUser?: Maybe<SendMessageByUserOutput>;
  sendSimulationMessage?: Maybe<SendSimulationMessageOutput>;
  startAddingNewCandidatesToCampaign?: Maybe<AddNewCandidatesToCampaignOutput>;
  startCampaign?: Maybe<StartCampaignOutput>;
  startCandidateBatchProcessing?: Maybe<StartCandidateBatchProcessingOutput>;
  startCandidateMessagesGeneration?: Maybe<StartCandidateMessageGenerationOutput>;
  startInternalSourcingWorkflowRuns?: Maybe<StartWorkflowRunsResult>;
  startSendingMessages?: Maybe<StartCampaignOutput>;
  startWorkflowContactImport?: Maybe<StartWorkflowContactImportResult>;
  startWorkflowRuns?: Maybe<StartWorkflowRunsResult>;
  stopCampaign?: Maybe<StopCampaignOutput>;
  testOrganizationWebhook?: Maybe<TestOrganizationWebhookResult>;
  unhideOrganization?: Maybe<UnhideOrganizationResult>;
  updateAgent?: Maybe<Agent>;
  updateAnalysedApplicationSnapshot?: Maybe<AnalysedApplicationSnapshot>;
  updateAnalysisAutomationTasks?: Maybe<UpdateAnalysisAutomationTasksOutput>;
  updateAnalysisRequirement?: Maybe<AnalysisRequirement>;
  updateAnalysisRequirements?: Maybe<AnalysisRequirementsUpdateOutput>;
  updateApplicationStage: UpdateApplicationStageOutput;
  updateApplicationStageUpdate?: Maybe<ApplicationStageUpdate>;
  updateAtsApplication?: Maybe<AtsApplication>;
  updateAtsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  updateAtsBulkSync?: Maybe<AtsBulkSync>;
  updateAtsBulkSyncError?: Maybe<AtsBulkSyncError>;
  updateAtsConfig?: Maybe<AtsConfig>;
  updateAtsQuestion?: Maybe<AtsQuestion>;
  updateAttachment?: Maybe<Attachment>;
  updateAutomationTask?: Maybe<AutomationTask>;
  updateAutomationTaskEmailTemplate?: Maybe<AutomationTaskEmailTemplate>;
  updateAutomationTasksTemplate?: Maybe<AutomationTasksTemplate>;
  updateCalendarBooking?: Maybe<CalendarBooking>;
  updateCalendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  updateCampaign?: Maybe<Campaign>;
  updateCampaignCandidate?: Maybe<CampaignCandidate>;
  updateCampaignCsvKeys?: Maybe<CampaignCsvKeys>;
  updateCampaignQuestion?: Maybe<CampaignQuestion>;
  updateCampaignStats?: Maybe<Campaign>;
  updateCampaignSubscription?: Maybe<CampaignSubscription>;
  updateCandidate?: Maybe<Candidate>;
  updateCandidateAvailabilitySuggestion?: Maybe<CandidateAvailabilitySuggestion>;
  updateCandidateBatch?: Maybe<CandidateBatch>;
  updateCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  updateCandidateBatchGroupComponents?: Maybe<CandidateBatchGroup>;
  updateCandidateCvsParsing?: Maybe<CandidateCvsParsing>;
  updateCandidateEmailCorrespondence?: Maybe<CandidateEmailCorrespondence>;
  updateCandidateMessage?: Maybe<CandidateMessage>;
  updateCandidateNote?: Maybe<CandidateNote>;
  updateCandidateProfile?: Maybe<CandidateProfile>;
  updateCandidateProfileList?: Maybe<CandidateProfileList>;
  updateCandidateProfileListForUser: CandidateProfileListForUser;
  updateCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  updateCandidateProfileNote?: Maybe<CandidateProfileNote>;
  updateCandidateStatusUpdate?: Maybe<CandidateStatusUpdate>;
  updateCandidateTag?: Maybe<CandidateTag>;
  updateClientApiKey?: Maybe<ClientApiKey>;
  updateConversation?: Maybe<Conversation>;
  updateDocumentCredential?: Maybe<DocumentCredential>;
  updateDocumentType?: Maybe<DocumentType>;
  updateDocumentTypeRelationships?: Maybe<DocumentTypeRelationships>;
  updateIntegrationCredentials?: Maybe<IntegrationCredentials>;
  updateJobPosting?: Maybe<JobPosting>;
  updateJobPostingRecommendation?: Maybe<JobPostingRecommendation>;
  updateMessage?: Maybe<Message>;
  updateNeedsReviewItem?: Maybe<NeedsReviewItem>;
  updateOptOutEmailAddress?: Maybe<OptOutEmailAddress>;
  updateOptOutPhoneNumber?: Maybe<OptOutPhoneNumber>;
  updateOrganization?: Maybe<Organization>;
  updateOrganizationConfig?: Maybe<OrganizationConfig>;
  updateOrganizationCustomField?: Maybe<OrganizationCustomFieldConfig>;
  updateOrganizationCustomFieldConfig?: Maybe<OrganizationCustomFieldConfig>;
  updateOrganizationGroup?: Maybe<OrganizationGroup>;
  updateOrganizationPhoneNumber?: Maybe<UpdateOrganizationPhoneNumberResult>;
  updateOrganizationWebhook?: Maybe<OrganizationWebhook>;
  updateOutreachQuestion?: Maybe<OutreachQuestion>;
  updatePlanMembership?: Maybe<PlanMembership>;
  updatePreferences?: Maybe<Preferences>;
  updateProfileData?: Maybe<ProfileData>;
  updateQualification?: Maybe<Qualification>;
  updateQuestionOutcome?: Maybe<QuestionOutcome>;
  updateRequirementOutcome?: Maybe<RequirementOutcome>;
  updateSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  updateSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  updateSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  updateSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  updateSearchPeopleQueryFields?: Maybe<SearchPeopleQueryFields>;
  updateSelectedCandidateBatchStatuses?: Maybe<SelectedCandidateBatchStatuses>;
  updateSimulationConversation?: Maybe<SimulationConversation>;
  updateSimulationMessage?: Maybe<SimulationMessage>;
  updateSkill?: Maybe<Skill>;
  updateSourcedCandidate?: Maybe<SourcedCandidate>;
  updateStatusSet?: Maybe<StatusSet>;
  updateTag?: Maybe<Tag>;
  updateTeam?: Maybe<Team>;
  updateTeamMembership?: Maybe<TeamMembership>;
  updateTwilioAccountCredentials?: Maybe<TwilioAccountCredentials>;
  updateTypeformLink?: Maybe<TypeformLink>;
  updateTypeformRecord?: Maybe<TypeformRecord>;
  updateUnansweredQuestion?: Maybe<UnansweredQuestion>;
  updateUser?: Maybe<User>;
  updateUserCalendar?: Maybe<UserCalendar>;
  updateUserCalendarMeetingTemplate?: Maybe<UserCalendarMeetingTemplate>;
  updateUserCalendarOrganization?: Maybe<UserCalendarOrganization>;
  updateUserOrganization?: Maybe<UserOrganization>;
  updateUserOrganizationRole?: Maybe<UpdateUserOrganizationRoleOutput>;
  updateVirtualCalendarConversation?: Maybe<VirtualCalendarConversation>;
  updateWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  updateWorkflow?: Maybe<Workflow>;
  updateWorkflowAtsJob?: Maybe<WorkflowAtsJob>;
  updateWorkflowContact?: Maybe<WorkflowContact>;
  updateWorkflowContactImport?: Maybe<WorkflowContactImport>;
  updateWorkflowEvent?: Maybe<WorkflowEvent>;
  updateWorkflowFromApi?: Maybe<Workflow>;
  updateWorkflowRun?: Maybe<WorkflowRun>;
  updateWorkflowRunCandidateProfile?: Maybe<WorkflowRunCandidateProfile>;
  updateWorkflowStats?: Maybe<WorkflowStats>;
  updateWorkflowVersion?: Maybe<WorkflowVersion>;
  updateWorkflowVersionNodeStats?: Maybe<WorkflowVersionNodeStats>;
  upsertOrganizationConfig?: Maybe<OrganizationConfig>;
  workflowBuilderAgentTurn?: Maybe<WorkflowBuilderAgentTurnOutput>;
  workflowBuilderLiveToken?: Maybe<WorkflowBuilderLiveTokenOutput>;
  workflowBuilderTranscribe?: Maybe<WorkflowBuilderTranscribeOutput>;
};


export type MutationAddCVsToCandidateBatchArgs = {
  input: AddCVsToCandidateBatchInput;
};


export type MutationAddCandidateProfilesToListArgs = {
  input: AddCandidateProfilesToListInput;
};


export type MutationAddDocumentTypeArgs = {
  input: AddDocumentTypeInput;
};


export type MutationAddWorkflowContactArgs = {
  input: AddWorkflowContactInput;
};


export type MutationApplyCandidateBatchGroupArgs = {
  input: ApplyCandidateBatchGroupInput;
};


export type MutationArchiveDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationAttachOrganizationWebhookArgs = {
  input: AttachOrganizationWebhookInput;
};


export type MutationAutomationTasksSavedArgs = {
  input: AutomationTasksSavedInput;
};


export type MutationCampaignAutomationTasksSavedArgs = {
  input: CampaignAutomationTasksSavedInput;
};


export type MutationCancelWorkflowRunArgs = {
  input: CancelWorkflowRunInput;
};


export type MutationCreateAgentArgs = {
  condition?: InputMaybe<ModelAgentConditionInput>;
  input: CreateAgentInput;
};


export type MutationCreateAnalysedApplicationSnapshotArgs = {
  condition?: InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>;
  input: CreateAnalysedApplicationSnapshotInput;
};


export type MutationCreateAnalysisRequirementArgs = {
  condition?: InputMaybe<ModelAnalysisRequirementConditionInput>;
  input: CreateAnalysisRequirementInput;
};


export type MutationCreateApplicationStageUpdateArgs = {
  condition?: InputMaybe<ModelApplicationStageUpdateConditionInput>;
  input: CreateApplicationStageUpdateInput;
};


export type MutationCreateAtsApplicationArgs = {
  condition?: InputMaybe<ModelAtsApplicationConditionInput>;
  input: CreateAtsApplicationInput;
};


export type MutationCreateAtsApplicationForCandidateArgs = {
  input: CreateAtsApplicationForCandidateInput;
};


export type MutationCreateAtsApplicationScreeningAnswersArgs = {
  condition?: InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>;
  input: CreateAtsApplicationScreeningAnswersInput;
};


export type MutationCreateAtsBulkSyncArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncConditionInput>;
  input: CreateAtsBulkSyncInput;
};


export type MutationCreateAtsBulkSyncErrorArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncErrorConditionInput>;
  input: CreateAtsBulkSyncErrorInput;
};


export type MutationCreateAtsConfigArgs = {
  condition?: InputMaybe<ModelAtsConfigConditionInput>;
  input: CreateAtsConfigInput;
};


export type MutationCreateAtsQuestionArgs = {
  condition?: InputMaybe<ModelAtsQuestionConditionInput>;
  input: CreateAtsQuestionInput;
};


export type MutationCreateAttachmentArgs = {
  condition?: InputMaybe<ModelAttachmentConditionInput>;
  input: CreateAttachmentInput;
};


export type MutationCreateAutomationTaskArgs = {
  condition?: InputMaybe<ModelAutomationTaskConditionInput>;
  input: CreateAutomationTaskInput;
};


export type MutationCreateAutomationTaskEmailTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>;
  input: CreateAutomationTaskEmailTemplateInput;
};


export type MutationCreateAutomationTaskTemplateFromCandidateBatchArgs = {
  input: CreateAutomationTaskTemplateFromCandidateBatchInput;
};


export type MutationCreateAutomationTasksTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTasksTemplateConditionInput>;
  input: CreateAutomationTasksTemplateInput;
};


export type MutationCreateCalendarBookingArgs = {
  condition?: InputMaybe<ModelCalendarBookingConditionInput>;
  input: CreateCalendarBookingInput;
};


export type MutationCreateCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelCalendarMeetingTemplateConditionInput>;
  input: CreateCalendarMeetingTemplateInput;
};


export type MutationCreateCampaignArgs = {
  condition?: InputMaybe<ModelCampaignConditionInput>;
  input: CreateCampaignInput;
};


export type MutationCreateCampaignCandidateArgs = {
  condition?: InputMaybe<ModelCampaignCandidateConditionInput>;
  input: CreateCampaignCandidateInput;
};


export type MutationCreateCampaignCsvKeysArgs = {
  condition?: InputMaybe<ModelCampaignCsvKeysConditionInput>;
  input: CreateCampaignCsvKeysInput;
};


export type MutationCreateCampaignQuestionArgs = {
  condition?: InputMaybe<ModelCampaignQuestionConditionInput>;
  input: CreateCampaignQuestionInput;
};


export type MutationCreateCampaignSubscriptionArgs = {
  condition?: InputMaybe<ModelCampaignSubscriptionConditionInput>;
  input: CreateCampaignSubscriptionInput;
};


export type MutationCreateCandidateArgs = {
  condition?: InputMaybe<ModelCandidateConditionInput>;
  input: CreateCandidateInput;
};


export type MutationCreateCandidateAvailabilitySuggestionArgs = {
  condition?: InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>;
  input: CreateCandidateAvailabilitySuggestionInput;
};


export type MutationCreateCandidateBatchArgs = {
  condition?: InputMaybe<ModelCandidateBatchConditionInput>;
  input: CreateCandidateBatchInput;
};


export type MutationCreateCandidateBatchGroupArgs = {
  condition?: InputMaybe<ModelCandidateBatchGroupConditionInput>;
  input: CreateCandidateBatchGroupInput;
};


export type MutationCreateCandidateBatchGroupFromCandidateBatchArgs = {
  input: CreateCandidateBatchGroupFromCandidateBatchInput;
};


export type MutationCreateCandidateCvsParsingArgs = {
  condition?: InputMaybe<ModelCandidateCvsParsingConditionInput>;
  input: CreateCandidateCvsParsingInput;
};


export type MutationCreateCandidateEmailCorrespondenceArgs = {
  condition?: InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>;
  input: CreateCandidateEmailCorrespondenceInput;
};


export type MutationCreateCandidateMessageArgs = {
  condition?: InputMaybe<ModelCandidateMessageConditionInput>;
  input: CreateCandidateMessageInput;
};


export type MutationCreateCandidateNoteArgs = {
  condition?: InputMaybe<ModelCandidateNoteConditionInput>;
  input: CreateCandidateNoteInput;
};


export type MutationCreateCandidateProfileArgs = {
  condition?: InputMaybe<ModelCandidateProfileConditionInput>;
  input: CreateCandidateProfileInput;
};


export type MutationCreateCandidateProfileListArgs = {
  condition?: InputMaybe<ModelCandidateProfileListConditionInput>;
  input: CreateCandidateProfileListInput;
};


export type MutationCreateCandidateProfileListForUserArgs = {
  input: CreateCandidateProfileListForUserInput;
};


export type MutationCreateCandidateProfileListMembershipArgs = {
  condition?: InputMaybe<ModelCandidateProfileListMembershipConditionInput>;
  input: CreateCandidateProfileListMembershipInput;
};


export type MutationCreateCandidateProfileNoteArgs = {
  condition?: InputMaybe<ModelCandidateProfileNoteConditionInput>;
  input: CreateCandidateProfileNoteInput;
};


export type MutationCreateCandidateStatusUpdateArgs = {
  condition?: InputMaybe<ModelCandidateStatusUpdateConditionInput>;
  input: CreateCandidateStatusUpdateInput;
};


export type MutationCreateCandidateTagArgs = {
  condition?: InputMaybe<ModelCandidateTagConditionInput>;
  input: CreateCandidateTagInput;
};


export type MutationCreateClientApiKeyArgs = {
  condition?: InputMaybe<ModelClientApiKeyConditionInput>;
  input: CreateClientApiKeyInput;
};


export type MutationCreateConversationArgs = {
  condition?: InputMaybe<ModelConversationConditionInput>;
  input: CreateConversationInput;
};


export type MutationCreateDocumentCredentialArgs = {
  condition?: InputMaybe<ModelDocumentCredentialConditionInput>;
  input: CreateDocumentCredentialInput;
};


export type MutationCreateDocumentTypeArgs = {
  condition?: InputMaybe<ModelDocumentTypeConditionInput>;
  input: CreateDocumentTypeInput;
};


export type MutationCreateDocumentTypeRelationshipsArgs = {
  condition?: InputMaybe<ModelDocumentTypeRelationshipsConditionInput>;
  input: CreateDocumentTypeRelationshipsInput;
};


export type MutationCreateIntegrationCredentialsArgs = {
  condition?: InputMaybe<ModelIntegrationCredentialsConditionInput>;
  input: CreateIntegrationCredentialsInput;
};


export type MutationCreateJobPostingArgs = {
  condition?: InputMaybe<ModelJobPostingConditionInput>;
  input: CreateJobPostingInput;
};


export type MutationCreateJobPostingRecommendationArgs = {
  condition?: InputMaybe<ModelJobPostingRecommendationConditionInput>;
  input: CreateJobPostingRecommendationInput;
};


export type MutationCreateMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: CreateMessageInput;
};


export type MutationCreateNeedsReviewItemArgs = {
  condition?: InputMaybe<ModelNeedsReviewItemConditionInput>;
  input: CreateNeedsReviewItemInput;
};


export type MutationCreateOptOutEmailAddressArgs = {
  condition?: InputMaybe<ModelOptOutEmailAddressConditionInput>;
  input: CreateOptOutEmailAddressInput;
};


export type MutationCreateOptOutPhoneNumberArgs = {
  condition?: InputMaybe<ModelOptOutPhoneNumberConditionInput>;
  input: CreateOptOutPhoneNumberInput;
};


export type MutationCreateOrganizationArgs = {
  condition?: InputMaybe<ModelOrganizationConditionInput>;
  input: CreateOrganizationInput;
};


export type MutationCreateOrganizationConfigArgs = {
  condition?: InputMaybe<ModelOrganizationConfigConditionInput>;
  input: CreateOrganizationConfigInput;
};


export type MutationCreateOrganizationCustomFieldArgs = {
  input: CreateOrganizationCustomFieldInput;
};


export type MutationCreateOrganizationCustomFieldConfigArgs = {
  condition?: InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>;
  input: CreateOrganizationCustomFieldConfigInput;
};


export type MutationCreateOrganizationGroupArgs = {
  condition?: InputMaybe<ModelOrganizationGroupConditionInput>;
  input: CreateOrganizationGroupInput;
};


export type MutationCreateOrganizationWebhookArgs = {
  condition?: InputMaybe<ModelOrganizationWebhookConditionInput>;
  input: CreateOrganizationWebhookInput;
};


export type MutationCreateOutreachQuestionArgs = {
  condition?: InputMaybe<ModelOutreachQuestionConditionInput>;
  input: CreateOutreachQuestionInput;
};


export type MutationCreatePlanMembershipArgs = {
  condition?: InputMaybe<ModelPlanMembershipConditionInput>;
  input: CreatePlanMembershipInput;
};


export type MutationCreatePreferencesArgs = {
  condition?: InputMaybe<ModelPreferencesConditionInput>;
  input: CreatePreferencesInput;
};


export type MutationCreateProfileDataArgs = {
  condition?: InputMaybe<ModelProfileDataConditionInput>;
  input: CreateProfileDataInput;
};


export type MutationCreateQualificationArgs = {
  condition?: InputMaybe<ModelQualificationConditionInput>;
  input: CreateQualificationInput;
};


export type MutationCreateQuestionOutcomeArgs = {
  condition?: InputMaybe<ModelQuestionOutcomeConditionInput>;
  input: CreateQuestionOutcomeInput;
};


export type MutationCreateRequirementOutcomeArgs = {
  condition?: InputMaybe<ModelRequirementOutcomeConditionInput>;
  input: CreateRequirementOutcomeInput;
};


export type MutationCreateSandboxAccountArgs = {
  input: CreateSandboxAccountInput;
};


export type MutationCreateSearchCandidateProfileMessageArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileMessageConditionInput>;
  input: CreateSearchCandidateProfileMessageInput;
};


export type MutationCreateSearchCandidateProfileQueryArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileQueryConditionInput>;
  input: CreateSearchCandidateProfileQueryInput;
};


export type MutationCreateSearchCandidateProfileSelectedArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>;
  input: CreateSearchCandidateProfileSelectedInput;
};


export type MutationCreateSearchCandidateProfileSelectedItemArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>;
  input: CreateSearchCandidateProfileSelectedItemInput;
};


export type MutationCreateSearchPeopleQueryFieldsArgs = {
  condition?: InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>;
  input: CreateSearchPeopleQueryFieldsInput;
};


export type MutationCreateSelectedCandidateBatchStatusesArgs = {
  condition?: InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>;
  input: CreateSelectedCandidateBatchStatusesInput;
};


export type MutationCreateSimulationConversationArgs = {
  condition?: InputMaybe<ModelSimulationConversationConditionInput>;
  input: CreateSimulationConversationInput;
};


export type MutationCreateSimulationMessageArgs = {
  condition?: InputMaybe<ModelSimulationMessageConditionInput>;
  input: CreateSimulationMessageInput;
};


export type MutationCreateSkillArgs = {
  condition?: InputMaybe<ModelSkillConditionInput>;
  input: CreateSkillInput;
};


export type MutationCreateSourcedCandidateArgs = {
  condition?: InputMaybe<ModelSourcedCandidateConditionInput>;
  input: CreateSourcedCandidateInput;
};


export type MutationCreateStatusSetArgs = {
  condition?: InputMaybe<ModelStatusSetConditionInput>;
  input: CreateStatusSetInput;
};


export type MutationCreateTagArgs = {
  condition?: InputMaybe<ModelTagConditionInput>;
  input: CreateTagInput;
};


export type MutationCreateTeamArgs = {
  condition?: InputMaybe<ModelTeamConditionInput>;
  input: CreateTeamInput;
};


export type MutationCreateTeamMembershipArgs = {
  condition?: InputMaybe<ModelTeamMembershipConditionInput>;
  input: CreateTeamMembershipInput;
};


export type MutationCreateTwilioAccountCredentialsArgs = {
  condition?: InputMaybe<ModelTwilioAccountCredentialsConditionInput>;
  input: CreateTwilioAccountCredentialsInput;
};


export type MutationCreateTypeformLinkArgs = {
  condition?: InputMaybe<ModelTypeformLinkConditionInput>;
  input: CreateTypeformLinkInput;
};


export type MutationCreateTypeformRecordArgs = {
  condition?: InputMaybe<ModelTypeformRecordConditionInput>;
  input: CreateTypeformRecordInput;
};


export type MutationCreateUnansweredQuestionArgs = {
  condition?: InputMaybe<ModelUnansweredQuestionConditionInput>;
  input: CreateUnansweredQuestionInput;
};


export type MutationCreateUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: CreateUserInput;
};


export type MutationCreateUserCalendarArgs = {
  condition?: InputMaybe<ModelUserCalendarConditionInput>;
  input: CreateUserCalendarInput;
};


export type MutationCreateUserCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>;
  input: CreateUserCalendarMeetingTemplateInput;
};


export type MutationCreateUserCalendarOrganizationArgs = {
  condition?: InputMaybe<ModelUserCalendarOrganizationConditionInput>;
  input: CreateUserCalendarOrganizationInput;
};


export type MutationCreateUserOrganizationArgs = {
  condition?: InputMaybe<ModelUserOrganizationConditionInput>;
  input: CreateUserOrganizationInput;
};


export type MutationCreateVirtualCalendarConversationArgs = {
  condition?: InputMaybe<ModelVirtualCalendarConversationConditionInput>;
  input: CreateVirtualCalendarConversationInput;
};


export type MutationCreateWhatsaapTemplateArgs = {
  condition?: InputMaybe<ModelWhatsaapTemplateConditionInput>;
  input: CreateWhatsaapTemplateInput;
};


export type MutationCreateWorkflowArgs = {
  condition?: InputMaybe<ModelWorkflowConditionInput>;
  input: CreateWorkflowInput;
};


export type MutationCreateWorkflowAtsJobArgs = {
  condition?: InputMaybe<ModelWorkflowAtsJobConditionInput>;
  input: CreateWorkflowAtsJobInput;
};


export type MutationCreateWorkflowContactArgs = {
  condition?: InputMaybe<ModelWorkflowContactConditionInput>;
  input: CreateWorkflowContactInput;
};


export type MutationCreateWorkflowContactImportArgs = {
  condition?: InputMaybe<ModelWorkflowContactImportConditionInput>;
  input: CreateWorkflowContactImportInput;
};


export type MutationCreateWorkflowEventArgs = {
  condition?: InputMaybe<ModelWorkflowEventConditionInput>;
  input: CreateWorkflowEventInput;
};


export type MutationCreateWorkflowFromApiArgs = {
  input: CreateWorkflowFromApiInput;
};


export type MutationCreateWorkflowRunArgs = {
  condition?: InputMaybe<ModelWorkflowRunConditionInput>;
  input: CreateWorkflowRunInput;
};


export type MutationCreateWorkflowRunCandidateProfileArgs = {
  condition?: InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>;
  input: CreateWorkflowRunCandidateProfileInput;
};


export type MutationCreateWorkflowStatsArgs = {
  condition?: InputMaybe<ModelWorkflowStatsConditionInput>;
  input: CreateWorkflowStatsInput;
};


export type MutationCreateWorkflowVersionArgs = {
  condition?: InputMaybe<ModelWorkflowVersionConditionInput>;
  input: CreateWorkflowVersionInput;
};


export type MutationCreateWorkflowVersionNodeStatsArgs = {
  condition?: InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>;
  input: CreateWorkflowVersionNodeStatsInput;
};


export type MutationDeactivateUserArgs = {
  input: DeactivateUserInput;
};


export type MutationDecrementCandidateProfileListCountArgs = {
  input: DecrementCandidateProfileListCountInput;
};


export type MutationDeleteAgentArgs = {
  condition?: InputMaybe<ModelAgentConditionInput>;
  input: DeleteAgentInput;
};


export type MutationDeleteAnalysedApplicationSnapshotArgs = {
  condition?: InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>;
  input: DeleteAnalysedApplicationSnapshotInput;
};


export type MutationDeleteAnalysisRequirementArgs = {
  condition?: InputMaybe<ModelAnalysisRequirementConditionInput>;
  input: DeleteAnalysisRequirementInput;
};


export type MutationDeleteApplicationStageUpdateArgs = {
  condition?: InputMaybe<ModelApplicationStageUpdateConditionInput>;
  input: DeleteApplicationStageUpdateInput;
};


export type MutationDeleteAtsApplicationArgs = {
  condition?: InputMaybe<ModelAtsApplicationConditionInput>;
  input: DeleteAtsApplicationInput;
};


export type MutationDeleteAtsApplicationScreeningAnswersArgs = {
  condition?: InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>;
  input: DeleteAtsApplicationScreeningAnswersInput;
};


export type MutationDeleteAtsBulkSyncArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncConditionInput>;
  input: DeleteAtsBulkSyncInput;
};


export type MutationDeleteAtsBulkSyncErrorArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncErrorConditionInput>;
  input: DeleteAtsBulkSyncErrorInput;
};


export type MutationDeleteAtsConfigArgs = {
  condition?: InputMaybe<ModelAtsConfigConditionInput>;
  input: DeleteAtsConfigInput;
};


export type MutationDeleteAtsQuestionArgs = {
  condition?: InputMaybe<ModelAtsQuestionConditionInput>;
  input: DeleteAtsQuestionInput;
};


export type MutationDeleteAttachmentArgs = {
  condition?: InputMaybe<ModelAttachmentConditionInput>;
  input: DeleteAttachmentInput;
};


export type MutationDeleteAutomationTaskArgs = {
  condition?: InputMaybe<ModelAutomationTaskConditionInput>;
  input: DeleteAutomationTaskInput;
};


export type MutationDeleteAutomationTaskEmailTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>;
  input: DeleteAutomationTaskEmailTemplateInput;
};


export type MutationDeleteAutomationTasksTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTasksTemplateConditionInput>;
  input: DeleteAutomationTasksTemplateInput;
};


export type MutationDeleteCalendarBookingArgs = {
  condition?: InputMaybe<ModelCalendarBookingConditionInput>;
  input: DeleteCalendarBookingInput;
};


export type MutationDeleteCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelCalendarMeetingTemplateConditionInput>;
  input: DeleteCalendarMeetingTemplateInput;
};


export type MutationDeleteCampaignArgs = {
  condition?: InputMaybe<ModelCampaignConditionInput>;
  input: DeleteCampaignInput;
};


export type MutationDeleteCampaignCandidateArgs = {
  condition?: InputMaybe<ModelCampaignCandidateConditionInput>;
  input: DeleteCampaignCandidateInput;
};


export type MutationDeleteCampaignCsvKeysArgs = {
  condition?: InputMaybe<ModelCampaignCsvKeysConditionInput>;
  input: DeleteCampaignCsvKeysInput;
};


export type MutationDeleteCampaignQuestionArgs = {
  condition?: InputMaybe<ModelCampaignQuestionConditionInput>;
  input: DeleteCampaignQuestionInput;
};


export type MutationDeleteCampaignSubscriptionArgs = {
  condition?: InputMaybe<ModelCampaignSubscriptionConditionInput>;
  input: DeleteCampaignSubscriptionInput;
};


export type MutationDeleteCandidateArgs = {
  condition?: InputMaybe<ModelCandidateConditionInput>;
  input: DeleteCandidateInput;
};


export type MutationDeleteCandidateAvailabilitySuggestionArgs = {
  condition?: InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>;
  input: DeleteCandidateAvailabilitySuggestionInput;
};


export type MutationDeleteCandidateBatchArgs = {
  condition?: InputMaybe<ModelCandidateBatchConditionInput>;
  input: DeleteCandidateBatchInput;
};


export type MutationDeleteCandidateBatchGroupArgs = {
  condition?: InputMaybe<ModelCandidateBatchGroupConditionInput>;
  input: DeleteCandidateBatchGroupInput;
};


export type MutationDeleteCandidateCvsParsingArgs = {
  condition?: InputMaybe<ModelCandidateCvsParsingConditionInput>;
  input: DeleteCandidateCvsParsingInput;
};


export type MutationDeleteCandidateEmailCorrespondenceArgs = {
  condition?: InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>;
  input: DeleteCandidateEmailCorrespondenceInput;
};


export type MutationDeleteCandidateMessageArgs = {
  condition?: InputMaybe<ModelCandidateMessageConditionInput>;
  input: DeleteCandidateMessageInput;
};


export type MutationDeleteCandidateNoteArgs = {
  condition?: InputMaybe<ModelCandidateNoteConditionInput>;
  input: DeleteCandidateNoteInput;
};


export type MutationDeleteCandidateProfileArgs = {
  condition?: InputMaybe<ModelCandidateProfileConditionInput>;
  input: DeleteCandidateProfileInput;
};


export type MutationDeleteCandidateProfileListArgs = {
  condition?: InputMaybe<ModelCandidateProfileListConditionInput>;
  input: DeleteCandidateProfileListInput;
};


export type MutationDeleteCandidateProfileListMembershipArgs = {
  condition?: InputMaybe<ModelCandidateProfileListMembershipConditionInput>;
  input: DeleteCandidateProfileListMembershipInput;
};


export type MutationDeleteCandidateProfileNoteArgs = {
  condition?: InputMaybe<ModelCandidateProfileNoteConditionInput>;
  input: DeleteCandidateProfileNoteInput;
};


export type MutationDeleteCandidateStatusUpdateArgs = {
  condition?: InputMaybe<ModelCandidateStatusUpdateConditionInput>;
  input: DeleteCandidateStatusUpdateInput;
};


export type MutationDeleteCandidateTagArgs = {
  condition?: InputMaybe<ModelCandidateTagConditionInput>;
  input: DeleteCandidateTagInput;
};


export type MutationDeleteClientApiKeyArgs = {
  condition?: InputMaybe<ModelClientApiKeyConditionInput>;
  input: DeleteClientApiKeyInput;
};


export type MutationDeleteConversationArgs = {
  condition?: InputMaybe<ModelConversationConditionInput>;
  input: DeleteConversationInput;
};


export type MutationDeleteDocumentCredentialArgs = {
  condition?: InputMaybe<ModelDocumentCredentialConditionInput>;
  input: DeleteDocumentCredentialInput;
};


export type MutationDeleteDocumentTypeArgs = {
  condition?: InputMaybe<ModelDocumentTypeConditionInput>;
  input: DeleteDocumentTypeInput;
};


export type MutationDeleteDocumentTypeRelationshipsArgs = {
  condition?: InputMaybe<ModelDocumentTypeRelationshipsConditionInput>;
  input: DeleteDocumentTypeRelationshipsInput;
};


export type MutationDeleteIntegrationCredentialsArgs = {
  condition?: InputMaybe<ModelIntegrationCredentialsConditionInput>;
  input: DeleteIntegrationCredentialsInput;
};


export type MutationDeleteJobPostingArgs = {
  condition?: InputMaybe<ModelJobPostingConditionInput>;
  input: DeleteJobPostingInput;
};


export type MutationDeleteJobPostingRecommendationArgs = {
  condition?: InputMaybe<ModelJobPostingRecommendationConditionInput>;
  input: DeleteJobPostingRecommendationInput;
};


export type MutationDeleteMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: DeleteMessageInput;
};


export type MutationDeleteNeedsReviewItemArgs = {
  condition?: InputMaybe<ModelNeedsReviewItemConditionInput>;
  input: DeleteNeedsReviewItemInput;
};


export type MutationDeleteOptOutEmailAddressArgs = {
  condition?: InputMaybe<ModelOptOutEmailAddressConditionInput>;
  input: DeleteOptOutEmailAddressInput;
};


export type MutationDeleteOptOutPhoneNumberArgs = {
  condition?: InputMaybe<ModelOptOutPhoneNumberConditionInput>;
  input: DeleteOptOutPhoneNumberInput;
};


export type MutationDeleteOrganizationArgs = {
  condition?: InputMaybe<ModelOrganizationConditionInput>;
  input: DeleteOrganizationInput;
};


export type MutationDeleteOrganizationConfigArgs = {
  condition?: InputMaybe<ModelOrganizationConfigConditionInput>;
  input: DeleteOrganizationConfigInput;
};


export type MutationDeleteOrganizationCustomFieldArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOrganizationCustomFieldConfigArgs = {
  condition?: InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>;
  input: DeleteOrganizationCustomFieldConfigInput;
};


export type MutationDeleteOrganizationGroupArgs = {
  condition?: InputMaybe<ModelOrganizationGroupConditionInput>;
  input: DeleteOrganizationGroupInput;
};


export type MutationDeleteOrganizationWebhookArgs = {
  condition?: InputMaybe<ModelOrganizationWebhookConditionInput>;
  input: DeleteOrganizationWebhookInput;
};


export type MutationDeleteOutreachQuestionArgs = {
  condition?: InputMaybe<ModelOutreachQuestionConditionInput>;
  input: DeleteOutreachQuestionInput;
};


export type MutationDeletePlanMembershipArgs = {
  condition?: InputMaybe<ModelPlanMembershipConditionInput>;
  input: DeletePlanMembershipInput;
};


export type MutationDeletePreferencesArgs = {
  condition?: InputMaybe<ModelPreferencesConditionInput>;
  input: DeletePreferencesInput;
};


export type MutationDeleteProfileDataArgs = {
  condition?: InputMaybe<ModelProfileDataConditionInput>;
  input: DeleteProfileDataInput;
};


export type MutationDeleteQualificationArgs = {
  condition?: InputMaybe<ModelQualificationConditionInput>;
  input: DeleteQualificationInput;
};


export type MutationDeleteQuestionOutcomeArgs = {
  condition?: InputMaybe<ModelQuestionOutcomeConditionInput>;
  input: DeleteQuestionOutcomeInput;
};


export type MutationDeleteRequirementOutcomeArgs = {
  condition?: InputMaybe<ModelRequirementOutcomeConditionInput>;
  input: DeleteRequirementOutcomeInput;
};


export type MutationDeleteSearchCandidateProfileMessageArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileMessageConditionInput>;
  input: DeleteSearchCandidateProfileMessageInput;
};


export type MutationDeleteSearchCandidateProfileQueryArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileQueryConditionInput>;
  input: DeleteSearchCandidateProfileQueryInput;
};


export type MutationDeleteSearchCandidateProfileSelectedArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>;
  input: DeleteSearchCandidateProfileSelectedInput;
};


export type MutationDeleteSearchCandidateProfileSelectedItemArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>;
  input: DeleteSearchCandidateProfileSelectedItemInput;
};


export type MutationDeleteSearchPeopleQueryFieldsArgs = {
  condition?: InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>;
  input: DeleteSearchPeopleQueryFieldsInput;
};


export type MutationDeleteSelectedCandidateBatchStatusesArgs = {
  condition?: InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>;
  input: DeleteSelectedCandidateBatchStatusesInput;
};


export type MutationDeleteSimulationConversationArgs = {
  condition?: InputMaybe<ModelSimulationConversationConditionInput>;
  input: DeleteSimulationConversationInput;
};


export type MutationDeleteSimulationMessageArgs = {
  condition?: InputMaybe<ModelSimulationMessageConditionInput>;
  input: DeleteSimulationMessageInput;
};


export type MutationDeleteSkillArgs = {
  condition?: InputMaybe<ModelSkillConditionInput>;
  input: DeleteSkillInput;
};


export type MutationDeleteSourcedCandidateArgs = {
  condition?: InputMaybe<ModelSourcedCandidateConditionInput>;
  input: DeleteSourcedCandidateInput;
};


export type MutationDeleteStatusSetArgs = {
  condition?: InputMaybe<ModelStatusSetConditionInput>;
  input: DeleteStatusSetInput;
};


export type MutationDeleteTagArgs = {
  condition?: InputMaybe<ModelTagConditionInput>;
  input: DeleteTagInput;
};


export type MutationDeleteTeamArgs = {
  condition?: InputMaybe<ModelTeamConditionInput>;
  input: DeleteTeamInput;
};


export type MutationDeleteTeamMembershipArgs = {
  condition?: InputMaybe<ModelTeamMembershipConditionInput>;
  input: DeleteTeamMembershipInput;
};


export type MutationDeleteTwilioAccountCredentialsArgs = {
  condition?: InputMaybe<ModelTwilioAccountCredentialsConditionInput>;
  input: DeleteTwilioAccountCredentialsInput;
};


export type MutationDeleteTypeformLinkArgs = {
  condition?: InputMaybe<ModelTypeformLinkConditionInput>;
  input: DeleteTypeformLinkInput;
};


export type MutationDeleteTypeformRecordArgs = {
  condition?: InputMaybe<ModelTypeformRecordConditionInput>;
  input: DeleteTypeformRecordInput;
};


export type MutationDeleteUnansweredQuestionArgs = {
  condition?: InputMaybe<ModelUnansweredQuestionConditionInput>;
  input: DeleteUnansweredQuestionInput;
};


export type MutationDeleteUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: DeleteUserInput;
};


export type MutationDeleteUserCalendarArgs = {
  condition?: InputMaybe<ModelUserCalendarConditionInput>;
  input: DeleteUserCalendarInput;
};


export type MutationDeleteUserCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>;
  input: DeleteUserCalendarMeetingTemplateInput;
};


export type MutationDeleteUserCalendarOrganizationArgs = {
  condition?: InputMaybe<ModelUserCalendarOrganizationConditionInput>;
  input: DeleteUserCalendarOrganizationInput;
};


export type MutationDeleteUserOrganizationArgs = {
  condition?: InputMaybe<ModelUserOrganizationConditionInput>;
  input: DeleteUserOrganizationInput;
};


export type MutationDeleteVirtualCalendarConversationArgs = {
  condition?: InputMaybe<ModelVirtualCalendarConversationConditionInput>;
  input: DeleteVirtualCalendarConversationInput;
};


export type MutationDeleteWhatsaapTemplateArgs = {
  condition?: InputMaybe<ModelWhatsaapTemplateConditionInput>;
  input: DeleteWhatsaapTemplateInput;
};


export type MutationDeleteWorkflowArgs = {
  condition?: InputMaybe<ModelWorkflowConditionInput>;
  input: DeleteWorkflowInput;
};


export type MutationDeleteWorkflowAtsJobArgs = {
  condition?: InputMaybe<ModelWorkflowAtsJobConditionInput>;
  input: DeleteWorkflowAtsJobInput;
};


export type MutationDeleteWorkflowContactArgs = {
  condition?: InputMaybe<ModelWorkflowContactConditionInput>;
  input: DeleteWorkflowContactInput;
};


export type MutationDeleteWorkflowContactImportArgs = {
  condition?: InputMaybe<ModelWorkflowContactImportConditionInput>;
  input: DeleteWorkflowContactImportInput;
};


export type MutationDeleteWorkflowEventArgs = {
  condition?: InputMaybe<ModelWorkflowEventConditionInput>;
  input: DeleteWorkflowEventInput;
};


export type MutationDeleteWorkflowRunArgs = {
  condition?: InputMaybe<ModelWorkflowRunConditionInput>;
  input: DeleteWorkflowRunInput;
};


export type MutationDeleteWorkflowRunCandidateProfileArgs = {
  condition?: InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>;
  input: DeleteWorkflowRunCandidateProfileInput;
};


export type MutationDeleteWorkflowStatsArgs = {
  condition?: InputMaybe<ModelWorkflowStatsConditionInput>;
  input: DeleteWorkflowStatsInput;
};


export type MutationDeleteWorkflowVersionArgs = {
  condition?: InputMaybe<ModelWorkflowVersionConditionInput>;
  input: DeleteWorkflowVersionInput;
};


export type MutationDeleteWorkflowVersionNodeStatsArgs = {
  condition?: InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>;
  input: DeleteWorkflowVersionNodeStatsInput;
};


export type MutationEditCampaignInfoArgs = {
  input: EditCampaignInfoInput;
};


export type MutationEditDocumentTypeArgs = {
  input: EditDocumentTypeInput;
};


export type MutationEditWorkflowContactArgs = {
  input: EditWorkflowContactInput;
};


export type MutationEnrolWorkflowContactsArgs = {
  input: EnrolWorkflowContactsInput;
};


export type MutationGenerateAdjustedAnalysisRequirementArgs = {
  input: GenerateAdjustedAnalysisRequirementInput;
};


export type MutationGenerateAnalysisRequirementRecommendationArgs = {
  input: GenerateAnalysisRequirementRecommendationInput;
};


export type MutationGenerateCandidateProfileRelevanceArgs = {
  input: GenerateCandidateProfileRelevanceInput;
};


export type MutationGenerateCandidateRelevanceArgs = {
  input: GenerateCandidateRelevanceInput;
};


export type MutationGenerateSearchPeopleQueryFieldsArgs = {
  input: GenerateSearchPeopleQueryFieldsInput;
};


export type MutationGenerateSourcingTemplateArgs = {
  input: GenerateSourcingTemplateInput;
};


export type MutationGenerateVectorSearchQuestionsArgs = {
  input: GenerateVectorSearchQuestionsInput;
};


export type MutationGenerateVectorSearchReplyArgs = {
  input: GenerateVectorSearchReplyInput;
};


export type MutationGlobalSignOutArgs = {
  input: GlobalSignOutInput;
};


export type MutationHideOrganizationArgs = {
  input: HideOrganizationInput;
};


export type MutationIncrementAnalysisRequirementCountsArgs = {
  input: IncrementAnalysisRequirementCountsInput;
};


export type MutationIncrementCampaignCountsArgs = {
  input: IncrementCampaignCountsInput;
};


export type MutationIncrementCandidateBatchCountsArgs = {
  input: IncrementCandidateBatchCountsInput;
};


export type MutationIncrementCandidateProfileListCountArgs = {
  input: IncrementCandidateProfileListCountInput;
};


export type MutationIncrementConversationCountsArgs = {
  input: IncrementConversationCountsInput;
};


export type MutationInitializeCampaignArgs = {
  input: InitializeCampaignInput;
};


export type MutationInitializeCampaignWithParticipantsArgs = {
  input: InitializeCampaignWithParticipantsInput;
};


export type MutationInitializeCandidateBatchArgs = {
  input: InitializeCandidateBatchInput;
};


export type MutationInitializeCandidateBatchGroupArgs = {
  input: InitializeCandidateBatchGroupInput;
};


export type MutationInitializeDraftCandidateBatchArgs = {
  input: InitializeDraftCandidateBatchInput;
};


export type MutationInitializeSourcedCandidatesCampaignArgs = {
  input: InitializeSourcedCandidatesCampaignInput;
};


export type MutationInitializeVectorSearchSessionArgs = {
  input: InitializeVectorSearchSessionInput;
};


export type MutationInviteUserToOrganizationArgs = {
  input: InviteUserToOrganizationInput;
};


export type MutationOpenOrCreateWorkflowForAtsJobArgs = {
  input: OpenOrCreateWorkflowForAtsJobInput;
};


export type MutationOptimiseJobDescriptionForDeiArgs = {
  input: OptimiseJobDescriptionInput;
};


export type MutationPauseWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationProcessCandidateBatchesArgs = {
  input: ProcessCandidateBatchesInput;
};


export type MutationPublishWorkflowArgs = {
  input: PublishWorkflowInput;
};


export type MutationRegenerateWebhookSigningSecretArgs = {
  webhookId: Scalars['ID']['input'];
};


export type MutationRegisterCandidateTagsArgs = {
  input: RegisterCandidateTagsInput;
};


export type MutationRemoveCandidateProfileListArgs = {
  input: RemoveCandidateProfileListInput;
};


export type MutationRemoveCandidateProfilesFromListArgs = {
  input: RemoveCandidateProfilesFromListInput;
};


export type MutationRemoveDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type MutationRemoveUserFromOrganizationArgs = {
  input: RemoveUserFromOrganizationInput;
};


export type MutationRemoveWorkflowContactArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResendUserInviteArgs = {
  input: ResendUserInviteInput;
};


export type MutationRestartConversationArgs = {
  input: RestartConversationInput;
};


export type MutationResumeWorkflowArgs = {
  workflowId: Scalars['ID']['input'];
};


export type MutationRevealSourcedCandidatePhoneNumberArgs = {
  input: RevealSourcedCandidatePhoneNumberInput;
};


export type MutationSendMessageByUserArgs = {
  input: SendMessageByUserInput;
};


export type MutationSendSimulationMessageArgs = {
  input: SendSimulationMessageInput;
};


export type MutationStartAddingNewCandidatesToCampaignArgs = {
  input: AddNewCandidatesToCampaignInput;
};


export type MutationStartCampaignArgs = {
  input?: InputMaybe<StartCampaignInput>;
};


export type MutationStartCandidateBatchProcessingArgs = {
  input: StartCandidateBatchProcessingInput;
};


export type MutationStartCandidateMessagesGenerationArgs = {
  input: StartCandidateMessageGenerationInput;
};


export type MutationStartInternalSourcingWorkflowRunsArgs = {
  input: StartInternalSourcingWorkflowRunsInput;
};


export type MutationStartSendingMessagesArgs = {
  input?: InputMaybe<StartCampaignInput>;
};


export type MutationStartWorkflowContactImportArgs = {
  input: StartWorkflowContactImportInput;
};


export type MutationStartWorkflowRunsArgs = {
  input: StartWorkflowRunsInput;
};


export type MutationStopCampaignArgs = {
  input: StopCampaignInput;
};


export type MutationTestOrganizationWebhookArgs = {
  input: TestOrganizationWebhookInput;
};


export type MutationUnhideOrganizationArgs = {
  input: UnhideOrganizationInput;
};


export type MutationUpdateAgentArgs = {
  condition?: InputMaybe<ModelAgentConditionInput>;
  input: UpdateAgentInput;
};


export type MutationUpdateAnalysedApplicationSnapshotArgs = {
  condition?: InputMaybe<ModelAnalysedApplicationSnapshotConditionInput>;
  input: UpdateAnalysedApplicationSnapshotInput;
};


export type MutationUpdateAnalysisAutomationTasksArgs = {
  input: UpdateAnalysisAutomationTasksInput;
};


export type MutationUpdateAnalysisRequirementArgs = {
  condition?: InputMaybe<ModelAnalysisRequirementConditionInput>;
  input: UpdateAnalysisRequirementInput;
};


export type MutationUpdateAnalysisRequirementsArgs = {
  input: UpdateAnalysisRequirementsInput;
};


export type MutationUpdateApplicationStageArgs = {
  input: UpdateApplicationStageInput;
};


export type MutationUpdateApplicationStageUpdateArgs = {
  condition?: InputMaybe<ModelApplicationStageUpdateConditionInput>;
  input: UpdateApplicationStageUpdateInput;
};


export type MutationUpdateAtsApplicationArgs = {
  condition?: InputMaybe<ModelAtsApplicationConditionInput>;
  input: UpdateAtsApplicationInput;
};


export type MutationUpdateAtsApplicationScreeningAnswersArgs = {
  condition?: InputMaybe<ModelAtsApplicationScreeningAnswersConditionInput>;
  input: UpdateAtsApplicationScreeningAnswersInput;
};


export type MutationUpdateAtsBulkSyncArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncConditionInput>;
  input: UpdateAtsBulkSyncInput;
};


export type MutationUpdateAtsBulkSyncErrorArgs = {
  condition?: InputMaybe<ModelAtsBulkSyncErrorConditionInput>;
  input: UpdateAtsBulkSyncErrorInput;
};


export type MutationUpdateAtsConfigArgs = {
  condition?: InputMaybe<ModelAtsConfigConditionInput>;
  input: UpdateAtsConfigInput;
};


export type MutationUpdateAtsQuestionArgs = {
  condition?: InputMaybe<ModelAtsQuestionConditionInput>;
  input: UpdateAtsQuestionInput;
};


export type MutationUpdateAttachmentArgs = {
  condition?: InputMaybe<ModelAttachmentConditionInput>;
  input: UpdateAttachmentInput;
};


export type MutationUpdateAutomationTaskArgs = {
  condition?: InputMaybe<ModelAutomationTaskConditionInput>;
  input: UpdateAutomationTaskInput;
};


export type MutationUpdateAutomationTaskEmailTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTaskEmailTemplateConditionInput>;
  input: UpdateAutomationTaskEmailTemplateInput;
};


export type MutationUpdateAutomationTasksTemplateArgs = {
  condition?: InputMaybe<ModelAutomationTasksTemplateConditionInput>;
  input: UpdateAutomationTasksTemplateInput;
};


export type MutationUpdateCalendarBookingArgs = {
  condition?: InputMaybe<ModelCalendarBookingConditionInput>;
  input: UpdateCalendarBookingInput;
};


export type MutationUpdateCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelCalendarMeetingTemplateConditionInput>;
  input: UpdateCalendarMeetingTemplateInput;
};


export type MutationUpdateCampaignArgs = {
  condition?: InputMaybe<ModelCampaignConditionInput>;
  input: UpdateCampaignInput;
};


export type MutationUpdateCampaignCandidateArgs = {
  condition?: InputMaybe<ModelCampaignCandidateConditionInput>;
  input: UpdateCampaignCandidateInput;
};


export type MutationUpdateCampaignCsvKeysArgs = {
  condition?: InputMaybe<ModelCampaignCsvKeysConditionInput>;
  input: UpdateCampaignCsvKeysInput;
};


export type MutationUpdateCampaignQuestionArgs = {
  condition?: InputMaybe<ModelCampaignQuestionConditionInput>;
  input: UpdateCampaignQuestionInput;
};


export type MutationUpdateCampaignStatsArgs = {
  input: UpdateCampaignStatsInput;
};


export type MutationUpdateCampaignSubscriptionArgs = {
  condition?: InputMaybe<ModelCampaignSubscriptionConditionInput>;
  input: UpdateCampaignSubscriptionInput;
};


export type MutationUpdateCandidateArgs = {
  condition?: InputMaybe<ModelCandidateConditionInput>;
  input: UpdateCandidateInput;
};


export type MutationUpdateCandidateAvailabilitySuggestionArgs = {
  condition?: InputMaybe<ModelCandidateAvailabilitySuggestionConditionInput>;
  input: UpdateCandidateAvailabilitySuggestionInput;
};


export type MutationUpdateCandidateBatchArgs = {
  condition?: InputMaybe<ModelCandidateBatchConditionInput>;
  input: UpdateCandidateBatchInput;
};


export type MutationUpdateCandidateBatchGroupArgs = {
  condition?: InputMaybe<ModelCandidateBatchGroupConditionInput>;
  input: UpdateCandidateBatchGroupInput;
};


export type MutationUpdateCandidateBatchGroupComponentsArgs = {
  input: UpdateCandidateBatchGroupComponentsInput;
};


export type MutationUpdateCandidateCvsParsingArgs = {
  condition?: InputMaybe<ModelCandidateCvsParsingConditionInput>;
  input: UpdateCandidateCvsParsingInput;
};


export type MutationUpdateCandidateEmailCorrespondenceArgs = {
  condition?: InputMaybe<ModelCandidateEmailCorrespondenceConditionInput>;
  input: UpdateCandidateEmailCorrespondenceInput;
};


export type MutationUpdateCandidateMessageArgs = {
  condition?: InputMaybe<ModelCandidateMessageConditionInput>;
  input: UpdateCandidateMessageInput;
};


export type MutationUpdateCandidateNoteArgs = {
  condition?: InputMaybe<ModelCandidateNoteConditionInput>;
  input: UpdateCandidateNoteInput;
};


export type MutationUpdateCandidateProfileArgs = {
  condition?: InputMaybe<ModelCandidateProfileConditionInput>;
  input: UpdateCandidateProfileInput;
};


export type MutationUpdateCandidateProfileListArgs = {
  condition?: InputMaybe<ModelCandidateProfileListConditionInput>;
  input: UpdateCandidateProfileListInput;
};


export type MutationUpdateCandidateProfileListForUserArgs = {
  input: UpdateCandidateProfileListForUserInput;
};


export type MutationUpdateCandidateProfileListMembershipArgs = {
  condition?: InputMaybe<ModelCandidateProfileListMembershipConditionInput>;
  input: UpdateCandidateProfileListMembershipInput;
};


export type MutationUpdateCandidateProfileNoteArgs = {
  condition?: InputMaybe<ModelCandidateProfileNoteConditionInput>;
  input: UpdateCandidateProfileNoteInput;
};


export type MutationUpdateCandidateStatusUpdateArgs = {
  condition?: InputMaybe<ModelCandidateStatusUpdateConditionInput>;
  input: UpdateCandidateStatusUpdateInput;
};


export type MutationUpdateCandidateTagArgs = {
  condition?: InputMaybe<ModelCandidateTagConditionInput>;
  input: UpdateCandidateTagInput;
};


export type MutationUpdateClientApiKeyArgs = {
  condition?: InputMaybe<ModelClientApiKeyConditionInput>;
  input: UpdateClientApiKeyInput;
};


export type MutationUpdateConversationArgs = {
  condition?: InputMaybe<ModelConversationConditionInput>;
  input: UpdateConversationInput;
};


export type MutationUpdateDocumentCredentialArgs = {
  condition?: InputMaybe<ModelDocumentCredentialConditionInput>;
  input: UpdateDocumentCredentialInput;
};


export type MutationUpdateDocumentTypeArgs = {
  condition?: InputMaybe<ModelDocumentTypeConditionInput>;
  input: UpdateDocumentTypeInput;
};


export type MutationUpdateDocumentTypeRelationshipsArgs = {
  condition?: InputMaybe<ModelDocumentTypeRelationshipsConditionInput>;
  input: UpdateDocumentTypeRelationshipsInput;
};


export type MutationUpdateIntegrationCredentialsArgs = {
  condition?: InputMaybe<ModelIntegrationCredentialsConditionInput>;
  input: UpdateIntegrationCredentialsInput;
};


export type MutationUpdateJobPostingArgs = {
  condition?: InputMaybe<ModelJobPostingConditionInput>;
  input: UpdateJobPostingInput;
};


export type MutationUpdateJobPostingRecommendationArgs = {
  condition?: InputMaybe<ModelJobPostingRecommendationConditionInput>;
  input: UpdateJobPostingRecommendationInput;
};


export type MutationUpdateMessageArgs = {
  condition?: InputMaybe<ModelMessageConditionInput>;
  input: UpdateMessageInput;
};


export type MutationUpdateNeedsReviewItemArgs = {
  condition?: InputMaybe<ModelNeedsReviewItemConditionInput>;
  input: UpdateNeedsReviewItemInput;
};


export type MutationUpdateOptOutEmailAddressArgs = {
  condition?: InputMaybe<ModelOptOutEmailAddressConditionInput>;
  input: UpdateOptOutEmailAddressInput;
};


export type MutationUpdateOptOutPhoneNumberArgs = {
  condition?: InputMaybe<ModelOptOutPhoneNumberConditionInput>;
  input: UpdateOptOutPhoneNumberInput;
};


export type MutationUpdateOrganizationArgs = {
  condition?: InputMaybe<ModelOrganizationConditionInput>;
  input: UpdateOrganizationInput;
};


export type MutationUpdateOrganizationConfigArgs = {
  condition?: InputMaybe<ModelOrganizationConfigConditionInput>;
  input: UpdateOrganizationConfigInput;
};


export type MutationUpdateOrganizationCustomFieldArgs = {
  input: UpdateOrganizationCustomFieldInput;
};


export type MutationUpdateOrganizationCustomFieldConfigArgs = {
  condition?: InputMaybe<ModelOrganizationCustomFieldConfigConditionInput>;
  input: UpdateOrganizationCustomFieldConfigInput;
};


export type MutationUpdateOrganizationGroupArgs = {
  condition?: InputMaybe<ModelOrganizationGroupConditionInput>;
  input: UpdateOrganizationGroupInput;
};


export type MutationUpdateOrganizationPhoneNumberArgs = {
  input: UpdateOrganizationPhoneNumberInput;
};


export type MutationUpdateOrganizationWebhookArgs = {
  condition?: InputMaybe<ModelOrganizationWebhookConditionInput>;
  input: UpdateOrganizationWebhookInput;
};


export type MutationUpdateOutreachQuestionArgs = {
  condition?: InputMaybe<ModelOutreachQuestionConditionInput>;
  input: UpdateOutreachQuestionInput;
};


export type MutationUpdatePlanMembershipArgs = {
  condition?: InputMaybe<ModelPlanMembershipConditionInput>;
  input: UpdatePlanMembershipInput;
};


export type MutationUpdatePreferencesArgs = {
  condition?: InputMaybe<ModelPreferencesConditionInput>;
  input: UpdatePreferencesInput;
};


export type MutationUpdateProfileDataArgs = {
  condition?: InputMaybe<ModelProfileDataConditionInput>;
  input: UpdateProfileDataInput;
};


export type MutationUpdateQualificationArgs = {
  condition?: InputMaybe<ModelQualificationConditionInput>;
  input: UpdateQualificationInput;
};


export type MutationUpdateQuestionOutcomeArgs = {
  condition?: InputMaybe<ModelQuestionOutcomeConditionInput>;
  input: UpdateQuestionOutcomeInput;
};


export type MutationUpdateRequirementOutcomeArgs = {
  condition?: InputMaybe<ModelRequirementOutcomeConditionInput>;
  input: UpdateRequirementOutcomeInput;
};


export type MutationUpdateSearchCandidateProfileMessageArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileMessageConditionInput>;
  input: UpdateSearchCandidateProfileMessageInput;
};


export type MutationUpdateSearchCandidateProfileQueryArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileQueryConditionInput>;
  input: UpdateSearchCandidateProfileQueryInput;
};


export type MutationUpdateSearchCandidateProfileSelectedArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedConditionInput>;
  input: UpdateSearchCandidateProfileSelectedInput;
};


export type MutationUpdateSearchCandidateProfileSelectedItemArgs = {
  condition?: InputMaybe<ModelSearchCandidateProfileSelectedItemConditionInput>;
  input: UpdateSearchCandidateProfileSelectedItemInput;
};


export type MutationUpdateSearchPeopleQueryFieldsArgs = {
  condition?: InputMaybe<ModelSearchPeopleQueryFieldsConditionInput>;
  input: UpdateSearchPeopleQueryFieldsInput;
};


export type MutationUpdateSelectedCandidateBatchStatusesArgs = {
  condition?: InputMaybe<ModelSelectedCandidateBatchStatusesConditionInput>;
  input: UpdateSelectedCandidateBatchStatusesInput;
};


export type MutationUpdateSimulationConversationArgs = {
  condition?: InputMaybe<ModelSimulationConversationConditionInput>;
  input: UpdateSimulationConversationInput;
};


export type MutationUpdateSimulationMessageArgs = {
  condition?: InputMaybe<ModelSimulationMessageConditionInput>;
  input: UpdateSimulationMessageInput;
};


export type MutationUpdateSkillArgs = {
  condition?: InputMaybe<ModelSkillConditionInput>;
  input: UpdateSkillInput;
};


export type MutationUpdateSourcedCandidateArgs = {
  condition?: InputMaybe<ModelSourcedCandidateConditionInput>;
  input: UpdateSourcedCandidateInput;
};


export type MutationUpdateStatusSetArgs = {
  condition?: InputMaybe<ModelStatusSetConditionInput>;
  input: UpdateStatusSetInput;
};


export type MutationUpdateTagArgs = {
  condition?: InputMaybe<ModelTagConditionInput>;
  input: UpdateTagInput;
};


export type MutationUpdateTeamArgs = {
  condition?: InputMaybe<ModelTeamConditionInput>;
  input: UpdateTeamInput;
};


export type MutationUpdateTeamMembershipArgs = {
  condition?: InputMaybe<ModelTeamMembershipConditionInput>;
  input: UpdateTeamMembershipInput;
};


export type MutationUpdateTwilioAccountCredentialsArgs = {
  condition?: InputMaybe<ModelTwilioAccountCredentialsConditionInput>;
  input: UpdateTwilioAccountCredentialsInput;
};


export type MutationUpdateTypeformLinkArgs = {
  condition?: InputMaybe<ModelTypeformLinkConditionInput>;
  input: UpdateTypeformLinkInput;
};


export type MutationUpdateTypeformRecordArgs = {
  condition?: InputMaybe<ModelTypeformRecordConditionInput>;
  input: UpdateTypeformRecordInput;
};


export type MutationUpdateUnansweredQuestionArgs = {
  condition?: InputMaybe<ModelUnansweredQuestionConditionInput>;
  input: UpdateUnansweredQuestionInput;
};


export type MutationUpdateUserArgs = {
  condition?: InputMaybe<ModelUserConditionInput>;
  input: UpdateUserInput;
};


export type MutationUpdateUserCalendarArgs = {
  condition?: InputMaybe<ModelUserCalendarConditionInput>;
  input: UpdateUserCalendarInput;
};


export type MutationUpdateUserCalendarMeetingTemplateArgs = {
  condition?: InputMaybe<ModelUserCalendarMeetingTemplateConditionInput>;
  input: UpdateUserCalendarMeetingTemplateInput;
};


export type MutationUpdateUserCalendarOrganizationArgs = {
  condition?: InputMaybe<ModelUserCalendarOrganizationConditionInput>;
  input: UpdateUserCalendarOrganizationInput;
};


export type MutationUpdateUserOrganizationArgs = {
  condition?: InputMaybe<ModelUserOrganizationConditionInput>;
  input: UpdateUserOrganizationInput;
};


export type MutationUpdateUserOrganizationRoleArgs = {
  input: UpdateUserOrganizationRoleInput;
};


export type MutationUpdateVirtualCalendarConversationArgs = {
  condition?: InputMaybe<ModelVirtualCalendarConversationConditionInput>;
  input: UpdateVirtualCalendarConversationInput;
};


export type MutationUpdateWhatsaapTemplateArgs = {
  condition?: InputMaybe<ModelWhatsaapTemplateConditionInput>;
  input: UpdateWhatsaapTemplateInput;
};


export type MutationUpdateWorkflowArgs = {
  condition?: InputMaybe<ModelWorkflowConditionInput>;
  input: UpdateWorkflowInput;
};


export type MutationUpdateWorkflowAtsJobArgs = {
  condition?: InputMaybe<ModelWorkflowAtsJobConditionInput>;
  input: UpdateWorkflowAtsJobInput;
};


export type MutationUpdateWorkflowContactArgs = {
  condition?: InputMaybe<ModelWorkflowContactConditionInput>;
  input: UpdateWorkflowContactInput;
};


export type MutationUpdateWorkflowContactImportArgs = {
  condition?: InputMaybe<ModelWorkflowContactImportConditionInput>;
  input: UpdateWorkflowContactImportInput;
};


export type MutationUpdateWorkflowEventArgs = {
  condition?: InputMaybe<ModelWorkflowEventConditionInput>;
  input: UpdateWorkflowEventInput;
};


export type MutationUpdateWorkflowFromApiArgs = {
  input: UpdateWorkflowFromApiInput;
};


export type MutationUpdateWorkflowRunArgs = {
  condition?: InputMaybe<ModelWorkflowRunConditionInput>;
  input: UpdateWorkflowRunInput;
};


export type MutationUpdateWorkflowRunCandidateProfileArgs = {
  condition?: InputMaybe<ModelWorkflowRunCandidateProfileConditionInput>;
  input: UpdateWorkflowRunCandidateProfileInput;
};


export type MutationUpdateWorkflowStatsArgs = {
  condition?: InputMaybe<ModelWorkflowStatsConditionInput>;
  input: UpdateWorkflowStatsInput;
};


export type MutationUpdateWorkflowVersionArgs = {
  condition?: InputMaybe<ModelWorkflowVersionConditionInput>;
  input: UpdateWorkflowVersionInput;
};


export type MutationUpdateWorkflowVersionNodeStatsArgs = {
  condition?: InputMaybe<ModelWorkflowVersionNodeStatsConditionInput>;
  input: UpdateWorkflowVersionNodeStatsInput;
};


export type MutationUpsertOrganizationConfigArgs = {
  input: UpsertOrganizationConfigInput;
};


export type MutationWorkflowBuilderAgentTurnArgs = {
  input: Scalars['AWSJSON']['input'];
};


export type MutationWorkflowBuilderLiveTokenArgs = {
  mode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationWorkflowBuilderTranscribeArgs = {
  audio: WorkflowBuilderAudioInput;
};

export type NeedsReviewItem = {
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['AWSJSON']['output']>;
  organizationId: Scalars['ID']['output'];
  reason: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum NeedsReviewReason {
  MoreTimeRequested = 'MORE_TIME_REQUESTED'
}

export enum NodeExecutionState {
  Awaiting = 'AWAITING',
  Executing = 'EXECUTING'
}

export enum NoteTakerStatus {
  Available = 'AVAILABLE',
  Error = 'ERROR',
  Processing = 'PROCESSING',
  Scheduled = 'SCHEDULED'
}

export type NoteTakerTranscriptItem = {
  end: Scalars['Int']['output'];
  speaker: Scalars['String']['output'];
  start: Scalars['Int']['output'];
  text: Scalars['String']['output'];
};

export type NoteTakerTranscriptItemInput = {
  end: Scalars['Int']['input'];
  speaker: Scalars['String']['input'];
  start: Scalars['Int']['input'];
  text: Scalars['String']['input'];
};

export enum NoteType {
  ApplicationNote = 'APPLICATION_NOTE',
  CandidateNote = 'CANDIDATE_NOTE'
}

export type NudgeSetting = {
  delayHours: Scalars['Int']['output'];
};

export type NudgeSettingInput = {
  delayHours: Scalars['Int']['input'];
};

export enum OnboardingTourStatus {
  Completed = 'COMPLETED',
  NotStarted = 'NOT_STARTED',
  Skipped = 'SKIPPED'
}

export type OpenEndedQuestion = {
  content: Scalars['String']['output'];
  preferredAnswer: Scalars['String']['output'];
};

export type OpenOrCreateWorkflowForAtsJobInput = {
  atsJobId: Scalars['ID']['input'];
  canvasVisualConfiguration: Scalars['AWSJSON']['input'];
};

export enum OpenOrCreateWorkflowForAtsJobOutcome {
  BlockedByClassic = 'BLOCKED_BY_CLASSIC',
  Created = 'CREATED',
  OpenedDraft = 'OPENED_DRAFT',
  OpenedLive = 'OPENED_LIVE'
}

export type OpenOrCreateWorkflowForAtsJobResult = {
  blockedByAnalysis?: Maybe<ConnectedRecord>;
  blockedByCampaign?: Maybe<ConnectedRecord>;
  outcome: OpenOrCreateWorkflowForAtsJobOutcome;
  workflowId?: Maybe<Scalars['ID']['output']>;
};

export type OpenQuestionOutcome = {
  openQuestionRequirementOutcomes?: Maybe<Array<OpenQuestionRequirementOutcome>>;
  question: Scalars['String']['output'];
  responseSummary: Scalars['String']['output'];
  score?: Maybe<Scalars['Float']['output']>;
};

export type OpenQuestionOutcomeInput = {
  openQuestionRequirementOutcomes?: InputMaybe<Array<OpenQuestionRequirementOutcomeInput>>;
  question: Scalars['String']['input'];
  responseSummary: Scalars['String']['input'];
  score?: InputMaybe<Scalars['Float']['input']>;
};

export type OpenQuestionRequirementOutcome = {
  content: Scalars['String']['output'];
  evidence: Scalars['String']['output'];
  isMet: Scalars['Boolean']['output'];
};

export type OpenQuestionRequirementOutcomeInput = {
  content: Scalars['String']['input'];
  evidence: Scalars['String']['input'];
  isMet: Scalars['Boolean']['input'];
};

export enum OpeningMessageMode {
  CustomOpeningMessage = 'CUSTOM_OPENING_MESSAGE',
  CustomOrTemplatedOpeningMessage = 'CUSTOM_OR_TEMPLATED_OPENING_MESSAGE',
  TemplatedOpeningMessage = 'TEMPLATED_OPENING_MESSAGE'
}

export type OptOutEmailAddress = {
  createdAt: Scalars['AWSDateTime']['output'];
  emailAddress: Scalars['String']['output'];
  emailIdentity: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type OptOutPhoneNumber = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type OptimiseJobDescriptionInput = {
  jobDescription: Scalars['String']['input'];
};

export type OptimiseJobDescriptionOutput = {
  newJobDescription: Scalars['String']['output'];
  oldJobDescription: Scalars['String']['output'];
};

export type Organization = {
  alphaSenderID?: Maybe<Scalars['String']['output']>;
  atsBulkSyncs?: Maybe<ModelAtsBulkSyncConnection>;
  atsConfig?: Maybe<AtsConfig>;
  campaignEmailAddress?: Maybe<Scalars['String']['output']>;
  campaignSubscriptions?: Maybe<ModelCampaignSubscriptionConnection>;
  campaigns?: Maybe<ModelCampaignConnection>;
  candidateBatches?: Maybe<ModelCandidateBatchConnection>;
  candidateCvsParsings?: Maybe<ModelCandidateCvsParsingConnection>;
  candidateDisplayName?: Maybe<Scalars['String']['output']>;
  candidateProfileListMemberships?: Maybe<ModelCandidateProfileListMembershipConnection>;
  candidateProfileLists?: Maybe<ModelCandidateProfileListConnection>;
  channelsEnabled?: Maybe<Array<Channels>>;
  createdAt: Scalars['AWSDateTime']['output'];
  emailIdentity?: Maybe<Scalars['String']['output']>;
  externalId?: Maybe<Scalars['String']['output']>;
  hasCalendarIntegration?: Maybe<Scalars['Boolean']['output']>;
  hiddenAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  initialWhatsAppTemplatesBatchStatus?: Maybe<InitialWhatsAppTemplatesBatchStatus>;
  integrationCredentials?: Maybe<ModelIntegrationCredentialsConnection>;
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  isSandbox?: Maybe<Scalars['Boolean']['output']>;
  jobRecommendationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  logoS3Key?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  organizationAtsConfigId?: Maybe<Scalars['ID']['output']>;
  organizationConfig?: Maybe<OrganizationConfig>;
  organizationGroupId?: Maybe<Scalars['ID']['output']>;
  organizationOrganizationConfigId?: Maybe<Scalars['ID']['output']>;
  organizationTwilioAccountCredentialsId?: Maybe<Scalars['ID']['output']>;
  organizationWebhooks?: Maybe<ModelOrganizationWebhookConnection>;
  planMembership?: Maybe<ModelPlanMembershipConnection>;
  sandboxExpiresAt?: Maybe<Scalars['AWSDateTime']['output']>;
  sandboxStatus?: Maybe<SandboxStatus>;
  searchCandidateProfileMessages?: Maybe<ModelSearchCandidateProfileMessageConnection>;
  searchCandidateProfileQueries?: Maybe<ModelSearchCandidateProfileQueryConnection>;
  searchCandidateProfileSelected?: Maybe<ModelSearchCandidateProfileSelectedConnection>;
  searchCandidateProfileSelectedItems?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  twilioAccountCredentials?: Maybe<TwilioAccountCredentials>;
  twilioInboundPhoneNumberAnswers?: Maybe<Scalars['AWSPhone']['output']>;
  twilioInboundPhoneNumberQuestions?: Maybe<Scalars['AWSPhone']['output']>;
  twilioPhoneNumber?: Maybe<Scalars['AWSPhone']['output']>;
  twilioSenderStatus?: Maybe<TwilioSenderStatus>;
  typeformRecords?: Maybe<ModelTypeformRecordConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userOrganizations?: Maybe<ModelUserOrganizationConnection>;
  users?: Maybe<ModelUserConnection>;
  usersCount?: Maybe<Scalars['Int']['output']>;
  vectorDbTenantName?: Maybe<Scalars['String']['output']>;
  websiteUrl?: Maybe<Scalars['AWSURL']['output']>;
  whatsAppBusinessAccountId?: Maybe<Scalars['String']['output']>;
};


export type OrganizationAtsBulkSyncsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCampaignSubscriptionsArgs = {
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCampaignsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCandidateBatchesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCandidateCvsParsingsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCandidateProfileListMembershipsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationCandidateProfileListsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationIntegrationCredentialsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationOrganizationWebhooksArgs = {
  filter?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationPlanMembershipArgs = {
  filter?: InputMaybe<ModelPlanMembershipFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationSearchCandidateProfileMessagesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationSearchCandidateProfileQueriesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationSearchCandidateProfileSelectedArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationSearchCandidateProfileSelectedItemsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationTypeformRecordsArgs = {
  filter?: InputMaybe<ModelTypeformRecordFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationUserOrganizationsArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationUsersArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type OrganizationConfig = {
  agent?: Maybe<Agent>;
  agentId?: Maybe<Scalars['ID']['output']>;
  allowWhatsAppForAtsListCampaigns?: Maybe<Scalars['Boolean']['output']>;
  availableLanguages?: Maybe<Array<Scalars['String']['output']>>;
  closingMessage?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customRequest?: Maybe<Scalars['String']['output']>;
  defaultAutomationTaskTemplate?: Maybe<AutomationTasksTemplate>;
  defaultAutomationTaskTemplateId?: Maybe<Scalars['ID']['output']>;
  emailChannelFallbackEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailFooterHtml?: Maybe<Scalars['String']['output']>;
  globalContext?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  internalSourcingAddToJobActionUrl?: Maybe<Scalars['String']['output']>;
  internalSourcingEnabled?: Maybe<Scalars['Boolean']['output']>;
  internalSourcingProtectedCharacteristics?: Maybe<Scalars['AWSJSON']['output']>;
  openingMessageMode?: Maybe<OpeningMessageMode>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  rejectionMessage?: Maybe<Scalars['String']['output']>;
  sourcingEnabled?: Maybe<Scalars['Boolean']['output']>;
  timeToAutoCloseConversationsInHours?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  webhookJobSyncingFlowEnabled?: Maybe<Scalars['Boolean']['output']>;
  whatsAppTemplates?: Maybe<ModelWhatsaapTemplateConnection>;
  whiteLabelSettings?: Maybe<WhiteLabelSettings>;
  whiteLabelingEnabled?: Maybe<Scalars['Boolean']['output']>;
};


export type OrganizationConfigWhatsAppTemplatesArgs = {
  filter?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type OrganizationCustomFieldConfig = {
  allowedValues?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['AWSDateTime']['output'];
  displayAs?: Maybe<CustomFieldDisplay>;
  fieldKey: Scalars['String']['output'];
  hasFixedOptions: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  label: Scalars['String']['output'];
  organizationGroupId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  retiredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  type: CustomFieldType;
  updatedAt: Scalars['AWSDateTime']['output'];
  vectorDbKey: Scalars['String']['output'];
};

export type OrganizationGroup = {
  atsBulkSyncs?: Maybe<ModelAtsBulkSyncConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizations?: Maybe<ModelOrganizationConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type OrganizationGroupAtsBulkSyncsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type OrganizationGroupOrganizationsArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<ModelStringKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum OrganizationGroupRole {
  OrganizationGroupAdmin = 'ORGANIZATION_GROUP_ADMIN',
  OrganizationGroupMember = 'ORGANIZATION_GROUP_MEMBER'
}

export type OrganizationUserItem = {
  correspondenceEmail?: Maybe<Scalars['AWSEmail']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  email?: Maybe<Scalars['AWSEmail']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isOnboard?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationGroupRole?: Maybe<OrganizationGroupRole>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UserRole>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userOrganizationId?: Maybe<Scalars['ID']['output']>;
};

export type OrganizationWebhook = {
  createdAt: Scalars['AWSDateTime']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  signingSecret: Scalars['String']['output'];
  subscribedEvents?: Maybe<Array<WebhookEventType>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  url: Scalars['AWSURL']['output'];
};

export type OutreachQuestion = {
  answerRoutes?: Maybe<Scalars['AWSJSON']['output']>;
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  documentItems?: Maybe<Array<DocumentItem>>;
  /** @deprecated Use documentItems instead. A Question must carry either documentTypes (legacy free-text) or documentItems (typed references), never both. */
  documentTypes?: Maybe<Array<Scalars['String']['output']>>;
  expectedAnswer?: Maybe<QuestionExpectedAnswer>;
  hasPreferredAnswer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  order: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  preferredAnswerRequirements?: Maybe<Array<Scalars['String']['output']>>;
  preferredAnswerText?: Maybe<Scalars['String']['output']>;
  questionOutcomes?: Maybe<ModelQuestionOutcomeConnection>;
  questionType?: Maybe<QuestionType>;
  slug?: Maybe<Scalars['String']['output']>;
  strictness?: Maybe<QuestionStrictness>;
  supportingInformation?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowVersionId?: Maybe<Scalars['ID']['output']>;
};


export type OutreachQuestionQuestionOutcomesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export enum Plan {
  Free = 'FREE',
  Tier_1 = 'TIER_1',
  Tier_1Deprecated = 'TIER_1_DEPRECATED',
  Tier_2 = 'TIER_2',
  Tier_3 = 'TIER_3',
  Tier_4 = 'TIER_4'
}

export type PlanMembership = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  messagesLimit?: Maybe<Scalars['Int']['output']>;
  messagesUsage?: Maybe<Scalars['Int']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  plan?: Maybe<Plan>;
  product?: Maybe<SubscriptionProduct>;
  scoringLimit?: Maybe<Scalars['Int']['output']>;
  scoringUsage?: Maybe<Scalars['Int']['output']>;
  sourcingUsage?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['AWSDate']['output']>;
  status?: Maybe<PlanStatus>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  stripePriceId?: Maybe<Scalars['String']['output']>;
  stripeProductId?: Maybe<Scalars['String']['output']>;
  stripeProductName?: Maybe<Scalars['String']['output']>;
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  usersCountLimit?: Maybe<Scalars['Int']['output']>;
};

export enum PlanStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED',
  Inactive = 'INACTIVE',
  PastDue = 'PAST_DUE',
  PendingDowngrade = 'PENDING_DOWNGRADE'
}

export type Preferences = {
  companyName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  owner?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  tone?: Maybe<Tone>;
  updatedAt: Scalars['AWSDateTime']['output'];
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export type PreferredAnswerEvaluation = {
  evidence: Scalars['String']['output'];
  generatedAnswer?: Maybe<Scalars['String']['output']>;
  isMet: Scalars['Boolean']['output'];
  requirement: Scalars['String']['output'];
};

export type PreferredAnswerEvaluationInput = {
  evidence: Scalars['String']['input'];
  generatedAnswer?: InputMaybe<Scalars['String']['input']>;
  isMet: Scalars['Boolean']['input'];
  requirement: Scalars['String']['input'];
};

export type PreviousQuestionAnswer = {
  answerPolarity?: Maybe<Scalars['String']['output']>;
  context?: Maybe<Scalars['String']['output']>;
  isAnswered: Scalars['Boolean']['output'];
  question: Scalars['String']['output'];
};

export type PreviousQuestionAnswerInput = {
  answerPolarity?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['String']['input']>;
  isAnswered: Scalars['Boolean']['input'];
  question: Scalars['String']['input'];
};

export type ProcessCandidateBatchesInput = {
  atsJobs: Array<AtsJobInput>;
  candidateBatchGroupId: Scalars['ID']['input'];
};

export type ProfileResult = {
  companyName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Array<Scalars['String']['output']>>;
  experience?: Maybe<Array<Scalars['String']['output']>>;
  fullName?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  linkedInProfileUrl: Scalars['String']['output'];
  location?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type PromptInstruction = {
  content?: Maybe<Scalars['String']['output']>;
};

export type PromptInstructionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
};

export type PublishWorkflowInput = {
  changeNotes?: InputMaybe<Scalars['String']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type PublishWorkflowResult = {
  publishedAt: Scalars['AWSDateTime']['output'];
  status: WorkflowVersionStatus;
  validation: WorkflowValidationResult;
  versionId: Scalars['ID']['output'];
  versionNumber: Scalars['Int']['output'];
  workflowId: Scalars['ID']['output'];
};

export type Qualification = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  qualification: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  vectorDbTenantName: Scalars['String']['output'];
};

export type Query = {
  agentsByUserId?: Maybe<ModelAgentConnection>;
  analysedApplicationSnapshotsByCandidateIdAndCreatedAt?: Maybe<ModelAnalysedApplicationSnapshotConnection>;
  atsQuestionsByCandidateBatchId?: Maybe<ModelAtsQuestionConnection>;
  calendarBookingsByCalendarMeetingTemplateIdAndId?: Maybe<ModelCalendarBookingConnection>;
  campaignsByAgentId?: Maybe<ModelCampaignConnection>;
  campaignsByCalendarMeetingTemplateIdAndId?: Maybe<ModelCampaignConnection>;
  campaignsByWorkflowId?: Maybe<ModelCampaignConnection>;
  campaignsByWorkflowVersionId?: Maybe<ModelCampaignConnection>;
  candidateBatchesByWorkflowId?: Maybe<ModelCandidateBatchConnection>;
  candidateBatchesByWorkflowRunId?: Maybe<ModelCandidateBatchConnection>;
  candidateBatchesByWorkflowVersionIdAndWorkflowNodeId?: Maybe<ModelCandidateBatchConnection>;
  candidatesByWorkflowRunId?: Maybe<ModelCandidateConnection>;
  conversationsByAgentId?: Maybe<ModelConversationConnection>;
  conversationsByCampaignId?: Maybe<ModelConversationConnection>;
  conversationsByUserId?: Maybe<ModelConversationConnection>;
  conversationsByWorkflowRunId?: Maybe<ModelConversationConnection>;
  detectBiasedSearch?: Maybe<DetectBiasedSearchResult>;
  documentTypeRelationshipsByCampaignId?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  documentTypeRelationshipsByDocumentTypeIdAndCreatedAt?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  documentTypeRelationshipsByOrganizationIdAndCreatedAt?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  documentTypeRelationshipsByWorkflowId?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  documentTypesByOrganizationIdAndCreatedAt?: Maybe<ModelDocumentTypeConnection>;
  exportAllAnalysisData?: Maybe<ExportAllAnalysisDataOutput>;
  exportAllCampaignsData?: Maybe<ExportAllCampaignsDataOutput>;
  exportAllCampaignsDataV2?: Maybe<ExportAllCampaignsDataV2Output>;
  exportAnalysisData?: Maybe<ExportAnalysisDataOutput>;
  exportCampaignData?: Maybe<ExportCampaignDataOutput>;
  generateClientApiKey?: Maybe<GenerateClientApiKeyResult>;
  generateJobRequirements?: Maybe<GenerateJobRequirementsResolverResponse>;
  generatePreferredAnswerRequirements?: Maybe<GeneratePreferredAnswerRequirementsResponse>;
  generateQuestions?: Maybe<GenerateQuestionsResponse>;
  getAgent?: Maybe<Agent>;
  getAgentsByOrganization?: Maybe<ModelAgentConnection>;
  getAgentsByUserAndOrganization?: Maybe<ModelAgentConnection>;
  getAnalysedApplicationSnapshot?: Maybe<AnalysedApplicationSnapshot>;
  getAnalysisNodeMoveOnCount?: Maybe<AnalysisNodeMoveOnCount>;
  getAnalysisNodeSummary?: Maybe<AnalysisNodeSummary>;
  getAnalysisRequirement?: Maybe<AnalysisRequirement>;
  getAnalysisRequirementsByCandidateBatch?: Maybe<ModelAnalysisRequirementConnection>;
  getAnalysisRequirementsByCandidateBatchGroup?: Maybe<ModelAnalysisRequirementConnection>;
  getApplicationStageUpdate?: Maybe<ApplicationStageUpdate>;
  getApplicationStageUpdatesByConversation?: Maybe<ModelApplicationStageUpdateConnection>;
  getAtsApplication?: Maybe<AtsApplication>;
  getAtsApplicationByRemoteId?: Maybe<ModelAtsApplicationConnection>;
  getAtsApplicationScreeningAnswers?: Maybe<AtsApplicationScreeningAnswers>;
  getAtsApplicationsByCandidateProfile?: Maybe<ModelAtsApplicationConnection>;
  getAtsApplicationsByJob?: Maybe<ModelAtsApplicationConnection>;
  getAtsApplicationsByOrganization?: Maybe<ModelAtsApplicationConnection>;
  getAtsApplicationsByOrganizationGroup?: Maybe<ModelAtsApplicationConnection>;
  getAtsBulkSync?: Maybe<AtsBulkSync>;
  getAtsBulkSyncError?: Maybe<AtsBulkSyncError>;
  getAtsConfig?: Maybe<AtsConfig>;
  getAtsConfigByOrganizationId?: Maybe<ModelAtsConfigConnection>;
  getAtsQuestion?: Maybe<AtsQuestion>;
  getAtsQuestionsByJob?: Maybe<ModelAtsQuestionConnection>;
  getAttachment?: Maybe<Attachment>;
  getAttachmentsByCandidateProfile?: Maybe<ModelAttachmentConnection>;
  getAttachmentsByConversation?: Maybe<ModelAttachmentConnection>;
  getAutomationTask?: Maybe<AutomationTask>;
  getAutomationTaskEmailTemplate?: Maybe<AutomationTaskEmailTemplate>;
  getAutomationTaskEmailTemplatesByOrganization?: Maybe<ModelAutomationTaskEmailTemplateConnection>;
  getAutomationTasksByAutomationType?: Maybe<GetAutomationTasksByAutomationTypeOutput>;
  getAutomationTasksByCampaignId?: Maybe<ModelAutomationTaskConnection>;
  getAutomationTasksByCandidateBatchGroup?: Maybe<ModelAutomationTaskConnection>;
  getAutomationTasksByCandidateBatchId?: Maybe<ModelAutomationTaskConnection>;
  getAutomationTasksTemplate?: Maybe<AutomationTasksTemplate>;
  getAutomationTasksTemplateByOrganization?: Maybe<ModelAutomationTasksTemplateConnection>;
  getAutomationTasksTemplatesByAutomationType?: Maybe<Array<AutomationTasksTemplate>>;
  getAutomationsTasksTemplateByUser?: Maybe<ModelAutomationTasksTemplateConnection>;
  getCalendarBooking?: Maybe<CalendarBooking>;
  getCalendarBookingByCampaign?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByConversation?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByIcalUid?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByNoteTaker?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByNylasBookingId?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByNylasEventId?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByOrganization?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByOrganizerUserCalendar?: Maybe<ModelCalendarBookingConnection>;
  getCalendarBookingByWorkflow?: Maybe<ModelCalendarBookingConnection>;
  getCalendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  getCalendarMeetingTemplateByNylasConfiguration?: Maybe<ModelCalendarMeetingTemplateConnection>;
  getCalendarMeetingTemplateByOrganization?: Maybe<ModelCalendarMeetingTemplateConnection>;
  getCalendarMeetingTemplateByOrganizerUserCalendar?: Maybe<ModelCalendarMeetingTemplateConnection>;
  getCalendarMeetingTemplateByUser?: Maybe<ModelCalendarMeetingTemplateConnection>;
  getCampaign?: Maybe<Campaign>;
  getCampaignCandidate?: Maybe<CampaignCandidate>;
  getCampaignCsvKeys?: Maybe<CampaignCsvKeys>;
  getCampaignCsvKeysByCampaign?: Maybe<ModelCampaignCsvKeysConnection>;
  getCampaignQuestion?: Maybe<CampaignQuestion>;
  getCampaignSubscribers?: Maybe<GetCampaignSubscribersOutput>;
  getCampaignSubscription?: Maybe<CampaignSubscription>;
  getCampaignSubscriptionsByCampaign?: Maybe<ModelCampaignSubscriptionConnection>;
  getCampaignSubscriptionsByOrganization?: Maybe<ModelCampaignSubscriptionConnection>;
  getCampaignSubscriptionsByUser?: Maybe<ModelCampaignSubscriptionConnection>;
  getCampaignSubscriptionsByUserAndOrganization?: Maybe<ModelCampaignSubscriptionConnection>;
  getCampaignsByAtsJobId?: Maybe<ModelCampaignConnection>;
  getCampaignsByAtsListId?: Maybe<ModelCampaignConnection>;
  getCampaignsByCampaignGroup?: Maybe<ModelCampaignConnection>;
  getCampaignsByCandidateBatch?: Maybe<ModelCampaignConnection>;
  getCampaignsByKomboJobId?: Maybe<ModelCampaignConnection>;
  getCampaignsByOrganization?: Maybe<ModelCampaignConnection>;
  getCampaignsByReferenceId?: Maybe<ModelCampaignConnection>;
  getCampaignsByStatusAndAtsJobId?: Maybe<ModelCampaignConnection>;
  getCampaignsByStatusAndAtsListId?: Maybe<ModelCampaignConnection>;
  getCampaignsByStatusAndExternalId?: Maybe<ModelCampaignConnection>;
  getCampaignsByUser?: Maybe<ModelCampaignConnection>;
  getCampaignsByUserAndOrganization?: Maybe<ModelCampaignConnection>;
  getCandidate?: Maybe<Candidate>;
  getCandidateAvailabilitySuggestion?: Maybe<CandidateAvailabilitySuggestion>;
  getCandidateAvailabilitySuggestionsByConversation?: Maybe<ModelCandidateAvailabilitySuggestionConnection>;
  getCandidateBatch?: Maybe<CandidateBatch>;
  getCandidateBatchByAtsJobId?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchByKomboJobId?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchByOrganization?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchByStatusAndAtsJobId?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchByStatusAndExternalId?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchByUser?: Maybe<ModelCandidateBatchConnection>;
  getCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  getCandidateBatchGroupByJobCode?: Maybe<ModelCandidateBatchGroupConnection>;
  getCandidateBatchGroupByOrganization?: Maybe<ModelCandidateBatchGroupConnection>;
  getCandidateBatchGroupByUser?: Maybe<ModelCandidateBatchGroupConnection>;
  getCandidateBatchesByCandidateBatchGroup?: Maybe<ModelCandidateBatchConnection>;
  getCandidateByExternalId?: Maybe<ModelCandidateConnection>;
  getCandidateCampaignsByCampaign?: Maybe<ModelCampaignCandidateConnection>;
  getCandidateCampaignsByCandidatesBatch?: Maybe<ModelCampaignCandidateConnection>;
  getCandidateConversationBlockingDependencies?: Maybe<CandidateBlockingDependencies>;
  getCandidateCvsParsing?: Maybe<CandidateCvsParsing>;
  getCandidateCvsParsingByOrganization?: Maybe<ModelCandidateCvsParsingConnection>;
  getCandidateCvsParsingByUser?: Maybe<ModelCandidateCvsParsingConnection>;
  getCandidateEmailCorrespondence?: Maybe<CandidateEmailCorrespondence>;
  getCandidateEmailCorrespondencesByCandidate?: Maybe<ModelCandidateEmailCorrespondenceConnection>;
  getCandidateEmailCorrespondencesByCandidateBatch?: Maybe<ModelCandidateEmailCorrespondenceConnection>;
  getCandidateEmailCorrespondencesByOrganization?: Maybe<ModelCandidateEmailCorrespondenceConnection>;
  getCandidateMessage?: Maybe<CandidateMessage>;
  getCandidateMessagesByCandidate?: Maybe<ModelCandidateMessageConnection>;
  getCandidateNote?: Maybe<CandidateNote>;
  getCandidateNotesByCandidate?: Maybe<ModelCandidateNoteConnection>;
  getCandidateNotesByCandidateProfile?: Maybe<ModelCandidateNoteConnection>;
  getCandidateNotesByUser?: Maybe<ModelCandidateNoteConnection>;
  getCandidateProfile?: Maybe<CandidateProfile>;
  getCandidateProfileByAtsApplicationId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByAtsCandidateId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByCandidateProfileVectorId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByEmail?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByExternalId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByKomboApplicationId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByKomboCandidateId?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByLinkedInProfileUrl?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileByPhoneNumber?: Maybe<ModelCandidateProfileConnection>;
  getCandidateProfileIdsInListForUser: Array<Scalars['ID']['output']>;
  getCandidateProfileList?: Maybe<CandidateProfileList>;
  getCandidateProfileListByExternalId?: Maybe<ModelCandidateProfileListConnection>;
  getCandidateProfileListForUser?: Maybe<CandidateProfileListForUser>;
  getCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  getCandidateProfileListMembershipsByCandidateProfileList?: Maybe<ModelCandidateProfileListMembershipConnection>;
  getCandidateProfileListMembershipsByListAndProfileId?: Maybe<ModelCandidateProfileListMembershipConnection>;
  getCandidateProfileListMembershipsByOrganization?: Maybe<ModelCandidateProfileListMembershipConnection>;
  getCandidateProfileListsByOrganization?: Maybe<ModelCandidateProfileListConnection>;
  getCandidateProfileListsByUser?: Maybe<ModelCandidateProfileListConnection>;
  getCandidateProfileNote?: Maybe<CandidateProfileNote>;
  getCandidateProfileNotesByAtsApplicationId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByAtsCandidateId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByAtsCandidateNoteId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByCandidateProfile?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByKomboApplicationId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByKomboCandidateId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfileNotesByKomboCandidateNoteId?: Maybe<ModelCandidateProfileNoteConnection>;
  getCandidateProfilesByOrganizationGroup?: Maybe<ModelCandidateProfileConnection>;
  getCandidateStatusUpdate?: Maybe<CandidateStatusUpdate>;
  getCandidateStatusUpdatesByCandidate?: Maybe<ModelCandidateStatusUpdateConnection>;
  getCandidateStatusUpdatesByCandidateBatch?: Maybe<ModelCandidateStatusUpdateConnection>;
  getCandidateStatusUpdatesByOrganization?: Maybe<ModelCandidateStatusUpdateConnection>;
  getCandidateTag?: Maybe<CandidateTag>;
  getCandidateTagsByOrganization?: Maybe<ModelCandidateTagConnection>;
  getCandidatesByAtsApplicationId?: Maybe<ModelCandidateConnection>;
  getCandidatesByAtsApplicationIdAndCandidateBatchId?: Maybe<ModelCandidateConnection>;
  getCandidatesByAtsJobId?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidateCvsParsing?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidateProfile?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatch?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatchAndCandidateProfile?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatchAndCvKey?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatchAndProfileId?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatchAndScore?: Maybe<ModelCandidateConnection>;
  getCandidatesByCandidatesBatchAndScoreScaled?: Maybe<ModelCandidateConnection>;
  getCandidatesByKomboApplicationIdAndCandidateBatchId?: Maybe<ModelCandidateConnection>;
  getCandidatesByKomboJobId?: Maybe<ModelCandidateConnection>;
  getCandidatesByOrganization?: Maybe<ModelCandidateConnection>;
  getClientApiKey?: Maybe<ClientApiKey>;
  getClientApiKeysByOrganization?: Maybe<ModelClientApiKeyConnection>;
  getClientApiKeysByUser?: Maybe<ModelClientApiKeyConnection>;
  getConversation?: Maybe<Conversation>;
  getConversationByAtsApplicationId?: Maybe<ModelConversationConnection>;
  getConversationByAtsApplicationIdAndCampaignId?: Maybe<ModelConversationConnection>;
  getConversationByAtsCandidateId?: Maybe<ModelConversationConnection>;
  getConversationByEmailPrefix?: Maybe<ModelConversationConnection>;
  getConversationByExternalId?: Maybe<ModelConversationConnection>;
  getConversationByKomboApplicationIdAndCampaignId?: Maybe<ModelConversationConnection>;
  getConversationByParticipantEmailAddress?: Maybe<ModelConversationConnection>;
  getConversationByParticipantEmailAddressAndCampaignId?: Maybe<ModelConversationConnection>;
  getConversationByParticipantPhoneNumber?: Maybe<ModelConversationConnection>;
  getConversationByParticipantPhoneNumberAndCampaignId?: Maybe<ModelConversationConnection>;
  getConversationByTwilioConversationId?: Maybe<ModelConversationConnection>;
  getConversationByTwilioConversationIdAndUpdatedAt?: Maybe<ModelConversationConnection>;
  getConversationsByCampaignAndUpdatedAt?: Maybe<ModelConversationConnection>;
  getConversationsByCandidateProfile?: Maybe<ModelConversationConnection>;
  getConversationsByOrganizationAndUpdatedAt?: Maybe<ModelConversationConnection>;
  getConversationsByStatusAndTwilioConversationId?: Maybe<ModelConversationConnection>;
  getDocumentCredential?: Maybe<DocumentCredential>;
  getDocumentCredentialsByOrganizationGroup?: Maybe<ModelDocumentCredentialConnection>;
  getDocumentType?: Maybe<DocumentType>;
  getDocumentTypeByExternalId?: Maybe<ModelDocumentTypeConnection>;
  getDocumentTypeRelationships?: Maybe<DocumentTypeRelationships>;
  getFormattedPhoneNumber?: Maybe<GetFormattedPhoneNumberOutput>;
  getIntegrationCredentials?: Maybe<IntegrationCredentials>;
  getIntegrationCredentialsByAtsInstanceId?: Maybe<ModelIntegrationCredentialsConnection>;
  getIntegrationCredentialsByKomboIntegrationId?: Maybe<ModelIntegrationCredentialsConnection>;
  getIntegrationCredentialsByOrganization?: Maybe<ModelIntegrationCredentialsConnection>;
  getIntegrationCredentialsByStackOneAccountId?: Maybe<ModelIntegrationCredentialsConnection>;
  getJobDescriptionAndQuestions?: Maybe<GetJobDescriptionOutput>;
  getJobPosting?: Maybe<JobPosting>;
  getJobPostingRecommendation?: Maybe<JobPostingRecommendation>;
  getJobPostingRecommendationsByCandidate?: Maybe<ModelJobPostingRecommendationConnection>;
  getJobPostingRecommendationsByJobPosting?: Maybe<ModelJobPostingRecommendationConnection>;
  getJobPostingsByOrganization?: Maybe<ModelJobPostingConnection>;
  getMediaDownloadUrl?: Maybe<GetMediaDownloadUrlOutput>;
  getMessage?: Maybe<Message>;
  getMessageBySesEmailId?: Maybe<ModelMessageConnection>;
  getMessagesByCampaign?: Maybe<ModelMessageConnection>;
  getMessagesByConversation?: Maybe<ModelMessageConnection>;
  getMessagesByTwilioMessageId?: Maybe<ModelMessageConnection>;
  getNeedsReviewItem?: Maybe<NeedsReviewItem>;
  getNeedsReviewItemsByConversation?: Maybe<ModelNeedsReviewItemConnection>;
  getOptOutEmailAddress?: Maybe<OptOutEmailAddress>;
  getOptOutEmailAddressByEmailAddressAndEmailIdentity?: Maybe<ModelOptOutEmailAddressConnection>;
  getOptOutPhoneNumber?: Maybe<OptOutPhoneNumber>;
  getOptOutPhoneNumberByPhoneNumberAndOrganization?: Maybe<ModelOptOutPhoneNumberConnection>;
  getOptOutPhoneNumbersByOrganization?: Maybe<ModelOptOutPhoneNumberConnection>;
  getOrganization?: Maybe<Organization>;
  getOrganizationByExternalId?: Maybe<ModelOrganizationConnection>;
  getOrganizationByTwilioInboundPhoneNumberAnswers?: Maybe<ModelOrganizationConnection>;
  getOrganizationByTwilioInboundPhoneNumberQuestions?: Maybe<ModelOrganizationConnection>;
  getOrganizationConfig?: Maybe<OrganizationConfig>;
  getOrganizationConfigByOrganizationId?: Maybe<ModelOrganizationConfigConnection>;
  getOrganizationCustomFieldConfig?: Maybe<OrganizationCustomFieldConfig>;
  getOrganizationCustomFieldConfigsByOrganizationId?: Maybe<ModelOrganizationCustomFieldConfigConnection>;
  getOrganizationGroup?: Maybe<OrganizationGroup>;
  getOrganizationWebhook?: Maybe<OrganizationWebhook>;
  getOrganizationWebhooksByOrganization?: Maybe<ModelOrganizationWebhookConnection>;
  getOrganizationsByOrganizationGroup?: Maybe<ModelOrganizationConnection>;
  getOutreachQuestion?: Maybe<OutreachQuestion>;
  getOutreachQuestions?: Maybe<GetOutreachQuestionsResolverResponse>;
  getPlanMembership?: Maybe<PlanMembership>;
  getPlanMembershipByOrganization?: Maybe<ModelPlanMembershipConnection>;
  getPlanMembershipByProductAndOrganization?: Maybe<ModelPlanMembershipConnection>;
  getPlanMembershipByUser?: Maybe<ModelPlanMembershipConnection>;
  getPreferences?: Maybe<Preferences>;
  getPreferencesByUser?: Maybe<ModelPreferencesConnection>;
  getProfileData?: Maybe<ProfileData>;
  getQualification?: Maybe<Qualification>;
  getQualificationsByVectorDbTenantName?: Maybe<ModelQualificationConnection>;
  getQuestionOutcome?: Maybe<QuestionOutcome>;
  getRequirementOutcome?: Maybe<RequirementOutcome>;
  getRequirementOutcomesByAnalysisRequirement?: Maybe<ModelRequirementOutcomeConnection>;
  getRequirementOutcomesByCandidate?: Maybe<ModelRequirementOutcomeConnection>;
  getSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  getSearchCandidateProfileMessages?: Maybe<ModelSearchCandidateProfileMessageConnection>;
  getSearchCandidateProfileMessagesByOrganization?: Maybe<ModelSearchCandidateProfileMessageConnection>;
  getSearchCandidateProfileQueriesByOrganization?: Maybe<ModelSearchCandidateProfileQueryConnection>;
  getSearchCandidateProfileQueriesByUser?: Maybe<ModelSearchCandidateProfileQueryConnection>;
  getSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  getSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  getSearchCandidateProfileSelectedByOrganization?: Maybe<ModelSearchCandidateProfileSelectedConnection>;
  getSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  getSearchCandidateProfileSelectedItemsByCandidateProfile?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  getSearchCandidateProfileSelectedItemsByOrganization?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  getSearchCandidateProfileSelectedItemsBySearchCandidateProfileSelected?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  getSearchPeopleQueryFields?: Maybe<SearchPeopleQueryFields>;
  getSearchPeopleQueryFieldsByCandidateBatch?: Maybe<ModelSearchPeopleQueryFieldsConnection>;
  getSelectedCandidateBatchStatuses?: Maybe<SelectedCandidateBatchStatuses>;
  getSelectedCandidateBatchStatusesByCampaign?: Maybe<ModelSelectedCandidateBatchStatusesConnection>;
  getSelectedCandidateBatchStatusesByCandidateBatch?: Maybe<ModelSelectedCandidateBatchStatusesConnection>;
  getSimulationConversation?: Maybe<SimulationConversation>;
  getSimulationMessage?: Maybe<SimulationMessage>;
  getSimulationMessagesBySimulationId?: Maybe<ModelSimulationMessageConnection>;
  getSkill?: Maybe<Skill>;
  getSkillsByVectorDbTenantName?: Maybe<ModelSkillConnection>;
  getSourcedCandidate?: Maybe<SourcedCandidate>;
  getSourcedCandidateByCandidate?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidateByCandidateProfile?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidateByConversation?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidateByEmail?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidateByLinkedInProfileUrl?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidateByLinkedInProfileUrlAndCandidateBatch?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidatesByCampaign?: Maybe<ModelSourcedCandidateConnection>;
  getSourcedCandidatesByCandidateBatch?: Maybe<ModelSourcedCandidateConnection>;
  getStatusSet?: Maybe<StatusSet>;
  getStatusSetByOrganization?: Maybe<ModelStatusSetConnection>;
  getStripeCustomerPortal?: Maybe<GetStripeCustomerPortalOutput>;
  getTag?: Maybe<Tag>;
  getTagsByVectorDbTenantName?: Maybe<ModelTagConnection>;
  getTeam?: Maybe<Team>;
  getTeamByExternalId?: Maybe<ModelTeamConnection>;
  getTeamMembership?: Maybe<TeamMembership>;
  getTeamMembershipsByTeam?: Maybe<ModelTeamMembershipConnection>;
  getTeamMembershipsByUser?: Maybe<ModelTeamMembershipConnection>;
  getTeamsByOrganization?: Maybe<ModelTeamConnection>;
  getTwilioAccountCredentials?: Maybe<TwilioAccountCredentials>;
  getTwilioAccountCredentialsByChatServiceSid?: Maybe<ModelTwilioAccountCredentialsConnection>;
  getTwilioAccountCredentialsByInboundChatServiceId?: Maybe<ModelTwilioAccountCredentialsConnection>;
  getTwilioAccountCredentialsByOrganization?: Maybe<ModelTwilioAccountCredentialsConnection>;
  getTypeformLink?: Maybe<TypeformLink>;
  getTypeformLinksByCampaign?: Maybe<ModelTypeformLinkConnection>;
  getTypeformLinksByCandidateBatch?: Maybe<ModelTypeformLinkConnection>;
  getTypeformRecord?: Maybe<TypeformRecord>;
  getTypeformRecordsByOrganization?: Maybe<ModelTypeformRecordConnection>;
  getUnansweredQuestion?: Maybe<UnansweredQuestion>;
  getUnansweredQuestionsByAssociatedMessage?: Maybe<ModelUnansweredQuestionConnection>;
  getUnansweredQuestionsByCampaign?: Maybe<ModelUnansweredQuestionConnection>;
  getUnansweredQuestionsByConversation?: Maybe<ModelUnansweredQuestionConnection>;
  getUser?: Maybe<User>;
  getUserByEmail?: Maybe<ModelUserConnection>;
  getUserCalendar?: Maybe<UserCalendar>;
  getUserCalendarByEmail?: Maybe<ModelUserCalendarConnection>;
  getUserCalendarByUser?: Maybe<ModelUserCalendarConnection>;
  getUserCalendarMeetingTemplate?: Maybe<UserCalendarMeetingTemplate>;
  getUserCalendarMeetingTemplateByCalendarMeetingTemplate?: Maybe<ModelUserCalendarMeetingTemplateConnection>;
  getUserCalendarMeetingTemplateByUserCalendar?: Maybe<ModelUserCalendarMeetingTemplateConnection>;
  getUserCalendarOrganization?: Maybe<UserCalendarOrganization>;
  getUserCalendarOrganizationByOrganization?: Maybe<ModelUserCalendarOrganizationConnection>;
  getUserCalendarOrganizationByUser?: Maybe<ModelUserCalendarOrganizationConnection>;
  getUserCalendarOrganizationByUserCalendar?: Maybe<ModelUserCalendarOrganizationConnection>;
  getUserOrganization?: Maybe<UserOrganization>;
  getUserOrganizationByOrganization?: Maybe<ModelUserOrganizationConnection>;
  getUserOrganizationByUser?: Maybe<ModelUserOrganizationConnection>;
  getUserOrganizationByUserAndOrganization?: Maybe<ModelUserOrganizationConnection>;
  getUserRelationshipToOrganization?: Maybe<GetUserRelationshipToOrganizationOutput>;
  getUsersByOrganization?: Maybe<ModelUserConnection>;
  getUsersByOrganizationGroup?: Maybe<ModelUserConnection>;
  getUsersByOrganizationGroupAndEmail?: Maybe<ModelUserConnection>;
  getUsersForOrganization?: Maybe<GetUsersForOrganizationOutput>;
  getVirtualCalendarConversation?: Maybe<VirtualCalendarConversation>;
  getVirtualCalendarConversationByConversation?: Maybe<ModelVirtualCalendarConversationConnection>;
  getVirtualCalendarConversationByOrganization?: Maybe<ModelVirtualCalendarConversationConnection>;
  getWebhookEvents?: Maybe<Array<WebhookEventDefinition>>;
  getWhatsAppTemplatesByOrganizationConfig?: Maybe<ModelWhatsaapTemplateConnection>;
  getWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  getWhatsaapTemplatesByOrganization?: Maybe<ModelWhatsaapTemplateConnection>;
  getWhatsaapTemplatesByTypeAndOrganization?: Maybe<ModelWhatsaapTemplateConnection>;
  getWorkflow?: Maybe<Workflow>;
  getWorkflowAtsJob?: Maybe<WorkflowAtsJob>;
  getWorkflowByExternalId?: Maybe<ModelWorkflowConnection>;
  getWorkflowContact?: Maybe<WorkflowContact>;
  getWorkflowContactImport?: Maybe<WorkflowContactImport>;
  getWorkflowContactImportsByWorkflow?: Maybe<ModelWorkflowContactImportConnection>;
  getWorkflowContactsByCandidateProfile?: Maybe<ModelWorkflowContactConnection>;
  getWorkflowContactsByDedupKey?: Maybe<ModelWorkflowContactConnection>;
  getWorkflowContactsByImport?: Maybe<ModelWorkflowContactConnection>;
  getWorkflowContactsByWorkflow?: Maybe<ModelWorkflowContactConnection>;
  getWorkflowEvent?: Maybe<WorkflowEvent>;
  getWorkflowRun?: Maybe<WorkflowRun>;
  getWorkflowRunCandidateProfile?: Maybe<WorkflowRunCandidateProfile>;
  getWorkflowRunsByAtsApplicationId?: Maybe<ModelWorkflowRunConnection>;
  getWorkflowStats?: Maybe<WorkflowStats>;
  getWorkflowVersion?: Maybe<WorkflowVersion>;
  getWorkflowVersionNodeStats?: Maybe<WorkflowVersionNodeStats>;
  getWorkflowsByOrganizationAndEmbeddedAtsJobId?: Maybe<ModelWorkflowConnection>;
  listAgents?: Maybe<ModelAgentConnection>;
  listAnalysedApplicationSnapshots?: Maybe<ModelAnalysedApplicationSnapshotConnection>;
  listAnalysisRequirements?: Maybe<ModelAnalysisRequirementConnection>;
  listApplicationStageUpdates?: Maybe<ModelApplicationStageUpdateConnection>;
  listAtsApplicationScreeningAnswers?: Maybe<ModelAtsApplicationScreeningAnswersConnection>;
  listAtsApplications?: Maybe<ModelAtsApplicationConnection>;
  listAtsBulkSyncErrors?: Maybe<ModelAtsBulkSyncErrorConnection>;
  listAtsBulkSyncErrorsByAtsRecordId?: Maybe<ModelAtsBulkSyncErrorConnection>;
  listAtsBulkSyncErrorsBySync?: Maybe<ModelAtsBulkSyncErrorConnection>;
  listAtsBulkSyncs?: Maybe<ModelAtsBulkSyncConnection>;
  listAtsBulkSyncsByAtsAccountId?: Maybe<ModelAtsBulkSyncConnection>;
  listAtsBulkSyncsByOrganization?: Maybe<ModelAtsBulkSyncConnection>;
  listAtsBulkSyncsByOrganizationGroup?: Maybe<ModelAtsBulkSyncConnection>;
  listAtsConfigs?: Maybe<ModelAtsConfigConnection>;
  listAtsJobStages?: Maybe<Array<AtsStage>>;
  listAtsJobs?: Maybe<ListAtsJobsResult>;
  listAtsQuestions?: Maybe<ModelAtsQuestionConnection>;
  listAtsRejectionReasons?: Maybe<Array<AtsRejectionReason>>;
  listAttachments?: Maybe<ModelAttachmentConnection>;
  listAutomationTaskEmailTemplates?: Maybe<ModelAutomationTaskEmailTemplateConnection>;
  listAutomationTasks?: Maybe<ModelAutomationTaskConnection>;
  listAutomationTasksTemplates?: Maybe<ModelAutomationTasksTemplateConnection>;
  listCalendarBookings?: Maybe<ModelCalendarBookingConnection>;
  listCalendarMeetingTemplates?: Maybe<ModelCalendarMeetingTemplateConnection>;
  listCampaignCandidates?: Maybe<ModelCampaignCandidateConnection>;
  listCampaignCsvKeys?: Maybe<ModelCampaignCsvKeysConnection>;
  listCampaignQuestions?: Maybe<ModelCampaignQuestionConnection>;
  listCampaignSubscriptions?: Maybe<ModelCampaignSubscriptionConnection>;
  listCampaigns?: Maybe<ModelCampaignConnection>;
  listCandidateAvailabilitySuggestions?: Maybe<ModelCandidateAvailabilitySuggestionConnection>;
  listCandidateBatchGroups?: Maybe<ModelCandidateBatchGroupConnection>;
  listCandidateBatches?: Maybe<ModelCandidateBatchConnection>;
  listCandidateCvsParsings?: Maybe<ModelCandidateCvsParsingConnection>;
  listCandidateEmailCorrespondences?: Maybe<ModelCandidateEmailCorrespondenceConnection>;
  listCandidateMessages?: Maybe<ModelCandidateMessageConnection>;
  listCandidateNotes?: Maybe<ModelCandidateNoteConnection>;
  listCandidateProfileListMemberships?: Maybe<ModelCandidateProfileListMembershipConnection>;
  listCandidateProfileLists?: Maybe<ModelCandidateProfileListConnection>;
  listCandidateProfileNotes?: Maybe<ModelCandidateProfileNoteConnection>;
  listCandidateProfiles?: Maybe<ModelCandidateProfileConnection>;
  listCandidateStatusUpdates?: Maybe<ModelCandidateStatusUpdateConnection>;
  listCandidateTags?: Maybe<ModelCandidateTagConnection>;
  listCandidates?: Maybe<ModelCandidateConnection>;
  listClientApiKeys?: Maybe<ModelClientApiKeyConnection>;
  listConversations?: Maybe<ModelConversationConnection>;
  listDocumentCredentials?: Maybe<ModelDocumentCredentialConnection>;
  listDocumentTypeRelationships?: Maybe<ModelDocumentTypeRelationshipsConnection>;
  listDocumentTypes?: Maybe<ModelDocumentTypeConnection>;
  listIntegrationCredentials?: Maybe<ModelIntegrationCredentialsConnection>;
  listJobPostingRecommendations?: Maybe<ModelJobPostingRecommendationConnection>;
  listJobPostings?: Maybe<ModelJobPostingConnection>;
  listMessages?: Maybe<ModelMessageConnection>;
  listNeedsReviewItems?: Maybe<ModelNeedsReviewItemConnection>;
  listOptOutEmailAddresses?: Maybe<ModelOptOutEmailAddressConnection>;
  listOptOutPhoneNumbers?: Maybe<ModelOptOutPhoneNumberConnection>;
  listOrganizationConfigs?: Maybe<ModelOrganizationConfigConnection>;
  listOrganizationCustomFieldConfigs?: Maybe<ModelOrganizationCustomFieldConfigConnection>;
  listOrganizationGroups?: Maybe<ModelOrganizationGroupConnection>;
  listOrganizationWebhooks?: Maybe<ModelOrganizationWebhookConnection>;
  listOrganizations?: Maybe<ModelOrganizationConnection>;
  listOutreachQuestions?: Maybe<ModelOutreachQuestionConnection>;
  listPlanMemberships?: Maybe<ModelPlanMembershipConnection>;
  listPreferences?: Maybe<ModelPreferencesConnection>;
  listProfileData?: Maybe<ModelProfileDataConnection>;
  listQualifications?: Maybe<ModelQualificationConnection>;
  listQuestionOutcomes?: Maybe<ModelQuestionOutcomeConnection>;
  listRequirementOutcomes?: Maybe<ModelRequirementOutcomeConnection>;
  listSearchCandidateProfileMessages?: Maybe<ModelSearchCandidateProfileMessageConnection>;
  listSearchCandidateProfileQueries?: Maybe<ModelSearchCandidateProfileQueryConnection>;
  listSearchCandidateProfileSelectedItems?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  listSearchCandidateProfileSelecteds?: Maybe<ModelSearchCandidateProfileSelectedConnection>;
  listSearchPeopleQueryFields?: Maybe<ModelSearchPeopleQueryFieldsConnection>;
  listSelectedCandidateBatchStatuses?: Maybe<ModelSelectedCandidateBatchStatusesConnection>;
  listSimulationConversations?: Maybe<ModelSimulationConversationConnection>;
  listSimulationMessages?: Maybe<ModelSimulationMessageConnection>;
  listSkills?: Maybe<ModelSkillConnection>;
  listSourcedCandidates?: Maybe<ModelSourcedCandidateConnection>;
  listStatusSets?: Maybe<ModelStatusSetConnection>;
  listTags?: Maybe<ModelTagConnection>;
  listTeamMemberships?: Maybe<ModelTeamMembershipConnection>;
  listTeams?: Maybe<ModelTeamConnection>;
  listTeamsForUser: ListTeamConnection;
  listTwilioAccountCredentials?: Maybe<ModelTwilioAccountCredentialsConnection>;
  listTypeformLinks?: Maybe<ModelTypeformLinkConnection>;
  listTypeformRecords?: Maybe<ModelTypeformRecordConnection>;
  listUnansweredQuestions?: Maybe<ModelUnansweredQuestionConnection>;
  listUserCalendarMeetingTemplates?: Maybe<ModelUserCalendarMeetingTemplateConnection>;
  listUserCalendarOrganizations?: Maybe<ModelUserCalendarOrganizationConnection>;
  listUserCalendars?: Maybe<ModelUserCalendarConnection>;
  listUserOrganizations?: Maybe<ModelUserOrganizationConnection>;
  listUsers?: Maybe<ModelUserConnection>;
  listVirtualCalendarConversations?: Maybe<ModelVirtualCalendarConversationConnection>;
  listWhatsaapTemplates?: Maybe<ModelWhatsaapTemplateConnection>;
  listWorkflowAtsJobs?: Maybe<ModelWorkflowAtsJobConnection>;
  listWorkflowContactImports?: Maybe<ModelWorkflowContactImportConnection>;
  listWorkflowContacts?: Maybe<ModelWorkflowContactConnection>;
  listWorkflowEvents?: Maybe<ModelWorkflowEventConnection>;
  listWorkflowRunCandidateProfiles?: Maybe<ModelWorkflowRunCandidateProfileConnection>;
  listWorkflowRuns?: Maybe<ModelWorkflowRunConnection>;
  listWorkflowStats?: Maybe<ModelWorkflowStatsConnection>;
  listWorkflowVersionNodeStats?: Maybe<ModelWorkflowVersionNodeStatsConnection>;
  listWorkflowVersions?: Maybe<ModelWorkflowVersionConnection>;
  listWorkflows?: Maybe<ModelWorkflowConnection>;
  locationAutocomplete?: Maybe<LocationAutocompleteOutput>;
  messagesByAgentId?: Maybe<ModelMessageConnection>;
  messagesByOutreachQuestionIdAndCreatedAt?: Maybe<ModelMessageConnection>;
  messagesByTemplateId?: Maybe<ModelMessageConnection>;
  messagesByUserId?: Maybe<ModelMessageConnection>;
  messagesByWorkflowRunId?: Maybe<ModelMessageConnection>;
  organizationWebhooksByCreatedByUserId?: Maybe<ModelOrganizationWebhookConnection>;
  outreachQuestionsByCampaignIdAndOrder?: Maybe<ModelOutreachQuestionConnection>;
  outreachQuestionsByOrganizationIdAndCreatedAt?: Maybe<ModelOutreachQuestionConnection>;
  outreachQuestionsByWorkflowId?: Maybe<ModelOutreachQuestionConnection>;
  outreachQuestionsByWorkflowVersionIdAndWorkflowNodeId?: Maybe<ModelOutreachQuestionConnection>;
  questionOutcomesByCampaignIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByCandidateProfileIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByConversationIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByOrganizationIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByOutreachQuestionIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByWorkflowIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  questionOutcomesByWorkflowRunIdAndCreatedAt?: Maybe<ModelQuestionOutcomeConnection>;
  searchAgents?: Maybe<SearchableAgentConnection>;
  searchCalendarBookings?: Maybe<SearchableCalendarBookingConnection>;
  searchCalendarMeetingTemplates?: Maybe<SearchableCalendarMeetingTemplateConnection>;
  searchCampaigns?: Maybe<SearchableCampaignConnection>;
  searchCandidateBatches?: Maybe<SearchableCandidateBatchConnection>;
  searchCandidateProfileLists?: Maybe<SearchableCandidateProfileListConnection>;
  searchCandidateProfileListsForUser: CandidateProfileListForUserConnection;
  searchCandidateProfileNotes?: Maybe<SearchableCandidateProfileNoteConnection>;
  searchCandidateProfiles?: Maybe<SearchableCandidateProfileConnection>;
  searchCandidateTags?: Maybe<SearchableCandidateTagConnection>;
  searchCandidates?: Maybe<SearchableCandidateConnection>;
  searchConversations?: Maybe<SearchableConversationConnection>;
  searchDocumentTypes?: Maybe<SearchableDocumentTypeConnection>;
  searchJobPostings?: Maybe<SearchableJobPostingConnection>;
  searchPeople?: Maybe<SearchPeopleQueryOutput>;
  searchQualifications?: Maybe<SearchableQualificationConnection>;
  searchQuestionOutcomes?: Maybe<SearchableQuestionOutcomeConnection>;
  searchSearchCandidateProfileQueries?: Maybe<SearchableSearchCandidateProfileQueryConnection>;
  searchSkills?: Maybe<SearchableSkillConnection>;
  searchSourcedCandidates?: Maybe<SearchableSourcedCandidateConnection>;
  searchTags?: Maybe<SearchableTagConnection>;
  searchUserCalendars?: Maybe<SearchableUserCalendarConnection>;
  searchVectorCandidateProfile?: Maybe<SearchVectorCandidateProfileOutput>;
  searchVirtualCalendarConversations?: Maybe<SearchableVirtualCalendarConversationConnection>;
  searchWorkflowContacts?: Maybe<SearchableWorkflowContactConnection>;
  searchWorkflowEvents?: Maybe<SearchableWorkflowEventConnection>;
  searchWorkflowRunCandidateProfiles?: Maybe<SearchableWorkflowRunCandidateProfileConnection>;
  searchWorkflowRuns?: Maybe<SearchableWorkflowRunConnection>;
  searchWorkflows?: Maybe<SearchableWorkflowConnection>;
  structureJobDescription?: Maybe<StructureJobDescriptionResponse>;
  structureJobDescriptionParsed?: Maybe<StructureJobDescriptionParsedResponse>;
  workflowAtsJobsByWorkflowIdAndAtsJobId?: Maybe<ModelWorkflowAtsJobConnection>;
  workflowEventsByEventTypeAndCreatedAt?: Maybe<ModelWorkflowEventConnection>;
  workflowEventsByOrganizationIdAndCreatedAt?: Maybe<ModelWorkflowEventConnection>;
  workflowEventsByWorkflowRunIdAndCreatedAt?: Maybe<ModelWorkflowEventConnection>;
  workflowRunCandidateProfilesByCandidateProfileId?: Maybe<ModelWorkflowRunCandidateProfileConnection>;
  workflowRunCandidateProfilesByOrganizationIdAndCreatedAt?: Maybe<ModelWorkflowRunCandidateProfileConnection>;
  workflowRunsByCandidateProfileIdAndCreatedAt?: Maybe<ModelWorkflowRunConnection>;
  workflowRunsByOrganizationIdAndCreatedAt?: Maybe<ModelWorkflowRunConnection>;
  workflowRunsByWorkflowIdAndCreatedAt?: Maybe<ModelWorkflowRunConnection>;
  workflowRunsByWorkflowVersionIdAndCreatedAt?: Maybe<ModelWorkflowRunConnection>;
  workflowStatsByOrganizationId?: Maybe<ModelWorkflowStatsConnection>;
  workflowVersionNodeStatsByOrganizationIdAndCreatedAt?: Maybe<ModelWorkflowVersionNodeStatsConnection>;
  workflowVersionNodeStatsByWorkflowVersionIdAndNodeId?: Maybe<ModelWorkflowVersionNodeStatsConnection>;
  workflowVersionsByOrganizationIdAndCreatedAt?: Maybe<ModelWorkflowVersionConnection>;
  workflowVersionsByWorkflowIdAndVersionNumber?: Maybe<ModelWorkflowVersionConnection>;
  workflowsByCreatedByUserIdAndCreatedAt?: Maybe<ModelWorkflowConnection>;
  workflowsByOrganizationIdAndUpdatedAt?: Maybe<ModelWorkflowConnection>;
};


export type QueryAgentsByUserIdArgs = {
  filter?: InputMaybe<ModelAgentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryAnalysedApplicationSnapshotsByCandidateIdAndCreatedAtArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryAtsQuestionsByCandidateBatchIdArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelAtsQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryCalendarBookingsByCalendarMeetingTemplateIdAndIdArgs = {
  calendarMeetingTemplateId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryCampaignsByAgentIdArgs = {
  agentId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryCampaignsByCalendarMeetingTemplateIdAndIdArgs = {
  calendarMeetingTemplateId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryCampaignsByWorkflowIdArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryCampaignsByWorkflowVersionIdArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowVersionId: Scalars['ID']['input'];
};


export type QueryCandidateBatchesByWorkflowIdArgs = {
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryCandidateBatchesByWorkflowRunIdArgs = {
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QueryCandidateBatchesByWorkflowVersionIdAndWorkflowNodeIdArgs = {
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowNodeId?: InputMaybe<ModelStringKeyConditionInput>;
  workflowVersionId: Scalars['ID']['input'];
};


export type QueryCandidatesByWorkflowRunIdArgs = {
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QueryConversationsByAgentIdArgs = {
  agentId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryConversationsByCampaignIdArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryConversationsByUserIdArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryConversationsByWorkflowRunIdArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QueryDetectBiasedSearchArgs = {
  query: Scalars['String']['input'];
};


export type QueryDocumentTypeRelationshipsByCampaignIdArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryDocumentTypeRelationshipsByDocumentTypeIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  documentTypeId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryDocumentTypeRelationshipsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryDocumentTypeRelationshipsByWorkflowIdArgs = {
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryDocumentTypesByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelDocumentTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryExportAllCampaignsDataV2Args = {
  filter?: InputMaybe<Scalars['AWSJSON']['input']>;
};


export type QueryExportAnalysisDataArgs = {
  candidateBatchId: Scalars['String']['input'];
};


export type QueryExportCampaignDataArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryGenerateClientApiKeyArgs = {
  input?: InputMaybe<GenerateClientApiKeyInput>;
};


export type QueryGenerateJobRequirementsArgs = {
  jobDescription: Scalars['String']['input'];
};


export type QueryGeneratePreferredAnswerRequirementsArgs = {
  preferredAnswer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};


export type QueryGenerateQuestionsArgs = {
  content: Scalars['String']['input'];
};


export type QueryGetAgentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAgentsByOrganizationArgs = {
  filter?: InputMaybe<ModelAgentFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAgentsByUserAndOrganizationArgs = {
  filter?: InputMaybe<ModelAgentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetAnalysedApplicationSnapshotArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnalysisNodeMoveOnCountArgs = {
  input: GetAnalysisNodeMoveOnCountInput;
};


export type QueryGetAnalysisNodeSummaryArgs = {
  input: GetAnalysisNodeSummaryInput;
};


export type QueryGetAnalysisRequirementArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAnalysisRequirementsByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAnalysisRequirementsByCandidateBatchGroupArgs = {
  candidateBatchGroupId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetApplicationStageUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetApplicationStageUpdatesByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelApplicationStageUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsApplicationArgs = {
  komboApplicationId: Scalars['ID']['input'];
};


export type QueryGetAtsApplicationByRemoteIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsApplicationScreeningAnswersArgs = {
  komboApplicationId: Scalars['ID']['input'];
};


export type QueryGetAtsApplicationsByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsApplicationsByJobArgs = {
  atsJobId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsApplicationsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsApplicationsByOrganizationGroupArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsBulkSyncArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAtsBulkSyncErrorArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAtsConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAtsConfigByOrganizationIdArgs = {
  filter?: InputMaybe<ModelAtsConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAtsQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAtsQuestionsByJobArgs = {
  atsJobIdAtsQuestionId?: InputMaybe<ModelAtsQuestionByOrganizationAtsJobCompositeKeyConditionInput>;
  filter?: InputMaybe<ModelAtsQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAttachmentArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAttachmentsByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAttachmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAttachmentsByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAttachmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTaskArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAutomationTaskEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAutomationTaskEmailTemplatesByOrganizationArgs = {
  filter?: InputMaybe<ModelAutomationTaskEmailTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTasksByAutomationTypeArgs = {
  candidateBatchId: Scalars['ID']['input'];
  type: AutomationType;
};


export type QueryGetAutomationTasksByCampaignIdArgs = {
  campaignId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTasksByCandidateBatchGroupArgs = {
  candidateBatchGroupId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTasksByCandidateBatchIdArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTasksTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetAutomationTasksTemplateByOrganizationArgs = {
  filter?: InputMaybe<ModelAutomationTasksTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetAutomationTasksTemplatesByAutomationTypeArgs = {
  type: AutomationType;
};


export type QueryGetAutomationsTasksTemplateByUserArgs = {
  filter?: InputMaybe<ModelAutomationTasksTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCalendarBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCalendarBookingByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByIcalUidArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  icalUid: Scalars['String']['input'];
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByNoteTakerArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  noteTakerId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByNylasBookingIdArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  nylasBookingId: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByNylasEventIdArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  nylasEventId: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByOrganizationArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByOrganizerUserCalendarArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizerUserCalendarId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarBookingByWorkflowArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  startDateTime?: InputMaybe<ModelStringKeyConditionInput>;
  workflowId: Scalars['ID']['input'];
};


export type QueryGetCalendarMeetingTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCalendarMeetingTemplateByNylasConfigurationArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  nylasConfigurationId: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarMeetingTemplateByOrganizationArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarMeetingTemplateByOrganizerUserCalendarArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizerUserCalendarId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCalendarMeetingTemplateByUserArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedByUserId: Scalars['ID']['input'];
};


export type QueryGetCampaignArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignCsvKeysArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignCsvKeysByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignCsvKeysFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignSubscribersArgs = {
  campaignId: Scalars['ID']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetCampaignSubscriptionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCampaignSubscriptionsByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type QueryGetCampaignSubscriptionsByOrganizationArgs = {
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignSubscriptionsByUserArgs = {
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCampaignSubscriptionsByUserAndOrganizationArgs = {
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCampaignsByAtsJobIdArgs = {
  atsJobId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByAtsListIdArgs = {
  atsListId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByCampaignGroupArgs = {
  campaignGroupId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByKomboJobIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  komboJobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByReferenceIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  referenceId: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCampaignsByStatusAndAtsJobIdArgs = {
  atsJobId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: CampaignStatus;
};


export type QueryGetCampaignsByStatusAndAtsListIdArgs = {
  atsListId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: CampaignStatus;
};


export type QueryGetCampaignsByStatusAndExternalIdArgs = {
  externalId?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: CampaignStatus;
};


export type QueryGetCampaignsByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCampaignsByUserAndOrganizationArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateAvailabilitySuggestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateAvailabilitySuggestionsByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateBatchArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateBatchByAtsJobIdArgs = {
  atsJobId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateBatchByKomboJobIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  komboJobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateBatchByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateBatchByStatusAndAtsJobIdArgs = {
  atsJobId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: CandidateBatchStatus;
};


export type QueryGetCandidateBatchByStatusAndExternalIdArgs = {
  externalId?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: CandidateBatchStatus;
};


export type QueryGetCandidateBatchByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateBatchGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateBatchGroupByJobCodeArgs = {
  filter?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  jobCode: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetCandidateBatchGroupByOrganizationArgs = {
  filter?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetCandidateBatchGroupByUserArgs = {
  filter?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateBatchesByCandidateBatchGroupArgs = {
  candidateBatchGroupId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateByExternalIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateCampaignsByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignCandidateFilterInput>;
  isProcessed?: InputMaybe<ModelStringKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateCampaignsByCandidatesBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCampaignCandidateFilterInput>;
  isProcessed?: InputMaybe<ModelStringKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateConversationBlockingDependenciesArgs = {
  conversationId: Scalars['ID']['input'];
};


export type QueryGetCandidateCvsParsingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateCvsParsingByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateCvsParsingByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateEmailCorrespondenceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateEmailCorrespondencesByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateEmailCorrespondencesByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateEmailCorrespondencesByOrganizationArgs = {
  filter?: InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateMessagesByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateNotesByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateNotesByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateNotesByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileByAtsApplicationIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  latestAtsApplicationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByAtsCandidateIdArgs = {
  atsCandidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByCandidateProfileVectorIdArgs = {
  candidateProfileVectorId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByEmailArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  email: Scalars['String']['input'];
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByKomboApplicationIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  latestKomboApplicationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByKomboCandidateIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  komboCandidateId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByLinkedInProfileUrlArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedInProfileUrl: Scalars['String']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileByPhoneNumberArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileIdsInListForUserArgs = {
  candidateProfileIds: Array<Scalars['ID']['input']>;
  candidateProfileListId: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileListByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileListForUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileListMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileListMembershipsByCandidateProfileListArgs = {
  candidateProfileListId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileListMembershipsByListAndProfileIdArgs = {
  candidateProfileId: Scalars['ID']['input'];
  candidateProfileListId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileListMembershipsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileListsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileListsByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileNoteArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateProfileNotesByAtsApplicationIdArgs = {
  atsApplicationId: Scalars['String']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByAtsCandidateIdArgs = {
  atsCandidateId: Scalars['String']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByAtsCandidateNoteIdArgs = {
  atsCandidateNoteId: Scalars['String']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByKomboApplicationIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  komboApplicationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByKomboCandidateIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  komboCandidateId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfileNotesByKomboCandidateNoteIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  komboCandidateNoteId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateProfilesByOrganizationGroupArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateStatusUpdateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateStatusUpdatesByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateStatusUpdatesByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateStatusUpdatesByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidateTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetCandidateTagsByOrganizationArgs = {
  filter?: InputMaybe<ModelCandidateTagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
  valueNormalized?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetCandidatesByAtsApplicationIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByAtsApplicationIdAndCandidateBatchIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  candidateBatchId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByAtsJobIdArgs = {
  atsJobId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidateCvsParsingArgs = {
  candidateCvsParsingId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidatesBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidatesBatchAndCandidateProfileArgs = {
  candidateBatchId: Scalars['ID']['input'];
  candidateProfileId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidatesBatchAndCvKeyArgs = {
  candidateBatchId: Scalars['ID']['input'];
  cvS3Key?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidatesBatchAndProfileIdArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedInProfileId?: InputMaybe<ModelStringKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByCandidatesBatchAndScoreArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  totalScore?: InputMaybe<ModelFloatKeyConditionInput>;
};


export type QueryGetCandidatesByCandidatesBatchAndScoreScaledArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  totalScoreScaled?: InputMaybe<ModelFloatKeyConditionInput>;
};


export type QueryGetCandidatesByKomboApplicationIdAndCandidateBatchIdArgs = {
  candidateBatchId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  komboApplicationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByKomboJobIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  komboJobId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetCandidatesByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetClientApiKeyArgs = {
  hashedKey: Scalars['String']['input'];
};


export type QueryGetClientApiKeysByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelClientApiKeyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetClientApiKeysByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelClientApiKeyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetConversationByAtsApplicationIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByAtsApplicationIdAndCampaignIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByAtsCandidateIdArgs = {
  atsCandidateId: Scalars['ID']['input'];
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByEmailPrefixArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  emailPrefix: Scalars['String']['input'];
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByExternalIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByKomboApplicationIdAndCampaignIdArgs = {
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  komboApplicationId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByParticipantEmailAddressArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  participantEmailAddress: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
  status?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetConversationByParticipantEmailAddressAndCampaignIdArgs = {
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  participantEmailAddress: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByParticipantPhoneNumberArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  participantPhoneNumber: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByParticipantPhoneNumberAndCampaignIdArgs = {
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  participantPhoneNumber: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationByTwilioConversationIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  twilioConversationId: Scalars['String']['input'];
};


export type QueryGetConversationByTwilioConversationIdAndUpdatedAtArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  twilioConversationId: Scalars['String']['input'];
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetConversationsByCampaignAndUpdatedAtArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetConversationsByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetConversationsByOrganizationAndUpdatedAtArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetConversationsByStatusAndTwilioConversationIdArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  status: ConversationStatus;
  twilioConversationId?: InputMaybe<ModelStringKeyConditionInput>;
};


export type QueryGetDocumentCredentialArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentCredentialsByOrganizationGroupArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelDocumentCredentialFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetDocumentTypeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetDocumentTypeByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelDocumentTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetDocumentTypeRelationshipsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetFormattedPhoneNumberArgs = {
  location?: InputMaybe<Scalars['String']['input']>;
  phoneNumber: Scalars['String']['input'];
};


export type QueryGetIntegrationCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetIntegrationCredentialsByAtsInstanceIdArgs = {
  atsInstanceId: Scalars['String']['input'];
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetIntegrationCredentialsByKomboIntegrationIdArgs = {
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  komboIntegrationId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetIntegrationCredentialsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetIntegrationCredentialsByStackOneAccountIdArgs = {
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  stackOneAccountId: Scalars['String']['input'];
};


export type QueryGetJobDescriptionAndQuestionsArgs = {
  text: Scalars['String']['input'];
};


export type QueryGetJobPostingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobPostingRecommendationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetJobPostingRecommendationsByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetJobPostingRecommendationsByJobPostingArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  jobPostingId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetJobPostingsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelJobPostingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetMediaDownloadUrlArgs = {
  attachmentId?: InputMaybe<Scalars['ID']['input']>;
  messageId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryGetMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetMessageBySesEmailIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sesEmailId: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetMessagesByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetMessagesByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetMessagesByTwilioMessageIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  twilioMessageId: Scalars['String']['input'];
};


export type QueryGetNeedsReviewItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetNeedsReviewItemsByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelNeedsReviewItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOptOutEmailAddressArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOptOutEmailAddressByEmailAddressAndEmailIdentityArgs = {
  emailAddress: Scalars['String']['input'];
  emailIdentity?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelOptOutEmailAddressFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOptOutPhoneNumberArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOptOutPhoneNumberByPhoneNumberAndOrganizationArgs = {
  filter?: InputMaybe<ModelOptOutPhoneNumberFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  phoneNumber: Scalars['String']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOptOutPhoneNumbersByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelOptOutPhoneNumberFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOrganizationByTwilioInboundPhoneNumberAnswersArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  twilioInboundPhoneNumberAnswers: Scalars['AWSPhone']['input'];
};


export type QueryGetOrganizationByTwilioInboundPhoneNumberQuestionsArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  twilioInboundPhoneNumberQuestions: Scalars['AWSPhone']['input'];
};


export type QueryGetOrganizationConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationConfigByOrganizationIdArgs = {
  filter?: InputMaybe<ModelOrganizationConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOrganizationCustomFieldConfigArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationCustomFieldConfigsByOrganizationIdArgs = {
  filter?: InputMaybe<ModelOrganizationCustomFieldConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOrganizationGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationWebhookArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOrganizationWebhooksByOrganizationArgs = {
  filter?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOrganizationsByOrganizationGroupArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<ModelStringKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetOutreachQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetOutreachQuestionsArgs = {
  outreachDescription: Scalars['String']['input'];
};


export type QueryGetPlanMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPlanMembershipByOrganizationArgs = {
  filter?: InputMaybe<ModelPlanMembershipFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetPlanMembershipByProductAndOrganizationArgs = {
  filter?: InputMaybe<ModelPlanMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  product: SubscriptionProduct;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetPlanMembershipByUserArgs = {
  filter?: InputMaybe<ModelPlanMembershipFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetPreferencesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetPreferencesByUserArgs = {
  filter?: InputMaybe<ModelPreferencesFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetProfileDataArgs = {
  profileId: Scalars['String']['input'];
};


export type QueryGetQualificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetQualificationsByVectorDbTenantNameArgs = {
  filter?: InputMaybe<ModelQualificationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  qualification?: InputMaybe<ModelStringKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  vectorDbTenantName: Scalars['String']['input'];
};


export type QueryGetQuestionOutcomeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRequirementOutcomeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetRequirementOutcomesByAnalysisRequirementArgs = {
  analysisRequirementId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetRequirementOutcomesByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchCandidateProfileMessagesArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchCandidateProfileQueryId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileMessagesByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileQueriesByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileQueriesByUserArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetSearchCandidateProfileQueryArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchCandidateProfileSelectedArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchCandidateProfileSelectedByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileSelectedItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchCandidateProfileSelectedItemsByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileSelectedItemsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchCandidateProfileSelectedItemsBySearchCandidateProfileSelectedArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  searchCandidateProfileSelectedId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSearchPeopleQueryFieldsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSearchPeopleQueryFieldsByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchPeopleQueryFieldsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSelectedCandidateBatchStatusesArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSelectedCandidateBatchStatusesByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSelectedCandidateBatchStatusesByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSimulationConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSimulationMessageArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSimulationMessagesBySimulationIdArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSimulationMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  simulationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSkillArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSkillsByVectorDbTenantNameArgs = {
  filter?: InputMaybe<ModelSkillFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  skill?: InputMaybe<ModelStringKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  vectorDbTenantName: Scalars['String']['input'];
};


export type QueryGetSourcedCandidateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetSourcedCandidateByCandidateArgs = {
  candidateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidateByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidateByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidateByEmailArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  email: Scalars['String']['input'];
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidateByLinkedInProfileUrlArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedInProfileUrl: Scalars['String']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidateByLinkedInProfileUrlAndCandidateBatchArgs = {
  candidateBatchId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkedInProfileUrl: Scalars['String']['input'];
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidatesByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetSourcedCandidatesByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetStatusSetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetStatusSetByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelStatusSetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetStripeCustomerPortalArgs = {
  organizationId: Scalars['ID']['input'];
  returnUrl: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTagsByVectorDbTenantNameArgs = {
  filter?: InputMaybe<ModelTagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  tag?: InputMaybe<ModelStringKeyConditionInput>;
  vectorDbTenantName: Scalars['String']['input'];
};


export type QueryGetTeamArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTeamByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTeamMembershipArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTeamMembershipsByTeamArgs = {
  filter?: InputMaybe<ModelTeamMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  teamId: Scalars['ID']['input'];
  userId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type QueryGetTeamMembershipsByUserArgs = {
  filter?: InputMaybe<ModelTeamMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetTeamsByOrganizationArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<ModelStringKeyConditionInput>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTwilioAccountCredentialsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTwilioAccountCredentialsByChatServiceSidArgs = {
  chatServiceSid: Scalars['ID']['input'];
  filter?: InputMaybe<ModelTwilioAccountCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTwilioAccountCredentialsByInboundChatServiceIdArgs = {
  filter?: InputMaybe<ModelTwilioAccountCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  inboundChatServiceId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTwilioAccountCredentialsByOrganizationArgs = {
  filter?: InputMaybe<ModelTwilioAccountCredentialsFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTypeformLinkArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTypeformLinksByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelTypeformLinkFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTypeformLinksByCandidateBatchArgs = {
  candidateBatchId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelTypeformLinkFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetTypeformRecordArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetTypeformRecordsByOrganizationArgs = {
  filter?: InputMaybe<ModelTypeformRecordFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUnansweredQuestionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUnansweredQuestionsByAssociatedMessageArgs = {
  associatedMessageId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelUnansweredQuestionFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUnansweredQuestionsByCampaignArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelUnansweredQuestionFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUnansweredQuestionsByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelUnansweredQuestionFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserByEmailArgs = {
  email: Scalars['AWSEmail']['input'];
  filter?: InputMaybe<ModelUserFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserCalendarArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserCalendarByEmailArgs = {
  email: Scalars['String']['input'];
  filter?: InputMaybe<ModelUserCalendarFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserCalendarByUserArgs = {
  createdByUserId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelUserCalendarFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserCalendarMeetingTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserCalendarMeetingTemplateByCalendarMeetingTemplateArgs = {
  calendarMeetingTemplateId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserCalendarMeetingTemplateByUserCalendarArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userCalendarId: Scalars['ID']['input'];
};


export type QueryGetUserCalendarOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserCalendarOrganizationByOrganizationArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserCalendarOrganizationByUserArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetUserCalendarOrganizationByUserCalendarArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userCalendarId: Scalars['ID']['input'];
};


export type QueryGetUserOrganizationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetUserOrganizationByOrganizationArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUserOrganizationByUserArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetUserOrganizationByUserAndOrganizationArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryGetUserRelationshipToOrganizationArgs = {
  organizationId: Scalars['ID']['input'];
};


export type QueryGetUsersByOrganizationArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUsersByOrganizationGroupArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUsersByOrganizationGroupAndEmailArgs = {
  email?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetUsersForOrganizationArgs = {
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryGetVirtualCalendarConversationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetVirtualCalendarConversationByConversationArgs = {
  conversationId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelVirtualCalendarConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userCalendarId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type QueryGetVirtualCalendarConversationByOrganizationArgs = {
  filter?: InputMaybe<ModelVirtualCalendarConversationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWhatsAppTemplatesByOrganizationConfigArgs = {
  filter?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationConfigId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWhatsaapTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWhatsaapTemplatesByOrganizationArgs = {
  filter?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWhatsaapTemplatesByTypeAndOrganizationArgs = {
  filter?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  type: TemplateType;
};


export type QueryGetWorkflowArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowAtsJobArgs = {
  atsJobId: Scalars['ID']['input'];
  organizationId: Scalars['ID']['input'];
};


export type QueryGetWorkflowByExternalIdArgs = {
  externalId: Scalars['String']['input'];
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWorkflowContactArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowContactImportArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowContactImportsByWorkflowArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowContactImportFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryGetWorkflowContactsByCandidateProfileArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowContactFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWorkflowContactsByDedupKeyArgs = {
  dedupKey: Scalars['String']['input'];
  filter?: InputMaybe<ModelWorkflowContactFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId?: InputMaybe<ModelIdKeyConditionInput>;
};


export type QueryGetWorkflowContactsByImportArgs = {
  filter?: InputMaybe<ModelWorkflowContactFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowContactImportId: Scalars['ID']['input'];
};


export type QueryGetWorkflowContactsByWorkflowArgs = {
  filter?: InputMaybe<ModelWorkflowContactFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  statusCreatedAtId?: InputMaybe<ModelWorkflowContactByWorkflowAndStatusCompositeKeyConditionInput>;
  workflowId: Scalars['ID']['input'];
};


export type QueryGetWorkflowEventArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowRunArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowRunCandidateProfileArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowRunsByAtsApplicationIdArgs = {
  atsApplicationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryGetWorkflowStatsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowVersionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowVersionNodeStatsArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetWorkflowsByOrganizationAndEmbeddedAtsJobIdArgs = {
  embeddedAtsJobId?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAgentsArgs = {
  filter?: InputMaybe<ModelAgentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAnalysedApplicationSnapshotsArgs = {
  filter?: InputMaybe<ModelAnalysedApplicationSnapshotFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAnalysisRequirementsArgs = {
  filter?: InputMaybe<ModelAnalysisRequirementFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListApplicationStageUpdatesArgs = {
  filter?: InputMaybe<ModelApplicationStageUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAtsApplicationScreeningAnswersArgs = {
  filter?: InputMaybe<ModelAtsApplicationScreeningAnswersFilterInput>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsApplicationsArgs = {
  filter?: InputMaybe<ModelAtsApplicationFilterInput>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsBulkSyncErrorsArgs = {
  filter?: InputMaybe<ModelAtsBulkSyncErrorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAtsBulkSyncErrorsByAtsRecordIdArgs = {
  atsRecordId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncErrorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsBulkSyncErrorsBySyncArgs = {
  atsBulkSyncId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncErrorFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsBulkSyncsArgs = {
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAtsBulkSyncsByAtsAccountIdArgs = {
  atsAccountId: Scalars['String']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsBulkSyncsByOrganizationArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsBulkSyncsByOrganizationGroupArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelAtsBulkSyncFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListAtsConfigsArgs = {
  filter?: InputMaybe<ModelAtsConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAtsJobStagesArgs = {
  input: ListAtsJobStagesInput;
};


export type QueryListAtsJobsArgs = {
  input: ListAtsJobsInput;
};


export type QueryListAtsQuestionsArgs = {
  filter?: InputMaybe<ModelAtsQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAtsRejectionReasonsArgs = {
  input: ListAtsRejectionReasonsInput;
};


export type QueryListAttachmentsArgs = {
  filter?: InputMaybe<ModelAttachmentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAutomationTaskEmailTemplatesArgs = {
  filter?: InputMaybe<ModelAutomationTaskEmailTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAutomationTasksArgs = {
  filter?: InputMaybe<ModelAutomationTaskFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListAutomationTasksTemplatesArgs = {
  filter?: InputMaybe<ModelAutomationTasksTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCalendarBookingsArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCalendarMeetingTemplatesArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignCandidatesArgs = {
  filter?: InputMaybe<ModelCampaignCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignCsvKeysArgs = {
  filter?: InputMaybe<ModelCampaignCsvKeysFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignQuestionsArgs = {
  filter?: InputMaybe<ModelCampaignQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignSubscriptionsArgs = {
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCampaignsArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateAvailabilitySuggestionsArgs = {
  filter?: InputMaybe<ModelCandidateAvailabilitySuggestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateBatchGroupsArgs = {
  filter?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateBatchesArgs = {
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateCvsParsingsArgs = {
  filter?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateEmailCorrespondencesArgs = {
  filter?: InputMaybe<ModelCandidateEmailCorrespondenceFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateMessagesArgs = {
  filter?: InputMaybe<ModelCandidateMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateNotesArgs = {
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateProfileListMembershipsArgs = {
  filter?: InputMaybe<ModelCandidateProfileListMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateProfileListsArgs = {
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateProfileNotesArgs = {
  filter?: InputMaybe<ModelCandidateProfileNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateProfilesArgs = {
  filter?: InputMaybe<ModelCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateStatusUpdatesArgs = {
  filter?: InputMaybe<ModelCandidateStatusUpdateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidateTagsArgs = {
  filter?: InputMaybe<ModelCandidateTagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListCandidatesArgs = {
  filter?: InputMaybe<ModelCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListClientApiKeysArgs = {
  filter?: InputMaybe<ModelClientApiKeyFilterInput>;
  hashedKey?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListConversationsArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDocumentCredentialsArgs = {
  filter?: InputMaybe<ModelDocumentCredentialFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDocumentTypeRelationshipsArgs = {
  filter?: InputMaybe<ModelDocumentTypeRelationshipsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListDocumentTypesArgs = {
  filter?: InputMaybe<ModelDocumentTypeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListIntegrationCredentialsArgs = {
  filter?: InputMaybe<ModelIntegrationCredentialsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListJobPostingRecommendationsArgs = {
  filter?: InputMaybe<ModelJobPostingRecommendationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListJobPostingsArgs = {
  filter?: InputMaybe<ModelJobPostingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListMessagesArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListNeedsReviewItemsArgs = {
  filter?: InputMaybe<ModelNeedsReviewItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOptOutEmailAddressesArgs = {
  filter?: InputMaybe<ModelOptOutEmailAddressFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOptOutPhoneNumbersArgs = {
  filter?: InputMaybe<ModelOptOutPhoneNumberFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationConfigsArgs = {
  filter?: InputMaybe<ModelOrganizationConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationCustomFieldConfigsArgs = {
  filter?: InputMaybe<ModelOrganizationCustomFieldConfigFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationGroupsArgs = {
  filter?: InputMaybe<ModelOrganizationGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationWebhooksArgs = {
  filter?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOrganizationsArgs = {
  filter?: InputMaybe<ModelOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListOutreachQuestionsArgs = {
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPlanMembershipsArgs = {
  filter?: InputMaybe<ModelPlanMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListPreferencesArgs = {
  filter?: InputMaybe<ModelPreferencesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListProfileDataArgs = {
  filter?: InputMaybe<ModelProfileDataFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  profileId?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListQualificationsArgs = {
  filter?: InputMaybe<ModelQualificationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListQuestionOutcomesArgs = {
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListRequirementOutcomesArgs = {
  filter?: InputMaybe<ModelRequirementOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSearchCandidateProfileMessagesArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSearchCandidateProfileQueriesArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSearchCandidateProfileSelectedItemsArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSearchCandidateProfileSelectedsArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSearchPeopleQueryFieldsArgs = {
  filter?: InputMaybe<ModelSearchPeopleQueryFieldsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSelectedCandidateBatchStatusesArgs = {
  filter?: InputMaybe<ModelSelectedCandidateBatchStatusesFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSimulationConversationsArgs = {
  filter?: InputMaybe<ModelSimulationConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSimulationMessagesArgs = {
  filter?: InputMaybe<ModelSimulationMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSkillsArgs = {
  filter?: InputMaybe<ModelSkillFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListSourcedCandidatesArgs = {
  filter?: InputMaybe<ModelSourcedCandidateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListStatusSetsArgs = {
  filter?: InputMaybe<ModelStatusSetFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTagsArgs = {
  filter?: InputMaybe<ModelTagFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTeamMembershipsArgs = {
  filter?: InputMaybe<ModelTeamMembershipFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTeamsArgs = {
  filter?: InputMaybe<ModelTeamFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTeamsForUserArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
};


export type QueryListTwilioAccountCredentialsArgs = {
  filter?: InputMaybe<ModelTwilioAccountCredentialsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTypeformLinksArgs = {
  filter?: InputMaybe<ModelTypeformLinkFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListTypeformRecordsArgs = {
  filter?: InputMaybe<ModelTypeformRecordFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUnansweredQuestionsArgs = {
  filter?: InputMaybe<ModelUnansweredQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserCalendarMeetingTemplatesArgs = {
  filter?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserCalendarOrganizationsArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserCalendarsArgs = {
  filter?: InputMaybe<ModelUserCalendarFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUserOrganizationsArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListUsersArgs = {
  filter?: InputMaybe<ModelUserFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListVirtualCalendarConversationsArgs = {
  filter?: InputMaybe<ModelVirtualCalendarConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWhatsaapTemplatesArgs = {
  filter?: InputMaybe<ModelWhatsaapTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowAtsJobsArgs = {
  atsJobId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowAtsJobFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryListWorkflowContactImportsArgs = {
  filter?: InputMaybe<ModelWorkflowContactImportFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowContactsArgs = {
  filter?: InputMaybe<ModelWorkflowContactFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowEventsArgs = {
  filter?: InputMaybe<ModelWorkflowEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowRunCandidateProfilesArgs = {
  filter?: InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowRunsArgs = {
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowStatsArgs = {
  filter?: InputMaybe<ModelWorkflowStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowVersionNodeStatsArgs = {
  filter?: InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowVersionsArgs = {
  filter?: InputMaybe<ModelWorkflowVersionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryListWorkflowsArgs = {
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationAutocompleteArgs = {
  input: LocationAutocompleteInput;
};


export type QueryMessagesByAgentIdArgs = {
  agentId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryMessagesByOutreachQuestionIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  outreachQuestionId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryMessagesByTemplateIdArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  templateId: Scalars['ID']['input'];
};


export type QueryMessagesByUserIdArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  userId: Scalars['ID']['input'];
};


export type QueryMessagesByWorkflowRunIdArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QueryOrganizationWebhooksByCreatedByUserIdArgs = {
  createdByUserId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryOutreachQuestionsByCampaignIdAndOrderArgs = {
  campaignId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<ModelIntKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryOutreachQuestionsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryOutreachQuestionsByWorkflowIdArgs = {
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryOutreachQuestionsByWorkflowVersionIdAndWorkflowNodeIdArgs = {
  filter?: InputMaybe<ModelOutreachQuestionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowNodeId?: InputMaybe<ModelStringKeyConditionInput>;
  workflowVersionId: Scalars['ID']['input'];
};


export type QueryQuestionOutcomesByCampaignIdAndCreatedAtArgs = {
  campaignId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryQuestionOutcomesByCandidateProfileIdAndCreatedAtArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryQuestionOutcomesByConversationIdAndCreatedAtArgs = {
  conversationId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryQuestionOutcomesByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryQuestionOutcomesByOutreachQuestionIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  outreachQuestionId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryQuestionOutcomesByWorkflowIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryQuestionOutcomesByWorkflowRunIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelQuestionOutcomeFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QuerySearchAgentsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableAgentAggregationInput>>>;
  filter?: InputMaybe<SearchableAgentFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableAgentSortInput>>>;
};


export type QuerySearchCalendarBookingsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCalendarBookingAggregationInput>>>;
  filter?: InputMaybe<SearchableCalendarBookingFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCalendarBookingSortInput>>>;
};


export type QuerySearchCalendarMeetingTemplatesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCalendarMeetingTemplateAggregationInput>>>;
  filter?: InputMaybe<SearchableCalendarMeetingTemplateFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCalendarMeetingTemplateSortInput>>>;
};


export type QuerySearchCampaignsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCampaignAggregationInput>>>;
  filter?: InputMaybe<SearchableCampaignFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCampaignSortInput>>>;
};


export type QuerySearchCandidateBatchesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateBatchAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateBatchFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateBatchSortInput>>>;
};


export type QuerySearchCandidateProfileListsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileListAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateProfileListFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileListSortInput>>>;
};


export type QuerySearchCandidateProfileListsForUserArgs = {
  filter?: InputMaybe<Scalars['AWSJSON']['input']>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  organizationId: Scalars['ID']['input'];
  sort?: InputMaybe<Scalars['AWSJSON']['input']>;
};


export type QuerySearchCandidateProfileNotesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileNoteAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateProfileNoteFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileNoteSortInput>>>;
};


export type QuerySearchCandidateProfilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateProfileFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileSortInput>>>;
};


export type QuerySearchCandidateTagsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateTagAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateTagFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateTagSortInput>>>;
};


export type QuerySearchCandidatesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableCandidateAggregationInput>>>;
  filter?: InputMaybe<SearchableCandidateFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableCandidateSortInput>>>;
};


export type QuerySearchConversationsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableConversationAggregationInput>>>;
  filter?: InputMaybe<SearchableConversationFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableConversationSortInput>>>;
};


export type QuerySearchDocumentTypesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableDocumentTypeAggregationInput>>>;
  filter?: InputMaybe<SearchableDocumentTypeFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableDocumentTypeSortInput>>>;
};


export type QuerySearchJobPostingsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableJobPostingAggregationInput>>>;
  filter?: InputMaybe<SearchableJobPostingFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableJobPostingSortInput>>>;
};


export type QuerySearchPeopleArgs = {
  query: SearchPeopleQueryInput;
};


export type QuerySearchQualificationsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableQualificationAggregationInput>>>;
  filter?: InputMaybe<SearchableQualificationFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableQualificationSortInput>>>;
};


export type QuerySearchQuestionOutcomesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableQuestionOutcomeAggregationInput>>>;
  filter?: InputMaybe<SearchableQuestionOutcomeFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableQuestionOutcomeSortInput>>>;
};


export type QuerySearchSearchCandidateProfileQueriesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableSearchCandidateProfileQueryAggregationInput>>>;
  filter?: InputMaybe<SearchableSearchCandidateProfileQueryFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableSearchCandidateProfileQuerySortInput>>>;
};


export type QuerySearchSkillsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableSkillAggregationInput>>>;
  filter?: InputMaybe<SearchableSkillFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableSkillSortInput>>>;
};


export type QuerySearchSourcedCandidatesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableSourcedCandidateAggregationInput>>>;
  filter?: InputMaybe<SearchableSourcedCandidateFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableSourcedCandidateSortInput>>>;
};


export type QuerySearchTagsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableTagAggregationInput>>>;
  filter?: InputMaybe<SearchableTagFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableTagSortInput>>>;
};


export type QuerySearchUserCalendarsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableUserCalendarAggregationInput>>>;
  filter?: InputMaybe<SearchableUserCalendarFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableUserCalendarSortInput>>>;
};


export type QuerySearchVectorCandidateProfileArgs = {
  input: SearchVectorCandidateProfileInput;
};


export type QuerySearchVirtualCalendarConversationsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableVirtualCalendarConversationAggregationInput>>>;
  filter?: InputMaybe<SearchableVirtualCalendarConversationFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableVirtualCalendarConversationSortInput>>>;
};


export type QuerySearchWorkflowContactsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableWorkflowContactAggregationInput>>>;
  filter?: InputMaybe<SearchableWorkflowContactFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableWorkflowContactSortInput>>>;
};


export type QuerySearchWorkflowEventsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableWorkflowEventAggregationInput>>>;
  filter?: InputMaybe<SearchableWorkflowEventFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableWorkflowEventSortInput>>>;
};


export type QuerySearchWorkflowRunCandidateProfilesArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunCandidateProfileAggregationInput>>>;
  filter?: InputMaybe<SearchableWorkflowRunCandidateProfileFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunCandidateProfileSortInput>>>;
};


export type QuerySearchWorkflowRunsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunAggregationInput>>>;
  filter?: InputMaybe<SearchableWorkflowRunFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunSortInput>>>;
};


export type QuerySearchWorkflowsArgs = {
  aggregates?: InputMaybe<Array<InputMaybe<SearchableWorkflowAggregationInput>>>;
  filter?: InputMaybe<SearchableWorkflowFilterInput>;
  from?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Array<InputMaybe<SearchableWorkflowSortInput>>>;
};


export type QueryStructureJobDescriptionArgs = {
  content: Scalars['String']['input'];
};


export type QueryStructureJobDescriptionParsedArgs = {
  content: Scalars['String']['input'];
};


export type QueryWorkflowAtsJobsByWorkflowIdAndAtsJobIdArgs = {
  atsJobId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowAtsJobFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryWorkflowEventsByEventTypeAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  eventType: Scalars['String']['input'];
  filter?: InputMaybe<ModelWorkflowEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowEventsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowEventsByWorkflowRunIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowEventFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowRunId: Scalars['ID']['input'];
};


export type QueryWorkflowRunCandidateProfilesByCandidateProfileIdArgs = {
  candidateProfileId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowRunCandidateProfilesByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunCandidateProfileFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowRunsByCandidateProfileIdAndCreatedAtArgs = {
  candidateProfileId: Scalars['ID']['input'];
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowRunsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowRunsByWorkflowIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowId: Scalars['ID']['input'];
};


export type QueryWorkflowRunsByWorkflowVersionIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowVersionId: Scalars['ID']['input'];
};


export type QueryWorkflowStatsByOrganizationIdArgs = {
  filter?: InputMaybe<ModelWorkflowStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowVersionNodeStatsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowVersionNodeStatsByWorkflowVersionIdAndNodeIdArgs = {
  filter?: InputMaybe<ModelWorkflowVersionNodeStatsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  nodeId?: InputMaybe<ModelStringKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  workflowVersionId: Scalars['ID']['input'];
};


export type QueryWorkflowVersionsByOrganizationIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowVersionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowVersionsByWorkflowIdAndVersionNumberArgs = {
  filter?: InputMaybe<ModelWorkflowVersionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  versionNumber?: InputMaybe<ModelIntKeyConditionInput>;
  workflowId: Scalars['ID']['input'];
};


export type QueryWorkflowsByCreatedByUserIdAndCreatedAtArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  createdByUserId: Scalars['ID']['input'];
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type QueryWorkflowsByOrganizationIdAndUpdatedAtArgs = {
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['ID']['input'];
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};

export type Question = {
  content: Scalars['String']['output'];
  documentItems?: Maybe<Array<DocumentItem>>;
  /** @deprecated Use documentItems instead. A Question must carry either documentTypes (legacy free-text) or documentItems (typed references), never both. */
  documentTypes?: Maybe<Array<Scalars['String']['output']>>;
  expectedAnswer?: Maybe<QuestionExpectedAnswer>;
  hasPreferredAnswer?: Maybe<Scalars['Boolean']['output']>;
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  preferredAnswerRequirements?: Maybe<Array<Scalars['String']['output']>>;
  preferredAnswerText?: Maybe<Scalars['String']['output']>;
  questionType?: Maybe<QuestionType>;
  supportingInformation?: Maybe<Scalars['String']['output']>;
};

export enum QuestionActionCategory {
  GoToQuestion = 'GO_TO_QUESTION',
  TriggerReview = 'TRIGGER_REVIEW',
  UpdatedStatus = 'UPDATED_STATUS'
}

export enum QuestionEvaluationResult {
  Failed = 'FAILED',
  Incomplete = 'INCOMPLETE',
  NeedsReview = 'NEEDS_REVIEW',
  NotCompleted = 'NOT_COMPLETED',
  Passed = 'PASSED',
  Pending = 'PENDING'
}

export enum QuestionExpectedAnswer {
  IsNo = 'IS_NO',
  IsYes = 'IS_YES'
}

export type QuestionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  documentItems?: InputMaybe<Array<DocumentItemInput>>;
  documentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expectedAnswer?: InputMaybe<QuestionExpectedAnswer>;
  hasPreferredAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  preferredAnswerRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredAnswerText?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<QuestionType>;
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
};

export type QuestionOutcome = {
  agentMessageId?: Maybe<Scalars['ID']['output']>;
  answerPolarity?: Maybe<Scalars['String']['output']>;
  answerProgress?: Maybe<Array<AnswerProgress>>;
  answerState: AnswerState;
  answerSummary?: Maybe<Scalars['String']['output']>;
  answerText?: Maybe<Scalars['String']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId: Scalars['ID']['output'];
  classifiedDocumentString?: Maybe<Scalars['String']['output']>;
  classifiedDocumentType?: Maybe<Scalars['String']['output']>;
  classifiedDocumentTypeId?: Maybe<Scalars['ID']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  documentFileName?: Maybe<Scalars['String']['output']>;
  documentS3Key?: Maybe<Scalars['String']['output']>;
  documentTwilioMediaSid?: Maybe<Scalars['String']['output']>;
  evaluationResult: QuestionEvaluationResult;
  evidence?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isMet?: Maybe<Scalars['Boolean']['output']>;
  neededReview?: Maybe<Scalars['Boolean']['output']>;
  neededReviewReason?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  outreachQuestion?: Maybe<OutreachQuestion>;
  outreachQuestionId: Scalars['ID']['output'];
  preferredAnswerEvaluations?: Maybe<Array<PreferredAnswerEvaluation>>;
  prospectMessageId?: Maybe<Scalars['ID']['output']>;
  questionContent?: Maybe<Scalars['String']['output']>;
  questionSlug?: Maybe<Scalars['String']['output']>;
  routeTaken?: Maybe<Scalars['String']['output']>;
  score?: Maybe<Scalars['Float']['output']>;
  trafficLight?: Maybe<TrafficLight>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId?: Maybe<Scalars['ID']['output']>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum QuestionStrictness {
  Lenient = 'LENIENT',
  Strict = 'STRICT'
}

export enum QuestionType {
  Document = 'DOCUMENT',
  Text = 'TEXT'
}

export type RegenerateWebhookSigningSecretResult = {
  signingSecret: Scalars['String']['output'];
  webhookId: Scalars['ID']['output'];
};

export type RegisterCandidateTagsInput = {
  organizationId: Scalars['ID']['input'];
  tags: Array<Scalars['String']['input']>;
};

export type RegisterCandidateTagsResult = {
  tags: Array<Scalars['String']['output']>;
};

export type RelevantExperience = {
  maximum?: Maybe<Scalars['Int']['output']>;
  minimum?: Maybe<Scalars['Int']['output']>;
  rawText?: Maybe<Scalars['String']['output']>;
};

export type RelevantExperienceInput = {
  maximum?: InputMaybe<Scalars['Int']['input']>;
  minimum?: InputMaybe<Scalars['Int']['input']>;
  rawText?: InputMaybe<Scalars['String']['input']>;
};

export type RemoveCandidateProfileListInput = {
  candidateProfileListId: Scalars['ID']['input'];
};

export type RemoveCandidateProfileListOutput = {
  message: Scalars['String']['output'];
};

export type RemoveCandidateProfilesFromListInput = {
  candidateProfileIds: Array<Scalars['ID']['input']>;
  candidateProfileListId: Scalars['ID']['input'];
};

export type RemoveCandidateProfilesFromListOutput = {
  message: Scalars['String']['output'];
};

export type RemoveUserFromOrganizationInput = {
  userOrganizationId: Scalars['ID']['input'];
};

export type RemoveUserFromOrganizationOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type Requirement = {
  content: Scalars['String']['output'];
  isMandatory?: Maybe<Scalars['Boolean']['output']>;
};

export type RequirementCondition = {
  candidateStatus?: Maybe<Scalars['String']['output']>;
  conversationConditionCampaignId?: Maybe<Scalars['ID']['output']>;
  conversationStatus?: Maybe<ConversationStatus>;
  documentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  operator?: Maybe<RequirementConditionOperator>;
  preferredAnswerScore?: Maybe<Scalars['Float']['output']>;
  scoreScaled?: Maybe<Scalars['Float']['output']>;
  scoreScaledMax?: Maybe<Scalars['Float']['output']>;
  type: RequirementConditionType;
};

export type RequirementConditionInput = {
  candidateStatus?: InputMaybe<Scalars['String']['input']>;
  conversationConditionCampaignId?: InputMaybe<Scalars['ID']['input']>;
  conversationStatus?: InputMaybe<ConversationStatus>;
  documentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  operator?: InputMaybe<RequirementConditionOperator>;
  preferredAnswerScore?: InputMaybe<Scalars['Float']['input']>;
  scoreScaled?: InputMaybe<Scalars['Float']['input']>;
  scoreScaledMax?: InputMaybe<Scalars['Float']['input']>;
  type: RequirementConditionType;
};

export enum RequirementConditionOperator {
  Between = 'BETWEEN',
  Equals = 'EQUALS',
  EqualToOrGreaterThan = 'EQUAL_TO_OR_GREATER_THAN',
  EqualToOrLowerThan = 'EQUAL_TO_OR_LOWER_THAN',
  GreaterThan = 'GREATER_THAN',
  IsFalse = 'IS_FALSE',
  IsTrue = 'IS_TRUE',
  LowerThan = 'LOWER_THAN'
}

export enum RequirementConditionType {
  AnyCandidateStatusCondition = 'ANY_CANDIDATE_STATUS_CONDITION',
  CandidateRequirementsMetCondition = 'CANDIDATE_REQUIREMENTS_MET_CONDITION',
  CandidateScoreCondition = 'CANDIDATE_SCORE_CONDITION',
  CandidateStatusCondition = 'CANDIDATE_STATUS_CONDITION',
  ConversationDocumentUploadCondition = 'CONVERSATION_DOCUMENT_UPLOAD_CONDITION',
  ConversationMandatoryQuestionsMet = 'CONVERSATION_MANDATORY_QUESTIONS_MET',
  ConversationScore = 'CONVERSATION_SCORE',
  ConversationStatusCondition = 'CONVERSATION_STATUS_CONDITION'
}

export type RequirementInput = {
  content: Scalars['String']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  recommendationCategory?: InputMaybe<RequirementRecommendationCategory>;
  recommendationText?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
};

export type RequirementOutcome = {
  analysisRequirement?: Maybe<AnalysisRequirement>;
  analysisRequirementId: Scalars['ID']['output'];
  candidate?: Maybe<Candidate>;
  candidateBatchId: Scalars['ID']['output'];
  candidateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  evidence: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMet: Scalars['Boolean']['output'];
  organizationId: Scalars['ID']['output'];
  requirementSlug?: Maybe<Scalars['String']['output']>;
  scoredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  scoringConfigurationDigest?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum RequirementRecommendationCategory {
  MultipleSkills = 'MULTIPLE_SKILLS',
  NeedsSpecificLocation = 'NEEDS_SPECIFIC_LOCATION',
  NotAvailable = 'NOT_AVAILABLE',
  OpenToInterpretation = 'OPEN_TO_INTERPRETATION',
  TooRestrictive = 'TOO_RESTRICTIVE',
  VagueDateReference = 'VAGUE_DATE_REFERENCE'
}

export type ResendUserInviteInput = {
  email: Scalars['AWSEmail']['input'];
};

export type ResendUserInviteOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type RestartConversationInput = {
  conversationId: Scalars['ID']['input'];
};

export type RevealSourcedCandidatePhoneNumberInput = {
  linkedInProfileUrl: Scalars['String']['input'];
  sourcedCandidateId: Scalars['ID']['input'];
};

export type RevealSourcedCandidatePhoneNumberOutput = {
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum Role {
  Founder = 'FOUNDER',
  Recruiter = 'RECRUITER',
  Salesperson = 'SALESPERSON'
}

export type Rubric = {
  relevantExperience: Array<RubricScore>;
  relevantQualifications: Array<RubricScore>;
  relevantSkills: Array<RubricScore>;
  softSkills: Array<RubricScore>;
};

export type RubricInput = {
  relevantExperience: Array<RubricScoreInput>;
  relevantQualifications: Array<RubricScoreInput>;
  relevantSkills: Array<RubricScoreInput>;
  softSkills: Array<RubricScoreInput>;
};

export type RubricScore = {
  description: Scalars['String']['output'];
  score: Scalars['Int']['output'];
};

export type RubricScoreInput = {
  description: Scalars['String']['input'];
  score: Scalars['Int']['input'];
};

export enum SandboxStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  Suspended = 'SUSPENDED'
}

export enum ScoringCategory {
  Experience = 'EXPERIENCE',
  Qualifications = 'QUALIFICATIONS',
  SoftSkills = 'SOFT_SKILLS',
  TechnicalSkills = 'TECHNICAL_SKILLS'
}

export type ScreeningQuestionOutcome = {
  questionOutcome: ScreeningQuestionOutcomeType;
  responseSummary?: Maybe<Scalars['String']['output']>;
  screeningQuestion: Scalars['String']['output'];
};

export type ScreeningQuestionOutcomeInput = {
  questionOutcome: ScreeningQuestionOutcomeType;
  responseSummary?: InputMaybe<Scalars['String']['input']>;
  screeningQuestion: Scalars['String']['input'];
};

export enum ScreeningQuestionOutcomeType {
  Failed = 'FAILED',
  NotCompleted = 'NOT_COMPLETED',
  Passed = 'PASSED'
}

export type SearchCandidateProfileMessage = {
  body: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  generatedSemanticSearchFilters?: Maybe<GeneratedSemanticSearchFilters>;
  generatedSemanticSearchQuery?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isOverwritten?: Maybe<Scalars['Boolean']['output']>;
  normalisedQueryUserBody?: Maybe<Scalars['String']['output']>;
  optimisedSemanticMessage?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  searchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  searchCandidateProfileQueryId: Scalars['ID']['output'];
  semanticQueries?: Maybe<Array<Scalars['String']['output']>>;
  sender: SearchCandidateProfileMessageSender;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum SearchCandidateProfileMessageSender {
  Agent = 'AGENT',
  User = 'USER'
}

export type SearchCandidateProfileQuery = {
  appliedFilter?: Maybe<Scalars['AWSJSON']['output']>;
  ats_candidate_id?: Maybe<Scalars['String']['output']>;
  candidate_profile_list_ids?: Maybe<Array<Scalars['ID']['output']>>;
  createdAt: Scalars['AWSDateTime']['output'];
  current_company?: Maybe<Scalars['String']['output']>;
  current_job_title?: Maybe<Scalars['String']['output']>;
  displayTitle?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  filter?: Maybe<Scalars['AWSJSON']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  generatedFilter?: Maybe<Scalars['AWSJSON']['output']>;
  geo_coordinates?: Maybe<GeoCoordinates>;
  geo_radius?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  isArchived?: Maybe<Scalars['Boolean']['output']>;
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  original_source?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  returnedCandidatesCount?: Maybe<Scalars['Int']['output']>;
  searchCandidateProfileMessages?: Maybe<ModelSearchCandidateProfileMessageConnection>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  time_in_role?: Maybe<Array<TimeComparison>>;
  total_years_of_experience?: Maybe<Scalars['Float']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};


export type SearchCandidateProfileQuerySearchCandidateProfileMessagesArgs = {
  filter?: InputMaybe<ModelSearchCandidateProfileMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SearchCandidateProfileSelected = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  selectedCandidateProfileSelectedItems?: Maybe<ModelSearchCandidateProfileSelectedItemConnection>;
  updatedAt: Scalars['AWSDateTime']['output'];
};


export type SearchCandidateProfileSelectedSelectedCandidateProfileSelectedItemsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelSearchCandidateProfileSelectedItemFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type SearchCandidateProfileSelectedItem = {
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId: Scalars['ID']['output'];
  candidateRelevance?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  customInvitationMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  searchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  searchCandidateProfileSelectedId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SearchPeopleQueryFields = {
  accumulated_results?: Maybe<Scalars['Int']['output']>;
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId: Scalars['ID']['output'];
  company?: Maybe<Array<Scalars['String']['output']>>;
  company_filter?: Maybe<TimeFilterType>;
  company_size?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['AWSDateTime']['output'];
  current_company_only?: Maybe<Scalars['Boolean']['output']>;
  current_titles_only?: Maybe<Scalars['Boolean']['output']>;
  domain?: Maybe<Array<Scalars['String']['output']>>;
  education?: Maybe<Array<Scalars['String']['output']>>;
  exclude_companies?: Maybe<Array<Scalars['String']['output']>>;
  exclude_job_titles?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['ID']['output'];
  include_related_job_titles?: Maybe<Scalars['Boolean']['output']>;
  industry?: Maybe<Array<Scalars['String']['output']>>;
  job_title?: Maybe<Array<Scalars['String']['output']>>;
  keyword?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Array<Scalars['String']['output']>>;
  match_experience?: Maybe<TimeFilterType>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  page?: Maybe<Scalars['Int']['output']>;
  page_size?: Maybe<Scalars['Int']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  total_results?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  years_in_current_role?: Maybe<Array<Scalars['String']['output']>>;
  years_of_experience?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchPeopleQueryInput = {
  candidateBatchId: Scalars['ID']['input'];
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  company_filter?: InputMaybe<TimeFilterType>;
  company_size?: InputMaybe<Array<Scalars['String']['input']>>;
  current_company_only?: InputMaybe<Scalars['Boolean']['input']>;
  current_titles_only?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Array<Scalars['String']['input']>>;
  education?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_companies?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_job_titles?: InputMaybe<Array<Scalars['String']['input']>>;
  id?: InputMaybe<Scalars['ID']['input']>;
  include_related_job_titles?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  job_title?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  match_experience?: InputMaybe<TimeFilterType>;
  name?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  years_in_current_role?: InputMaybe<Array<Scalars['String']['input']>>;
  years_of_experience?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchPeopleQueryOutput = {
  id: Scalars['ID']['output'];
  page: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  profiles?: Maybe<Array<ProfileResult>>;
  total: Scalars['Int']['output'];
};

export type SearchVectorCandidateProfileInput = {
  ats_candidate_id?: InputMaybe<Scalars['String']['input']>;
  candidate_profile_list_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  current_company?: InputMaybe<Scalars['String']['input']>;
  current_job_title?: InputMaybe<Scalars['String']['input']>;
  custom_fields?: InputMaybe<Scalars['AWSJSON']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  exclude_candidate_profile_list_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  geo_coordinates_latitude?: InputMaybe<Scalars['Float']['input']>;
  geo_coordinates_longitude?: InputMaybe<Scalars['Float']['input']>;
  geo_radius?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  include_explanations?: InputMaybe<Scalars['Boolean']['input']>;
  like_candidate_names?: InputMaybe<Array<Scalars['String']['input']>>;
  message_body?: InputMaybe<Scalars['String']['input']>;
  original_source?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  time_in_role?: InputMaybe<Array<TimeComparison>>;
  total_years_of_experience?: InputMaybe<Scalars['Float']['input']>;
};

export type SearchVectorCandidateProfileOutput = {
  candidateProfiles: Array<SearchVectorCandidateProfileResultItem>;
  id?: Maybe<Scalars['ID']['output']>;
  newUserMessage?: Maybe<SearchCandidateProfileMessage>;
  totalCandidatesCount: Scalars['Int']['output'];
};

export type SearchVectorCandidateProfileResultItem = {
  ats_candidate_id?: Maybe<Scalars['ID']['output']>;
  candidate_profile_id: Scalars['ID']['output'];
  candidate_profile_list_ids?: Maybe<Array<Scalars['ID']['output']>>;
  current_company?: Maybe<Scalars['String']['output']>;
  current_job_title?: Maybe<Scalars['String']['output']>;
  current_role_start_date?: Maybe<Scalars['AWSDateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  job_titles?: Maybe<Array<Scalars['String']['output']>>;
  location_name?: Maybe<Scalars['String']['output']>;
  original_source?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  qualifications?: Maybe<Array<Scalars['String']['output']>>;
  score?: Maybe<Scalars['Float']['output']>;
  skills?: Maybe<Array<Scalars['String']['output']>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  years_of_experience?: Maybe<Scalars['Float']['output']>;
};

export enum SearchableAgentAggregateField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OrganizationConfigId = 'organizationConfigId',
  OrganizationId = 'organizationId',
  Personality = 'personality',
  Tone = 'tone',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type SearchableAgentAggregationInput = {
  field: SearchableAgentAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableAgentConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Agent>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableAgentFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableAgentFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableAgentFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableAgentFilterInput>>>;
  organizationConfigId?: InputMaybe<SearchableIdFilterInput>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  personality?: InputMaybe<SearchableStringFilterInput>;
  tone?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableAgentSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableAgentSortableFields>;
};

export enum SearchableAgentSortableFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  OrganizationConfigId = 'organizationConfigId',
  OrganizationId = 'organizationId',
  Personality = 'personality',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type SearchableAggregateBucketResult = {
  buckets?: Maybe<Array<Maybe<SearchableAggregateBucketResultItem>>>;
};

export type SearchableAggregateBucketResultItem = {
  doc_count: Scalars['Int']['output'];
  key: Scalars['String']['output'];
};

export type SearchableAggregateGenericResult = SearchableAggregateBucketResult | SearchableAggregateScalarResult;

export type SearchableAggregateResult = {
  name: Scalars['String']['output'];
  result?: Maybe<SearchableAggregateGenericResult>;
};

export type SearchableAggregateScalarResult = {
  value: Scalars['Float']['output'];
};

export enum SearchableAggregateType {
  Avg = 'avg',
  Max = 'max',
  Min = 'min',
  Sum = 'sum',
  Terms = 'terms'
}

export type SearchableBooleanFilterInput = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum SearchableCalendarBookingAggregateField {
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignId = 'campaignId',
  CandidateEmail = 'candidateEmail',
  CandidateName = 'candidateName',
  CandidateTimeZone = 'candidateTimeZone',
  ConferenceUrl = 'conferenceUrl',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  EndDateTime = 'endDateTime',
  IcalUid = 'icalUid',
  Id = 'id',
  Location = 'location',
  NoteTakerId = 'noteTakerId',
  NoteTakerMediaTranscriptS3Key = 'noteTakerMediaTranscriptS3Key',
  NoteTakerStatus = 'noteTakerStatus',
  NoteTakerTranscriptSummary = 'noteTakerTranscriptSummary',
  NotetakerMediaRecordingS3Key = 'notetakerMediaRecordingS3Key',
  NylasBookingId = 'nylasBookingId',
  NylasBookingRef = 'nylasBookingRef',
  NylasEventId = 'nylasEventId',
  OrganizationId = 'organizationId',
  OrganizerUserCalendarId = 'organizerUserCalendarId',
  StartDateTime = 'startDateTime',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableCalendarBookingAggregationInput = {
  field: SearchableCalendarBookingAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCalendarBookingConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CalendarBooking>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCalendarBookingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCalendarBookingFilterInput>>>;
  calendarMeetingTemplateId?: InputMaybe<SearchableIdFilterInput>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateEmail?: InputMaybe<SearchableStringFilterInput>;
  candidateName?: InputMaybe<SearchableStringFilterInput>;
  candidateTimeZone?: InputMaybe<SearchableStringFilterInput>;
  conferenceUrl?: InputMaybe<SearchableStringFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  endDateTime?: InputMaybe<SearchableStringFilterInput>;
  icalUid?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  location?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCalendarBookingFilterInput>;
  noteTakerId?: InputMaybe<SearchableIdFilterInput>;
  noteTakerMediaTranscriptS3Key?: InputMaybe<SearchableStringFilterInput>;
  noteTakerStatus?: InputMaybe<SearchableStringFilterInput>;
  noteTakerTranscriptSummary?: InputMaybe<SearchableStringFilterInput>;
  notetakerMediaRecordingS3Key?: InputMaybe<SearchableStringFilterInput>;
  nylasBookingId?: InputMaybe<SearchableStringFilterInput>;
  nylasBookingRef?: InputMaybe<SearchableStringFilterInput>;
  nylasEventId?: InputMaybe<SearchableStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCalendarBookingFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  organizerUserCalendarId?: InputMaybe<SearchableIdFilterInput>;
  startDateTime?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableCalendarBookingSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCalendarBookingSortableFields>;
};

export enum SearchableCalendarBookingSortableFields {
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignId = 'campaignId',
  CandidateEmail = 'candidateEmail',
  CandidateName = 'candidateName',
  CandidateTimeZone = 'candidateTimeZone',
  ConferenceUrl = 'conferenceUrl',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  EndDateTime = 'endDateTime',
  IcalUid = 'icalUid',
  Id = 'id',
  Location = 'location',
  NoteTakerId = 'noteTakerId',
  NoteTakerMediaTranscriptS3Key = 'noteTakerMediaTranscriptS3Key',
  NoteTakerTranscriptSummary = 'noteTakerTranscriptSummary',
  NotetakerMediaRecordingS3Key = 'notetakerMediaRecordingS3Key',
  NylasBookingId = 'nylasBookingId',
  NylasBookingRef = 'nylasBookingRef',
  NylasEventId = 'nylasEventId',
  OrganizationId = 'organizationId',
  OrganizerUserCalendarId = 'organizerUserCalendarId',
  StartDateTime = 'startDateTime',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableCalendarMeetingTemplateAggregateField {
  AvailabilityMethod = 'availabilityMethod',
  CreatedAt = 'createdAt',
  DurationMinutes = 'durationMinutes',
  GuestLabel = 'guestLabel',
  HideParticipantEmails = 'hideParticipantEmails',
  Id = 'id',
  IsSingleUse = 'isSingleUse',
  IsVideoConference = 'isVideoConference',
  IsWorkflowManaged = 'isWorkflowManaged',
  LastUsedAt = 'lastUsedAt',
  Location = 'location',
  NylasConfigurationId = 'nylasConfigurationId',
  OrganizationId = 'organizationId',
  OrganizerUserCalendarId = 'organizerUserCalendarId',
  Status = 'status',
  Title = 'title',
  TotalBookingsCount = 'totalBookingsCount',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

export type SearchableCalendarMeetingTemplateAggregationInput = {
  field: SearchableCalendarMeetingTemplateAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCalendarMeetingTemplateConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CalendarMeetingTemplate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCalendarMeetingTemplateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCalendarMeetingTemplateFilterInput>>>;
  availabilityMethod?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  durationMinutes?: InputMaybe<SearchableIntFilterInput>;
  guestLabel?: InputMaybe<SearchableStringFilterInput>;
  hideParticipantEmails?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isSingleUse?: InputMaybe<SearchableBooleanFilterInput>;
  isVideoConference?: InputMaybe<SearchableBooleanFilterInput>;
  isWorkflowManaged?: InputMaybe<SearchableBooleanFilterInput>;
  lastUsedAt?: InputMaybe<SearchableStringFilterInput>;
  location?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCalendarMeetingTemplateFilterInput>;
  nylasConfigurationId?: InputMaybe<SearchableStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCalendarMeetingTemplateFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  organizerUserCalendarId?: InputMaybe<SearchableIdFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  totalBookingsCount?: InputMaybe<SearchableIntFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  updatedByUserId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableCalendarMeetingTemplateSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCalendarMeetingTemplateSortableFields>;
};

export enum SearchableCalendarMeetingTemplateSortableFields {
  CreatedAt = 'createdAt',
  DurationMinutes = 'durationMinutes',
  GuestLabel = 'guestLabel',
  HideParticipantEmails = 'hideParticipantEmails',
  Id = 'id',
  IsSingleUse = 'isSingleUse',
  IsVideoConference = 'isVideoConference',
  IsWorkflowManaged = 'isWorkflowManaged',
  LastUsedAt = 'lastUsedAt',
  Location = 'location',
  NylasConfigurationId = 'nylasConfigurationId',
  OrganizationId = 'organizationId',
  OrganizerUserCalendarId = 'organizerUserCalendarId',
  Title = 'title',
  TotalBookingsCount = 'totalBookingsCount',
  UpdatedAt = 'updatedAt',
  UpdatedByUserId = 'updatedByUserId'
}

export enum SearchableCampaignAggregateField {
  AdditionalContext = 'additionalContext',
  AgentId = 'agentId',
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  AtsListId = 'atsListId',
  AverageTimeToComplete = 'averageTimeToComplete',
  AverageTimeToFirstResponse = 'averageTimeToFirstResponse',
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignGroupId = 'campaignGroupId',
  CancellationMessage = 'cancellationMessage',
  CandidateBatchId = 'candidateBatchId',
  Channel = 'channel',
  ClosingMessage = 'closingMessage',
  ClosingMethod = 'closingMethod',
  ContactNumber = 'contactNumber',
  ConversationCompletedMessage = 'conversationCompletedMessage',
  CreatedAt = 'createdAt',
  CsvS3Key = 'csvS3Key',
  CustomRequest = 'customRequest',
  CustomTemplatedMessage = 'customTemplatedMessage',
  CustomTemplatedSubjectLine = 'customTemplatedSubjectLine',
  DisableNudging = 'disableNudging',
  EmailChannelFallbackEnabled = 'emailChannelFallbackEnabled',
  ExternalId = 'externalId',
  FollowUpMessage = 'followUpMessage',
  GuestLabel = 'guestLabel',
  Id = 'id',
  InitialMessagesDeliveredCount = 'initialMessagesDeliveredCount',
  InitialMessagesReadCount = 'initialMessagesReadCount',
  InitialMessagesSentCount = 'initialMessagesSentCount',
  InitialMessagesUndeliveredCount = 'initialMessagesUndeliveredCount',
  IsDuplicate = 'isDuplicate',
  IsParent = 'isParent',
  IsWorkflowManaged = 'isWorkflowManaged',
  JobDescription = 'jobDescription',
  JobDescriptionText = 'jobDescriptionText',
  KomboJobId = 'komboJobId',
  Language = 'language',
  LaunchScheduleDateTime = 'launchScheduleDateTime',
  LaunchedAt = 'launchedAt',
  MeetingUrl = 'meetingUrl',
  MessagesProcessedCount = 'messagesProcessedCount',
  NeedsReview = 'needsReview',
  NudgesCount = 'nudgesCount',
  OrganizationId = 'organizationId',
  OutreachDescription = 'outreachDescription',
  Owner = 'owner',
  PeriodDays = 'periodDays',
  ReferenceId = 'referenceId',
  RejectionMessage = 'rejectionMessage',
  RequiredHours = 'requiredHours',
  Status = 'status',
  StoppedAt = 'stoppedAt',
  StoppedByUserId = 'stoppedByUserId',
  TemplateId = 'templateId',
  TimeToAutoCloseConversationsInHours = 'timeToAutoCloseConversationsInHours',
  Title = 'title',
  TotalConversationsCount = 'totalConversationsCount',
  TotalConversationsWithRepliesCount = 'totalConversationsWithRepliesCount',
  TotalMessagesCount = 'totalMessagesCount',
  TotalMessagesWithCallRequest = 'totalMessagesWithCallRequest',
  TotalMessagesWithCustomRequest = 'totalMessagesWithCustomRequest',
  TotalMessagesWithMeetingUrlCount = 'totalMessagesWithMeetingUrlCount',
  TotalNotInterestedConversationCount = 'totalNotInterestedConversationCount',
  TotalOptedOutConversationCount = 'totalOptedOutConversationCount',
  TotalProspectsCount = 'totalProspectsCount',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WebChatTemplateId = 'webChatTemplateId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowVersionId = 'workflowVersionId'
}

export type SearchableCampaignAggregationInput = {
  field: SearchableCampaignAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCampaignConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Campaign>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCampaignFilterInput = {
  additionalContext?: InputMaybe<SearchableStringFilterInput>;
  agentId?: InputMaybe<SearchableIdFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableCampaignFilterInput>>>;
  atsJobId?: InputMaybe<SearchableIdFilterInput>;
  atsJobPostingId?: InputMaybe<SearchableIdFilterInput>;
  atsListId?: InputMaybe<SearchableIdFilterInput>;
  averageTimeToComplete?: InputMaybe<SearchableFloatFilterInput>;
  averageTimeToFirstResponse?: InputMaybe<SearchableFloatFilterInput>;
  calendarMeetingTemplateId?: InputMaybe<SearchableIdFilterInput>;
  campaignGroupId?: InputMaybe<SearchableIdFilterInput>;
  cancellationMessage?: InputMaybe<SearchableStringFilterInput>;
  candidateBatchId?: InputMaybe<SearchableIdFilterInput>;
  channel?: InputMaybe<SearchableStringFilterInput>;
  closingMessage?: InputMaybe<SearchableStringFilterInput>;
  closingMethod?: InputMaybe<SearchableStringFilterInput>;
  contactNumber?: InputMaybe<SearchableStringFilterInput>;
  conversationCompletedMessage?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  csvS3Key?: InputMaybe<SearchableStringFilterInput>;
  customRequest?: InputMaybe<SearchableStringFilterInput>;
  customTemplatedMessage?: InputMaybe<SearchableStringFilterInput>;
  customTemplatedSubjectLine?: InputMaybe<SearchableStringFilterInput>;
  disableNudging?: InputMaybe<SearchableBooleanFilterInput>;
  emailChannelFallbackEnabled?: InputMaybe<SearchableBooleanFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  followUpMessage?: InputMaybe<SearchableStringFilterInput>;
  guestLabel?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  initialMessagesDeliveredCount?: InputMaybe<SearchableIntFilterInput>;
  initialMessagesReadCount?: InputMaybe<SearchableIntFilterInput>;
  initialMessagesSentCount?: InputMaybe<SearchableIntFilterInput>;
  initialMessagesUndeliveredCount?: InputMaybe<SearchableIntFilterInput>;
  isDuplicate?: InputMaybe<SearchableBooleanFilterInput>;
  isParent?: InputMaybe<SearchableBooleanFilterInput>;
  isWorkflowManaged?: InputMaybe<SearchableBooleanFilterInput>;
  jobDescription?: InputMaybe<SearchableStringFilterInput>;
  jobDescriptionText?: InputMaybe<SearchableStringFilterInput>;
  komboJobId?: InputMaybe<SearchableIdFilterInput>;
  language?: InputMaybe<SearchableStringFilterInput>;
  launchScheduleDateTime?: InputMaybe<SearchableStringFilterInput>;
  launchedAt?: InputMaybe<SearchableStringFilterInput>;
  meetingUrl?: InputMaybe<SearchableStringFilterInput>;
  messagesProcessedCount?: InputMaybe<SearchableIntFilterInput>;
  needsReview?: InputMaybe<SearchableBooleanFilterInput>;
  not?: InputMaybe<SearchableCampaignFilterInput>;
  nudgesCount?: InputMaybe<SearchableIntFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCampaignFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  outreachDescription?: InputMaybe<SearchableStringFilterInput>;
  owner?: InputMaybe<SearchableStringFilterInput>;
  periodDays?: InputMaybe<SearchableIntFilterInput>;
  referenceId?: InputMaybe<SearchableStringFilterInput>;
  rejectionMessage?: InputMaybe<SearchableStringFilterInput>;
  requiredHours?: InputMaybe<SearchableIntFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  stoppedAt?: InputMaybe<SearchableStringFilterInput>;
  stoppedByUserId?: InputMaybe<SearchableIdFilterInput>;
  templateId?: InputMaybe<SearchableIdFilterInput>;
  timeToAutoCloseConversationsInHours?: InputMaybe<SearchableFloatFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  totalConversationsCount?: InputMaybe<SearchableIntFilterInput>;
  totalConversationsWithRepliesCount?: InputMaybe<SearchableIntFilterInput>;
  totalMessagesCount?: InputMaybe<SearchableIntFilterInput>;
  totalMessagesWithCallRequest?: InputMaybe<SearchableIntFilterInput>;
  totalMessagesWithCustomRequest?: InputMaybe<SearchableIntFilterInput>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<SearchableIntFilterInput>;
  totalNotInterestedConversationCount?: InputMaybe<SearchableIntFilterInput>;
  totalOptedOutConversationCount?: InputMaybe<SearchableIntFilterInput>;
  totalProspectsCount?: InputMaybe<SearchableIntFilterInput>;
  type?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
  webChatTemplateId?: InputMaybe<SearchableIdFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowVersionId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableCampaignSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCampaignSortableFields>;
};

export enum SearchableCampaignSortableFields {
  AdditionalContext = 'additionalContext',
  AgentId = 'agentId',
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  AtsListId = 'atsListId',
  AverageTimeToComplete = 'averageTimeToComplete',
  AverageTimeToFirstResponse = 'averageTimeToFirstResponse',
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignGroupId = 'campaignGroupId',
  CancellationMessage = 'cancellationMessage',
  CandidateBatchId = 'candidateBatchId',
  ClosingMessage = 'closingMessage',
  ContactNumber = 'contactNumber',
  ConversationCompletedMessage = 'conversationCompletedMessage',
  CreatedAt = 'createdAt',
  CsvS3Key = 'csvS3Key',
  CustomRequest = 'customRequest',
  CustomTemplatedMessage = 'customTemplatedMessage',
  CustomTemplatedSubjectLine = 'customTemplatedSubjectLine',
  DisableNudging = 'disableNudging',
  EmailChannelFallbackEnabled = 'emailChannelFallbackEnabled',
  ExternalId = 'externalId',
  FollowUpMessage = 'followUpMessage',
  GuestLabel = 'guestLabel',
  Id = 'id',
  InitialMessagesDeliveredCount = 'initialMessagesDeliveredCount',
  InitialMessagesReadCount = 'initialMessagesReadCount',
  InitialMessagesSentCount = 'initialMessagesSentCount',
  InitialMessagesUndeliveredCount = 'initialMessagesUndeliveredCount',
  IsDuplicate = 'isDuplicate',
  IsParent = 'isParent',
  IsWorkflowManaged = 'isWorkflowManaged',
  JobDescription = 'jobDescription',
  JobDescriptionText = 'jobDescriptionText',
  KomboJobId = 'komboJobId',
  Language = 'language',
  LaunchScheduleDateTime = 'launchScheduleDateTime',
  LaunchedAt = 'launchedAt',
  MeetingUrl = 'meetingUrl',
  MessagesProcessedCount = 'messagesProcessedCount',
  NeedsReview = 'needsReview',
  NudgesCount = 'nudgesCount',
  OrganizationId = 'organizationId',
  OutreachDescription = 'outreachDescription',
  Owner = 'owner',
  PeriodDays = 'periodDays',
  ReferenceId = 'referenceId',
  RejectionMessage = 'rejectionMessage',
  RequiredHours = 'requiredHours',
  StoppedAt = 'stoppedAt',
  StoppedByUserId = 'stoppedByUserId',
  TemplateId = 'templateId',
  TimeToAutoCloseConversationsInHours = 'timeToAutoCloseConversationsInHours',
  Title = 'title',
  TotalConversationsCount = 'totalConversationsCount',
  TotalConversationsWithRepliesCount = 'totalConversationsWithRepliesCount',
  TotalMessagesCount = 'totalMessagesCount',
  TotalMessagesWithCallRequest = 'totalMessagesWithCallRequest',
  TotalMessagesWithCustomRequest = 'totalMessagesWithCustomRequest',
  TotalMessagesWithMeetingUrlCount = 'totalMessagesWithMeetingUrlCount',
  TotalNotInterestedConversationCount = 'totalNotInterestedConversationCount',
  TotalOptedOutConversationCount = 'totalOptedOutConversationCount',
  TotalProspectsCount = 'totalProspectsCount',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WebChatTemplateId = 'webChatTemplateId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowVersionId = 'workflowVersionId'
}

export enum SearchableCandidateAggregateField {
  AnalysisErrorCode = 'analysisErrorCode',
  AnalysisOutcomeActedOnAt = 'analysisOutcomeActedOnAt',
  ApplicationSource = 'applicationSource',
  AtsApplicationId = 'atsApplicationId',
  AtsApplicationSource = 'atsApplicationSource',
  AtsCandidateId = 'atsCandidateId',
  AtsInterviewStageId = 'atsInterviewStageId',
  AtsJobId = 'atsJobId',
  AtsRejectedReasonId = 'atsRejectedReasonId',
  CandidateBatchId = 'candidateBatchId',
  CandidateCvsParsingId = 'candidateCvsParsingId',
  CandidateProfileId = 'candidateProfileId',
  ConversationId = 'conversationId',
  ConversationPreferredAnswersScore = 'conversationPreferredAnswersScore',
  CreatedAt = 'createdAt',
  CvParsedText = 'cvParsedText',
  CvS3Key = 'cvS3Key',
  Email = 'email',
  ExternalId = 'externalId',
  FirstName = 'firstName',
  Id = 'id',
  IsAllRequirementsMet = 'isAllRequirementsMet',
  IsDeleted = 'isDeleted',
  IsLocked = 'isLocked',
  IsMessagesGenerating = 'isMessagesGenerating',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboJobId = 'komboJobId',
  KomboRejectionReasonId = 'komboRejectionReasonId',
  KomboStageId = 'komboStageId',
  LastName = 'lastName',
  LinkedInProfileId = 'linkedInProfileId',
  MetRequirementSlugs = 'metRequirementSlugs',
  OrganizationId = 'organizationId',
  Origin = 'origin',
  PhoneNumber = 'phoneNumber',
  Skills = 'skills',
  SourcedCandidateId = 'sourcedCandidateId',
  Status = 'status',
  TotalScore = 'totalScore',
  TotalScoreScaled = 'totalScoreScaled',
  UnmetRequirementSlugs = 'unmetRequirementSlugs',
  UpdatedAt = 'updatedAt',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableCandidateAggregationInput = {
  field: SearchableCandidateAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export enum SearchableCandidateBatchAggregateField {
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  AtsJobPostingUrl = 'atsJobPostingUrl',
  AtsJobReference = 'atsJobReference',
  CampaignId = 'campaignId',
  CandidateBatchGroupId = 'candidateBatchGroupId',
  CandidateBatchReanalysisReferenceId = 'candidateBatchReanalysisReferenceId',
  CandidatesCount = 'candidatesCount',
  CandidatesRequirementsMetCount = 'candidatesRequirementsMetCount',
  CandidatesRequirementsNotMetCount = 'candidatesRequirementsNotMetCount',
  CandidatesToProcessCount = 'candidatesToProcessCount',
  CreatedAt = 'createdAt',
  CsvS3Key = 'csvS3Key',
  CustomJobPostingUrl = 'customJobPostingUrl',
  CvS3Keys = 'cvS3Keys',
  ExternalId = 'externalId',
  Id = 'id',
  IsInitial = 'isInitial',
  IsRecalculatingScores = 'isRecalculatingScores',
  IsWorkflowManaged = 'isWorkflowManaged',
  JobDescription = 'jobDescription',
  KomboJobId = 'komboJobId',
  OrganizationId = 'organizationId',
  RemainingRescoredCandidatesCount = 'remainingRescoredCandidatesCount',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowNodeSlug = 'workflowNodeSlug',
  WorkflowRunId = 'workflowRunId',
  WorkflowVersionId = 'workflowVersionId'
}

export type SearchableCandidateBatchAggregationInput = {
  field: SearchableCandidateBatchAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCandidateBatchConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CandidateBatch>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateBatchFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateBatchFilterInput>>>;
  atsJobId?: InputMaybe<SearchableIdFilterInput>;
  atsJobPostingId?: InputMaybe<SearchableIdFilterInput>;
  atsJobPostingUrl?: InputMaybe<SearchableStringFilterInput>;
  atsJobReference?: InputMaybe<SearchableStringFilterInput>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateBatchGroupId?: InputMaybe<SearchableIdFilterInput>;
  candidateBatchReanalysisReferenceId?: InputMaybe<SearchableIdFilterInput>;
  candidatesCount?: InputMaybe<SearchableIntFilterInput>;
  candidatesRequirementsMetCount?: InputMaybe<SearchableIntFilterInput>;
  candidatesRequirementsNotMetCount?: InputMaybe<SearchableIntFilterInput>;
  candidatesToProcessCount?: InputMaybe<SearchableIntFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  csvS3Key?: InputMaybe<SearchableStringFilterInput>;
  customJobPostingUrl?: InputMaybe<SearchableStringFilterInput>;
  cvS3Keys?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isInitial?: InputMaybe<SearchableBooleanFilterInput>;
  isRecalculatingScores?: InputMaybe<SearchableBooleanFilterInput>;
  isWorkflowManaged?: InputMaybe<SearchableBooleanFilterInput>;
  jobDescription?: InputMaybe<SearchableStringFilterInput>;
  komboJobId?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableCandidateBatchFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateBatchFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  remainingRescoredCandidatesCount?: InputMaybe<SearchableIntFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowNodeSlug?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
  workflowVersionId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableCandidateBatchSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateBatchSortableFields>;
};

export enum SearchableCandidateBatchSortableFields {
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  AtsJobPostingUrl = 'atsJobPostingUrl',
  AtsJobReference = 'atsJobReference',
  CampaignId = 'campaignId',
  CandidateBatchGroupId = 'candidateBatchGroupId',
  CandidateBatchReanalysisReferenceId = 'candidateBatchReanalysisReferenceId',
  CandidatesCount = 'candidatesCount',
  CandidatesRequirementsMetCount = 'candidatesRequirementsMetCount',
  CandidatesRequirementsNotMetCount = 'candidatesRequirementsNotMetCount',
  CandidatesToProcessCount = 'candidatesToProcessCount',
  CreatedAt = 'createdAt',
  CsvS3Key = 'csvS3Key',
  CustomJobPostingUrl = 'customJobPostingUrl',
  CvS3Keys = 'cvS3Keys',
  ExternalId = 'externalId',
  Id = 'id',
  IsInitial = 'isInitial',
  IsRecalculatingScores = 'isRecalculatingScores',
  IsWorkflowManaged = 'isWorkflowManaged',
  JobDescription = 'jobDescription',
  KomboJobId = 'komboJobId',
  OrganizationId = 'organizationId',
  RemainingRescoredCandidatesCount = 'remainingRescoredCandidatesCount',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowNodeSlug = 'workflowNodeSlug',
  WorkflowRunId = 'workflowRunId',
  WorkflowVersionId = 'workflowVersionId'
}

export type SearchableCandidateConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Candidate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateFilterInput = {
  analysisErrorCode?: InputMaybe<SearchableStringFilterInput>;
  analysisOutcomeActedOnAt?: InputMaybe<SearchableStringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateFilterInput>>>;
  applicationSource?: InputMaybe<SearchableStringFilterInput>;
  atsApplicationId?: InputMaybe<SearchableIdFilterInput>;
  atsApplicationSource?: InputMaybe<SearchableStringFilterInput>;
  atsCandidateId?: InputMaybe<SearchableIdFilterInput>;
  atsInterviewStageId?: InputMaybe<SearchableIdFilterInput>;
  atsJobId?: InputMaybe<SearchableIdFilterInput>;
  atsRejectedReasonId?: InputMaybe<SearchableIdFilterInput>;
  candidateBatchId?: InputMaybe<SearchableIdFilterInput>;
  candidateCvsParsingId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  conversationPreferredAnswersScore?: InputMaybe<SearchableFloatFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  cvParsedText?: InputMaybe<SearchableStringFilterInput>;
  cvS3Key?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  firstName?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isAllRequirementsMet?: InputMaybe<SearchableBooleanFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  isLocked?: InputMaybe<SearchableBooleanFilterInput>;
  isMessagesGenerating?: InputMaybe<SearchableBooleanFilterInput>;
  komboApplicationId?: InputMaybe<SearchableIdFilterInput>;
  komboCandidateId?: InputMaybe<SearchableIdFilterInput>;
  komboJobId?: InputMaybe<SearchableIdFilterInput>;
  komboRejectionReasonId?: InputMaybe<SearchableIdFilterInput>;
  komboStageId?: InputMaybe<SearchableIdFilterInput>;
  lastName?: InputMaybe<SearchableStringFilterInput>;
  linkedInProfileId?: InputMaybe<SearchableStringFilterInput>;
  metRequirementSlugs?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCandidateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  origin?: InputMaybe<SearchableStringFilterInput>;
  phoneNumber?: InputMaybe<SearchableStringFilterInput>;
  skills?: InputMaybe<SearchableStringFilterInput>;
  sourcedCandidateId?: InputMaybe<SearchableIdFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  totalScore?: InputMaybe<SearchableFloatFilterInput>;
  totalScoreScaled?: InputMaybe<SearchableFloatFilterInput>;
  unmetRequirementSlugs?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export enum SearchableCandidateProfileAggregateField {
  AtsApplicationIds = 'atsApplicationIds',
  AtsCandidateId = 'atsCandidateId',
  Awards = 'awards',
  CandidateProfileVectorId = 'candidateProfileVectorId',
  Certifications = 'certifications',
  Company = 'company',
  CreatedAt = 'createdAt',
  CustomFields = 'customFields',
  Email = 'email',
  EmailFromCv = 'emailFromCv',
  Emails = 'emails',
  ExternalId = 'externalId',
  ExternalUrl = 'externalUrl',
  FirstName = 'firstName',
  FirstNameFromCv = 'firstNameFromCv',
  Id = 'id',
  IsDeleted = 'isDeleted',
  KomboApplicationIds = 'komboApplicationIds',
  KomboCandidateId = 'komboCandidateId',
  Languages = 'languages',
  LastName = 'lastName',
  LastNameFromCv = 'lastNameFromCv',
  LatestAtsApplicationDate = 'latestAtsApplicationDate',
  LatestAtsApplicationId = 'latestAtsApplicationId',
  LatestCvS3Key = 'latestCvS3Key',
  LatestCvText = 'latestCvText',
  LatestKomboApplicationId = 'latestKomboApplicationId',
  LinkedInProfileUrl = 'linkedInProfileUrl',
  LinkedInProfileUrlFromCv = 'linkedInProfileUrlFromCv',
  LinksFromCv = 'linksFromCv',
  LocationFromCv = 'locationFromCv',
  Metadata = 'metadata',
  Name = 'name',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  OriginalSource = 'originalSource',
  PhoneNumber = 'phoneNumber',
  PhoneNumberFromCv = 'phoneNumberFromCv',
  PhoneNumbers = 'phoneNumbers',
  ProfessionalSummaryFromCv = 'professionalSummaryFromCv',
  Publications = 'publications',
  Qualifications = 'qualifications',
  QualificationsFromCv = 'qualificationsFromCv',
  Skills = 'skills',
  SkillsFromCv = 'skillsFromCv',
  SocialLinks = 'socialLinks',
  Status = 'status',
  StatusChangedAt = 'statusChangedAt',
  Tags = 'tags',
  Title = 'title',
  TotalExperienceInYears = 'totalExperienceInYears',
  UpdatedAt = 'updatedAt'
}

export type SearchableCandidateProfileAggregationInput = {
  field: SearchableCandidateProfileAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCandidateProfileConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CandidateProfile>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateProfileFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileFilterInput>>>;
  atsApplicationIds?: InputMaybe<SearchableIdFilterInput>;
  atsCandidateId?: InputMaybe<SearchableIdFilterInput>;
  awards?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileVectorId?: InputMaybe<SearchableIdFilterInput>;
  certifications?: InputMaybe<SearchableStringFilterInput>;
  company?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  customFields?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  emailFromCv?: InputMaybe<SearchableStringFilterInput>;
  emails?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  externalUrl?: InputMaybe<SearchableStringFilterInput>;
  firstName?: InputMaybe<SearchableStringFilterInput>;
  firstNameFromCv?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  komboApplicationIds?: InputMaybe<SearchableIdFilterInput>;
  komboCandidateId?: InputMaybe<SearchableIdFilterInput>;
  languages?: InputMaybe<SearchableStringFilterInput>;
  lastName?: InputMaybe<SearchableStringFilterInput>;
  lastNameFromCv?: InputMaybe<SearchableStringFilterInput>;
  latestAtsApplicationDate?: InputMaybe<SearchableStringFilterInput>;
  latestAtsApplicationId?: InputMaybe<SearchableIdFilterInput>;
  latestCvS3Key?: InputMaybe<SearchableStringFilterInput>;
  latestCvText?: InputMaybe<SearchableStringFilterInput>;
  latestKomboApplicationId?: InputMaybe<SearchableIdFilterInput>;
  linkedInProfileUrl?: InputMaybe<SearchableStringFilterInput>;
  linkedInProfileUrlFromCv?: InputMaybe<SearchableStringFilterInput>;
  linksFromCv?: InputMaybe<SearchableStringFilterInput>;
  locationFromCv?: InputMaybe<SearchableStringFilterInput>;
  metadata?: InputMaybe<SearchableStringFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCandidateProfileFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileFilterInput>>>;
  organizationGroupId?: InputMaybe<SearchableIdFilterInput>;
  organizationIds?: InputMaybe<SearchableIdFilterInput>;
  originalSource?: InputMaybe<SearchableStringFilterInput>;
  phoneNumber?: InputMaybe<SearchableStringFilterInput>;
  phoneNumberFromCv?: InputMaybe<SearchableStringFilterInput>;
  phoneNumbers?: InputMaybe<SearchableStringFilterInput>;
  professionalSummaryFromCv?: InputMaybe<SearchableStringFilterInput>;
  publications?: InputMaybe<SearchableStringFilterInput>;
  qualifications?: InputMaybe<SearchableStringFilterInput>;
  qualificationsFromCv?: InputMaybe<SearchableStringFilterInput>;
  skills?: InputMaybe<SearchableStringFilterInput>;
  skillsFromCv?: InputMaybe<SearchableStringFilterInput>;
  socialLinks?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  statusChangedAt?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  totalExperienceInYears?: InputMaybe<SearchableFloatFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export enum SearchableCandidateProfileListAggregateField {
  CandidateProfilesCount = 'candidateProfilesCount',
  CreatedAt = 'createdAt',
  Description = 'description',
  ExternalId = 'externalId',
  Id = 'id',
  LastApiWriteAt = 'lastApiWriteAt',
  OrganizationId = 'organizationId',
  TeamIds = 'teamIds',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type SearchableCandidateProfileListAggregationInput = {
  field: SearchableCandidateProfileListAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCandidateProfileListConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CandidateProfileList>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateProfileListFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileListFilterInput>>>;
  candidateProfilesCount?: InputMaybe<SearchableIntFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  lastApiWriteAt?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCandidateProfileListFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileListFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  teamIds?: InputMaybe<SearchableIdFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableCandidateProfileListSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateProfileListSortableFields>;
};

export enum SearchableCandidateProfileListSortableFields {
  CandidateProfilesCount = 'candidateProfilesCount',
  CreatedAt = 'createdAt',
  Description = 'description',
  ExternalId = 'externalId',
  Id = 'id',
  LastApiWriteAt = 'lastApiWriteAt',
  OrganizationId = 'organizationId',
  TeamIds = 'teamIds',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum SearchableCandidateProfileNoteAggregateField {
  AtsApplicationId = 'atsApplicationId',
  AtsAuthorId = 'atsAuthorId',
  AtsCandidateId = 'atsCandidateId',
  AtsCandidateNoteId = 'atsCandidateNoteId',
  AtsNoteCreatedAt = 'atsNoteCreatedAt',
  AtsNoteDeletedAt = 'atsNoteDeletedAt',
  AtsNoteUpdatedAt = 'atsNoteUpdatedAt',
  CandidateProfileId = 'candidateProfileId',
  Content = 'content',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboCandidateNoteId = 'komboCandidateNoteId',
  Metadata = 'metadata',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type SearchableCandidateProfileNoteAggregationInput = {
  field: SearchableCandidateProfileNoteAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCandidateProfileNoteConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CandidateProfileNote>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateProfileNoteFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileNoteFilterInput>>>;
  atsApplicationId?: InputMaybe<SearchableStringFilterInput>;
  atsAuthorId?: InputMaybe<SearchableStringFilterInput>;
  atsCandidateId?: InputMaybe<SearchableStringFilterInput>;
  atsCandidateNoteId?: InputMaybe<SearchableStringFilterInput>;
  atsNoteCreatedAt?: InputMaybe<SearchableStringFilterInput>;
  atsNoteDeletedAt?: InputMaybe<SearchableStringFilterInput>;
  atsNoteUpdatedAt?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  content?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  komboApplicationId?: InputMaybe<SearchableStringFilterInput>;
  komboCandidateId?: InputMaybe<SearchableStringFilterInput>;
  komboCandidateNoteId?: InputMaybe<SearchableStringFilterInput>;
  metadata?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableCandidateProfileNoteFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateProfileNoteFilterInput>>>;
  organizationGroupId?: InputMaybe<SearchableIdFilterInput>;
  organizationIds?: InputMaybe<SearchableIdFilterInput>;
  type?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableCandidateProfileNoteSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateProfileNoteSortableFields>;
};

export enum SearchableCandidateProfileNoteSortableFields {
  AtsApplicationId = 'atsApplicationId',
  AtsAuthorId = 'atsAuthorId',
  AtsCandidateId = 'atsCandidateId',
  AtsCandidateNoteId = 'atsCandidateNoteId',
  AtsNoteCreatedAt = 'atsNoteCreatedAt',
  AtsNoteDeletedAt = 'atsNoteDeletedAt',
  AtsNoteUpdatedAt = 'atsNoteUpdatedAt',
  CandidateProfileId = 'candidateProfileId',
  Content = 'content',
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDeleted = 'isDeleted',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboCandidateNoteId = 'komboCandidateNoteId',
  Metadata = 'metadata',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  UpdatedAt = 'updatedAt'
}

export type SearchableCandidateProfileSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateProfileSortableFields>;
};

export enum SearchableCandidateProfileSortableFields {
  AtsApplicationIds = 'atsApplicationIds',
  AtsCandidateId = 'atsCandidateId',
  Awards = 'awards',
  CandidateProfileVectorId = 'candidateProfileVectorId',
  Certifications = 'certifications',
  Company = 'company',
  CreatedAt = 'createdAt',
  CustomFields = 'customFields',
  Email = 'email',
  EmailFromCv = 'emailFromCv',
  Emails = 'emails',
  ExternalId = 'externalId',
  ExternalUrl = 'externalUrl',
  FirstName = 'firstName',
  FirstNameFromCv = 'firstNameFromCv',
  Id = 'id',
  IsDeleted = 'isDeleted',
  KomboApplicationIds = 'komboApplicationIds',
  KomboCandidateId = 'komboCandidateId',
  Languages = 'languages',
  LastName = 'lastName',
  LastNameFromCv = 'lastNameFromCv',
  LatestAtsApplicationDate = 'latestAtsApplicationDate',
  LatestAtsApplicationId = 'latestAtsApplicationId',
  LatestCvS3Key = 'latestCvS3Key',
  LatestCvText = 'latestCvText',
  LatestKomboApplicationId = 'latestKomboApplicationId',
  LinkedInProfileUrl = 'linkedInProfileUrl',
  LinkedInProfileUrlFromCv = 'linkedInProfileUrlFromCv',
  LinksFromCv = 'linksFromCv',
  LocationFromCv = 'locationFromCv',
  Metadata = 'metadata',
  Name = 'name',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  OriginalSource = 'originalSource',
  PhoneNumber = 'phoneNumber',
  PhoneNumberFromCv = 'phoneNumberFromCv',
  PhoneNumbers = 'phoneNumbers',
  ProfessionalSummaryFromCv = 'professionalSummaryFromCv',
  Publications = 'publications',
  Qualifications = 'qualifications',
  QualificationsFromCv = 'qualificationsFromCv',
  Skills = 'skills',
  SkillsFromCv = 'skillsFromCv',
  SocialLinks = 'socialLinks',
  StatusChangedAt = 'statusChangedAt',
  Tags = 'tags',
  Title = 'title',
  TotalExperienceInYears = 'totalExperienceInYears',
  UpdatedAt = 'updatedAt'
}

export type SearchableCandidateSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateSortableFields>;
};

export enum SearchableCandidateSortableFields {
  AnalysisOutcomeActedOnAt = 'analysisOutcomeActedOnAt',
  ApplicationSource = 'applicationSource',
  AtsApplicationId = 'atsApplicationId',
  AtsApplicationSource = 'atsApplicationSource',
  AtsCandidateId = 'atsCandidateId',
  AtsInterviewStageId = 'atsInterviewStageId',
  AtsJobId = 'atsJobId',
  AtsRejectedReasonId = 'atsRejectedReasonId',
  CandidateBatchId = 'candidateBatchId',
  CandidateCvsParsingId = 'candidateCvsParsingId',
  CandidateProfileId = 'candidateProfileId',
  ConversationId = 'conversationId',
  ConversationPreferredAnswersScore = 'conversationPreferredAnswersScore',
  CreatedAt = 'createdAt',
  CvParsedText = 'cvParsedText',
  CvS3Key = 'cvS3Key',
  Email = 'email',
  ExternalId = 'externalId',
  FirstName = 'firstName',
  Id = 'id',
  IsAllRequirementsMet = 'isAllRequirementsMet',
  IsDeleted = 'isDeleted',
  IsLocked = 'isLocked',
  IsMessagesGenerating = 'isMessagesGenerating',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboJobId = 'komboJobId',
  KomboRejectionReasonId = 'komboRejectionReasonId',
  KomboStageId = 'komboStageId',
  LastName = 'lastName',
  LinkedInProfileId = 'linkedInProfileId',
  MetRequirementSlugs = 'metRequirementSlugs',
  OrganizationId = 'organizationId',
  PhoneNumber = 'phoneNumber',
  Skills = 'skills',
  SourcedCandidateId = 'sourcedCandidateId',
  Status = 'status',
  TotalScore = 'totalScore',
  TotalScoreScaled = 'totalScoreScaled',
  UnmetRequirementSlugs = 'unmetRequirementSlugs',
  UpdatedAt = 'updatedAt',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableCandidateTagAggregateField {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  ValueNormalized = 'valueNormalized'
}

export type SearchableCandidateTagAggregationInput = {
  field: SearchableCandidateTagAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableCandidateTagConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<CandidateTag>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableCandidateTagFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableCandidateTagFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableCandidateTagFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableCandidateTagFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  value?: InputMaybe<SearchableStringFilterInput>;
  valueNormalized?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableCandidateTagSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableCandidateTagSortableFields>;
};

export enum SearchableCandidateTagSortableFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  Value = 'value',
  ValueNormalized = 'valueNormalized'
}

export enum SearchableConversationAggregateField {
  ActiveChannel = 'activeChannel',
  AdditionalContext = 'additionalContext',
  AgentId = 'agentId',
  ApplicationSource = 'applicationSource',
  ApplicationStage = 'applicationStage',
  AtsApplicationId = 'atsApplicationId',
  AtsCandidateId = 'atsCandidateId',
  AtsInterviewStageId = 'atsInterviewStageId',
  AtsRejectedReasonId = 'atsRejectedReasonId',
  CalendarBookingId = 'calendarBookingId',
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignId = 'campaignId',
  CandidateId = 'candidateId',
  CandidateProfileId = 'candidateProfileId',
  ClosePreviousConversations = 'closePreviousConversations',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CrmContactId = 'crmContactId',
  CurrentQuestionId = 'currentQuestionId',
  DisableNudging = 'disableNudging',
  EmailPrefix = 'emailPrefix',
  ErrorCode = 'errorCode',
  ExternalId = 'externalId',
  FirstQuestionHasBeenAsked = 'firstQuestionHasBeenAsked',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsHumanTakeover = 'isHumanTakeover',
  IsInbound = 'isInbound',
  IsInitialEmailMessageOpened = 'isInitialEmailMessageOpened',
  IsRead = 'isRead',
  IsWebChatJoined = 'isWebChatJoined',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboRejectionReasonId = 'komboRejectionReasonId',
  KomboStageId = 'komboStageId',
  MeetingBookingStatus = 'meetingBookingStatus',
  MessagesCount = 'messagesCount',
  NeedsReview = 'needsReview',
  NudgesSentCount = 'nudgesSentCount',
  OpeningMessage = 'openingMessage',
  OrganizationId = 'organizationId',
  ParticipantEmailAddress = 'participantEmailAddress',
  ParticipantFirstName = 'participantFirstName',
  ParticipantLastName = 'participantLastName',
  ParticipantLinkedInProfile = 'participantLinkedInProfile',
  ParticipantPhoneNumber = 'participantPhoneNumber',
  PastOngoingConversationId = 'pastOngoingConversationId',
  PreferredAnswersScore = 'preferredAnswersScore',
  RepliesCount = 'repliesCount',
  SentAt = 'sentAt',
  SourcedCandidateId = 'sourcedCandidateId',
  Stage = 'stage',
  Status = 'status',
  Tags = 'tags',
  TagsNormalized = 'tagsNormalized',
  TimeToComplete = 'timeToComplete',
  TimeToFirstResponse = 'timeToFirstResponse',
  TotalNudgesSentCount = 'totalNudgesSentCount',
  TwilioConversationId = 'twilioConversationId',
  TwilioParticipantId = 'twilioParticipantId',
  TwilioRedirectConversationId = 'twilioRedirectConversationId',
  TwilioRedirectParticipantId = 'twilioRedirectParticipantId',
  UnresolvedNeedsReviewReasons = 'unresolvedNeedsReviewReasons',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WebChatUrlId = 'webChatUrlId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableConversationAggregationInput = {
  field: SearchableConversationAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableConversationConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Conversation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableConversationFilterInput = {
  activeChannel?: InputMaybe<SearchableStringFilterInput>;
  additionalContext?: InputMaybe<SearchableStringFilterInput>;
  agentId?: InputMaybe<SearchableIdFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableConversationFilterInput>>>;
  applicationSource?: InputMaybe<SearchableStringFilterInput>;
  applicationStage?: InputMaybe<SearchableStringFilterInput>;
  atsApplicationId?: InputMaybe<SearchableIdFilterInput>;
  atsCandidateId?: InputMaybe<SearchableIdFilterInput>;
  atsInterviewStageId?: InputMaybe<SearchableIdFilterInput>;
  atsRejectedReasonId?: InputMaybe<SearchableIdFilterInput>;
  calendarBookingId?: InputMaybe<SearchableIdFilterInput>;
  calendarMeetingTemplateId?: InputMaybe<SearchableIdFilterInput>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  closePreviousConversations?: InputMaybe<SearchableBooleanFilterInput>;
  completedAt?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  crmContactId?: InputMaybe<SearchableIdFilterInput>;
  currentQuestionId?: InputMaybe<SearchableStringFilterInput>;
  disableNudging?: InputMaybe<SearchableBooleanFilterInput>;
  emailPrefix?: InputMaybe<SearchableStringFilterInput>;
  errorCode?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  firstQuestionHasBeenAsked?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  isHumanTakeover?: InputMaybe<SearchableBooleanFilterInput>;
  isInbound?: InputMaybe<SearchableBooleanFilterInput>;
  isInitialEmailMessageOpened?: InputMaybe<SearchableBooleanFilterInput>;
  isRead?: InputMaybe<SearchableBooleanFilterInput>;
  isWebChatJoined?: InputMaybe<SearchableBooleanFilterInput>;
  komboApplicationId?: InputMaybe<SearchableIdFilterInput>;
  komboCandidateId?: InputMaybe<SearchableIdFilterInput>;
  komboRejectionReasonId?: InputMaybe<SearchableIdFilterInput>;
  komboStageId?: InputMaybe<SearchableIdFilterInput>;
  meetingBookingStatus?: InputMaybe<SearchableStringFilterInput>;
  messagesCount?: InputMaybe<SearchableIntFilterInput>;
  needsReview?: InputMaybe<SearchableBooleanFilterInput>;
  not?: InputMaybe<SearchableConversationFilterInput>;
  nudgesSentCount?: InputMaybe<SearchableIntFilterInput>;
  openingMessage?: InputMaybe<SearchableStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableConversationFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  participantEmailAddress?: InputMaybe<SearchableStringFilterInput>;
  participantFirstName?: InputMaybe<SearchableStringFilterInput>;
  participantLastName?: InputMaybe<SearchableStringFilterInput>;
  participantLinkedInProfile?: InputMaybe<SearchableStringFilterInput>;
  participantPhoneNumber?: InputMaybe<SearchableStringFilterInput>;
  pastOngoingConversationId?: InputMaybe<SearchableIdFilterInput>;
  preferredAnswersScore?: InputMaybe<SearchableFloatFilterInput>;
  repliesCount?: InputMaybe<SearchableIntFilterInput>;
  sentAt?: InputMaybe<SearchableStringFilterInput>;
  sourcedCandidateId?: InputMaybe<SearchableIdFilterInput>;
  stage?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
  tagsNormalized?: InputMaybe<SearchableStringFilterInput>;
  timeToComplete?: InputMaybe<SearchableFloatFilterInput>;
  timeToFirstResponse?: InputMaybe<SearchableFloatFilterInput>;
  totalNudgesSentCount?: InputMaybe<SearchableIntFilterInput>;
  twilioConversationId?: InputMaybe<SearchableStringFilterInput>;
  twilioParticipantId?: InputMaybe<SearchableStringFilterInput>;
  twilioRedirectConversationId?: InputMaybe<SearchableIdFilterInput>;
  twilioRedirectParticipantId?: InputMaybe<SearchableIdFilterInput>;
  unresolvedNeedsReviewReasons?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
  webChatUrlId?: InputMaybe<SearchableStringFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableConversationSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableConversationSortableFields>;
};

export enum SearchableConversationSortableFields {
  AdditionalContext = 'additionalContext',
  AgentId = 'agentId',
  ApplicationSource = 'applicationSource',
  ApplicationStage = 'applicationStage',
  AtsApplicationId = 'atsApplicationId',
  AtsCandidateId = 'atsCandidateId',
  AtsInterviewStageId = 'atsInterviewStageId',
  AtsRejectedReasonId = 'atsRejectedReasonId',
  CalendarBookingId = 'calendarBookingId',
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  CampaignId = 'campaignId',
  CandidateId = 'candidateId',
  CandidateProfileId = 'candidateProfileId',
  ClosePreviousConversations = 'closePreviousConversations',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CrmContactId = 'crmContactId',
  CurrentQuestionId = 'currentQuestionId',
  DisableNudging = 'disableNudging',
  EmailPrefix = 'emailPrefix',
  ExternalId = 'externalId',
  FirstQuestionHasBeenAsked = 'firstQuestionHasBeenAsked',
  Id = 'id',
  IsDeleted = 'isDeleted',
  IsHumanTakeover = 'isHumanTakeover',
  IsInbound = 'isInbound',
  IsInitialEmailMessageOpened = 'isInitialEmailMessageOpened',
  IsRead = 'isRead',
  IsWebChatJoined = 'isWebChatJoined',
  KomboApplicationId = 'komboApplicationId',
  KomboCandidateId = 'komboCandidateId',
  KomboRejectionReasonId = 'komboRejectionReasonId',
  KomboStageId = 'komboStageId',
  MessagesCount = 'messagesCount',
  NeedsReview = 'needsReview',
  NudgesSentCount = 'nudgesSentCount',
  OpeningMessage = 'openingMessage',
  OrganizationId = 'organizationId',
  ParticipantEmailAddress = 'participantEmailAddress',
  ParticipantFirstName = 'participantFirstName',
  ParticipantLastName = 'participantLastName',
  ParticipantLinkedInProfile = 'participantLinkedInProfile',
  ParticipantPhoneNumber = 'participantPhoneNumber',
  PastOngoingConversationId = 'pastOngoingConversationId',
  PreferredAnswersScore = 'preferredAnswersScore',
  RepliesCount = 'repliesCount',
  SentAt = 'sentAt',
  SourcedCandidateId = 'sourcedCandidateId',
  Tags = 'tags',
  TagsNormalized = 'tagsNormalized',
  TimeToComplete = 'timeToComplete',
  TimeToFirstResponse = 'timeToFirstResponse',
  TotalNudgesSentCount = 'totalNudgesSentCount',
  TwilioConversationId = 'twilioConversationId',
  TwilioParticipantId = 'twilioParticipantId',
  TwilioRedirectConversationId = 'twilioRedirectConversationId',
  TwilioRedirectParticipantId = 'twilioRedirectParticipantId',
  UnresolvedNeedsReviewReasons = 'unresolvedNeedsReviewReasons',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  WebChatUrlId = 'webChatUrlId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableDocumentTypeAggregateField {
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  Id = 'id',
  IsArchived = 'isArchived',
  IsUsedInCampaign = 'isUsedInCampaign',
  Name = 'name',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  Validation = 'validation',
  ValidationSettings = 'validationSettings'
}

export type SearchableDocumentTypeAggregationInput = {
  field: SearchableDocumentTypeAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableDocumentTypeConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<DocumentType>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableDocumentTypeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableDocumentTypeFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isArchived?: InputMaybe<SearchableBooleanFilterInput>;
  isUsedInCampaign?: InputMaybe<SearchableBooleanFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableDocumentTypeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableDocumentTypeFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  validation?: InputMaybe<SearchableStringFilterInput>;
  validationSettings?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableDocumentTypeSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableDocumentTypeSortableFields>;
};

export enum SearchableDocumentTypeSortableFields {
  CreatedAt = 'createdAt',
  ExternalId = 'externalId',
  Id = 'id',
  IsArchived = 'isArchived',
  IsUsedInCampaign = 'isUsedInCampaign',
  Name = 'name',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  ValidationSettings = 'validationSettings'
}

export type SearchableFloatFilterInput = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type SearchableIdFilterInput = {
  eq?: InputMaybe<Scalars['ID']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  match?: InputMaybe<Scalars['ID']['input']>;
  matchPhrase?: InputMaybe<Scalars['ID']['input']>;
  matchPhrasePrefix?: InputMaybe<Scalars['ID']['input']>;
  multiMatch?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  regexp?: InputMaybe<Scalars['ID']['input']>;
  wildcard?: InputMaybe<Scalars['ID']['input']>;
};

export type SearchableIntFilterInput = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export enum SearchableJobPostingAggregateField {
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  CreatedAt = 'createdAt',
  Id = 'id',
  JobDescription = 'jobDescription',
  JobPostingUrl = 'jobPostingUrl',
  JobTitle = 'jobTitle',
  KomboJobId = 'komboJobId',
  NormalisedJobDescription = 'normalisedJobDescription',
  OrganizationId = 'organizationId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SearchableJobPostingAggregationInput = {
  field: SearchableJobPostingAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableJobPostingConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<JobPosting>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableJobPostingFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableJobPostingFilterInput>>>;
  atsJobId?: InputMaybe<SearchableIdFilterInput>;
  atsJobPostingId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  jobDescription?: InputMaybe<SearchableStringFilterInput>;
  jobPostingUrl?: InputMaybe<SearchableStringFilterInput>;
  jobTitle?: InputMaybe<SearchableStringFilterInput>;
  komboJobId?: InputMaybe<SearchableIdFilterInput>;
  normalisedJobDescription?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableJobPostingFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableJobPostingFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableJobPostingSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableJobPostingSortableFields>;
};

export enum SearchableJobPostingSortableFields {
  AtsJobId = 'atsJobId',
  AtsJobPostingId = 'atsJobPostingId',
  CreatedAt = 'createdAt',
  Id = 'id',
  JobDescription = 'jobDescription',
  JobPostingUrl = 'jobPostingUrl',
  JobTitle = 'jobTitle',
  KomboJobId = 'komboJobId',
  NormalisedJobDescription = 'normalisedJobDescription',
  OrganizationId = 'organizationId',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export enum SearchableQualificationAggregateField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Qualification = 'qualification',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export type SearchableQualificationAggregationInput = {
  field: SearchableQualificationAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableQualificationConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Qualification>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableQualificationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableQualificationFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableQualificationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableQualificationFilterInput>>>;
  qualification?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  vectorDbTenantName?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableQualificationSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableQualificationSortableFields>;
};

export enum SearchableQualificationSortableFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Qualification = 'qualification',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export enum SearchableQuestionOutcomeAggregateField {
  AgentMessageId = 'agentMessageId',
  AnswerPolarity = 'answerPolarity',
  AnswerState = 'answerState',
  AnswerSummary = 'answerSummary',
  AnswerText = 'answerText',
  CampaignId = 'campaignId',
  CandidateProfileId = 'candidateProfileId',
  ClassifiedDocumentString = 'classifiedDocumentString',
  ClassifiedDocumentType = 'classifiedDocumentType',
  ClassifiedDocumentTypeId = 'classifiedDocumentTypeId',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  DocumentFileName = 'documentFileName',
  DocumentS3Key = 'documentS3Key',
  DocumentTwilioMediaSid = 'documentTwilioMediaSid',
  EvaluationResult = 'evaluationResult',
  Evidence = 'evidence',
  Id = 'id',
  IsMet = 'isMet',
  NeededReview = 'neededReview',
  NeededReviewReason = 'neededReviewReason',
  OrganizationId = 'organizationId',
  OutreachQuestionId = 'outreachQuestionId',
  ProspectMessageId = 'prospectMessageId',
  QuestionContent = 'questionContent',
  QuestionSlug = 'questionSlug',
  RouteTaken = 'routeTaken',
  Score = 'score',
  TrafficLight = 'trafficLight',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableQuestionOutcomeAggregationInput = {
  field: SearchableQuestionOutcomeAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableQuestionOutcomeConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<QuestionOutcome>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableQuestionOutcomeFilterInput = {
  agentMessageId?: InputMaybe<SearchableIdFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableQuestionOutcomeFilterInput>>>;
  answerPolarity?: InputMaybe<SearchableStringFilterInput>;
  answerState?: InputMaybe<SearchableStringFilterInput>;
  answerSummary?: InputMaybe<SearchableStringFilterInput>;
  answerText?: InputMaybe<SearchableStringFilterInput>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  classifiedDocumentString?: InputMaybe<SearchableStringFilterInput>;
  classifiedDocumentType?: InputMaybe<SearchableStringFilterInput>;
  classifiedDocumentTypeId?: InputMaybe<SearchableIdFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  documentFileName?: InputMaybe<SearchableStringFilterInput>;
  documentS3Key?: InputMaybe<SearchableStringFilterInput>;
  documentTwilioMediaSid?: InputMaybe<SearchableStringFilterInput>;
  evaluationResult?: InputMaybe<SearchableStringFilterInput>;
  evidence?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isMet?: InputMaybe<SearchableBooleanFilterInput>;
  neededReview?: InputMaybe<SearchableBooleanFilterInput>;
  neededReviewReason?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableQuestionOutcomeFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableQuestionOutcomeFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  outreachQuestionId?: InputMaybe<SearchableIdFilterInput>;
  prospectMessageId?: InputMaybe<SearchableIdFilterInput>;
  questionContent?: InputMaybe<SearchableStringFilterInput>;
  questionSlug?: InputMaybe<SearchableStringFilterInput>;
  routeTaken?: InputMaybe<SearchableStringFilterInput>;
  score?: InputMaybe<SearchableFloatFilterInput>;
  trafficLight?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableQuestionOutcomeSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableQuestionOutcomeSortableFields>;
};

export enum SearchableQuestionOutcomeSortableFields {
  AgentMessageId = 'agentMessageId',
  AnswerPolarity = 'answerPolarity',
  AnswerSummary = 'answerSummary',
  AnswerText = 'answerText',
  CampaignId = 'campaignId',
  CandidateProfileId = 'candidateProfileId',
  ClassifiedDocumentString = 'classifiedDocumentString',
  ClassifiedDocumentType = 'classifiedDocumentType',
  ClassifiedDocumentTypeId = 'classifiedDocumentTypeId',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  DocumentFileName = 'documentFileName',
  DocumentS3Key = 'documentS3Key',
  DocumentTwilioMediaSid = 'documentTwilioMediaSid',
  Evidence = 'evidence',
  Id = 'id',
  IsMet = 'isMet',
  NeededReview = 'neededReview',
  NeededReviewReason = 'neededReviewReason',
  OrganizationId = 'organizationId',
  OutreachQuestionId = 'outreachQuestionId',
  ProspectMessageId = 'prospectMessageId',
  QuestionContent = 'questionContent',
  QuestionSlug = 'questionSlug',
  RouteTaken = 'routeTaken',
  Score = 'score',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableSearchCandidateProfileQueryAggregateField {
  AppliedFilter = 'appliedFilter',
  AtsCandidateId = 'ats_candidate_id',
  CandidateProfileListIds = 'candidate_profile_list_ids',
  CreatedAt = 'createdAt',
  CurrentCompany = 'current_company',
  CurrentJobTitle = 'current_job_title',
  DisplayTitle = 'displayTitle',
  Email = 'email',
  Filter = 'filter',
  FullName = 'full_name',
  GeneratedFilter = 'generatedFilter',
  GeoRadius = 'geo_radius',
  Id = 'id',
  IsArchived = 'isArchived',
  IsPinned = 'isPinned',
  OrganizationId = 'organizationId',
  OriginalSource = 'original_source',
  Phone = 'phone',
  Qualifications = 'qualifications',
  ReturnedCandidatesCount = 'returnedCandidatesCount',
  Skills = 'skills',
  Tags = 'tags',
  TimeInRole = 'time_in_role',
  TotalYearsOfExperience = 'total_years_of_experience',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type SearchableSearchCandidateProfileQueryAggregationInput = {
  field: SearchableSearchCandidateProfileQueryAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableSearchCandidateProfileQueryConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<SearchCandidateProfileQuery>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableSearchCandidateProfileQueryFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableSearchCandidateProfileQueryFilterInput>>>;
  appliedFilter?: InputMaybe<SearchableStringFilterInput>;
  ats_candidate_id?: InputMaybe<SearchableStringFilterInput>;
  candidate_profile_list_ids?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  current_company?: InputMaybe<SearchableStringFilterInput>;
  current_job_title?: InputMaybe<SearchableStringFilterInput>;
  displayTitle?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  filter?: InputMaybe<SearchableStringFilterInput>;
  full_name?: InputMaybe<SearchableStringFilterInput>;
  generatedFilter?: InputMaybe<SearchableStringFilterInput>;
  geo_radius?: InputMaybe<SearchableFloatFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isArchived?: InputMaybe<SearchableBooleanFilterInput>;
  isPinned?: InputMaybe<SearchableBooleanFilterInput>;
  not?: InputMaybe<SearchableSearchCandidateProfileQueryFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSearchCandidateProfileQueryFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  original_source?: InputMaybe<SearchableStringFilterInput>;
  phone?: InputMaybe<SearchableStringFilterInput>;
  qualifications?: InputMaybe<SearchableStringFilterInput>;
  returnedCandidatesCount?: InputMaybe<SearchableIntFilterInput>;
  skills?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
  time_in_role?: InputMaybe<SearchableStringFilterInput>;
  total_years_of_experience?: InputMaybe<SearchableFloatFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableSearchCandidateProfileQuerySortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableSearchCandidateProfileQuerySortableFields>;
};

export enum SearchableSearchCandidateProfileQuerySortableFields {
  AppliedFilter = 'appliedFilter',
  AtsCandidateId = 'ats_candidate_id',
  CandidateProfileListIds = 'candidate_profile_list_ids',
  CreatedAt = 'createdAt',
  CurrentCompany = 'current_company',
  CurrentJobTitle = 'current_job_title',
  DisplayTitle = 'displayTitle',
  Email = 'email',
  Filter = 'filter',
  FullName = 'full_name',
  GeneratedFilter = 'generatedFilter',
  GeoRadius = 'geo_radius',
  Id = 'id',
  IsArchived = 'isArchived',
  IsPinned = 'isPinned',
  OrganizationId = 'organizationId',
  OriginalSource = 'original_source',
  Phone = 'phone',
  Qualifications = 'qualifications',
  ReturnedCandidatesCount = 'returnedCandidatesCount',
  Skills = 'skills',
  Tags = 'tags',
  TotalYearsOfExperience = 'total_years_of_experience',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export enum SearchableSkillAggregateField {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  NormalizedSkill = 'normalizedSkill',
  Skill = 'skill',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export type SearchableSkillAggregationInput = {
  field: SearchableSkillAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableSkillConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Skill>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableSkillFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableSkillFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  normalizedSkill?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableSkillFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSkillFilterInput>>>;
  skill?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  vectorDbTenantName?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableSkillSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableSkillSortableFields>;
};

export enum SearchableSkillSortableFields {
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  NormalizedSkill = 'normalizedSkill',
  Skill = 'skill',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export enum SearchableSortDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export enum SearchableSourcedCandidateAggregateField {
  CampaignId = 'campaignId',
  CandidateBatchId = 'candidateBatchId',
  CandidateId = 'candidateId',
  CandidateProfileId = 'candidateProfileId',
  CandidateRelevance = 'candidateRelevance',
  ContactOutRawData = 'contactOutRawData',
  ConversationId = 'conversationId',
  ConversationNeedsReview = 'conversationNeedsReview',
  ConversationRepliesCount = 'conversationRepliesCount',
  ConversationStatus = 'conversationStatus',
  CreatedAt = 'createdAt',
  CustomInvitationMessage = 'customInvitationMessage',
  Education = 'education',
  Email = 'email',
  Experience = 'experience',
  FetchPhoneNumberAttempted = 'fetchPhoneNumberAttempted',
  FirstName = 'firstName',
  FullName = 'fullName',
  Id = 'id',
  IsDeleted = 'isDeleted',
  LastName = 'lastName',
  LinkedInProfileUrl = 'linkedInProfileUrl',
  Location = 'location',
  OrganizationId = 'organizationId',
  PersonalEmails = 'personalEmails',
  PhoneNumber = 'phoneNumber',
  Skills = 'skills',
  Source = 'source',
  Status = 'status',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  WorkEmails = 'workEmails',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableSourcedCandidateAggregationInput = {
  field: SearchableSourcedCandidateAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableSourcedCandidateConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<SourcedCandidate>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableSourcedCandidateFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableSourcedCandidateFilterInput>>>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateBatchId?: InputMaybe<SearchableIdFilterInput>;
  candidateId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  candidateRelevance?: InputMaybe<SearchableStringFilterInput>;
  contactOutRawData?: InputMaybe<SearchableStringFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  conversationNeedsReview?: InputMaybe<SearchableBooleanFilterInput>;
  conversationRepliesCount?: InputMaybe<SearchableIntFilterInput>;
  conversationStatus?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  customInvitationMessage?: InputMaybe<SearchableStringFilterInput>;
  education?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  experience?: InputMaybe<SearchableStringFilterInput>;
  fetchPhoneNumberAttempted?: InputMaybe<SearchableBooleanFilterInput>;
  firstName?: InputMaybe<SearchableStringFilterInput>;
  fullName?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  lastName?: InputMaybe<SearchableStringFilterInput>;
  linkedInProfileUrl?: InputMaybe<SearchableStringFilterInput>;
  location?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableSourcedCandidateFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableSourcedCandidateFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  personalEmails?: InputMaybe<SearchableStringFilterInput>;
  phoneNumber?: InputMaybe<SearchableStringFilterInput>;
  skills?: InputMaybe<SearchableStringFilterInput>;
  source?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  title?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workEmails?: InputMaybe<SearchableStringFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableSourcedCandidateSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableSourcedCandidateSortableFields>;
};

export enum SearchableSourcedCandidateSortableFields {
  CampaignId = 'campaignId',
  CandidateBatchId = 'candidateBatchId',
  CandidateId = 'candidateId',
  CandidateProfileId = 'candidateProfileId',
  CandidateRelevance = 'candidateRelevance',
  ContactOutRawData = 'contactOutRawData',
  ConversationId = 'conversationId',
  ConversationNeedsReview = 'conversationNeedsReview',
  ConversationRepliesCount = 'conversationRepliesCount',
  CreatedAt = 'createdAt',
  CustomInvitationMessage = 'customInvitationMessage',
  Education = 'education',
  Email = 'email',
  Experience = 'experience',
  FetchPhoneNumberAttempted = 'fetchPhoneNumberAttempted',
  FirstName = 'firstName',
  FullName = 'fullName',
  Id = 'id',
  IsDeleted = 'isDeleted',
  LastName = 'lastName',
  LinkedInProfileUrl = 'linkedInProfileUrl',
  Location = 'location',
  OrganizationId = 'organizationId',
  PersonalEmails = 'personalEmails',
  PhoneNumber = 'phoneNumber',
  Skills = 'skills',
  Title = 'title',
  UpdatedAt = 'updatedAt',
  WorkEmails = 'workEmails',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableStringFilterInput = {
  eq?: InputMaybe<Scalars['String']['input']>;
  exists?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  match?: InputMaybe<Scalars['String']['input']>;
  matchPhrase?: InputMaybe<Scalars['String']['input']>;
  matchPhrasePrefix?: InputMaybe<Scalars['String']['input']>;
  multiMatch?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  range?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  regexp?: InputMaybe<Scalars['String']['input']>;
  wildcard?: InputMaybe<Scalars['String']['input']>;
};

export enum SearchableTagAggregateField {
  CreatedAt = 'createdAt',
  Id = 'id',
  Tag = 'tag',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export type SearchableTagAggregationInput = {
  field: SearchableTagAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableTagConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Tag>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableTagFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableTagFilterInput>>>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableTagFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableTagFilterInput>>>;
  tag?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  vectorDbTenantName?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableTagSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableTagSortableFields>;
};

export enum SearchableTagSortableFields {
  CreatedAt = 'createdAt',
  Id = 'id',
  Tag = 'tag',
  UpdatedAt = 'updatedAt',
  VectorDbTenantName = 'vectorDbTenantName'
}

export enum SearchableUserCalendarAggregateField {
  AvailabilityRedirectCalendarId = 'availabilityRedirectCalendarId',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Email = 'email',
  Id = 'id',
  InvitedEmail = 'invitedEmail',
  IsSharedMailbox = 'isSharedMailbox',
  Name = 'name',
  NylasGrantId = 'nylasGrantId',
  NylasVirtualCalendarId = 'nylasVirtualCalendarId',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  Provider = 'provider',
  Reference = 'reference',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SearchableUserCalendarAggregationInput = {
  field: SearchableUserCalendarAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableUserCalendarConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<UserCalendar>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableUserCalendarFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableUserCalendarFilterInput>>>;
  availabilityRedirectCalendarId?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  createdByUserId?: InputMaybe<SearchableIdFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  invitedEmail?: InputMaybe<SearchableStringFilterInput>;
  isSharedMailbox?: InputMaybe<SearchableBooleanFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableUserCalendarFilterInput>;
  nylasGrantId?: InputMaybe<SearchableStringFilterInput>;
  nylasVirtualCalendarId?: InputMaybe<SearchableStringFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableUserCalendarFilterInput>>>;
  organizationGroupId?: InputMaybe<SearchableIdFilterInput>;
  organizationIds?: InputMaybe<SearchableIdFilterInput>;
  provider?: InputMaybe<SearchableStringFilterInput>;
  reference?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export type SearchableUserCalendarSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableUserCalendarSortableFields>;
};

export enum SearchableUserCalendarSortableFields {
  AvailabilityRedirectCalendarId = 'availabilityRedirectCalendarId',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Email = 'email',
  Id = 'id',
  InvitedEmail = 'invitedEmail',
  IsSharedMailbox = 'isSharedMailbox',
  Name = 'name',
  NylasGrantId = 'nylasGrantId',
  NylasVirtualCalendarId = 'nylasVirtualCalendarId',
  OrganizationGroupId = 'organizationGroupId',
  OrganizationIds = 'organizationIds',
  Reference = 'reference',
  UpdatedAt = 'updatedAt'
}

export enum SearchableVirtualCalendarConversationAggregateField {
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  ConversationId = 'conversationId',
  ConversationStage = 'conversationStage',
  ConversationStatus = 'conversationStatus',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  UserCalendarId = 'userCalendarId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableVirtualCalendarConversationAggregationInput = {
  field: SearchableVirtualCalendarConversationAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableVirtualCalendarConversationConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<VirtualCalendarConversation>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableVirtualCalendarConversationFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableVirtualCalendarConversationFilterInput>>>;
  calendarMeetingTemplateId?: InputMaybe<SearchableIdFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  conversationStage?: InputMaybe<SearchableStringFilterInput>;
  conversationStatus?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableVirtualCalendarConversationFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableVirtualCalendarConversationFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  userCalendarId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableVirtualCalendarConversationSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableVirtualCalendarConversationSortableFields>;
};

export enum SearchableVirtualCalendarConversationSortableFields {
  CalendarMeetingTemplateId = 'calendarMeetingTemplateId',
  ConversationId = 'conversationId',
  CreatedAt = 'createdAt',
  Id = 'id',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  UserCalendarId = 'userCalendarId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableWorkflowAggregateField {
  ApiModifiedDate = 'apiModifiedDate',
  CanvasVisualConfiguration = 'canvasVisualConfiguration',
  CanvasVisualConfigurationModifiedDate = 'canvasVisualConfigurationModifiedDate',
  Configuration = 'configuration',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Description = 'description',
  EmbeddedAtsJobId = 'embeddedAtsJobId',
  EntrySources = 'entrySources',
  ExternalId = 'externalId',
  Id = 'id',
  LiveWorkflowVersionId = 'liveWorkflowVersionId',
  Name = 'name',
  OrganizationId = 'organizationId',
  Settings = 'settings',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type SearchableWorkflowAggregationInput = {
  field: SearchableWorkflowAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableWorkflowConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<Workflow>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export enum SearchableWorkflowContactAggregateField {
  AlreadyEnrolledRunId = 'alreadyEnrolledRunId',
  CandidateProfileId = 'candidateProfileId',
  CreatedAt = 'createdAt',
  DedupKey = 'dedupKey',
  Email = 'email',
  EnrolmentFailureReason = 'enrolmentFailureReason',
  EntrySource = 'entrySource',
  ExternalId = 'externalId',
  FirstName = 'firstName',
  Id = 'id',
  IsDeleted = 'isDeleted',
  LastName = 'lastName',
  OrganizationId = 'organizationId',
  PhoneNumber = 'phoneNumber',
  RowNumber = 'rowNumber',
  SourceRow = 'sourceRow',
  Status = 'status',
  Tags = 'tags',
  UpdatedAt = 'updatedAt',
  ValidationErrors = 'validationErrors',
  WorkflowContactImportId = 'workflowContactImportId',
  WorkflowId = 'workflowId',
  WorkflowRunId = 'workflowRunId'
}

export type SearchableWorkflowContactAggregationInput = {
  field: SearchableWorkflowContactAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableWorkflowContactConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<WorkflowContact>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableWorkflowContactFilterInput = {
  alreadyEnrolledRunId?: InputMaybe<SearchableIdFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableWorkflowContactFilterInput>>>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  dedupKey?: InputMaybe<SearchableStringFilterInput>;
  email?: InputMaybe<SearchableStringFilterInput>;
  enrolmentFailureReason?: InputMaybe<SearchableStringFilterInput>;
  entrySource?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  firstName?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  isDeleted?: InputMaybe<SearchableBooleanFilterInput>;
  lastName?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableWorkflowContactFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableWorkflowContactFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  phoneNumber?: InputMaybe<SearchableStringFilterInput>;
  rowNumber?: InputMaybe<SearchableIntFilterInput>;
  sourceRow?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  validationErrors?: InputMaybe<SearchableStringFilterInput>;
  workflowContactImportId?: InputMaybe<SearchableIdFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableWorkflowContactSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableWorkflowContactSortableFields>;
};

export enum SearchableWorkflowContactSortableFields {
  AlreadyEnrolledRunId = 'alreadyEnrolledRunId',
  CandidateProfileId = 'candidateProfileId',
  CreatedAt = 'createdAt',
  DedupKey = 'dedupKey',
  Email = 'email',
  ExternalId = 'externalId',
  FirstName = 'firstName',
  Id = 'id',
  IsDeleted = 'isDeleted',
  LastName = 'lastName',
  OrganizationId = 'organizationId',
  PhoneNumber = 'phoneNumber',
  RowNumber = 'rowNumber',
  SourceRow = 'sourceRow',
  Tags = 'tags',
  UpdatedAt = 'updatedAt',
  ValidationErrors = 'validationErrors',
  WorkflowContactImportId = 'workflowContactImportId',
  WorkflowId = 'workflowId',
  WorkflowRunId = 'workflowRunId'
}

export enum SearchableWorkflowEventAggregateField {
  AnalysedApplicationId = 'analysedApplicationId',
  CalendarBookingId = 'calendarBookingId',
  CampaignId = 'campaignId',
  CandidateBatchId = 'candidateBatchId',
  CandidateProfileId = 'candidateProfileId',
  CausationId = 'causationId',
  ContextSnapshot = 'contextSnapshot',
  ConversationId = 'conversationId',
  CorrelationId = 'correlationId',
  CreatedAt = 'createdAt',
  EventData = 'eventData',
  EventSource = 'eventSource',
  EventType = 'eventType',
  EventVersion = 'eventVersion',
  FailureReason = 'failureReason',
  Id = 'id',
  MessageId = 'messageId',
  OrganizationId = 'organizationId',
  ProcessedAt = 'processedAt',
  PublishedAt = 'publishedAt',
  RetryCount = 'retryCount',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  WorkflowExternalId = 'workflowExternalId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId',
  WorkflowVersionId = 'workflowVersionId'
}

export type SearchableWorkflowEventAggregationInput = {
  field: SearchableWorkflowEventAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableWorkflowEventConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<WorkflowEvent>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableWorkflowEventFilterInput = {
  analysedApplicationId?: InputMaybe<SearchableIdFilterInput>;
  and?: InputMaybe<Array<InputMaybe<SearchableWorkflowEventFilterInput>>>;
  calendarBookingId?: InputMaybe<SearchableIdFilterInput>;
  campaignId?: InputMaybe<SearchableIdFilterInput>;
  candidateBatchId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  causationId?: InputMaybe<SearchableStringFilterInput>;
  contextSnapshot?: InputMaybe<SearchableStringFilterInput>;
  conversationId?: InputMaybe<SearchableIdFilterInput>;
  correlationId?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  eventData?: InputMaybe<SearchableStringFilterInput>;
  eventSource?: InputMaybe<SearchableStringFilterInput>;
  eventType?: InputMaybe<SearchableStringFilterInput>;
  eventVersion?: InputMaybe<SearchableStringFilterInput>;
  failureReason?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  messageId?: InputMaybe<SearchableIdFilterInput>;
  not?: InputMaybe<SearchableWorkflowEventFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableWorkflowEventFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  processedAt?: InputMaybe<SearchableStringFilterInput>;
  publishedAt?: InputMaybe<SearchableStringFilterInput>;
  retryCount?: InputMaybe<SearchableIntFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowExternalId?: InputMaybe<SearchableStringFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowNodeId?: InputMaybe<SearchableStringFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
  workflowVersionId?: InputMaybe<SearchableIdFilterInput>;
};

export type SearchableWorkflowEventSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableWorkflowEventSortableFields>;
};

export enum SearchableWorkflowEventSortableFields {
  AnalysedApplicationId = 'analysedApplicationId',
  CalendarBookingId = 'calendarBookingId',
  CampaignId = 'campaignId',
  CandidateBatchId = 'candidateBatchId',
  CandidateProfileId = 'candidateProfileId',
  CausationId = 'causationId',
  ContextSnapshot = 'contextSnapshot',
  ConversationId = 'conversationId',
  CorrelationId = 'correlationId',
  CreatedAt = 'createdAt',
  EventData = 'eventData',
  EventSource = 'eventSource',
  EventType = 'eventType',
  EventVersion = 'eventVersion',
  FailureReason = 'failureReason',
  Id = 'id',
  MessageId = 'messageId',
  OrganizationId = 'organizationId',
  ProcessedAt = 'processedAt',
  PublishedAt = 'publishedAt',
  RetryCount = 'retryCount',
  UpdatedAt = 'updatedAt',
  WorkflowExternalId = 'workflowExternalId',
  WorkflowId = 'workflowId',
  WorkflowNodeId = 'workflowNodeId',
  WorkflowRunId = 'workflowRunId',
  WorkflowVersionId = 'workflowVersionId'
}

export type SearchableWorkflowFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableWorkflowFilterInput>>>;
  apiModifiedDate?: InputMaybe<SearchableStringFilterInput>;
  canvasVisualConfiguration?: InputMaybe<SearchableStringFilterInput>;
  canvasVisualConfigurationModifiedDate?: InputMaybe<SearchableStringFilterInput>;
  configuration?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  createdByUserId?: InputMaybe<SearchableIdFilterInput>;
  description?: InputMaybe<SearchableStringFilterInput>;
  embeddedAtsJobId?: InputMaybe<SearchableStringFilterInput>;
  entrySources?: InputMaybe<SearchableStringFilterInput>;
  externalId?: InputMaybe<SearchableStringFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  liveWorkflowVersionId?: InputMaybe<SearchableIdFilterInput>;
  name?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableWorkflowFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableWorkflowFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  settings?: InputMaybe<SearchableStringFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
};

export enum SearchableWorkflowRunAggregateField {
  AtsApplicationId = 'atsApplicationId',
  AtsJobId = 'atsJobId',
  CancellationCode = 'cancellationCode',
  CandidateProfileFirstName = 'candidateProfileFirstName',
  CandidateProfileId = 'candidateProfileId',
  CandidateProfileLastName = 'candidateProfileLastName',
  CandidateProfileName = 'candidateProfileName',
  CompletedAt = 'completedAt',
  Context = 'context',
  CreatedAt = 'createdAt',
  CurrentNodeId = 'currentNodeId',
  ErrorCode = 'errorCode',
  ErrorMessage = 'errorMessage',
  ErrorReason = 'errorReason',
  FailedNodeIds = 'failedNodeIds',
  HasPartialFailures = 'hasPartialFailures',
  Id = 'id',
  InFlightNodeId = 'inFlightNodeId',
  KomboApplicationId = 'komboApplicationId',
  KomboJobId = 'komboJobId',
  LastFailedNodeId = 'lastFailedNodeId',
  LatestAnalysisNodeSlug = 'latestAnalysisNodeSlug',
  LatestAnalysisRequirementsMet = 'latestAnalysisRequirementsMet',
  LatestAnalysisScore = 'latestAnalysisScore',
  LatestAnalysisScoredAt = 'latestAnalysisScoredAt',
  NeedsReview = 'needsReview',
  NodeExecutionState = 'nodeExecutionState',
  OrganizationId = 'organizationId',
  RunVersion = 'runVersion',
  Status = 'status',
  Tags = 'tags',
  TagsNormalized = 'tagsNormalized',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowVersionId = 'workflowVersionId',
  WorkflowVersionNumber = 'workflowVersionNumber'
}

export type SearchableWorkflowRunAggregationInput = {
  field: SearchableWorkflowRunAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export enum SearchableWorkflowRunCandidateProfileAggregateField {
  CandidateProfileFirstName = 'candidateProfileFirstName',
  CandidateProfileId = 'candidateProfileId',
  CandidateProfileLastName = 'candidateProfileLastName',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CurrentNodeId = 'currentNodeId',
  HasPartialFailures = 'hasPartialFailures',
  Id = 'id',
  NeedsReview = 'needsReview',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowRunId = 'workflowRunId',
  WorkflowRunStatus = 'workflowRunStatus',
  WorkflowVersionId = 'workflowVersionId',
  WorkflowVersionNumber = 'workflowVersionNumber'
}

export type SearchableWorkflowRunCandidateProfileAggregationInput = {
  field: SearchableWorkflowRunCandidateProfileAggregateField;
  name: Scalars['String']['input'];
  type: SearchableAggregateType;
};

export type SearchableWorkflowRunCandidateProfileConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<WorkflowRunCandidateProfile>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableWorkflowRunCandidateProfileFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunCandidateProfileFilterInput>>>;
  candidateProfileFirstName?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileLastName?: InputMaybe<SearchableStringFilterInput>;
  completedAt?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  currentNodeId?: InputMaybe<SearchableStringFilterInput>;
  hasPartialFailures?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  needsReview?: InputMaybe<SearchableBooleanFilterInput>;
  not?: InputMaybe<SearchableWorkflowRunCandidateProfileFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunCandidateProfileFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowRunId?: InputMaybe<SearchableIdFilterInput>;
  workflowRunStatus?: InputMaybe<SearchableStringFilterInput>;
  workflowVersionId?: InputMaybe<SearchableIdFilterInput>;
  workflowVersionNumber?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableWorkflowRunCandidateProfileSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableWorkflowRunCandidateProfileSortableFields>;
};

export enum SearchableWorkflowRunCandidateProfileSortableFields {
  CandidateProfileFirstName = 'candidateProfileFirstName',
  CandidateProfileId = 'candidateProfileId',
  CandidateProfileLastName = 'candidateProfileLastName',
  CompletedAt = 'completedAt',
  CreatedAt = 'createdAt',
  CurrentNodeId = 'currentNodeId',
  HasPartialFailures = 'hasPartialFailures',
  Id = 'id',
  NeedsReview = 'needsReview',
  OrganizationId = 'organizationId',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowRunId = 'workflowRunId',
  WorkflowVersionId = 'workflowVersionId',
  WorkflowVersionNumber = 'workflowVersionNumber'
}

export type SearchableWorkflowRunConnection = {
  aggregateItems: Array<Maybe<SearchableAggregateResult>>;
  items: Array<Maybe<WorkflowRun>>;
  nextToken?: Maybe<Scalars['String']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type SearchableWorkflowRunFilterInput = {
  and?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunFilterInput>>>;
  atsApplicationId?: InputMaybe<SearchableIdFilterInput>;
  atsJobId?: InputMaybe<SearchableIdFilterInput>;
  cancellationCode?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileFirstName?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileId?: InputMaybe<SearchableIdFilterInput>;
  candidateProfileLastName?: InputMaybe<SearchableStringFilterInput>;
  candidateProfileName?: InputMaybe<SearchableStringFilterInput>;
  completedAt?: InputMaybe<SearchableStringFilterInput>;
  context?: InputMaybe<SearchableStringFilterInput>;
  createdAt?: InputMaybe<SearchableStringFilterInput>;
  currentNodeId?: InputMaybe<SearchableStringFilterInput>;
  errorCode?: InputMaybe<SearchableStringFilterInput>;
  errorMessage?: InputMaybe<SearchableStringFilterInput>;
  errorReason?: InputMaybe<SearchableStringFilterInput>;
  failedNodeIds?: InputMaybe<SearchableStringFilterInput>;
  hasPartialFailures?: InputMaybe<SearchableBooleanFilterInput>;
  id?: InputMaybe<SearchableIdFilterInput>;
  inFlightNodeId?: InputMaybe<SearchableStringFilterInput>;
  komboApplicationId?: InputMaybe<SearchableIdFilterInput>;
  komboJobId?: InputMaybe<SearchableIdFilterInput>;
  lastFailedNodeId?: InputMaybe<SearchableStringFilterInput>;
  latestAnalysisNodeSlug?: InputMaybe<SearchableStringFilterInput>;
  latestAnalysisRequirementsMet?: InputMaybe<SearchableBooleanFilterInput>;
  latestAnalysisScore?: InputMaybe<SearchableIntFilterInput>;
  latestAnalysisScoredAt?: InputMaybe<SearchableStringFilterInput>;
  needsReview?: InputMaybe<SearchableBooleanFilterInput>;
  nodeExecutionState?: InputMaybe<SearchableStringFilterInput>;
  not?: InputMaybe<SearchableWorkflowRunFilterInput>;
  or?: InputMaybe<Array<InputMaybe<SearchableWorkflowRunFilterInput>>>;
  organizationId?: InputMaybe<SearchableIdFilterInput>;
  runVersion?: InputMaybe<SearchableIntFilterInput>;
  status?: InputMaybe<SearchableStringFilterInput>;
  tags?: InputMaybe<SearchableStringFilterInput>;
  tagsNormalized?: InputMaybe<SearchableStringFilterInput>;
  updatedAt?: InputMaybe<SearchableStringFilterInput>;
  workflowId?: InputMaybe<SearchableIdFilterInput>;
  workflowVersionId?: InputMaybe<SearchableIdFilterInput>;
  workflowVersionNumber?: InputMaybe<SearchableIntFilterInput>;
};

export type SearchableWorkflowRunSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableWorkflowRunSortableFields>;
};

export enum SearchableWorkflowRunSortableFields {
  AtsApplicationId = 'atsApplicationId',
  AtsJobId = 'atsJobId',
  CandidateProfileFirstName = 'candidateProfileFirstName',
  CandidateProfileId = 'candidateProfileId',
  CandidateProfileLastName = 'candidateProfileLastName',
  CandidateProfileName = 'candidateProfileName',
  CompletedAt = 'completedAt',
  Context = 'context',
  CreatedAt = 'createdAt',
  CurrentNodeId = 'currentNodeId',
  ErrorCode = 'errorCode',
  ErrorMessage = 'errorMessage',
  ErrorReason = 'errorReason',
  FailedNodeIds = 'failedNodeIds',
  HasPartialFailures = 'hasPartialFailures',
  Id = 'id',
  InFlightNodeId = 'inFlightNodeId',
  KomboApplicationId = 'komboApplicationId',
  KomboJobId = 'komboJobId',
  LastFailedNodeId = 'lastFailedNodeId',
  LatestAnalysisNodeSlug = 'latestAnalysisNodeSlug',
  LatestAnalysisRequirementsMet = 'latestAnalysisRequirementsMet',
  LatestAnalysisScore = 'latestAnalysisScore',
  LatestAnalysisScoredAt = 'latestAnalysisScoredAt',
  NeedsReview = 'needsReview',
  OrganizationId = 'organizationId',
  RunVersion = 'runVersion',
  Tags = 'tags',
  TagsNormalized = 'tagsNormalized',
  UpdatedAt = 'updatedAt',
  WorkflowId = 'workflowId',
  WorkflowVersionId = 'workflowVersionId',
  WorkflowVersionNumber = 'workflowVersionNumber'
}

export type SearchableWorkflowSortInput = {
  direction?: InputMaybe<SearchableSortDirection>;
  field?: InputMaybe<SearchableWorkflowSortableFields>;
};

export enum SearchableWorkflowSortableFields {
  ApiModifiedDate = 'apiModifiedDate',
  CanvasVisualConfiguration = 'canvasVisualConfiguration',
  CanvasVisualConfigurationModifiedDate = 'canvasVisualConfigurationModifiedDate',
  Configuration = 'configuration',
  CreatedAt = 'createdAt',
  CreatedByUserId = 'createdByUserId',
  Description = 'description',
  EmbeddedAtsJobId = 'embeddedAtsJobId',
  ExternalId = 'externalId',
  Id = 'id',
  LiveWorkflowVersionId = 'liveWorkflowVersionId',
  Name = 'name',
  OrganizationId = 'organizationId',
  Settings = 'settings',
  UpdatedAt = 'updatedAt'
}

export type SelectedCandidateBatchStatuses = {
  campaign?: Maybe<Campaign>;
  campaignId: Scalars['ID']['output'];
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId: Scalars['ID']['output'];
  candidateStatuses: Array<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type SelectedParticipantInput = {
  conversationId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageByUserInput = {
  conversationId?: InputMaybe<Scalars['String']['input']>;
  messageBody?: InputMaybe<Scalars['String']['input']>;
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type SendMessageByUserOutput = {
  message?: Maybe<Message>;
};

export type SendSimulationMessageInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentName: Scalars['String']['input'];
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  closingMethod?: InputMaybe<ClosingMethod>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  jobDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  messageBody: Scalars['String']['input'];
  openingMessage: Scalars['String']['input'];
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  questions: Array<QuestionInput>;
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  simulationId?: InputMaybe<Scalars['ID']['input']>;
  tone?: InputMaybe<Tone>;
  type: CampaignType;
};

export type SendSimulationMessageOutput = {
  message?: Maybe<SimulationMessage>;
  simulationId: Scalars['ID']['output'];
};

export enum Sender {
  Agent = 'AGENT',
  Prospect = 'PROSPECT',
  User = 'USER'
}

export enum SentimentName {
  Admiration = 'ADMIRATION',
  Amusement = 'AMUSEMENT',
  Anger = 'ANGER',
  Annoyance = 'ANNOYANCE',
  Approval = 'APPROVAL',
  Caring = 'CARING',
  Confusion = 'CONFUSION',
  Curiosity = 'CURIOSITY',
  Disappointment = 'DISAPPOINTMENT',
  Disapproval = 'DISAPPROVAL',
  Disgust = 'DISGUST',
  Embarrassment = 'EMBARRASSMENT',
  Excitement = 'EXCITEMENT',
  Fear = 'FEAR',
  Gratitude = 'GRATITUDE',
  Neutral = 'NEUTRAL',
  Optimism = 'OPTIMISM',
  Pride = 'PRIDE',
  Realization = 'REALIZATION',
  Relief = 'RELIEF',
  Remorse = 'REMORSE',
  Surprise = 'SURPRISE',
  Unknown = 'UNKNOWN'
}

export type SimulationConversation = {
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  currentQuestionId?: Maybe<Scalars['String']['output']>;
  firstQuestionHasBeenAsked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  stage?: Maybe<ConversationStage>;
  status: ConversationStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type SimulationMessage = {
  body: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  rawBody?: Maybe<Scalars['String']['output']>;
  sender: Sender;
  simulationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['String']['output'];
};

export type Skill = {
  createdAt: Scalars['AWSDateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  normalizedSkill?: Maybe<Scalars['String']['output']>;
  skill: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  vectorDbTenantName: Scalars['String']['output'];
};

export type SourcedCandidate = {
  campaign?: Maybe<Campaign>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidate?: Maybe<Candidate>;
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId: Scalars['ID']['output'];
  candidateId?: Maybe<Scalars['ID']['output']>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  candidateRelevance?: Maybe<Scalars['String']['output']>;
  contactOutRawData?: Maybe<Scalars['AWSJSON']['output']>;
  conversation?: Maybe<Conversation>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  conversationNeedsReview?: Maybe<Scalars['Boolean']['output']>;
  conversationRepliesCount?: Maybe<Scalars['Int']['output']>;
  conversationStatus?: Maybe<ConversationStatus>;
  createdAt: Scalars['AWSDateTime']['output'];
  customInvitationMessage?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
  experience?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fetchPhoneNumberAttempted?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  linkedInProfileUrl?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  personalEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  source: CandidateSource;
  status: SourcedCandidateStatus;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workEmails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum SourcedCandidateStatus {
  AwaitingEnrichment = 'AWAITING_ENRICHMENT',
  AwaitingInvite = 'AWAITING_INVITE',
  Duplicate = 'DUPLICATE',
  Enriching = 'ENRICHING',
  EnrichmentFailed = 'ENRICHMENT_FAILED',
  EnrichmentSuccess = 'ENRICHMENT_SUCCESS',
  Invited = 'INVITED'
}

export type StartCampaignInput = {
  campaignId: Scalars['ID']['input'];
  closePreviousConversations?: InputMaybe<Scalars['Boolean']['input']>;
  launchScheduleDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type StartCampaignOutput = {
  message?: Maybe<Scalars['String']['output']>;
};

export type StartCandidateBatchProcessingInput = {
  candidateBatchId: Scalars['ID']['input'];
};

export type StartCandidateBatchProcessingOutput = {
  message: Scalars['String']['output'];
};

export type StartCandidateMessageGenerationInput = {
  candidateBatchId: Scalars['String']['input'];
  candidateIds: Array<Scalars['String']['input']>;
  type: CandidateMessageType;
};

export type StartCandidateMessageGenerationOutput = {
  message: Scalars['String']['output'];
};

export type StartInternalSourcingWorkflowRunsInput = {
  candidateProfileIds: Array<Scalars['ID']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type StartWorkflowContactImportInput = {
  emailColumn?: InputMaybe<Scalars['String']['input']>;
  externalIdColumn?: InputMaybe<Scalars['String']['input']>;
  fileName: Scalars['String']['input'];
  firstNameColumn?: InputMaybe<Scalars['String']['input']>;
  lastNameColumn?: InputMaybe<Scalars['String']['input']>;
  phoneNumberColumn?: InputMaybe<Scalars['String']['input']>;
  tagColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowId: Scalars['ID']['input'];
};

export type StartWorkflowContactImportResult = {
  contactImport: WorkflowContactImport;
  uploadUrl: Scalars['String']['output'];
  uploadUrlExpiresAt: Scalars['AWSDateTime']['output'];
};

export enum StartWorkflowRunRejectionReason {
  EnqueueFailed = 'ENQUEUE_FAILED',
  ExternalIdConflict = 'EXTERNAL_ID_CONFLICT',
  ExternalIdNotFound = 'EXTERNAL_ID_NOT_FOUND',
  ExternalIdResolutionFailed = 'EXTERNAL_ID_RESOLUTION_FAILED',
  InvalidContactFields = 'INVALID_CONTACT_FIELDS',
  InvalidExternalIdFormat = 'INVALID_EXTERNAL_ID_FORMAT',
  NoEntryPathway = 'NO_ENTRY_PATHWAY'
}

export type StartWorkflowRunsError = {
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  contactIndex?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<StartWorkflowRunRejectionReason>;
};

export type StartWorkflowRunsInput = {
  candidateProfileExternalIds?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateProfileIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  contacts?: InputMaybe<Array<WorkflowContactInput>>;
  triggerMetadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type StartWorkflowRunsResult = {
  alreadyEnrolled?: Maybe<Array<AlreadyEnrolledContact>>;
  duplicatesInRequest?: Maybe<Array<DuplicateContactInRequest>>;
  errors?: Maybe<Array<StartWorkflowRunsError>>;
  queued: Scalars['Int']['output'];
  /** @deprecated startWorkflowRuns is fully asynchronous; runs are created downstream and this list is always empty. Fetch outcomes via the workflow-run read endpoints or the WorkflowContactResolved webhook. */
  runs?: Maybe<Array<WorkflowRunSummary>>;
  summary?: Maybe<StartWorkflowRunsSummary>;
};

export type StartWorkflowRunsSummary = {
  alreadyEnrolled: Scalars['Int']['output'];
  duplicatesInRequest: Scalars['Int']['output'];
  held?: Maybe<Scalars['Int']['output']>;
  queued: Scalars['Int']['output'];
  received: Scalars['Int']['output'];
  rejected: Scalars['Int']['output'];
};

export type Status = {
  label: Scalars['String']['output'];
  type: StatusType;
  value: Scalars['String']['output'];
};

export type StatusInput = {
  label: Scalars['String']['input'];
  type: StatusType;
  value: Scalars['String']['input'];
};

export type StatusSet = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  statuses: Array<Status>;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum StatusType {
  Failed = 'FAILED',
  Interview = 'INTERVIEW',
  Passed = 'PASSED',
  Review = 'REVIEW'
}

export type StopCampaignInput = {
  availabilityOutreachCancellationMessage?: InputMaybe<Scalars['String']['input']>;
  campaignId: Scalars['ID']['input'];
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  sendCancellationMessage: Scalars['Boolean']['input'];
};

export type StopCampaignOutput = {
  campaign?: Maybe<Campaign>;
};

export type StructureJobDescriptionParsedResponse = {
  jobDescription: StructuredJobDescriptionParsed;
};

export type StructureJobDescriptionResponse = {
  jobDescription: JobDescription;
};

export type StructuredJobDescriptionParsed = {
  contractType?: Maybe<Scalars['String']['output']>;
  employerName?: Maybe<Scalars['String']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  summaryOfRole?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  onCreateAtsQuestion?: Maybe<AtsQuestion>;
  onCreateCampaign?: Maybe<Campaign>;
  onCreateCandidate?: Maybe<Candidate>;
  onCreateCandidateBatch?: Maybe<CandidateBatch>;
  onCreateCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  onCreateCandidateProfile?: Maybe<CandidateProfile>;
  onCreateCandidateProfileList?: Maybe<CandidateProfileList>;
  onCreateCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  onCreateCandidateProfileNote?: Maybe<CandidateProfileNote>;
  onCreateConversation?: Maybe<Conversation>;
  onCreateIntegrationCredentials?: Maybe<IntegrationCredentials>;
  onCreateMessage?: Maybe<Message>;
  onCreateSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  onCreateSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  onCreateSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  onCreateSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  onCreateSimulationConversation?: Maybe<SimulationConversation>;
  onCreateSimulationMessage?: Maybe<SimulationMessage>;
  onCreateSourcedCandidate?: Maybe<SourcedCandidate>;
  onCreateUnansweredQuestion?: Maybe<UnansweredQuestion>;
  onCreateWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  onCreateWorkflowContactImport?: Maybe<WorkflowContactImport>;
  onDeleteAtsQuestion?: Maybe<AtsQuestion>;
  onDeleteCampaign?: Maybe<Campaign>;
  onDeleteCandidate?: Maybe<Candidate>;
  onDeleteCandidateBatch?: Maybe<CandidateBatch>;
  onDeleteCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  onDeleteCandidateProfile?: Maybe<CandidateProfile>;
  onDeleteCandidateProfileList?: Maybe<CandidateProfileList>;
  onDeleteCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  onDeleteCandidateProfileNote?: Maybe<CandidateProfileNote>;
  onDeleteConversation?: Maybe<Conversation>;
  onDeleteIntegrationCredentials?: Maybe<IntegrationCredentials>;
  onDeleteMessage?: Maybe<Message>;
  onDeleteSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  onDeleteSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  onDeleteSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  onDeleteSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  onDeleteSimulationConversation?: Maybe<SimulationConversation>;
  onDeleteSimulationMessage?: Maybe<SimulationMessage>;
  onDeleteSourcedCandidate?: Maybe<SourcedCandidate>;
  onDeleteUnansweredQuestion?: Maybe<UnansweredQuestion>;
  onDeleteWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  onDeleteWorkflowContactImport?: Maybe<WorkflowContactImport>;
  onUpdateAtsQuestion?: Maybe<AtsQuestion>;
  onUpdateCampaign?: Maybe<Campaign>;
  onUpdateCampaignStats?: Maybe<Campaign>;
  onUpdateCandidate?: Maybe<Candidate>;
  onUpdateCandidateBatch?: Maybe<CandidateBatch>;
  onUpdateCandidateBatchGroup?: Maybe<CandidateBatchGroup>;
  onUpdateCandidateProfile?: Maybe<CandidateProfile>;
  onUpdateCandidateProfileList?: Maybe<CandidateProfileList>;
  onUpdateCandidateProfileListMembership?: Maybe<CandidateProfileListMembership>;
  onUpdateCandidateProfileNote?: Maybe<CandidateProfileNote>;
  onUpdateConversation?: Maybe<Conversation>;
  onUpdateIntegrationCredentials?: Maybe<IntegrationCredentials>;
  onUpdateMessage?: Maybe<Message>;
  onUpdateSearchCandidateProfileMessage?: Maybe<SearchCandidateProfileMessage>;
  onUpdateSearchCandidateProfileQuery?: Maybe<SearchCandidateProfileQuery>;
  onUpdateSearchCandidateProfileSelected?: Maybe<SearchCandidateProfileSelected>;
  onUpdateSearchCandidateProfileSelectedItem?: Maybe<SearchCandidateProfileSelectedItem>;
  onUpdateSimulationConversation?: Maybe<SimulationConversation>;
  onUpdateSimulationMessage?: Maybe<SimulationMessage>;
  onUpdateSourcedCandidate?: Maybe<SourcedCandidate>;
  onUpdateUnansweredQuestion?: Maybe<UnansweredQuestion>;
  onUpdateWhatsaapTemplate?: Maybe<WhatsaapTemplate>;
  onUpdateWorkflowContactImport?: Maybe<WorkflowContactImport>;
};


export type SubscriptionOnCreateAtsQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionAtsQuestionFilterInput>;
};


export type SubscriptionOnCreateCampaignArgs = {
  filter?: InputMaybe<ModelSubscriptionCampaignFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnCreateCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateFilterInput>;
};


export type SubscriptionOnCreateCandidateBatchArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchFilterInput>;
};


export type SubscriptionOnCreateCandidateBatchGroupArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchGroupFilterInput>;
};


export type SubscriptionOnCreateCandidateProfileArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileFilterInput>;
};


export type SubscriptionOnCreateCandidateProfileListArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListFilterInput>;
};


export type SubscriptionOnCreateCandidateProfileListMembershipArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListMembershipFilterInput>;
};


export type SubscriptionOnCreateCandidateProfileNoteArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileNoteFilterInput>;
};


export type SubscriptionOnCreateConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionConversationFilterInput>;
};


export type SubscriptionOnCreateIntegrationCredentialsArgs = {
  filter?: InputMaybe<ModelSubscriptionIntegrationCredentialsFilterInput>;
};


export type SubscriptionOnCreateMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
};


export type SubscriptionOnCreateSearchCandidateProfileMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileMessageFilterInput>;
};


export type SubscriptionOnCreateSearchCandidateProfileQueryArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileQueryFilterInput>;
};


export type SubscriptionOnCreateSearchCandidateProfileSelectedArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedFilterInput>;
};


export type SubscriptionOnCreateSearchCandidateProfileSelectedItemArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput>;
};


export type SubscriptionOnCreateSimulationConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationConversationFilterInput>;
};


export type SubscriptionOnCreateSimulationMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationMessageFilterInput>;
};


export type SubscriptionOnCreateSourcedCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionSourcedCandidateFilterInput>;
};


export type SubscriptionOnCreateUnansweredQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionUnansweredQuestionFilterInput>;
};


export type SubscriptionOnCreateWhatsaapTemplateArgs = {
  filter?: InputMaybe<ModelSubscriptionWhatsaapTemplateFilterInput>;
};


export type SubscriptionOnCreateWorkflowContactImportArgs = {
  filter?: InputMaybe<ModelSubscriptionWorkflowContactImportFilterInput>;
};


export type SubscriptionOnDeleteAtsQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionAtsQuestionFilterInput>;
};


export type SubscriptionOnDeleteCampaignArgs = {
  filter?: InputMaybe<ModelSubscriptionCampaignFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnDeleteCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateFilterInput>;
};


export type SubscriptionOnDeleteCandidateBatchArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchFilterInput>;
};


export type SubscriptionOnDeleteCandidateBatchGroupArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchGroupFilterInput>;
};


export type SubscriptionOnDeleteCandidateProfileArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileFilterInput>;
};


export type SubscriptionOnDeleteCandidateProfileListArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListFilterInput>;
};


export type SubscriptionOnDeleteCandidateProfileListMembershipArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListMembershipFilterInput>;
};


export type SubscriptionOnDeleteCandidateProfileNoteArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileNoteFilterInput>;
};


export type SubscriptionOnDeleteConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionConversationFilterInput>;
};


export type SubscriptionOnDeleteIntegrationCredentialsArgs = {
  filter?: InputMaybe<ModelSubscriptionIntegrationCredentialsFilterInput>;
};


export type SubscriptionOnDeleteMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
};


export type SubscriptionOnDeleteSearchCandidateProfileMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileMessageFilterInput>;
};


export type SubscriptionOnDeleteSearchCandidateProfileQueryArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileQueryFilterInput>;
};


export type SubscriptionOnDeleteSearchCandidateProfileSelectedArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedFilterInput>;
};


export type SubscriptionOnDeleteSearchCandidateProfileSelectedItemArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput>;
};


export type SubscriptionOnDeleteSimulationConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationConversationFilterInput>;
};


export type SubscriptionOnDeleteSimulationMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationMessageFilterInput>;
};


export type SubscriptionOnDeleteSourcedCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionSourcedCandidateFilterInput>;
};


export type SubscriptionOnDeleteUnansweredQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionUnansweredQuestionFilterInput>;
};


export type SubscriptionOnDeleteWhatsaapTemplateArgs = {
  filter?: InputMaybe<ModelSubscriptionWhatsaapTemplateFilterInput>;
};


export type SubscriptionOnDeleteWorkflowContactImportArgs = {
  filter?: InputMaybe<ModelSubscriptionWorkflowContactImportFilterInput>;
};


export type SubscriptionOnUpdateAtsQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionAtsQuestionFilterInput>;
};


export type SubscriptionOnUpdateCampaignArgs = {
  filter?: InputMaybe<ModelSubscriptionCampaignFilterInput>;
  owner?: InputMaybe<Scalars['String']['input']>;
};


export type SubscriptionOnUpdateCampaignStatsArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionOnUpdateCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateFilterInput>;
};


export type SubscriptionOnUpdateCandidateBatchArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchFilterInput>;
};


export type SubscriptionOnUpdateCandidateBatchGroupArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateBatchGroupFilterInput>;
};


export type SubscriptionOnUpdateCandidateProfileArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileFilterInput>;
};


export type SubscriptionOnUpdateCandidateProfileListArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListFilterInput>;
};


export type SubscriptionOnUpdateCandidateProfileListMembershipArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileListMembershipFilterInput>;
};


export type SubscriptionOnUpdateCandidateProfileNoteArgs = {
  filter?: InputMaybe<ModelSubscriptionCandidateProfileNoteFilterInput>;
};


export type SubscriptionOnUpdateConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionConversationFilterInput>;
};


export type SubscriptionOnUpdateIntegrationCredentialsArgs = {
  filter?: InputMaybe<ModelSubscriptionIntegrationCredentialsFilterInput>;
};


export type SubscriptionOnUpdateMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionMessageFilterInput>;
};


export type SubscriptionOnUpdateSearchCandidateProfileMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileMessageFilterInput>;
};


export type SubscriptionOnUpdateSearchCandidateProfileQueryArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileQueryFilterInput>;
};


export type SubscriptionOnUpdateSearchCandidateProfileSelectedArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedFilterInput>;
};


export type SubscriptionOnUpdateSearchCandidateProfileSelectedItemArgs = {
  filter?: InputMaybe<ModelSubscriptionSearchCandidateProfileSelectedItemFilterInput>;
};


export type SubscriptionOnUpdateSimulationConversationArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationConversationFilterInput>;
};


export type SubscriptionOnUpdateSimulationMessageArgs = {
  filter?: InputMaybe<ModelSubscriptionSimulationMessageFilterInput>;
};


export type SubscriptionOnUpdateSourcedCandidateArgs = {
  filter?: InputMaybe<ModelSubscriptionSourcedCandidateFilterInput>;
};


export type SubscriptionOnUpdateUnansweredQuestionArgs = {
  filter?: InputMaybe<ModelSubscriptionUnansweredQuestionFilterInput>;
};


export type SubscriptionOnUpdateWhatsaapTemplateArgs = {
  filter?: InputMaybe<ModelSubscriptionWhatsaapTemplateFilterInput>;
};


export type SubscriptionOnUpdateWorkflowContactImportArgs = {
  filter?: InputMaybe<ModelSubscriptionWorkflowContactImportFilterInput>;
};

export enum SubscriptionProduct {
  PoppConversations = 'POPP_CONVERSATIONS',
  PoppScoring = 'POPP_SCORING',
  PoppSourcing = 'POPP_SOURCING'
}

export enum SyncStatus {
  Cancelled = 'CANCELLED',
  ListingRecords = 'LISTING_RECORDS',
  ListingRecordsCompleted = 'LISTING_RECORDS_COMPLETED',
  Starting = 'STARTING',
  SyncRecordsCompleted = 'SYNC_RECORDS_COMPLETED'
}

export type Tag = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  tag: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  vectorDbTenantName: Scalars['String']['output'];
};

export type Team = {
  createdAt: Scalars['AWSDateTime']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organizationGroupId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export type TeamMembership = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  teamId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userId: Scalars['ID']['output'];
};

export type TemplateMapping = {
  key: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export type TemplateMappingInput = {
  key: Scalars['String']['input'];
  variable: Scalars['String']['input'];
};

export type TemplateMessageValue = {
  value: Scalars['String']['output'];
  variable: Scalars['String']['output'];
};

export type TemplateMessageValueInput = {
  value: Scalars['String']['input'];
  variable: Scalars['String']['input'];
};

export enum TemplateType {
  CalendarBookingCancelled = 'CALENDAR_BOOKING_CANCELLED',
  CalendarBookingConfirmation = 'CALENDAR_BOOKING_CONFIRMATION',
  CalendarBookingNudge_1 = 'CALENDAR_BOOKING_NUDGE_1',
  CalendarBookingNudge_2 = 'CALENDAR_BOOKING_NUDGE_2',
  CalendarBookingNudge_3 = 'CALENDAR_BOOKING_NUDGE_3',
  CalendarBookingReminder = 'CALENDAR_BOOKING_REMINDER',
  CalendarBookingRescheduleConfirmation = 'CALENDAR_BOOKING_RESCHEDULE_CONFIRMATION',
  CalendarBookingRescheduleRequest = 'CALENDAR_BOOKING_RESCHEDULE_REQUEST',
  CalendarBookingUrlReady = 'CALENDAR_BOOKING_URL_READY',
  NudgeMessage_1 = 'NUDGE_MESSAGE_1',
  NudgeMessage_2 = 'NUDGE_MESSAGE_2',
  NudgeMessage_3 = 'NUDGE_MESSAGE_3',
  OpeningMessage = 'OPENING_MESSAGE',
  RestartOpenMessage = 'RESTART_OPEN_MESSAGE',
  WelcomeMessage = 'WELCOME_MESSAGE'
}

export type TemplateValuesInput = {
  agentName: Scalars['String']['input'];
  chatUrl: Scalars['String']['input'];
  companyName: Scalars['String']['input'];
  currentRoleCompanyName: Scalars['String']['input'];
  employerName: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  industry: Scalars['String']['input'];
  jobTitle: Scalars['String']['input'];
  location: Scalars['String']['input'];
};

export type TestOrganizationWebhookInput = {
  eventType: WebhookEventType;
  webhookId: Scalars['ID']['input'];
};

export type TestOrganizationWebhookResult = {
  error?: Maybe<Scalars['String']['output']>;
  responseBody?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
  success: Scalars['Boolean']['output'];
};

export enum TimeComparison {
  Between_1And_2Years = 'BETWEEN_1_AND_2_YEARS',
  Between_2And_3Years = 'BETWEEN_2_AND_3_YEARS',
  Between_3And_4Years = 'BETWEEN_3_AND_4_YEARS',
  Between_4And_5Years = 'BETWEEN_4_AND_5_YEARS',
  Between_5And_6Years = 'BETWEEN_5_AND_6_YEARS',
  Between_6And_7Years = 'BETWEEN_6_AND_7_YEARS',
  LessThan_1Year = 'LESS_THAN_1_YEAR',
  MoreThan_7Years = 'MORE_THAN_7_YEARS'
}

export enum TimeFilterType {
  Both = 'both',
  Current = 'current',
  Past = 'past'
}

export enum Tone {
  Casual = 'CASUAL',
  Custom = 'CUSTOM',
  Encouraging = 'ENCOURAGING',
  Friendly = 'FRIENDLY',
  Motivational = 'MOTIVATIONAL',
  Neutral = 'NEUTRAL',
  Professional = 'PROFESSIONAL'
}

export enum TrafficLight {
  Amber = 'AMBER',
  Green = 'GREEN',
  Red = 'RED'
}

export type TwilioAccountCredentials = {
  accountSid: Scalars['ID']['output'];
  alphaSenderMessagingServiceId?: Maybe<Scalars['ID']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  apiSecret?: Maybe<Scalars['String']['output']>;
  authToken: Scalars['String']['output'];
  chatServiceSid: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  inboundChatServiceId?: Maybe<Scalars['ID']['output']>;
  messagingServiceSid?: Maybe<Scalars['ID']['output']>;
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum TwilioSenderStatus {
  Offline = 'OFFLINE',
  Online = 'ONLINE',
  Pending = 'PENDING'
}

export type TypeformLink = {
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidateBatch?: Maybe<CandidateBatch>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  url: Scalars['String']['output'];
};

export type TypeformRecord = {
  createdAt: Scalars['AWSDateTime']['output'];
  formId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationId: Scalars['ID']['output'];
  type: TypeformRecordType;
  updatedAt: Scalars['AWSDateTime']['output'];
};

export enum TypeformRecordType {
  Analysis = 'ANALYSIS',
  Campaign = 'CAMPAIGN'
}

export type UnansweredQuestion = {
  associatedMessage?: Maybe<Message>;
  associatedMessageId: Scalars['ID']['output'];
  campaignId: Scalars['ID']['output'];
  conversationId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isAnswered?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  summary: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type UnhideOrganizationInput = {
  organizationId: Scalars['ID']['input'];
};

export type UnhideOrganizationResult = {
  hiddenAt?: Maybe<Scalars['AWSDateTime']['output']>;
  id: Scalars['ID']['output'];
  isHidden: Scalars['Boolean']['output'];
};

export type UpdateAgentInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  personality?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Tone>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAnalysedApplicationSnapshotInput = {
  analysisErrorCode?: InputMaybe<CandidateAnalysisErrorCode>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAllRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  requirementOutcomes?: InputMaybe<Array<AnalysedApplicationSnapshotRequirementOutcomeInput>>;
  screeningAnswers?: InputMaybe<Array<AtsScreeningAnswerInput>>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScoreScaled?: InputMaybe<Scalars['Float']['input']>;
  trigger?: InputMaybe<AnalysedApplicationSnapshotTrigger>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowNodeLabel?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAnalysisAutomationTasksInput = {
  analysisAutomationTasksToCreate?: InputMaybe<Array<AutomationTaskInput>>;
  analysisAutomationTasksToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  analysisAutomationTasksToUpdate?: InputMaybe<Array<AnalysisAutomationTaskUpdateInput>>;
  automationType?: InputMaybe<AutomationType>;
  candidateBatchId: Scalars['ID']['input'];
  overwriteLockedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  saveOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateAnalysisAutomationTasksOutput = {
  message: Scalars['String']['output'];
};

export type UpdateAnalysisRequirementInput = {
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  generatedRequirementText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isRecommendationDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  originalRequirementText?: InputMaybe<Scalars['String']['input']>;
  parentAnalysisRequirementId?: InputMaybe<Scalars['ID']['input']>;
  recommendationCategory?: InputMaybe<RequirementRecommendationCategory>;
  recommendationText?: InputMaybe<Scalars['String']['input']>;
  requirementMetCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAnalysisRequirementsInput = {
  candidateBatchId: Scalars['ID']['input'];
  overwriteLockedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  requirementsToAdd?: InputMaybe<Array<AnalysisRequirementCreateInput>>;
  requirementsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  requirementsToUpdate?: InputMaybe<Array<AnalysisRequirementUpdateInput>>;
};

export type UpdateApplicationStageInput = {
  applicationStage?: InputMaybe<Scalars['String']['input']>;
  conversationIds: Array<Scalars['ID']['input']>;
  stageUpdatedAt: Scalars['AWSDateTime']['input'];
};

export type UpdateApplicationStageOutput = {
  message: Scalars['String']['output'];
};

export type UpdateApplicationStageUpdateInput = {
  applicationStage?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  stageUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAtsApplicationInput = {
  analysisCandidateId?: InputMaybe<Scalars['ID']['input']>;
  analysisRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  analysisScore?: InputMaybe<Scalars['Int']['input']>;
  analysisScoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  analysisWorkflowNodeId?: InputMaybe<Scalars['ID']['input']>;
  appliedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentStage?: InputMaybe<Scalars['String']['input']>;
  currentStageId?: InputMaybe<Scalars['ID']['input']>;
  cvFileName?: InputMaybe<Scalars['String']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  cvText?: InputMaybe<Scalars['String']['input']>;
  hiringOutcome?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId: Scalars['ID']['input'];
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  rejectedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  rejectionReason?: InputMaybe<Scalars['String']['input']>;
  remoteUrl?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateAtsApplicationScreeningAnswersInput = {
  answers?: InputMaybe<Array<AtsScreeningAnswerInput>>;
  komboApplicationId: Scalars['ID']['input'];
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UpdateAtsBulkSyncErrorInput = {
  atsBulkSyncId?: InputMaybe<Scalars['ID']['input']>;
  atsRecordId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  errorDetails?: InputMaybe<Scalars['AWSJSON']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  retryCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAtsBulkSyncInput = {
  atsAccountId?: InputMaybe<Scalars['String']['input']>;
  atsBulkSyncType?: InputMaybe<AtsBulkSyncType>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  nextProcessingToken?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  recordsAttempted?: InputMaybe<Scalars['Int']['input']>;
  recordsFailed?: InputMaybe<Scalars['Int']['input']>;
  recordsFound?: InputMaybe<Scalars['Int']['input']>;
  recordsSucceeded?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<SyncStatus>;
  syncCompletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  syncMetadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  syncStartedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateAtsConfigInput = {
  applicationProxy?: InputMaybe<Scalars['AWSJSON']['input']>;
  id: Scalars['ID']['input'];
  jobPostingProxy?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAtsQuestionInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsQuestionId?: InputMaybe<Scalars['String']['input']>;
  atsQuestionOptions?: InputMaybe<Array<AtsQuestionOptionInput>>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  category?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isRequired?: InputMaybe<Scalars['Boolean']['input']>;
  komboQuestionId?: InputMaybe<Scalars['ID']['input']>;
  multipleChoiceAnswers?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  questionIndex?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAttachmentInput = {
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAutomationTaskEmailTemplateInput = {
  customEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  defaultEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  emailTemplateWithJobBoardLink?: InputMaybe<Scalars['String']['input']>;
  emailTemplateWithPersonalisation?: InputMaybe<Scalars['String']['input']>;
  emailTemplateWithPersonalisationAndJobBoardLink?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobRecommendationsEmailTemplate?: InputMaybe<Scalars['String']['input']>;
  jobRecommendationsEmailTemplateWithJobBoardLink?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAutomationTaskInput = {
  action?: InputMaybe<AutomationActionInput>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  parentAutomationTaskId?: InputMaybe<Scalars['ID']['input']>;
  requirementConditions?: InputMaybe<Array<RequirementConditionInput>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateAutomationTasksTemplateInput = {
  automationTasks?: InputMaybe<Array<AutomationTaskItemInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCalendarBookingInput = {
  bookingParticipants?: InputMaybe<Array<BookingParticipantInput>>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateEmail?: InputMaybe<Scalars['String']['input']>;
  candidateName?: InputMaybe<Scalars['String']['input']>;
  candidateTimeZone?: InputMaybe<Scalars['String']['input']>;
  conferenceUrl?: InputMaybe<Scalars['String']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  endDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  icalUid?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  location?: InputMaybe<Scalars['String']['input']>;
  noteTakerId?: InputMaybe<Scalars['ID']['input']>;
  noteTakerMediaTranscriptS3Key?: InputMaybe<Scalars['String']['input']>;
  noteTakerStatus?: InputMaybe<NoteTakerStatus>;
  noteTakerTranscript?: InputMaybe<Array<NoteTakerTranscriptItemInput>>;
  noteTakerTranscriptSummary?: InputMaybe<Scalars['String']['input']>;
  notetakerMediaRecordingS3Key?: InputMaybe<Scalars['String']['input']>;
  nylasBookingId?: InputMaybe<Scalars['String']['input']>;
  nylasBookingRef?: InputMaybe<Scalars['String']['input']>;
  nylasEventId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizerUserCalendarId?: InputMaybe<Scalars['ID']['input']>;
  startDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  status?: InputMaybe<MeetingBookingStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCalendarMeetingTemplateInput = {
  availabilityMethod?: InputMaybe<AvailabilityMethod>;
  availabilityOutreachSettings?: InputMaybe<AvailabilityOutreachSettingsInput>;
  durationMinutes?: InputMaybe<Scalars['Int']['input']>;
  guestLabel?: InputMaybe<Scalars['String']['input']>;
  hideParticipantEmails?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isSingleUse?: InputMaybe<Scalars['Boolean']['input']>;
  isVideoConference?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  lastUsedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  nylasConfigurationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  organizerUserCalendarId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CalendarMeetingTemplateStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalBookingsCount?: InputMaybe<Scalars['Int']['input']>;
  updatedByUserId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCampaignCandidateInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isProcessed?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCampaignCsvKeysInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCampaignInput = {
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsListId?: InputMaybe<Scalars['ID']['input']>;
  averageTimeToComplete?: InputMaybe<Scalars['Float']['input']>;
  averageTimeToFirstResponse?: InputMaybe<Scalars['Float']['input']>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignGroupId?: InputMaybe<Scalars['ID']['input']>;
  cancellationMessage?: InputMaybe<Scalars['String']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  channel?: InputMaybe<Channels>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  closingMethod?: InputMaybe<ClosingMethod>;
  contactNumber?: InputMaybe<Scalars['String']['input']>;
  conversationCompletedMessage?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  customTemplatedMessage?: InputMaybe<Scalars['String']['input']>;
  customTemplatedSubjectLine?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  followUpMessage?: InputMaybe<Scalars['String']['input']>;
  guestLabel?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  initialMessagesDeliveredCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesReadCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesSentCount?: InputMaybe<Scalars['Int']['input']>;
  initialMessagesUndeliveredCount?: InputMaybe<Scalars['Int']['input']>;
  isDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
  isParent?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['AWSJSON']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionParsedInput>;
  jobDescriptionText?: InputMaybe<Scalars['String']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  launchScheduleDateTime?: InputMaybe<Scalars['AWSDateTime']['input']>;
  launchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  meetingUrl?: InputMaybe<Scalars['String']['input']>;
  messagesProcessedCount?: InputMaybe<Scalars['Int']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nudgeSettings?: InputMaybe<Array<InputMaybe<NudgeSettingInput>>>;
  nudgesCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  outreachDescription?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  periodDays?: InputMaybe<Scalars['Int']['input']>;
  questions?: InputMaybe<Array<QuestionInput>>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  requiredHours?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<CampaignStatus>;
  stoppedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  stoppedByUserId?: InputMaybe<Scalars['ID']['input']>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  timeToAutoCloseConversationsInHours?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalConversationsCount?: InputMaybe<Scalars['Int']['input']>;
  totalConversationsWithRepliesCount?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesCount?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithCallRequest?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithCustomRequest?: InputMaybe<Scalars['Int']['input']>;
  totalMessagesWithMeetingUrlCount?: InputMaybe<Scalars['Int']['input']>;
  totalNotInterestedConversationCount?: InputMaybe<Scalars['Int']['input']>;
  totalOptedOutConversationCount?: InputMaybe<Scalars['Int']['input']>;
  totalProspectsCount?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<CampaignType>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  webChatTemplateId?: InputMaybe<Scalars['ID']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCampaignQuestionInput = {
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hubSpotProperty?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCampaignStatsInput = {
  id: Scalars['ID']['input'];
  increments: Array<CampaignStatsInput>;
};

export type UpdateCampaignSubscriptionInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateAvailabilitySuggestionInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  timeSlots?: InputMaybe<Array<CandidateSuggestedTimeSlotInput>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateBatchGroupComponentsInput = {
  candidateBatchGroupId: Scalars['ID']['input'];
  overwriteLockedCandidates?: InputMaybe<Scalars['Boolean']['input']>;
  parentAnalysisAutomationTasksToAdd?: InputMaybe<Array<AutomationTaskInput>>;
  parentAnalysisAutomationTasksToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentAnalysisAutomationTasksToUpdate?: InputMaybe<Array<AnalysisAutomationTaskUpdateInput>>;
  parentAnalysisRequirementsToAdd?: InputMaybe<Array<AnalysisRequirementCreateInput>>;
  parentAnalysisRequirementsToDelete?: InputMaybe<Array<Scalars['ID']['input']>>;
  parentAnalysisRequirementsToUpdate?: InputMaybe<Array<AnalysisRequirementUpdateInput>>;
  skipPastCandidatesUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateCandidateBatchGroupInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  jobCode?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateBatchInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchGroupId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchReanalysisReferenceId?: InputMaybe<Scalars['ID']['input']>;
  candidatesCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesRequirementsMetCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesRequirementsNotMetCount?: InputMaybe<Scalars['Int']['input']>;
  candidatesToProcessCount?: InputMaybe<Scalars['Int']['input']>;
  categorizedRequirements?: InputMaybe<Array<CategorizedRequirementsInput>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  csvS3Key?: InputMaybe<Scalars['String']['input']>;
  customJobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  cvS3Keys?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isInitial?: InputMaybe<Scalars['Boolean']['input']>;
  isRecalculatingScores?: InputMaybe<Scalars['Boolean']['input']>;
  isWorkflowManaged?: InputMaybe<Scalars['Boolean']['input']>;
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobDescriptionParsed?: InputMaybe<JobDescriptionInput>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  remainingRescoredCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  requirements?: InputMaybe<Array<RequirementInput>>;
  rubric?: InputMaybe<RubricInput>;
  screeningQuestions?: InputMaybe<Array<QuestionInput>>;
  status?: InputMaybe<CandidateBatchStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  weights?: InputMaybe<WeightsInput>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowNodeSlug?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateCvsParsingInput = {
  candidatesCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvsZipS3Key?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<CandidateCvsParsingStatus>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateEmailCorrespondenceInput = {
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']['input']>;
  scheduleDelayInHours?: InputMaybe<Scalars['String']['input']>;
  scheduleId?: InputMaybe<Scalars['ID']['input']>;
  scheduledAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  senderEmailAddress?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sesMessageId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CorrespondenceStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<EmailCorrespondenceType>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateInput = {
  analysisErrorCode?: InputMaybe<CandidateAnalysisErrorCode>;
  analysisOutcomeActedOnAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  applicationSource?: InputMaybe<Scalars['String']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsApplicationSource?: InputMaybe<Scalars['String']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsInterviewStageId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsQuestionnaireAnswers?: InputMaybe<Array<AtsQuestionnaireAnswerInput>>;
  atsRejectedReasonId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateCvsParsingId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationPreferredAnswersScore?: InputMaybe<Scalars['Float']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvParsedText?: InputMaybe<Scalars['String']['input']>;
  cvS3Key?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isAllRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  isMessagesGenerating?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  komboRejectionReasonId?: InputMaybe<Scalars['ID']['input']>;
  komboStageId?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInProfileId?: InputMaybe<Scalars['String']['input']>;
  metRequirementSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  origin?: InputMaybe<CandidateOrigin>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  requirements?: InputMaybe<Array<CandidateRequirementInput>>;
  scoring?: InputMaybe<Array<CandidateScoringInput>>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  sourcedCandidateId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  totalScore?: InputMaybe<Scalars['Float']['input']>;
  totalScoreScaled?: InputMaybe<Scalars['Float']['input']>;
  unmetRequirementSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<CandidateMessageType>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateNoteInput = {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateProfileInput = {
  atsApplicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  awards?: InputMaybe<Array<Scalars['String']['input']>>;
  candidateProfileVectorId?: InputMaybe<Scalars['ID']['input']>;
  certifications?: InputMaybe<Array<Scalars['String']['input']>>;
  company?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customFields?: InputMaybe<Scalars['AWSJSON']['input']>;
  education?: InputMaybe<Array<EducationInput>>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailFromCv?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedSalaryFromQuestionnaire?: InputMaybe<ExpectedSalaryInput>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  externalUrl?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  firstNameFromCv?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  jobs?: InputMaybe<Array<JobInput>>;
  komboApplicationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  languages?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  lastNameFromCv?: InputMaybe<Scalars['String']['input']>;
  latestAtsApplicationDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  latestAtsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  latestCvS3Key?: InputMaybe<Scalars['String']['input']>;
  latestCvText?: InputMaybe<Scalars['String']['input']>;
  latestKomboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  linkedInProfileUrl?: InputMaybe<Scalars['String']['input']>;
  linkedInProfileUrlFromCv?: InputMaybe<Scalars['String']['input']>;
  linksFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<LocationInput>;
  locationFromCv?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  originalSource?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  phoneNumberFromCv?: InputMaybe<Scalars['String']['input']>;
  phoneNumbers?: InputMaybe<Array<Scalars['String']['input']>>;
  professionalSummaryFromCv?: InputMaybe<Scalars['String']['input']>;
  publications?: InputMaybe<Array<Scalars['String']['input']>>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  qualificationsFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  relevantExperienceFromQuestionnaire?: InputMaybe<RelevantExperienceInput>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  skillsFromCv?: InputMaybe<Array<Scalars['String']['input']>>;
  socialLinks?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<CandidateProfileSyncStatus>;
  statusChangedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  totalExperienceInYears?: InputMaybe<Scalars['Float']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateCandidateProfileListForUserInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCandidateProfileListInput = {
  candidateProfilesCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastApiWriteAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateProfileListMembershipInput = {
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileListId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateCandidateProfileNoteInput = {
  atsApplicationId?: InputMaybe<Scalars['String']['input']>;
  atsAuthorId?: InputMaybe<Scalars['String']['input']>;
  atsCandidateId?: InputMaybe<Scalars['String']['input']>;
  atsCandidateNoteId?: InputMaybe<Scalars['String']['input']>;
  atsNoteCreatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsNoteDeletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsNoteUpdatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['String']['input']>;
  komboCandidateId?: InputMaybe<Scalars['String']['input']>;
  komboCandidateNoteId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type?: InputMaybe<NoteType>;
};

export type UpdateCandidateStatusUpdateInput = {
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  changeRecord?: InputMaybe<ChangeRecordInput>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCandidateTagInput = {
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
  valueNormalized?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateClientApiKeyInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hashedKey: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  partialKey?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateConversationInput = {
  activeChannel?: InputMaybe<Channels>;
  additionalContext?: InputMaybe<Scalars['String']['input']>;
  agentId?: InputMaybe<Scalars['ID']['input']>;
  applicationSource?: InputMaybe<Scalars['String']['input']>;
  applicationStage?: InputMaybe<Scalars['String']['input']>;
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsCandidateId?: InputMaybe<Scalars['ID']['input']>;
  atsInterviewStageId?: InputMaybe<Scalars['ID']['input']>;
  atsRejectedReasonId?: InputMaybe<Scalars['ID']['input']>;
  calendarBookingId?: InputMaybe<Scalars['ID']['input']>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  closePreviousConversations?: InputMaybe<Scalars['Boolean']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  crmContactId?: InputMaybe<Scalars['ID']['input']>;
  currentQuestionId?: InputMaybe<Scalars['String']['input']>;
  disableNudging?: InputMaybe<Scalars['Boolean']['input']>;
  emailPrefix?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<ConversationErrorCode>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstQuestionHasBeenAsked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isHumanTakeover?: InputMaybe<Scalars['Boolean']['input']>;
  isInbound?: InputMaybe<Scalars['Boolean']['input']>;
  isInitialEmailMessageOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  isWebChatJoined?: InputMaybe<Scalars['Boolean']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboCandidateId?: InputMaybe<Scalars['ID']['input']>;
  komboRejectionReasonId?: InputMaybe<Scalars['ID']['input']>;
  komboStageId?: InputMaybe<Scalars['ID']['input']>;
  meetingBookingStatus?: InputMaybe<MeetingBookingStatus>;
  messagesCount?: InputMaybe<Scalars['Int']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nudgesSentCount?: InputMaybe<Scalars['Int']['input']>;
  openQuestionOutcomes?: InputMaybe<Array<OpenQuestionOutcomeInput>>;
  openingMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  participantEmailAddress?: InputMaybe<Scalars['String']['input']>;
  participantFirstName?: InputMaybe<Scalars['String']['input']>;
  participantLastName?: InputMaybe<Scalars['String']['input']>;
  participantLinkedInProfile?: InputMaybe<Scalars['String']['input']>;
  participantPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  pastOngoingConversationId?: InputMaybe<Scalars['ID']['input']>;
  preferredAnswersScore?: InputMaybe<Scalars['Float']['input']>;
  previousConversationOutcome?: InputMaybe<Array<PreviousQuestionAnswerInput>>;
  repliesCount?: InputMaybe<Scalars['Int']['input']>;
  screeningQuestionsOutcome?: InputMaybe<Array<ScreeningQuestionOutcomeInput>>;
  sentAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sourcedCandidateId?: InputMaybe<Scalars['ID']['input']>;
  stage?: InputMaybe<ConversationStage>;
  status?: InputMaybe<ConversationStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsNormalized?: InputMaybe<Array<Scalars['String']['input']>>;
  timeToComplete?: InputMaybe<Scalars['Float']['input']>;
  timeToFirstResponse?: InputMaybe<Scalars['Float']['input']>;
  totalNudgesSentCount?: InputMaybe<Scalars['Int']['input']>;
  twilioConversationId?: InputMaybe<Scalars['String']['input']>;
  twilioParticipantId?: InputMaybe<Scalars['String']['input']>;
  twilioRedirectConversationId?: InputMaybe<Scalars['ID']['input']>;
  twilioRedirectParticipantId?: InputMaybe<Scalars['ID']['input']>;
  unresolvedNeedsReviewReasons?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  webChatUrlId?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDocumentCredentialInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  encryptedToken?: InputMaybe<Scalars['String']['input']>;
  headerTokenKey?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateDocumentTypeInput = {
  classificationRules?: InputMaybe<Array<ClassificationRuleInput>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isUsedInCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  validation?: InputMaybe<Array<DocumentValidationCheck>>;
  validationSettings?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export type UpdateDocumentTypeRelationshipsInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentTypeId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateIntegrationCredentialsInput = {
  appSubdomain?: InputMaybe<Scalars['String']['input']>;
  atsApplicationsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsCandidatesLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsInstanceId?: InputMaybe<Scalars['String']['input']>;
  atsJobsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  atsListsLastFetchedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  hubSpotAccessToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  komboIntegrationId?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  stackOneAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobPostingInput = {
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  atsJobPostingId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  jobDescription?: InputMaybe<Scalars['String']['input']>;
  jobPostingUrl?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  normalisedJobDescription?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateJobPostingRecommendationInput = {
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  jobPostingId?: InputMaybe<Scalars['ID']['input']>;
  jobRecommendationSummary?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMessageInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  deliveredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  emailDeliveryEvent?: InputMaybe<EmailDeliveryEvent>;
  emailSubjectLine?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isEmailOpened?: InputMaybe<Scalars['Boolean']['input']>;
  isFallback?: InputMaybe<Scalars['Boolean']['input']>;
  isInitial?: InputMaybe<Scalars['Boolean']['input']>;
  isNegativeSentiment?: InputMaybe<Scalars['Boolean']['input']>;
  media?: InputMaybe<MediaInput>;
  messageUnansweredQuestionId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  outreachQuestionId?: InputMaybe<Scalars['ID']['input']>;
  rawBody?: InputMaybe<Scalars['String']['input']>;
  readAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sender?: InputMaybe<Sender>;
  sentimentName?: InputMaybe<SentimentName>;
  sesEmailId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<MessageStatus>;
  templateId?: InputMaybe<Scalars['ID']['input']>;
  templateMessageValues?: InputMaybe<Array<TemplateMessageValueInput>>;
  twilioErrorCode?: InputMaybe<Scalars['String']['input']>;
  twilioMessageId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateNeedsReviewItemInput = {
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  metadata?: InputMaybe<Scalars['AWSJSON']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateOptOutEmailAddressInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailIdentity?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateOptOutPhoneNumberInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationConfigInput = {
  agentId?: InputMaybe<Scalars['ID']['input']>;
  allowWhatsAppForAtsListCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
  availableLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
  closingMessage?: InputMaybe<Scalars['String']['input']>;
  customRequest?: InputMaybe<Scalars['String']['input']>;
  defaultAutomationTaskTemplateId?: InputMaybe<Scalars['ID']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFooterHtml?: InputMaybe<Scalars['String']['input']>;
  globalContext?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  internalSourcingAddToJobActionUrl?: InputMaybe<Scalars['String']['input']>;
  internalSourcingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  internalSourcingProtectedCharacteristics?: InputMaybe<Scalars['AWSJSON']['input']>;
  openingMessageMode?: InputMaybe<OpeningMessageMode>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rejectionMessage?: InputMaybe<Scalars['String']['input']>;
  sourcingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  timeToAutoCloseConversationsInHours?: InputMaybe<Scalars['Int']['input']>;
  webhookJobSyncingFlowEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  whiteLabelSettings?: InputMaybe<WhiteLabelSettingsInput>;
  whiteLabelingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateOrganizationCustomFieldConfigInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  displayAs?: InputMaybe<CustomFieldDisplay>;
  fieldKey?: InputMaybe<Scalars['String']['input']>;
  hasFixedOptions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  retiredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  type?: InputMaybe<CustomFieldType>;
  vectorDbKey?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationCustomFieldInput = {
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  displayAs?: InputMaybe<CustomFieldDisplay>;
  hasFixedOptions?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationGroupInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationInput = {
  alphaSenderID?: InputMaybe<Scalars['String']['input']>;
  campaignEmailAddress?: InputMaybe<Scalars['String']['input']>;
  candidateDisplayName?: InputMaybe<Scalars['String']['input']>;
  channelsEnabled?: InputMaybe<Array<Channels>>;
  emailIdentity?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  hasCalendarIntegration?: InputMaybe<Scalars['Boolean']['input']>;
  hiddenAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  initialWhatsAppTemplatesBatchStatus?: InputMaybe<InitialWhatsAppTemplatesBatchStatus>;
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  isSandbox?: InputMaybe<Scalars['Boolean']['input']>;
  jobRecommendationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  logoS3Key?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationAtsConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationOrganizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationTwilioAccountCredentialsId?: InputMaybe<Scalars['ID']['input']>;
  sandboxExpiresAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  sandboxStatus?: InputMaybe<SandboxStatus>;
  twilioInboundPhoneNumberAnswers?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioInboundPhoneNumberQuestions?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioPhoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  twilioSenderStatus?: InputMaybe<TwilioSenderStatus>;
  usersCount?: InputMaybe<Scalars['Int']['input']>;
  vectorDbTenantName?: InputMaybe<Scalars['String']['input']>;
  websiteUrl?: InputMaybe<Scalars['AWSURL']['input']>;
  whatsAppBusinessAccountId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type UpdateOrganizationPhoneNumberResult = {
  id: Scalars['ID']['output'];
  phoneNumber: Scalars['String']['output'];
};

export type UpdateOrganizationWebhookInput = {
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  signingSecret?: InputMaybe<Scalars['String']['input']>;
  subscribedEvents?: InputMaybe<Array<WebhookEventType>>;
  url?: InputMaybe<Scalars['AWSURL']['input']>;
};

export type UpdateOutreachQuestionInput = {
  answerRoutes?: InputMaybe<Scalars['AWSJSON']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentItems?: InputMaybe<Array<DocumentItemInput>>;
  documentTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  expectedAnswer?: InputMaybe<QuestionExpectedAnswer>;
  hasPreferredAnswer?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  isMandatory?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  preferredAnswerRequirements?: InputMaybe<Array<Scalars['String']['input']>>;
  preferredAnswerText?: InputMaybe<Scalars['String']['input']>;
  questionType?: InputMaybe<QuestionType>;
  slug?: InputMaybe<Scalars['String']['input']>;
  strictness?: InputMaybe<QuestionStrictness>;
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdatePlanMembershipInput = {
  id: Scalars['ID']['input'];
  messagesLimit?: InputMaybe<Scalars['Int']['input']>;
  messagesUsage?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  plan?: InputMaybe<Plan>;
  product?: InputMaybe<SubscriptionProduct>;
  scoringLimit?: InputMaybe<Scalars['Int']['input']>;
  scoringUsage?: InputMaybe<Scalars['Int']['input']>;
  sourcingUsage?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['AWSDate']['input']>;
  status?: InputMaybe<PlanStatus>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  stripePriceId?: InputMaybe<Scalars['String']['input']>;
  stripeProductId?: InputMaybe<Scalars['String']['input']>;
  stripeProductName?: InputMaybe<Scalars['String']['input']>;
  stripeSubscriptionId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
  usersCountLimit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePreferencesInput = {
  companyName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  role?: InputMaybe<Role>;
  tone?: InputMaybe<Tone>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateProfileDataInput = {
  data?: InputMaybe<Scalars['AWSJSON']['input']>;
  profileId: Scalars['String']['input'];
};

export type UpdateQualificationInput = {
  id: Scalars['ID']['input'];
  qualification?: InputMaybe<Scalars['String']['input']>;
  vectorDbTenantName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateQuestionOutcomeInput = {
  agentMessageId?: InputMaybe<Scalars['ID']['input']>;
  answerPolarity?: InputMaybe<Scalars['String']['input']>;
  answerProgress?: InputMaybe<Array<AnswerProgressInput>>;
  answerState?: InputMaybe<AnswerState>;
  answerSummary?: InputMaybe<Scalars['String']['input']>;
  answerText?: InputMaybe<Scalars['String']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  classifiedDocumentString?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentType?: InputMaybe<Scalars['String']['input']>;
  classifiedDocumentTypeId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  documentFileName?: InputMaybe<Scalars['String']['input']>;
  documentS3Key?: InputMaybe<Scalars['String']['input']>;
  documentTwilioMediaSid?: InputMaybe<Scalars['String']['input']>;
  evaluationResult?: InputMaybe<QuestionEvaluationResult>;
  evidence?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMet?: InputMaybe<Scalars['Boolean']['input']>;
  neededReview?: InputMaybe<Scalars['Boolean']['input']>;
  neededReviewReason?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  outreachQuestionId?: InputMaybe<Scalars['ID']['input']>;
  preferredAnswerEvaluations?: InputMaybe<Array<PreferredAnswerEvaluationInput>>;
  prospectMessageId?: InputMaybe<Scalars['ID']['input']>;
  questionContent?: InputMaybe<Scalars['String']['input']>;
  questionSlug?: InputMaybe<Scalars['String']['input']>;
  routeTaken?: InputMaybe<Scalars['String']['input']>;
  score?: InputMaybe<Scalars['Float']['input']>;
  trafficLight?: InputMaybe<TrafficLight>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateRequirementOutcomeInput = {
  analysisRequirementId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  evidence?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isMet?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  requirementSlug?: InputMaybe<Scalars['String']['input']>;
  scoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  scoringConfigurationDigest?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSearchCandidateProfileMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  generatedSemanticSearchFilters?: InputMaybe<GeneratedSemanticSearchFiltersInput>;
  generatedSemanticSearchQuery?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isOverwritten?: InputMaybe<Scalars['Boolean']['input']>;
  normalisedQueryUserBody?: InputMaybe<Scalars['String']['input']>;
  optimisedSemanticMessage?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  searchCandidateProfileQueryId?: InputMaybe<Scalars['ID']['input']>;
  semanticQueries?: InputMaybe<Array<Scalars['String']['input']>>;
  sender?: InputMaybe<SearchCandidateProfileMessageSender>;
};

export type UpdateSearchCandidateProfileQueryInput = {
  appliedFilter?: InputMaybe<Scalars['AWSJSON']['input']>;
  ats_candidate_id?: InputMaybe<Scalars['String']['input']>;
  candidate_profile_list_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  current_company?: InputMaybe<Scalars['String']['input']>;
  current_job_title?: InputMaybe<Scalars['String']['input']>;
  displayTitle?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['AWSJSON']['input']>;
  full_name?: InputMaybe<Scalars['String']['input']>;
  generatedFilter?: InputMaybe<Scalars['AWSJSON']['input']>;
  geo_coordinates?: InputMaybe<GeoCoordinatesInput>;
  geo_radius?: InputMaybe<Scalars['Float']['input']>;
  id: Scalars['ID']['input'];
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isPinned?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  original_source?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  qualifications?: InputMaybe<Array<Scalars['String']['input']>>;
  returnedCandidatesCount?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  time_in_role?: InputMaybe<Array<TimeComparison>>;
  total_years_of_experience?: InputMaybe<Scalars['Float']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSearchCandidateProfileSelectedInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSearchCandidateProfileSelectedItemInput = {
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateRelevance?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customInvitationMessage?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  searchCandidateProfileSelectedId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSearchPeopleQueryFieldsInput = {
  accumulated_results?: InputMaybe<Scalars['Int']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  company_filter?: InputMaybe<TimeFilterType>;
  company_size?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  current_company_only?: InputMaybe<Scalars['Boolean']['input']>;
  current_titles_only?: InputMaybe<Scalars['Boolean']['input']>;
  domain?: InputMaybe<Array<Scalars['String']['input']>>;
  education?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_companies?: InputMaybe<Array<Scalars['String']['input']>>;
  exclude_job_titles?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  include_related_job_titles?: InputMaybe<Scalars['Boolean']['input']>;
  industry?: InputMaybe<Array<Scalars['String']['input']>>;
  job_title?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Array<Scalars['String']['input']>>;
  match_experience?: InputMaybe<TimeFilterType>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  page_size?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  total_results?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  years_in_current_role?: InputMaybe<Array<Scalars['String']['input']>>;
  years_of_experience?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSelectedCandidateBatchStatusesInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateStatuses?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateSimulationConversationInput = {
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentQuestionId?: InputMaybe<Scalars['String']['input']>;
  firstQuestionHasBeenAsked?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  stage?: InputMaybe<ConversationStage>;
  status?: InputMaybe<ConversationStatus>;
};

export type UpdateSimulationMessageInput = {
  body?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  rawBody?: InputMaybe<Scalars['String']['input']>;
  sender?: InputMaybe<Sender>;
  simulationId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSkillInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  normalizedSkill?: InputMaybe<Scalars['String']['input']>;
  skill?: InputMaybe<Scalars['String']['input']>;
  vectorDbTenantName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateSourcedCandidateInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateRelevance?: InputMaybe<Scalars['String']['input']>;
  contactOutRawData?: InputMaybe<Scalars['AWSJSON']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationNeedsReview?: InputMaybe<Scalars['Boolean']['input']>;
  conversationRepliesCount?: InputMaybe<Scalars['Int']['input']>;
  conversationStatus?: InputMaybe<ConversationStatus>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  customInvitationMessage?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Scalars['String']['input']>;
  experience?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fetchPhoneNumberAttempted?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedInProfileUrl?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  personalEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  source?: InputMaybe<CandidateSource>;
  status?: InputMaybe<SourcedCandidateStatus>;
  title?: InputMaybe<Scalars['String']['input']>;
  workEmails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateStatusSetInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  statuses?: InputMaybe<Array<StatusInput>>;
};

export type UpdateTagInput = {
  id: Scalars['ID']['input'];
  tag?: InputMaybe<Scalars['String']['input']>;
  vectorDbTenantName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTeamInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateTeamMembershipInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  teamId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTwilioAccountCredentialsInput = {
  accountSid?: InputMaybe<Scalars['ID']['input']>;
  alphaSenderMessagingServiceId?: InputMaybe<Scalars['ID']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  apiSecret?: InputMaybe<Scalars['String']['input']>;
  authToken?: InputMaybe<Scalars['String']['input']>;
  chatServiceSid?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  inboundChatServiceId?: InputMaybe<Scalars['ID']['input']>;
  messagingServiceSid?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateTypeformLinkInput = {
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTypeformRecordInput = {
  formId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TypeformRecordType>;
};

export type UpdateUnansweredQuestionInput = {
  associatedMessageId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isAnswered?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  summary?: InputMaybe<Scalars['String']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserCalendarInput = {
  availabilityRedirectCalendarId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invitedEmail?: InputMaybe<Scalars['String']['input']>;
  isSharedMailbox?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nylasGrantId?: InputMaybe<Scalars['String']['input']>;
  nylasVirtualCalendarId?: InputMaybe<Scalars['String']['input']>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  provider?: InputMaybe<UserCalendarProvider>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<UserCalendarStatus>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateUserCalendarMeetingTemplateInput = {
  autoCollectAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityOutreachSettings?: InputMaybe<AvailabilityOutreachSettingsInput>;
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  userCalendarId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserCalendarOrganizationInput = {
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userCalendarId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserInput = {
  correspondenceEmail?: InputMaybe<Scalars['AWSEmail']['input']>;
  email?: InputMaybe<Scalars['AWSEmail']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  invitedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  isDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isOnboard?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastLoginAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  onboardingTourStatus?: InputMaybe<OnboardingTourStatus>;
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationGroupRole?: InputMaybe<OrganizationGroupRole>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  owner?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
  twilioPhoneNumber?: InputMaybe<Scalars['AWSPhone']['input']>;
  userPlanMembershipId?: InputMaybe<Scalars['ID']['input']>;
  userPreferencesId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserOrganizationInput = {
  id: Scalars['ID']['input'];
  organizationGroupId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  role?: InputMaybe<UserRole>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserOrganizationRoleInput = {
  userOrganizationId: Scalars['ID']['input'];
  userOrganizationRole: UserRole;
};

export type UpdateUserOrganizationRoleOutput = {
  message: Scalars['String']['output'];
  userOrganizationRole: UserRole;
};

export type UpdateVirtualCalendarConversationInput = {
  calendarMeetingTemplateId?: InputMaybe<Scalars['ID']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  conversationStage?: InputMaybe<ConversationStage>;
  conversationStatus?: InputMaybe<ConversationStatus>;
  id: Scalars['ID']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  userCalendarId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWhatsaapTemplateInput = {
  campaignType?: InputMaybe<CampaignType>;
  channel?: InputMaybe<Channels>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isLinkedIn?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Array<TemplateMappingInput>>;
  organizationConfigId?: InputMaybe<Scalars['ID']['input']>;
  organizationConfigWhatsAppTemplatesId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  twilioContentTemplateId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TemplateType>;
  variablesCount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWorkflowAtsJobInput = {
  atsJobId: Scalars['ID']['input'];
  atsJobReference?: InputMaybe<Scalars['String']['input']>;
  atsJobTitle?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cvRequired?: InputMaybe<Scalars['Boolean']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  organizationId: Scalars['ID']['input'];
  stageFilter?: InputMaybe<WorkflowAtsStageFilterInput>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowContactImportInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  emailColumn?: InputMaybe<Scalars['String']['input']>;
  externalIdColumn?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
  firstFailedRowNumber?: InputMaybe<Scalars['Int']['input']>;
  firstNameColumn?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  importedByUserId?: InputMaybe<Scalars['ID']['input']>;
  lastNameColumn?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumberColumn?: InputMaybe<Scalars['String']['input']>;
  rowsImported?: InputMaybe<Scalars['Int']['input']>;
  rowsInFile?: InputMaybe<Scalars['Int']['input']>;
  s3ETag?: InputMaybe<Scalars['String']['input']>;
  s3Key?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<WorkflowContactImportStatus>;
  tagColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowContactInput = {
  alreadyEnrolledRunId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  dedupKey?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  enrolmentFailureReason?: InputMaybe<StartWorkflowRunRejectionReason>;
  entrySource?: InputMaybe<WorkflowTriggerSource>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  rowNumber?: InputMaybe<Scalars['Int']['input']>;
  sourceRow?: InputMaybe<Scalars['AWSJSON']['input']>;
  status?: InputMaybe<WorkflowContactStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  validationErrors?: InputMaybe<Array<Scalars['String']['input']>>;
  workflowContactImportId?: InputMaybe<Scalars['ID']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowEventInput = {
  analysedApplicationId?: InputMaybe<Scalars['ID']['input']>;
  calendarBookingId?: InputMaybe<Scalars['ID']['input']>;
  campaignId?: InputMaybe<Scalars['ID']['input']>;
  candidateBatchId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  causationId?: InputMaybe<Scalars['String']['input']>;
  contextSnapshot?: InputMaybe<Scalars['AWSJSON']['input']>;
  conversationId?: InputMaybe<Scalars['ID']['input']>;
  correlationId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  eventData?: InputMaybe<Scalars['AWSJSON']['input']>;
  eventSource?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  eventVersion?: InputMaybe<Scalars['String']['input']>;
  failureReason?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  messageId?: InputMaybe<Scalars['ID']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  processedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  publishedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  retryCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkflowEventStatus>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowExternalId?: InputMaybe<Scalars['String']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowNodeId?: InputMaybe<Scalars['String']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowFromApiInput = {
  configuration?: InputMaybe<Scalars['AWSJSON']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  settings?: InputMaybe<Scalars['AWSJSON']['input']>;
  workflowId: Scalars['ID']['input'];
};

export type UpdateWorkflowInput = {
  apiModifiedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  canvasVisualConfiguration?: InputMaybe<Scalars['AWSJSON']['input']>;
  canvasVisualConfigurationModifiedDate?: InputMaybe<Scalars['AWSDateTime']['input']>;
  configuration?: InputMaybe<Scalars['AWSJSON']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdByUserId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  embeddedAtsJobId?: InputMaybe<Scalars['String']['input']>;
  entrySources?: InputMaybe<Array<WorkflowTriggerSource>>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  liveWorkflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  settings?: InputMaybe<Scalars['AWSJSON']['input']>;
  status?: InputMaybe<WorkflowStatus>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
};

export type UpdateWorkflowRunCandidateProfileInput = {
  candidateProfileFirstName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileLastName?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentNodeId?: InputMaybe<Scalars['String']['input']>;
  hasPartialFailures?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowRunId?: InputMaybe<Scalars['ID']['input']>;
  workflowRunStatus?: InputMaybe<WorkflowRunStatus>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWorkflowRunInput = {
  atsApplicationId?: InputMaybe<Scalars['ID']['input']>;
  atsJobId?: InputMaybe<Scalars['ID']['input']>;
  cancellationCode?: InputMaybe<WorkflowRunCancellationCode>;
  candidateProfileFirstName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileId?: InputMaybe<Scalars['ID']['input']>;
  candidateProfileLastName?: InputMaybe<Scalars['String']['input']>;
  candidateProfileName?: InputMaybe<Scalars['String']['input']>;
  completedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  context?: InputMaybe<Scalars['AWSJSON']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  currentNodeId?: InputMaybe<Scalars['String']['input']>;
  errorCode?: InputMaybe<Scalars['String']['input']>;
  errorMessage?: InputMaybe<Scalars['String']['input']>;
  errorReason?: InputMaybe<Scalars['String']['input']>;
  failedNodeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasPartialFailures?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['ID']['input'];
  inFlightNodeId?: InputMaybe<Scalars['String']['input']>;
  komboApplicationId?: InputMaybe<Scalars['ID']['input']>;
  komboJobId?: InputMaybe<Scalars['ID']['input']>;
  lastFailedNodeId?: InputMaybe<Scalars['String']['input']>;
  latestAnalysisNodeSlug?: InputMaybe<Scalars['String']['input']>;
  latestAnalysisRequirementsMet?: InputMaybe<Scalars['Boolean']['input']>;
  latestAnalysisScore?: InputMaybe<Scalars['Int']['input']>;
  latestAnalysisScoredAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  needsReview?: InputMaybe<Scalars['Boolean']['input']>;
  nodeExecutionState?: InputMaybe<NodeExecutionState>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  runVersion?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkflowRunStatus>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsNormalized?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionNumber?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWorkflowStatsInput = {
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  id: Scalars['ID']['input'];
  lastFailureAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastRunCompletedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  lastRunStartedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  liveWorkflowVersionId?: InputMaybe<Scalars['ID']['input']>;
  liveWorkflowVersionNumber?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  totalActiveRunCount?: InputMaybe<Scalars['Int']['input']>;
  totalCancelledCount?: InputMaybe<Scalars['Int']['input']>;
  totalCompletedCount?: InputMaybe<Scalars['Int']['input']>;
  totalFailedCount?: InputMaybe<Scalars['Int']['input']>;
  totalNeedsReviewCount?: InputMaybe<Scalars['Int']['input']>;
  totalRunCount?: InputMaybe<Scalars['Int']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowVersionInput = {
  activeRunCount?: InputMaybe<Scalars['Int']['input']>;
  archivedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  cancelledCount?: InputMaybe<Scalars['Int']['input']>;
  canvasVisualConfiguration?: InputMaybe<Scalars['AWSJSON']['input']>;
  changeNotes?: InputMaybe<Scalars['String']['input']>;
  completedCount?: InputMaybe<Scalars['Int']['input']>;
  configuration?: InputMaybe<Scalars['AWSJSON']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  entrySources?: InputMaybe<Array<WorkflowTriggerSource>>;
  failedCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  needsReviewCount?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  publishedByUserId?: InputMaybe<Scalars['ID']['input']>;
  runCount?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<WorkflowVersionStatus>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  versionNumber?: InputMaybe<Scalars['Int']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateWorkflowVersionNodeStatsInput = {
  activeCount?: InputMaybe<Scalars['Int']['input']>;
  awaitingCount?: InputMaybe<Scalars['Int']['input']>;
  completedCount?: InputMaybe<Scalars['Int']['input']>;
  createdAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  enteredCount?: InputMaybe<Scalars['Int']['input']>;
  failedCount?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  lastActivityAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  nodeId?: InputMaybe<Scalars['String']['input']>;
  nodeType?: InputMaybe<WorkflowNodeType>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  stats?: InputMaybe<Scalars['AWSJSON']['input']>;
  updatedAt?: InputMaybe<Scalars['AWSDateTime']['input']>;
  workflowId?: InputMaybe<Scalars['ID']['input']>;
  workflowVersionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum UpdatedBy {
  System = 'SYSTEM',
  User = 'USER'
}

export type UpsertOrganizationConfigInput = {
  defaultAutomationTaskTemplateId?: InputMaybe<Scalars['ID']['input']>;
  emailChannelFallbackEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailFooterHtml?: InputMaybe<Scalars['String']['input']>;
  globalContext?: InputMaybe<Scalars['String']['input']>;
};

export type User = {
  agents?: Maybe<ModelAgentConnection>;
  automationTasksTemplates?: Maybe<ModelAutomationTasksTemplateConnection>;
  calendarMeetingTemplates?: Maybe<ModelCalendarMeetingTemplateConnection>;
  campaignSubscriptions?: Maybe<ModelCampaignSubscriptionConnection>;
  campaigns?: Maybe<ModelCampaignConnection>;
  candidateBatchGroups?: Maybe<ModelCandidateBatchGroupConnection>;
  candidateBatches?: Maybe<ModelCandidateBatchConnection>;
  candidateCvsParsings?: Maybe<ModelCandidateCvsParsingConnection>;
  candidateNotes?: Maybe<ModelCandidateNoteConnection>;
  candidateProfileLists?: Maybe<ModelCandidateProfileListConnection>;
  clientApiKeys?: Maybe<ModelClientApiKeyConnection>;
  conversations?: Maybe<ModelConversationConnection>;
  correspondenceEmail?: Maybe<Scalars['AWSEmail']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  email: Scalars['AWSEmail']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  isDeactivated?: Maybe<Scalars['Boolean']['output']>;
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  isOnboard?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastLoginAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  messages?: Maybe<ModelMessageConnection>;
  name?: Maybe<Scalars['String']['output']>;
  onboardingTourStatus?: Maybe<OnboardingTourStatus>;
  organization?: Maybe<Organization>;
  organizationGroupId?: Maybe<Scalars['ID']['output']>;
  organizationGroupRole?: Maybe<OrganizationGroupRole>;
  /** @deprecated Not the tenant or authorization key — auth derives from organizationGroupId and server-side UserOrganization membership (cognito:groups), never this field. Read-only; retained for the organization relationship and getUsersByOrganization. */
  organizationId?: Maybe<Scalars['ID']['output']>;
  organizationWebhooks?: Maybe<ModelOrganizationWebhookConnection>;
  owner?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  planMembership?: Maybe<PlanMembership>;
  preferences?: Maybe<Preferences>;
  role: UserRole;
  twilioPhoneNumber?: Maybe<Scalars['AWSPhone']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  userCalendarOrganizations?: Maybe<ModelUserCalendarOrganizationConnection>;
  userOrganizations?: Maybe<ModelUserOrganizationConnection>;
  userPlanMembershipId?: Maybe<Scalars['ID']['output']>;
  userPreferencesId?: Maybe<Scalars['ID']['output']>;
  workflows?: Maybe<ModelWorkflowConnection>;
};


export type UserAgentsArgs = {
  filter?: InputMaybe<ModelAgentFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserAutomationTasksTemplatesArgs = {
  filter?: InputMaybe<ModelAutomationTasksTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCalendarMeetingTemplatesArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCampaignSubscriptionsArgs = {
  campaignId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignSubscriptionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCampaignsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCandidateBatchGroupsArgs = {
  filter?: InputMaybe<ModelCandidateBatchGroupFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  updatedAt?: InputMaybe<ModelStringKeyConditionInput>;
};


export type UserCandidateBatchesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateBatchFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCandidateCvsParsingsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateCvsParsingFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCandidateNotesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateNoteFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCandidateProfileListsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelCandidateProfileListFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserClientApiKeysArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelClientApiKeyFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserConversationsArgs = {
  filter?: InputMaybe<ModelConversationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserMessagesArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserOrganizationWebhooksArgs = {
  filter?: InputMaybe<ModelOrganizationWebhookFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserUserCalendarOrganizationsArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserUserOrganizationsArgs = {
  filter?: InputMaybe<ModelUserOrganizationFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserWorkflowsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type UserCalendar = {
  availabilityRedirectCalendarId?: Maybe<Scalars['String']['output']>;
  calendarBookings?: Maybe<ModelCalendarBookingConnection>;
  calendarMeetingTemplates?: Maybe<ModelCalendarMeetingTemplateConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdByUserId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  invitedEmail?: Maybe<Scalars['String']['output']>;
  isSharedMailbox?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  nylasGrantId?: Maybe<Scalars['String']['output']>;
  nylasVirtualCalendarId?: Maybe<Scalars['String']['output']>;
  organizationGroupId: Scalars['ID']['output'];
  organizationIds?: Maybe<Array<Scalars['ID']['output']>>;
  participatingInTemplates?: Maybe<ModelUserCalendarMeetingTemplateConnection>;
  provider?: Maybe<UserCalendarProvider>;
  reference?: Maybe<Scalars['String']['output']>;
  status: UserCalendarStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
  userCalendarOrganizations?: Maybe<ModelUserCalendarOrganizationConnection>;
};


export type UserCalendarCalendarBookingsArgs = {
  filter?: InputMaybe<ModelCalendarBookingFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCalendarCalendarMeetingTemplatesArgs = {
  filter?: InputMaybe<ModelCalendarMeetingTemplateFilterInput>;
  id?: InputMaybe<ModelIdKeyConditionInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCalendarParticipatingInTemplatesArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelUserCalendarMeetingTemplateFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type UserCalendarUserCalendarOrganizationsArgs = {
  filter?: InputMaybe<ModelUserCalendarOrganizationFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<ModelIdKeyConditionInput>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type UserCalendarMeetingTemplate = {
  autoCollectAvailability?: Maybe<Scalars['Boolean']['output']>;
  availabilityOutreachSettings?: Maybe<AvailabilityOutreachSettings>;
  calendarMeetingTemplate?: Maybe<CalendarMeetingTemplate>;
  calendarMeetingTemplateId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  createdByUserId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userCalendar?: Maybe<UserCalendar>;
  userCalendarId: Scalars['ID']['output'];
};

export type UserCalendarOrganization = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userCalendar?: Maybe<UserCalendar>;
  userCalendarId: Scalars['ID']['output'];
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum UserCalendarProvider {
  Google = 'google',
  Microsoft = 'microsoft',
  Virtual = 'virtual'
}

export enum UserCalendarStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  Invited = 'INVITED'
}

export type UserOrganization = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organization?: Maybe<Organization>;
  organizationGroupId: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  role: UserRole;
  updatedAt: Scalars['AWSDateTime']['output'];
  user: User;
  userId: Scalars['ID']['output'];
};

export enum UserRole {
  Admin = 'ADMIN',
  Member = 'MEMBER'
}

export type VirtualCalendarConversation = {
  calendarMeetingTemplateId: Scalars['ID']['output'];
  conversation?: Maybe<Conversation>;
  conversationId: Scalars['ID']['output'];
  conversationStage: ConversationStage;
  conversationStatus: ConversationStatus;
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  userCalendarId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export enum VirtualCalendarEventType {
  CandidateAwaitingAvailability = 'CANDIDATE_AWAITING_AVAILABILITY',
  VirtualCalendarAvailabilityProcessed = 'VIRTUAL_CALENDAR_AVAILABILITY_PROCESSED',
  VirtualCalendarAvailabilityReceived = 'VIRTUAL_CALENDAR_AVAILABILITY_RECEIVED',
  VirtualCalendarBookingCreated = 'VIRTUAL_CALENDAR_BOOKING_CREATED',
  VirtualCalendarBookingRescheduled = 'VIRTUAL_CALENDAR_BOOKING_RESCHEDULED',
  VirtualCalendarBusyMarkersReleased = 'VIRTUAL_CALENDAR_BUSY_MARKERS_RELEASED',
  VirtualCalendarEventRejectedByCandidate = 'VIRTUAL_CALENDAR_EVENT_REJECTED_BY_CANDIDATE',
  VirtualCalendarEventRejectedByUser = 'VIRTUAL_CALENDAR_EVENT_REJECTED_BY_USER',
  VirtualCalendarOwnerOutreachClosed = 'VIRTUAL_CALENDAR_OWNER_OUTREACH_CLOSED'
}

export type WebhookEventDefinition = {
  category: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: WebhookEventType;
};

export enum WebhookEventType {
  AnalysisCreated = 'ANALYSIS_CREATED',
  CalendarAvailabilityNotFound = 'CALENDAR_AVAILABILITY_NOT_FOUND',
  CalendarMeetingCancelled = 'CALENDAR_MEETING_CANCELLED',
  CalendarMeetingRescheduled = 'CALENDAR_MEETING_RESCHEDULED',
  CalendarMeetingScheduled = 'CALENDAR_MEETING_SCHEDULED',
  CalendarMeetingUpdated = 'CALENDAR_MEETING_UPDATED',
  CalendarMoreTimeRequested = 'CALENDAR_MORE_TIME_REQUESTED',
  CalendarNoteTakerCompleted = 'CALENDAR_NOTE_TAKER_COMPLETED',
  CampaignStopped = 'CAMPAIGN_STOPPED',
  CandidateAnalysisCompleted = 'CANDIDATE_ANALYSIS_COMPLETED',
  CandidateAnalysisFailed = 'CANDIDATE_ANALYSIS_FAILED',
  CandidateAnalysisRescored = 'CANDIDATE_ANALYSIS_RESCORED',
  CandidateAnalysisRescoredAfterActedOn = 'CANDIDATE_ANALYSIS_RESCORED_AFTER_ACTED_ON',
  CandidateDeleted = 'CANDIDATE_DELETED',
  CandidateListCreated = 'CANDIDATE_LIST_CREATED',
  CandidateListDeleted = 'CANDIDATE_LIST_DELETED',
  CandidateListMembershipUpdated = 'CANDIDATE_LIST_MEMBERSHIP_UPDATED',
  CandidateListUpdated = 'CANDIDATE_LIST_UPDATED',
  CandidateProcessingCompleted = 'CANDIDATE_PROCESSING_COMPLETED',
  CandidateProcessingFailed = 'CANDIDATE_PROCESSING_FAILED',
  CandidateProcessingStarted = 'CANDIDATE_PROCESSING_STARTED',
  ConversationCompleted = 'CONVERSATION_COMPLETED',
  ConversationMaxNudgesReached = 'CONVERSATION_MAX_NUDGES_REACHED',
  ConversationNeedsReview = 'CONVERSATION_NEEDS_REVIEW',
  ConversationOptedOut = 'CONVERSATION_OPTED_OUT',
  ConversationQueued = 'CONVERSATION_QUEUED',
  ConversationStarted = 'CONVERSATION_STARTED',
  DocumentUploaded = 'DOCUMENT_UPLOADED',
  StartConversationFailed = 'START_CONVERSATION_FAILED',
  WorkflowContactResolutionFailed = 'WORKFLOW_CONTACT_RESOLUTION_FAILED',
  WorkflowContactResolutionSkipped = 'WORKFLOW_CONTACT_RESOLUTION_SKIPPED',
  WorkflowContactResolved = 'WORKFLOW_CONTACT_RESOLVED',
  WorkflowNodeCompleted = 'WORKFLOW_NODE_COMPLETED',
  WorkflowPublished = 'WORKFLOW_PUBLISHED',
  WorkflowRunCancelled = 'WORKFLOW_RUN_CANCELLED',
  WorkflowRunCompleted = 'WORKFLOW_RUN_COMPLETED',
  WorkflowRunFailed = 'WORKFLOW_RUN_FAILED',
  WorkflowRunStarted = 'WORKFLOW_RUN_STARTED'
}

export type Weights = {
  relevantExperience: Scalars['Float']['output'];
  relevantQualifications: Scalars['Float']['output'];
  relevantSkills: Scalars['Float']['output'];
  softSkills: Scalars['Float']['output'];
};

export type WeightsInput = {
  relevantExperience: Scalars['Float']['input'];
  relevantQualifications: Scalars['Float']['input'];
  relevantSkills: Scalars['Float']['input'];
  softSkills: Scalars['Float']['input'];
};

export type WhatsaapTemplate = {
  campaignType?: Maybe<CampaignType>;
  channel?: Maybe<Channels>;
  content: Scalars['String']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  isLinkedIn?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  mapping: Array<TemplateMapping>;
  messages?: Maybe<ModelMessageConnection>;
  organizationConfig?: Maybe<OrganizationConfig>;
  organizationConfigId?: Maybe<Scalars['ID']['output']>;
  organizationConfigWhatsAppTemplatesId?: Maybe<Scalars['ID']['output']>;
  organizationId?: Maybe<Scalars['ID']['output']>;
  twilioContentTemplateId?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TemplateType>;
  updatedAt: Scalars['AWSDateTime']['output'];
  variablesCount?: Maybe<Scalars['Int']['output']>;
};


export type WhatsaapTemplateMessagesArgs = {
  filter?: InputMaybe<ModelMessageFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type WhiteLabelSettings = {
  primaryColor: Scalars['String']['output'];
};

export type WhiteLabelSettingsInput = {
  primaryColor: Scalars['String']['input'];
};

export type Workflow = {
  apiModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  campaigns?: Maybe<ModelCampaignConnection>;
  canvasVisualConfiguration?: Maybe<Scalars['AWSJSON']['output']>;
  canvasVisualConfigurationModifiedDate?: Maybe<Scalars['AWSDateTime']['output']>;
  configuration?: Maybe<Scalars['AWSJSON']['output']>;
  connectedAtsJobs?: Maybe<ModelWorkflowAtsJobConnection>;
  createdAt: Scalars['AWSDateTime']['output'];
  createdByUser?: Maybe<User>;
  createdByUserId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  embeddedAtsJobId?: Maybe<Scalars['String']['output']>;
  entrySources?: Maybe<Array<WorkflowTriggerSource>>;
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  liveWorkflowVersion?: Maybe<WorkflowVersion>;
  liveWorkflowVersionId?: Maybe<Scalars['ID']['output']>;
  name: Scalars['String']['output'];
  organizationId: Scalars['ID']['output'];
  settings?: Maybe<Scalars['AWSJSON']['output']>;
  status: WorkflowStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowRuns?: Maybe<ModelWorkflowRunConnection>;
  workflowVersions?: Maybe<ModelWorkflowVersionConnection>;
};


export type WorkflowCampaignsArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type WorkflowConnectedAtsJobsArgs = {
  atsJobId?: InputMaybe<ModelIdKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowAtsJobFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type WorkflowWorkflowRunsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type WorkflowWorkflowVersionsArgs = {
  filter?: InputMaybe<ModelWorkflowVersionFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
  versionNumber?: InputMaybe<ModelIntKeyConditionInput>;
};

export type WorkflowAtsJob = {
  atsJobId: Scalars['ID']['output'];
  atsJobReference?: Maybe<Scalars['String']['output']>;
  atsJobTitle?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  cvRequired?: Maybe<Scalars['Boolean']['output']>;
  komboJobId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  stageFilter?: Maybe<WorkflowAtsStageFilter>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
};

export type WorkflowAtsStageFilter = {
  atsStageIds?: Maybe<Array<Scalars['ID']['output']>>;
  type: WorkflowAtsStageFilterType;
};

export type WorkflowAtsStageFilterInput = {
  atsStageIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  type: WorkflowAtsStageFilterType;
};

export enum WorkflowAtsStageFilterType {
  AllStages = 'ALL_STAGES',
  PredatesSelection = 'PREDATES_SELECTION',
  SelectedStages = 'SELECTED_STAGES'
}

export type WorkflowBuilderAgentTurnOutput = {
  assistantText: Scalars['String']['output'];
  canvas: Scalars['AWSJSON']['output'];
  canvasChanged: Scalars['Boolean']['output'];
  iterations?: Maybe<Scalars['Int']['output']>;
  toolActivity?: Maybe<Scalars['AWSJSON']['output']>;
};

export type WorkflowBuilderAudioInput = {
  data: Scalars['String']['input'];
  mimeType: Scalars['String']['input'];
};

export type WorkflowBuilderLiveTokenOutput = {
  expiresAt: Scalars['AWSDateTime']['output'];
  token: Scalars['String']['output'];
};

export type WorkflowBuilderTranscribeOutput = {
  text: Scalars['String']['output'];
};

export type WorkflowContact = {
  alreadyEnrolledRunId?: Maybe<Scalars['ID']['output']>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  dedupKey?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  enrolmentFailureReason?: Maybe<StartWorkflowRunRejectionReason>;
  entrySource?: Maybe<WorkflowTriggerSource>;
  externalId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isDeleted?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  rowNumber?: Maybe<Scalars['Int']['output']>;
  sourceRow?: Maybe<Scalars['AWSJSON']['output']>;
  status: WorkflowContactStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  validationErrors?: Maybe<Array<Scalars['String']['output']>>;
  workflowContactImportId?: Maybe<Scalars['ID']['output']>;
  workflowId: Scalars['ID']['output'];
  workflowRunId?: Maybe<Scalars['ID']['output']>;
};

export type WorkflowContactImport = {
  createdAt: Scalars['AWSDateTime']['output'];
  emailColumn?: Maybe<Scalars['String']['output']>;
  externalIdColumn?: Maybe<Scalars['String']['output']>;
  failureReason?: Maybe<Scalars['String']['output']>;
  fileName: Scalars['String']['output'];
  firstFailedRowNumber?: Maybe<Scalars['Int']['output']>;
  firstNameColumn?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  importedByUserId?: Maybe<Scalars['ID']['output']>;
  lastNameColumn?: Maybe<Scalars['String']['output']>;
  organizationId: Scalars['ID']['output'];
  phoneNumberColumn?: Maybe<Scalars['String']['output']>;
  rowsImported?: Maybe<Scalars['Int']['output']>;
  rowsInFile?: Maybe<Scalars['Int']['output']>;
  s3ETag?: Maybe<Scalars['String']['output']>;
  s3Key: Scalars['String']['output'];
  status: WorkflowContactImportStatus;
  tagColumns?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
};

export enum WorkflowContactImportStatus {
  AwaitingFile = 'AWAITING_FILE',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Importing = 'IMPORTING'
}

export type WorkflowContactInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  externalId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  tagsObject?: InputMaybe<Scalars['AWSJSON']['input']>;
};

export enum WorkflowContactStatus {
  AwaitingPublish = 'AWAITING_PUBLISH',
  Duplicate = 'DUPLICATE',
  Enrolled = 'ENROLLED',
  Enrolling = 'ENROLLING',
  Invalid = 'INVALID',
  NotEnrolled = 'NOT_ENROLLED',
  Ready = 'READY'
}

export type WorkflowEvent = {
  analysedApplicationId?: Maybe<Scalars['ID']['output']>;
  calendarBookingId?: Maybe<Scalars['ID']['output']>;
  campaignId?: Maybe<Scalars['ID']['output']>;
  candidateBatchId?: Maybe<Scalars['ID']['output']>;
  candidateProfileId?: Maybe<Scalars['ID']['output']>;
  causationId?: Maybe<Scalars['String']['output']>;
  contextSnapshot?: Maybe<Scalars['AWSJSON']['output']>;
  conversationId?: Maybe<Scalars['ID']['output']>;
  correlationId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  eventData: Scalars['AWSJSON']['output'];
  eventSource: Scalars['String']['output'];
  eventType: Scalars['String']['output'];
  eventVersion: Scalars['String']['output'];
  failureReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  messageId?: Maybe<Scalars['ID']['output']>;
  organizationId: Scalars['ID']['output'];
  processedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  publishedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  retryCount?: Maybe<Scalars['Int']['output']>;
  status: WorkflowEventStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowExternalId?: Maybe<Scalars['String']['output']>;
  workflowId: Scalars['ID']['output'];
  workflowNodeId?: Maybe<Scalars['String']['output']>;
  workflowRunId: Scalars['ID']['output'];
  workflowVersionId: Scalars['ID']['output'];
};

export enum WorkflowEventDetailType {
  WorkflowContactResolutionFailed = 'WORKFLOW_CONTACT_RESOLUTION_FAILED',
  WorkflowContactResolutionSkipped = 'WORKFLOW_CONTACT_RESOLUTION_SKIPPED',
  WorkflowContactResolved = 'WORKFLOW_CONTACT_RESOLVED',
  WorkflowNodeCompleted = 'WORKFLOW_NODE_COMPLETED',
  WorkflowPublished = 'WORKFLOW_PUBLISHED',
  WorkflowRunCancelled = 'WORKFLOW_RUN_CANCELLED',
  WorkflowRunCompleted = 'WORKFLOW_RUN_COMPLETED',
  WorkflowRunFailed = 'WORKFLOW_RUN_FAILED',
  WorkflowRunStarted = 'WORKFLOW_RUN_STARTED'
}

export enum WorkflowEventStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Processed = 'PROCESSED',
  Published = 'PUBLISHED'
}

export enum WorkflowNodeType {
  Analysis = 'ANALYSIS',
  Condition = 'CONDITION',
  CreateAtsApplication = 'CREATE_ATS_APPLICATION',
  EngagementOutreach = 'ENGAGEMENT_OUTREACH',
  SchedulingOutreach = 'SCHEDULING_OUTREACH',
  ScreeningOutreach = 'SCREENING_OUTREACH',
  UpdateAtsApplication = 'UPDATE_ATS_APPLICATION'
}

export enum WorkflowOutreachOutcome {
  Completed = 'COMPLETED',
  DeliveryFailed = 'DELIVERY_FAILED',
  FailedCriteria = 'FAILED_CRITERIA',
  NotInterested = 'NOT_INTERESTED',
  NoReply = 'NO_REPLY',
  OptedOut = 'OPTED_OUT',
  PassedCriteria = 'PASSED_CRITERIA'
}

export enum WorkflowRoutingEvent {
  OnAnalysisFailed = 'ON_ANALYSIS_FAILED',
  OnComplete = 'ON_COMPLETE',
  OnConditionResolved = 'ON_CONDITION_RESOLVED',
  OnDeliveryFailed = 'ON_DELIVERY_FAILED',
  OnNotInterested = 'ON_NOT_INTERESTED',
  OnNoReply = 'ON_NO_REPLY',
  OnOptedOut = 'ON_OPTED_OUT'
}

export type WorkflowRun = {
  atsApplicationId?: Maybe<Scalars['ID']['output']>;
  atsJobId?: Maybe<Scalars['ID']['output']>;
  cancellationCode?: Maybe<WorkflowRunCancellationCode>;
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileFirstName?: Maybe<Scalars['String']['output']>;
  candidateProfileId: Scalars['ID']['output'];
  candidateProfileLastName?: Maybe<Scalars['String']['output']>;
  candidateProfileName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  context: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  currentNodeId?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorReason?: Maybe<Scalars['String']['output']>;
  failedNodeIds?: Maybe<Array<Scalars['String']['output']>>;
  hasPartialFailures?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  inFlightNodeId?: Maybe<Scalars['String']['output']>;
  komboApplicationId?: Maybe<Scalars['ID']['output']>;
  komboJobId?: Maybe<Scalars['ID']['output']>;
  lastFailedNodeId?: Maybe<Scalars['String']['output']>;
  latestAnalysisNodeSlug?: Maybe<Scalars['String']['output']>;
  latestAnalysisRequirementsMet?: Maybe<Scalars['Boolean']['output']>;
  latestAnalysisScore?: Maybe<Scalars['Int']['output']>;
  latestAnalysisScoredAt?: Maybe<Scalars['AWSDateTime']['output']>;
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  nodeExecutionState?: Maybe<NodeExecutionState>;
  organizationId: Scalars['ID']['output'];
  runVersion: Scalars['Int']['output'];
  status: WorkflowRunStatus;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  tagsNormalized?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  /** @deprecated Use WorkflowRun.candidateProfileName/FirstName/LastName with searchWorkflowRuns. This composite is retired once popp-web-v2 stops reading it (PAD-6083 phase 3). */
  workflowRunCandidateProfile?: Maybe<WorkflowRunCandidateProfile>;
  workflowVersion?: Maybe<WorkflowVersion>;
  workflowVersionId: Scalars['ID']['output'];
  workflowVersionNumber: Scalars['Int']['output'];
};

export enum WorkflowRunCancellationCode {
  AnalysisStepRemoved = 'ANALYSIS_STEP_REMOVED',
  AtsApplicationRejected = 'ATS_APPLICATION_REJECTED',
  AtsStageNotSelected = 'ATS_STAGE_NOT_SELECTED',
  CandidateErased = 'CANDIDATE_ERASED',
  WorkflowArchived = 'WORKFLOW_ARCHIVED'
}

export type WorkflowRunCandidateProfile = {
  candidateProfile?: Maybe<CandidateProfile>;
  candidateProfileFirstName?: Maybe<Scalars['String']['output']>;
  candidateProfileId: Scalars['ID']['output'];
  candidateProfileLastName?: Maybe<Scalars['String']['output']>;
  completedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  createdAt: Scalars['AWSDateTime']['output'];
  currentNodeId?: Maybe<Scalars['String']['output']>;
  hasPartialFailures?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  organizationId: Scalars['ID']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  workflowRun?: Maybe<WorkflowRun>;
  workflowRunId: Scalars['ID']['output'];
  workflowRunStatus: WorkflowRunStatus;
  workflowVersionId: Scalars['ID']['output'];
  workflowVersionNumber: Scalars['Int']['output'];
};

export enum WorkflowRunStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Running = 'RUNNING'
}

export type WorkflowRunSummary = {
  candidateProfileId: Scalars['ID']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  status: WorkflowRunStatus;
};

export type WorkflowStats = {
  createdAt: Scalars['AWSDateTime']['output'];
  id: Scalars['ID']['output'];
  lastFailureAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastRunCompletedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  lastRunStartedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  liveWorkflowVersionId?: Maybe<Scalars['ID']['output']>;
  liveWorkflowVersionNumber?: Maybe<Scalars['Int']['output']>;
  organizationId: Scalars['ID']['output'];
  totalActiveRunCount: Scalars['Int']['output'];
  totalCancelledCount: Scalars['Int']['output'];
  totalCompletedCount: Scalars['Int']['output'];
  totalFailedCount: Scalars['Int']['output'];
  totalNeedsReviewCount: Scalars['Int']['output'];
  totalRunCount: Scalars['Int']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
};

export enum WorkflowStatus {
  Archived = 'ARCHIVED',
  Paused = 'PAUSED',
  Published = 'PUBLISHED',
  Unpublished = 'UNPUBLISHED'
}

export enum WorkflowTriggerSource {
  Api = 'API',
  Ats = 'ATS',
  InternalSourcing = 'INTERNAL_SOURCING',
  Push = 'PUSH',
  Spreadsheet = 'SPREADSHEET'
}

export type WorkflowValidationError = {
  errorCode: Scalars['String']['output'];
  message: Scalars['String']['output'];
  nodeId?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
};

export type WorkflowValidationResult = {
  errors: Array<WorkflowValidationError>;
  valid: Scalars['Boolean']['output'];
};

export type WorkflowVersion = {
  activeRunCount: Scalars['Int']['output'];
  archivedAt?: Maybe<Scalars['AWSDateTime']['output']>;
  campaigns?: Maybe<ModelCampaignConnection>;
  cancelledCount: Scalars['Int']['output'];
  canvasVisualConfiguration?: Maybe<Scalars['AWSJSON']['output']>;
  changeNotes?: Maybe<Scalars['String']['output']>;
  completedCount: Scalars['Int']['output'];
  configuration: Scalars['AWSJSON']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  entrySources?: Maybe<Array<WorkflowTriggerSource>>;
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  needsReviewCount: Scalars['Int']['output'];
  organizationId: Scalars['ID']['output'];
  publishedAt: Scalars['AWSDateTime']['output'];
  publishedByUserId: Scalars['ID']['output'];
  runCount: Scalars['Int']['output'];
  status: WorkflowVersionStatus;
  updatedAt: Scalars['AWSDateTime']['output'];
  versionNumber: Scalars['Int']['output'];
  workflowId: Scalars['ID']['output'];
  workflowRuns?: Maybe<ModelWorkflowRunConnection>;
};


export type WorkflowVersionCampaignsArgs = {
  filter?: InputMaybe<ModelCampaignFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};


export type WorkflowVersionWorkflowRunsArgs = {
  createdAt?: InputMaybe<ModelStringKeyConditionInput>;
  filter?: InputMaybe<ModelWorkflowRunFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextToken?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<ModelSortDirection>;
};

export type WorkflowVersionNodeStats = {
  activeCount: Scalars['Int']['output'];
  awaitingCount?: Maybe<Scalars['Int']['output']>;
  completedCount: Scalars['Int']['output'];
  createdAt: Scalars['AWSDateTime']['output'];
  enteredCount: Scalars['Int']['output'];
  failedCount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  lastActivityAt: Scalars['AWSDateTime']['output'];
  nodeId: Scalars['String']['output'];
  nodeType: WorkflowNodeType;
  organizationId: Scalars['ID']['output'];
  stats?: Maybe<Scalars['AWSJSON']['output']>;
  updatedAt: Scalars['AWSDateTime']['output'];
  workflowId: Scalars['ID']['output'];
  workflowVersionId: Scalars['ID']['output'];
};

export enum WorkflowVersionStatus {
  Archived = 'ARCHIVED',
  Live = 'LIVE'
}

export type InitializeCampaignWithParticipantsResult = {
  campaignId: Scalars['ID']['output'];
};

export type ProfileData = {
  createdAt: Scalars['AWSDateTime']['output'];
  data: Scalars['AWSJSON']['output'];
  profileId: Scalars['String']['output'];
  updatedAt: Scalars['AWSDateTime']['output'];
};
